(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboard', {
            url      : '/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            bodyClass: 'dashboard'
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('CompanyLogoDialogController', CompanyLogoDialogController);

    /** @ngInject */
    function CompanyLogoDialogController($scope, $mdToast, $mdDialog, api, bsLoadingOverlayService, companyId, logo)
    {
        // ******************************
        // Variables
        // ******************************

        var vm = this;
        vm.companyId = companyId;
        vm.srcImg = logo;

        // ******************************
        // Public Methods
        // ******************************

        vm.close = function() {
            $mdDialog.cancel();
        };

        vm.ok = function(data) {
            $mdDialog.hide(data);
        };

        vm.uploadCompanyLogo = function() {

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'company_logo_upload_loader'});

            api.adminCompanies.logo.save({
                companyId: vm.companyId,
                logoImg: vm.cropImg
            }, function(response) {
                console.log(response);

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'company_logo_upload_loader'});

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Uploaded successfully!')
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );

                vm.ok({
                    mode: 'upload',
                    data: response.logo
                });

            }, function(response) {
                console.log(response);

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'company_logo_upload_loader'});

                var errorMsg;
                if(response.data && response.data.message) {
                    errorMsg = response.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

            });

        };

        /**
         * File change listener
         */
        vm.onChangeFile = function($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {

            if($newFiles && $newFiles.length > 0) {
                var file = $newFiles[0];

                if(!file.$error) {
                    vm.srcImg = file;
                } else {

                    var errorMsg = 'Something went wrong!';
                    if(file.$error === 'maxSize') {
                        errorMsg = 'File size must be less than ' + file.$errorParam;
                    } else if(file.$error === 'pattern') {
                        errorMsg = 'File type ' + file.$errorParam + ' only are available';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            }
        };

        // ******************************
        // Internal methods
        // ******************************

        function init() {

        }

        init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site.materials', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site.materials')
        .controller('MaterialsController', MaterialsController);

    /** @ngInject */
    function MaterialsController()
    {

        // ******************************
        // Variables
        // ******************************

        var vm = this;

        // ******************************
        // Public Methods
        // ******************************



        // ******************************
        // Internal methods
        // ******************************



        /**
         * Initialize
         */
        function _init() {

        }

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site.home', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController(currentUser)
    {

        // ******************************
        // Variables
        // ******************************

        var vm = this;
        vm.currentUser = currentUser;

        // ******************************
        // Public Methods
        // ******************************



        // ******************************
        // Internal methods
        // ******************************



        /**
         * Initialize
         */
        function _init() {

        }

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site.analytics', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site.analytics')
        .controller('AnalyticsController', AnalyticsController);

    /** @ngInject */
    function AnalyticsController($scope, $rootScope, $mdDialog, currentUser)
    {

        // ******************************
        // Variables
        // ******************************

        var vm = this;
        vm.currentUser = currentUser;
        vm.todayDate = new Date();

        vm.financeTable = {
            order: 'order',
            columns: [
                {key: 'a', title: 'Status'},
                {key: 'b', title: 'Tank Level (%)'},
                {key: 'c', title: 'Fill Rate (p.p./day)'},
                {key: 'd', title: 'Days to Trigger'},
                {key: 'e', title: 'Days to Capacity'},
                {key: 'f', title: 'Next Pick-up Target Date'},
                {key: 'g', title: 'Contract Type'}
            ]
        };

        // ******************************
        // Public Methods
        // ******************************

        /**
         * Query site filters for auto complete box
         */
        vm.querySiteFilter = function(query) {
            var restFilters = _.reject($scope.$parent.benchmarkings, function(benchmarking) {
                return _.find($scope.$parent.siteFilter, function(filter) {
                    return filter.Site.id === benchmarking.Site.id;
                }) !== undefined;
            });
            return query ? restFilters.filter( _createFilterFor(query, 'aliasName') ) : restFilters;
        };

        /**
         * Listener when changed site filter
         */
        vm.onChangeSiteFilter = function() {
            $scope.$parent.onChangeSiteFilter();
        };

        /**
         * Query shift filters for auto complete box
         */
        vm.queryShiftFilter = function(query) {
            var restFilters = _.reject($scope.$parent.stats.SiteShifts, function(shift) {
                return _.findIndex($scope.$parent.shiftFilter, {id: shift.id}) !== -1;
            });
            return query ? restFilters.filter( _createFilterFor(query, 'name') ) : restFilters;
        };

        /**
         * Listener when changed shift filter
         */
        vm.onChangeShiftFilter = function() {
            vm.prePopulateDateRange();
        };

        /**
         * transform chip
         */
        vm.transformChip = function(chip) {
            // If it is an object, it's already a known chip
            //if (angular.isObject(chip)) {
            //    return chip;
            //}
            // Otherwise, create a new one
            //return { name: chip, type: 'new' }
            return chip;
        };

        /**
         * Show download drop-down
         */
        vm.openDownloadMenu = function($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        /**
         * Open Sustainability Report Edit Dialog
         */
        vm.openSustainabilityReportEditDlg = function(ev, benchmarking, year, month) {

            $mdDialog.show({
                controller: EditWasteProcessedDialogController,
                controllerAs: 'vm',
                locals: {
                    reports: $scope.$parent.reports,
                    benchmarking: benchmarking,
                    selectedYear: year,
                    selectedMonth: month
                },
                templateUrl: 'app/main/dashboard/sustainability/edit-waste-processed-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            }).then(function(ret) {
                if(ret.mode === 'edit') {
                    $scope.$parent.onUpdatedMonthlyReport(ret.data);
                }
            }, function() {

            });
        };

        /**
         * Open Event Log Dialog
         */
        vm.openPickupLogDlg = function(ev, year, month, installation) {

            if(installation) {

                var start_date = new Date(year, month, 1);
                var end_date = moment(start_date).add(1,'months').subtract(1,'days');
                end_date = new Date(end_date);

                $rootScope.isDashboard = false;
                $mdDialog.show({
                    controller: EventLogDialogController,
                    controllerAs: 'vm',
                    templateUrl: 'app/main/dashboard/customer/log-dialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose:false,
                    escapeToClose: false,
                    fullscreen: true,
                    locals: {
                        params: {
                            installation: installation,
                            selectedInstallations: [installation],
                            start_date: start_date,
                            end_date: end_date,
                            editable: $scope.$parent.visibilities.pickupHistoryEdit,
                            selectable: false,
                            expended: false,
                            tabs: {
                                TANK_LEVEL: false,
                                PICK_UP: true,
                                SYSTEM_FAULT: false,
                                NON_CRITICAL: false
                            },
                            defaultTab: 'PICK_UP'
                        }
                    }
                }).then(function(isLogChanged) {
                    if(isLogChanged === true) {
                        $scope.$parent.onRefresh();
                    }
                    $rootScope.isDashboard = true;
                }, function() {
                    $rootScope.isDashboard = true;
                });
            }
        };

        /**
         * Listener on donwload pdf
         */
        vm.onDownloadPdf = function(year) {
            $scope.$parent.onDownloadPdf(year);
        };

        /**
         * Listener when a metric selected
         */
        vm.onSelectMetric = function(index) {
            $scope.$parent.onSelectMetric(index);
        };

        /**
         * Listener to apply filters
         */
        vm.onApplyFilters = function() {
            $scope.$parent.onRefresh();
            vm.filterChangedTimeHorizon = false;
        };

        /**
         * Listener to select badges
         */
        vm.onSelectBadge = function() {
            vm.prePopulateDateRange();
        };

        /**
         * Listener to deselect badges
         */
        vm.onDeselectBadge = function() {
            vm.prePopulateDateRange();
        };

        /**
         * Listener to change on date picker
         */
        vm.onChangeDateRange = function() {
            vm.prePopulateDateRange();
        };

        /**
         * Listener to change on rolling drop-down
         */
        vm.onChangeRolling = function() {
            $scope.$parent.search_period = $scope.search_period
            if($scope.$parent.search_period) {
                $scope.$parent.search_start_date = null;
                $scope.$parent.search_end_date = null;
                $scope.search_start_date = null;
                $scope.search_end_date = null;

                $scope.$parent.shiftFilter = [];
                _.each($scope.$parent.benchmarkings, function(one) {
                    if(one.selectedBadges) {
                        one.selectedBadges = [];
                    }
                });
                vm.filterChangedTimeHorizon = true;
                vm.onApplyFilters();
            }
        };

        /**
         * * Time Range custom logic
         * - Default selection is Rolling 30 days
         * - Enterning a customer time range (NOT clicking refresh) will clear the Rolling 30 days selction AND turn the refresh button enable
         *      - If you enter first the Start Date, it will clear Rolling 30, and prepopulate End Date with MIN(Today; Start Date + 30)
         *          - Start date to be alwasys less or equal Today
         *      - If you enter first the End Date, it will clear Rolling 30, and prepopulate Start Date with MIN(Today - 30; End Date - 30)
         *      - Graph will only update when click on Refresh 
         *      - The full time stamp for the Start Date is always 00:00:00:000 of that day
         *      - The full time stamp for the End Date is always 23:59:59:999 of that day
         * - Selection another Rolling 30/60/90 Days selection will clear any custom time range and update the graph
         */
        vm.prePopulateDateRange = function() {

            if($scope.search_start_date && $scope.search_end_date) {
                $scope.$parent.search_start_date = $scope.search_start_date;
                $scope.$parent.search_end_date = $scope.search_end_date;
            } 
            else {
                var searchPeriod = 30; // calculate with 30 alwasys
                var todayDate = moment().format('YYYY-MM-DD');
                if($scope.search_start_date) {
                    var startPlusPeriod = moment($scope.search_start_date).add(searchPeriod, "days").format('YYYY-MM-DD');
                    var minDate = moment.min([moment(todayDate), moment(startPlusPeriod)]).format('YYYY-MM-DD')
                    $scope.search_end_date = new Date(minDate + ' 00:00:00');
                } 
                else if($scope.search_end_date) {
                    var todayMinPeriod = moment().subtract(searchPeriod, "days").format('YYYY-MM-DD');
                    var endMinPeriod = moment($scope.search_end_date).subtract(searchPeriod, "days").format('YYYY-MM-DD');
                    var minDate = moment.min([moment(todayMinPeriod), moment(endMinPeriod)]).format('YYYY-MM-DD')
                    $scope.search_start_date = new Date(minDate + ' 00:00:00');
                }

                $scope.$parent.search_start_date = $scope.search_start_date;
                $scope.$parent.search_end_date = $scope.search_end_date;

                $scope.search_period = '';
                $scope.$parent.search_period = '';
            } 

            if(!vm.filterChangedTimeHorizon) {
                vm.filterChangedTimeHorizon = true;
            }
        };

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Initialize
         */
        function _init() {

        }

        // ******************************
        // Event Listeners
        // ******************************

        //Listener for controller destroy
        $scope.$on('$destroy', function() {

        });

        _init();
    }
})();


function UserDialogController($scope, $mdDialog, $mdToast, $q, api, currentUser)
{

    // ******************************
    // Variables
    // ******************************

    var vm = this;
    vm.isDataChanged = false;
    vm.currentUser = currentUser;
    vm.usersData = {};
    vm.usersTable = {
      columns:[
        {
          title: 'First Name'
        },
        {
          title: 'Last Name'
        },
        {
          title: 'User Role'
        },
        {
          title: 'Email'
        },
        {
          title: 'Phone'
        },
        {
          title: 'Receive Emails for'
        }
      ],
      rows:[]
    };

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Open add dialog
     */
    vm.openAddDlg = function (ev, mode, id) {

      if(!vm.currentUser.hasAdminRole()) return;

      var userData = {};

      if(mode == 'edit') {
        userData = angular.copy(vm.getUserDataById(id));
      }

      $mdDialog.show({
          controller: AddUserDialogController,
          controllerAs: 'vm',
          locals: {
            mode: mode,
            userData: userData
          },
          templateUrl: 'app/main/dashboard/user/user-dialog-add.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          escapeToClose: false,
          fullscreen: true,
          skipHide: true
        })
        .then(function(ret) {
          if(ret) {

            if(ret.mode == 'add') {
              vm.addUserData(ret.data);
            } else if(ret.mode == 'edit') {
              vm.setUserData(ret.data);
            } else if(ret.mode == 'delete') {
              vm.deleteUserData(ret.data);
            }

            vm.isDataChanged = true;
          }
        }, function() {

        });
    };

    /**
     * Close dialog
     */
    vm.close = function() {
        $mdDialog.hide(vm.isDataChanged);
    };

    /**
     * Get UserData By Id
     */
    vm.getUserDataById = function(id) {
      return _.find(vm.usersData.rows, function(user) {
        return user.id == id;
      });
    };

    /**
     * Set UserData
     */
    vm.setUserData = function(data) {

      var index = _.findIndex(vm.usersData.rows, {id: data.id});

      if(index != -1) {
        vm.usersData.rows[index] = data;
      }

      var index = _.findIndex(vm.usersTable.rows, {id: data.id});

      if(index != -1) {
        vm.usersTable.rows[index] = _getUsersTableRow(data);
      }

    };

    /**
     * Delete UserData
     */
    vm.deleteUserData = function(data) {

      var index = _.findIndex(vm.usersData.rows, {id: data.id});

      if(index != -1) {
        vm.usersData.rows.splice(index, 1);
      }

      var index = _.findIndex(vm.usersTable.rows, {id: data.id});

      if(index != -1) {
        vm.usersTable.rows.splice(index, 1);
      }

    };

    /**
     * Add UserData
     */
    vm.addUserData = function(data) {

      vm.usersData.rows.push(data);
      vm.usersTable.rows.push(_getUsersTableRow(data));

    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Load user data
     */
    function _loadUsersData() {

      vm.isLoading = true;

      api.adminUsers.list.get(
        null,
        // Success
        function (response)
        {
          vm.isLoading = false;
          vm.usersData = response;

          vm.usersTable.rows = [];

          if(vm.usersData && vm.usersData.rows) {

            _.each(vm.usersData.rows, function(userData) {

              var row = _getUsersTableRow(userData);

              vm.usersTable.rows.push(row);

            });
          }

        },
        // Error
        function (response)
        {
          console.log(response);
          vm.isLoading = false;

          var errorMsg;
          if(response.data && response.data.message) {
            errorMsg = response.data.message;
          } else {
            errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );
        }
      );
    }

    /**
     * Get Table Row for render from data
     */
    function _getUsersTableRow(userData) {

      var row = {id: userData.id, cells:[]};

      row.cells[0] = {
        value: userData.firstName,
        isEditLink: true
      };
      row.cells[1] = {
        value: userData.lastName,
        isEditLink: true
      };
      row.cells[2] = {
        value: _rolesString(userData.Roles)
      };
      row.cells[3] = {
        value: userData.email
      };
      row.cells[4] = {
        value: userData.phone
      };
      row.cells[5] = {
        value: _servsString(userData.ListServs)
      };

      return row;
    }

    /**
     * Roles object array to string
     */
    function _rolesString(roles) {
      return _.pluck(_.sortBy(roles, 'id'), 'title').join(',');
    }

    /**
     * ListServs object array to string
     */
    function _servsString(servs) {
      return _.pluck(_.sortBy(servs, 'id'), 'title').join(',');
    }

    /**
     * Initialize
     */
    function _init() {

      vm.table = {
        dtOptions: {
          dom       : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          pageLength: 10,
          lengthMenu: [10, 20, 50, 100],
          autoWidth : true,
          responsive: false,
          aaSorting: [0, 'asc'],
          columnDefs: []
        }
      };

      _loadUsersData();

    }

    _init();

}

/**
 * Add Dialog Controller
 */
function AddUserDialogController($scope, $mdDialog, $mdToast, mode, userData, api, currentUser) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.currentUser = currentUser;
    vm.isSaving = false;
    vm.isLoadingRoles = false;
    vm.isLoadingServs = false;
    vm.userRole = '';

    vm.mode = mode;
    vm.userData = userData;
    vm.Servs = [];
    vm.Roles = [];

    if (userData.Roles && userData.Roles.length > 0) {
      vm.userRole = userData.Roles[0].name;
    }

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update user
     */
    vm.updateUser = function(sendWelcomeEmail) {

        vm.isSaving = true;
        vm.msg = 'Updating...';

        if(vm.mode === 'add') {

            var params = {
                firstName: vm.userData.firstName,
                lastName: vm.userData.lastName,
                email: vm.userData.email,
                phone: vm.userData.phone,
                roles: _.pluck(vm.userData.Roles, 'id'),
                listservs: _.pluck(vm.userData.ListServs, 'id'),
                sendWelcomeEmail: sendWelcomeEmail
            };

            if(vm.userPassword) {
                params.password = vm.userPassword;
            }

            api.adminUsers.list.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.userData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'add',
                        data: vm.userData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'edit') {

            var params = {
                firstName: vm.userData.firstName,
                lastName: vm.userData.lastName,
                email: vm.userData.email,
                phone: vm.userData.phone,
                roles: _.pluck(vm.userData.Roles, 'id'),
                listservs: _.pluck(vm.userData.ListServs, 'id'),
                sendWelcomeEmail: sendWelcomeEmail,
                userId: vm.userData.id
            };

            if(vm.userPassword && vm.userPassword !== vm.userData.updatedAt) { // Tricky to check if password changed
                params.password = vm.userPassword;
            }

            api.adminUsers.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.userData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.userData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'profile') {

            var params = {
                firstName: vm.userData.firstName,
                lastName: vm.userData.lastName,
                phone: vm.userData.phone,
                listservs: _.pluck(vm.userData.ListServs, 'id')
            };

            if(vm.userPassword !== vm.userData.updatedAt) { // Tricky to check if password changed
                params.password = vm.userPassword;
            }

            api.profile.update.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.userData = response;
                    vm.msg = 'Updated successfully!';

                    //console.log(response);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'profile',
                        data: vm.userData
                    });
                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );
        }

    };

    /**
     * Delete user
     */
    vm.deleteUser = function(ev) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this user?',
                okButton: 'Delete User',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){
            if(isOk) {

                vm.isSaving = true;
                vm.msg = 'Deleting...';

                api.adminUsers.actionById.remove(
                    {
                        userId: vm.userData.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isSaving = false;
                        vm.msg = 'Deleted successfully!';

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.msg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        vm.close({
                            mode: 'delete',
                            data: vm.userData
                        });

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isSaving = false;
                        vm.msg = '';

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Close customer dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };

    /**
     * Validate role is selected
     */
    vm.isSelectedRole = function(role) {
        return (_.findIndex(vm.userData.Roles, {id: role.id}) != -1);
    };

    /**
     * Update Roles data by selecting role
     */
    vm.chooseRole = function(role) {
        /*
        var index = _.findIndex(vm.userData.Roles, {id: role.id});
        if (index > -1) {
          vm.userData.Roles.splice(index, 1);
        } else {
          if(vm.userData.Roles)
            vm.userData.Roles.push(role);
          else
            vm.userData.Roles = [role];
        }*/
        vm.userRole = role.name;
        vm.userData.Roles = [role];

        if (vm.userRole == 'ADMIN_CONTACT_ONLY') {
          vm.userData.ListServs = []
        }

        vm.validateUserRoleSelected();
    };

    /**
     * Validate serv is selected
     */
    vm.isSelectedServ = function(serv) {
        return (_.findIndex(vm.userData.ListServs, {id: serv.id}) != -1);
    };

    /**
     * Update Serv data by selecting role
     */
    vm.chooseServ = function(serv) {
        if (vm.userRole == 'ADMIN_CONTACT_ONLY') {
            vm.userData.ListServs = []
            return;
        }

        var index = _.findIndex(vm.userData.ListServs, {id: serv.id});
        if (index > -1) {
            vm.userData.ListServs.splice(index, 1);
        } else {
            if(vm.userData.ListServs)
                vm.userData.ListServs.push(serv);
            else
                vm.userData.ListServs = [serv];
        }
    };

    /**
     * Validate password is matching with confirmation
     */
    vm.validatePasswordConfirm = function() {

        if(vm.userPassword == vm.userPasswordConfirm) {
            vm.errMsg = '';
            return true;
        } else {
            vm.errMsg = 'Password(Confirm) is not matched!';
            return false;
        }
    };

    /**
     * Validate a role is selected at least
     */
    vm.validateUserRoleSelected = function() {

        if(!vm.userData.Roles || vm.userData.Roles.length == 0) {
            vm.errMsg = 'At least a user role should be selected!';
            return false;
        } else {
            vm.errMsg = '';
            return true;
        }
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Load Roles
     */
    function _loadRoles() {

        vm.isLoadingRoles = true;

        api.adminRoles.query(
            null,
            // Success
            function (response)
            {
                vm.isLoadingRoles = false;
                vm.Roles = response;
            },
            // Error
            function (response)
            {
                console.log(response);
                vm.isLoadingRoles = false;
            }
        );
    }

    /**
     * Load Servs
     */
    function _loadServs() {
        vm.isLoadingServs = true;

        api.adminServs.query(
            null,
            // Success
            function (response)
            {
                vm.isLoadingServs = false;
                vm.Servs = response;
            },
            // Error
            function (response)
            {
                console.log(response);
                vm.isLoadingServs = false;
            }
        );
    }

    /**
     * Initialize
     */
    function _init() {

        _loadRoles();
        _loadServs();

        if(vm.mode === 'edit' || vm.mode === 'profile') { // Tricky to show fake password
            vm.userPassword = vm.userData.updatedAt;
            vm.userPasswordConfirm = vm.userData.updatedAt;
        } else if(vm.mode === 'add') {
            vm.userPassword = '';
            vm.userPasswordConfirm = '';
        }

    }

    _init();

}


function SustainabilityDialogController($scope, $mdDialog, $mdToast, $q, api, currentUser, bsLoadingOverlayService)
{

    // ******************************
    // Variables
    // ******************************


    var vm = this;
    vm.isSaving = false;
    vm.currentUser = currentUser;
    vm.sustDataDB = { settings: [] }; // keep to match if form was changed to show alert box
    vm.sustData = { settings: [] };
    vm.textSettings = [];
    vm.sustDataHeads = [];


    // ******************************
    // Public Methods
    // ******************************

    /**
     * Close dialog
     */
    vm.close = function(closeForce) {
      if (closeForce) {
        $mdDialog.cancel();
      }
      else {
        if (_isFormChanged()) {
          _closeAfterConfirmation()
        }
        else {
          $mdDialog.cancel();
        }
      }
    };

    /**
     * Submit/Update settings
     */
    vm.saveSettings = function() {

        vm.isSaving = true;
        vm.msg = 'Updating...';
        bsLoadingOverlayService.start({referenceId: 'sustainability_setting_loader'});

        // get changeable fields to api for udpates
        var payload = _.filter(vm.sustData.settings, function (s){
          return ( s.keyType == 'value' || s.keyType == 'text')
        });

        payload = _.map(payload, function(s) {
          return {
            key: s.key,
            text: s.text ? s.text : undefined,
            conversionFactor: s.keyType == 'value' ? parseFloat(s.conversionFactor) : undefined,
          }
        });

        api.adminSustainabilitySettings.list.save(
            {settings: payload},
            // Success
            function (response)
            {
                vm.isSaving = false;
                bsLoadingOverlayService.stop({referenceId: 'sustainability_setting_loader'});
                // vm.userData = response;
                //console.log('response', response)
                vm.msg = 'Updated successfully!';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.msg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );

                vm.close({
                    mode: 'edit',
                    data: vm.userData
                });

            },
            // Error
            function (response)
            {
                console.log(response);
                vm.isSaving = false;
                bsLoadingOverlayService.stop({referenceId: 'sustainability_setting_loader'});
                vm.msg = '';

                var errorMsg;
                if(response.data && response.data.message) {
                    errorMsg = response.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            }
        );

    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Load user data
     */
    function _loadSustData() {

      vm.isLoading = true;

      api.adminSustainabilitySettings.list.get(
        null,
        // Success
        function (response)
        {
          vm.isLoading = false;
          vm.sustData.settings = response.settings;
          // vm.sustDataDB = response;
          vm.sustDataDB = angular.copy(vm.sustData);
          vm.sustDataHeads = response.settingHeads;

          /*
           * Format the data into new array to populate the Text fields
           * Banner and Icons in One row as 60-40 ration
           * And Technical References/Legal Disclaimers as 100% flex width
           */
          const texts = _.filter(response.settings, function(s){
            return s.keyType == 'text';
          });

          var textSettings = [];
          var arr = [];

          _.each(texts, function(t, i) {
            if (t.key == 'Technical References' || t.key == 'Legal Disclaimers') {
              t.flex = 100;
              t.isText = true;
              textSettings.push([t]);
            }
            else {
              // banner on left
              if (i%2 == 0) {
                arr = [];
                t.isBanner = true;
                t.flex = 60;
                // t.cols = 60;
              }
              else {
                // banner icon on right
                t.isIcon = true;
                t.flex = 40;
                t.cols = 20;
              }


              arr.push(t);

              if (i%2 != 0) {
                textSettings.push(arr);
              }
            }
          });
          vm.textSettings = textSettings;

        },
        // Error
        function (response)
        {
          console.log(response);
          vm.isLoading = false;

          var errorMsg;
          if(response.data && response.data.message) {
            errorMsg = response.data.message;
          } else {
            errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );
        }
      );
    }


    /**
     * Show confirmation dialog if Changes aren't saved yet
     */
    function _closeAfterConfirmation() {

      $mdDialog.show({
        controller: CustomConfirmDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
        locals: {
          title: 'Updates Not Saved',
          message: 'Would you like you exit without saving?',
          okButton: 'Yes',
          cancelButton: 'Cancel',
          okFunc: null
        },
        parent: angular.element(document.body),
        // targetEvent: ev,
        clickOutsideToClose:false,
        escapeToClose: false,
        skipHide: true
      }).then(function(isOk){
        if(isOk) {
          vm.close(true)
        }
        else {
          // vm.close()
        }
      });

    };

    /**
     * Check if there are unsaved changes
     */
    function _isFormChanged() {
      // original data
      const sustDataDB = _.map(vm.sustDataDB.settings, function(s) {
        return { key: s.key, text: s.text, conversionFactor: s.conversionFactor }
      });

      // form data
      // grab non text settings
      var sustData = [];
      _.each(vm.sustData.settings, function(s){
        if (s.keyType != 'text') {
          sustData.push({ key: s.key, text: s.text, conversionFactor: s.conversionFactor })
        }
      });

      // grab text settings
      _.each(vm.textSettings, function(s) {
        _.each(s, function(t){
          sustData.push({ key: t.key, text: t.text, conversionFactor: t.conversionFactor })
        })
      });

      var _sustDataDB = JSON.stringify(sustDataDB);
      var _sustData = JSON.stringify(sustData);
      return _sustDataDB != _sustData;
    }

    /**
     * Initialize
     */
    function _init() {
      _loadSustData();
    }

    _init();

}


function EditWasteProcessedDialogController($scope, $mdDialog, $mdToast, api, reports, benchmarking, selectedYear, selectedMonth)
{

    // ******************************
    // Variables
    // ******************************


    var vm = this;
    vm.isSaving = false;
    vm.reports = reports;
    vm.benchmarking = benchmarking;
    vm.selectedYear = selectedYear;
    vm.selectedMonth = selectedMonth;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Close dialog
     */
    vm.close = function() {
        $mdDialog.cancel();
    };
    vm.ok = function(data) {
        $mdDialog.hide(data);
    };


    /**
     * Listener on year change
     */
    vm.onChangeYear = function() {
        vm.reportYear = _.findWhere(vm.reports, {year: parseInt(vm.selectedYear)});
        if(vm.reportYear) {
            vm.onChangeMonth();
        }
    };

    /**
     * Listener on month change
     */
    vm.onChangeMonth = function() {
        if(vm.reportYear) {
            vm.reportMonth = _.findWhere(vm.reportYear.months, {month: parseInt(vm.selectedMonth)});
            if(!vm.reportMonth) {
                delete vm.selectedMonth;
                delete vm.selectedValue;
            } else {
                vm.selectedValue = vm.reportMonth.value['site#'+vm.benchmarking.id];
            }
        }
    };

    /**
     * Update waste processed
     */
    vm.updateWasteProcessed = function() {

        if(!vm.benchmarking.Site.Installation) return;

        var params = {
            installationId: vm.benchmarking.Site.Installation.id,
            year: vm.selectedYear,
            month: vm.selectedMonth,
            wasteProcessed: vm.selectedValue
        };

        vm.isSaving = true;
        vm.msg = 'Updating...';

        api.adminSustainabilityReports.list.save(
            params,
            // Success
            function (response)
            {
                vm.isSaving = false;
                vm.msg = 'Updated successfully!';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.msg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );


                // update table value
                vm.reportMonth.value['site#'+vm.benchmarking.id] = vm.selectedValue;
                // update report original value
                if(benchmarking.Site.Installation.MonthlyReportsByYear[vm.selectedYear]) {
                    var dataReport = _.findWhere(benchmarking.Site.Installation.MonthlyReportsByYear[vm.selectedYear], {month: parseInt(vm.selectedMonth)});
                    if(dataReport) {
                        console.log('found..asd.f.asd.fa.sdf..');
                        dataReport.wasteProcessed = response.wasteProcessed;
                    } else {
                        benchmarking.Site.Installation.MonthlyReportsByYear[vm.selectedYear].push(response);
                    }
                } else {
                    benchmarking.Site.Installation.MonthlyReportsByYear[vm.selectedYear].push(response);
                }


                vm.ok({
                    mode: 'edit',
                    data: response
                });

            },
            // Error
            function (response)
            {
                console.log(response);
                vm.isSaving = false;
                vm.msg = '';

                var errorMsg;
                if(response.data && response.data.message) {
                    errorMsg = response.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            }
        );
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

        if(vm.benchmarking.Site.Installation && vm.benchmarking.Site.Installation.Tank.iotActivationDate) {

            vm.iotActivationDateYear = moment(vm.benchmarking.Site.Installation.Tank.iotActivationDate).year();
            vm.iotActivationDateMonth = moment(vm.benchmarking.Site.Installation.Tank.iotActivationDate).month();

            if(vm.selectedYear < vm.iotActivationDateYear || vm.selectedYear == vm.iotActivationDateYear && vm.selectedMonth < vm.iotActivationDateMonth) {
                delete vm.selectedYear;
                delete vm.selectedMonth;
            } else {
                vm.onChangeYear();
            }
        }
    }

    _init();

}


function SiteAttributeDialogController($scope, $filter, $mdDialog, $mdSidenav, $mdToast, $q, api, bsLoadingOverlayService, Upload, currentUser, siteId, tab)
{

    // ******************************
    // Variables
    // ******************************

    var vm = this;
    vm.hostUrl = api.hostUrl;
    vm.currentUser = currentUser;
    vm.tab = tab || 1;
    vm.usersTable = {
        order: 'firstName'
    };
    vm.badgesTable = {
        order: 'badgeId'
    };
    vm.shiftsTable = {
        order: 'name'
    };
    vm.trainingTable = {
        order: 'title'
    };
    vm.bemchmarkingTable = {
        order: '-visibility'
    };
    vm.siteDetailForm = {};
    vm.isSiteDetailUpdated = false;
    vm.isSiteNameEditable = currentUser.hasAdminRole();
    vm.isContactEditable = currentUser.hasAdminRole() || currentUser.hasSiteEditRole();
    vm.isDataChanged = false;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Select Tab
     */
    vm.selectTab = function(tabIndex) {
        vm.tab = tabIndex;
    };

    /**
     * Close dialog
     */
    vm.close = function() {
        if(vm.isSiteDetailUpdated) {
            $mdDialog.hide({
                mode: 'edit',
                data: vm.siteData
            });
        } else if(vm.isDataChanged) {
            $mdDialog.hide({
                mode: 'other'
            });
        } else {
            $mdDialog.hide();
        }
    };

    /**
     * Toggle left menu
     */
    vm.toggleLeft = function() {
        $mdSidenav('site-attr-left-side')
            .toggle()
            .then(function () {

            });
    };

    /**
     * Tab change listener
     */
    vm.onChangeTab = function(tabIndex) {

        if(vm.isLoading) return;

        if(vm.tab === 1 && (vm.isSiteDetailChanged() || vm.isSiteContactDetailChanged())) {
            $mdDialog.show({
                controller: CustomConfirmDialogController,
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
                locals: {
                    title: 'Updates Not Saved',
                    message: 'Would you like to save your changes before leaving?',
                    okButton: 'Save',
                    cancelButton: 'Cancel',
                    okFunc: null
                },
                parent: angular.element(document.body),
                clickOutsideToClose:false,
                escapeToClose: false,
                skipHide: true
            }).then(function(isOk){

                if(isOk) {
                    vm.saveSiteDetail();
                } else {

                    //SiteDetail Form
                    vm.siteDetailForm.siteName = vm.siteData.name;
                    if(vm.siteData.Installation && vm.siteData.Installation.Customer.contact) {
                        vm.siteDetailForm.contactName = vm.siteData.Installation.Customer.contact.name;
                        vm.siteDetailForm.contactTitle = vm.siteData.Installation.Customer.contact.title;
                        vm.siteDetailForm.contactPhone = vm.siteData.Installation.Customer.contact.phone1;
                        vm.siteDetailForm.contactEmail = vm.siteData.Installation.Customer.contact.email;
                    }

                    vm.selectTab(tabIndex);
                }
            });
        } else {
            vm.selectTab(tabIndex);
        }
    };

    /**
     * Save site detail
     */
    vm.saveSiteDetail = function() {

        var apiTasks = [];

        apiTasks.push(function(callback) {
            if(vm.isSiteDetailChanged()) {
                api.adminSites.actionById.save({
                    siteId: vm.siteData.id,
                    name: vm.siteDetailForm.siteName
                }, function(response) {
                    vm.siteData.name = vm.siteDetailForm.siteName;
                    vm.isSiteDetailUpdated = true;
                    callback(null);
                }, function(error) {
                    callback(error);
                });
            } else {
                callback(null);
            }
        });

        apiTasks.push(function(callback) {
            if(vm.isSiteContactDetailChanged()) {
                api.adminInstallations.customers.actionById.save({
                    installationId: vm.siteData.Installation.id,
                    customerId: vm.siteData.Installation.Customer.id,
                    contact: {
                        name: vm.siteDetailForm.contactName,
                        title: vm.siteDetailForm.contactTitle,
                        phone1: vm.siteDetailForm.contactPhone,
                        email: vm.siteDetailForm.contactEmail
                    }
                }, function(response) {
                    vm.siteData.Installation.Customer.contact = response.contact;
                    callback(null);
                }, function(error) {
                    callback(error);
                });
            } else {
                callback(null);
            }
        });

        vm.isDataChanged = true;
        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'site_attr_loader'});

        async.parallel(apiTasks, function(error) {
            if(error) {
                var errorMsg;
                if(error.data && error.data.message) {
                    errorMsg = error.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Updated successfully!')
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );
            }

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'site_attr_loader'});
        });

    };

    /**
     * Check if site detail changed
     */
    vm.isSiteDetailChanged = function() {

        if(vm.siteData.name !== vm.siteDetailForm.siteName) {
            return true;
        } else {
            return false;
        }
    };

    /**
     * Check if site contact changed
     */
    vm.isSiteContactDetailChanged = function() {
        var result = false;
        if(vm.siteData.Installation) {
            if(vm.siteData.Installation.Customer.contact) {
                if(vm.siteDetailForm.contactName != vm.siteData.Installation.Customer.contact.name ||
                    vm.siteDetailForm.contactTitle != vm.siteData.Installation.Customer.contact.title ||
                    vm.siteDetailForm.contactPhone != vm.siteData.Installation.Customer.contact.phone1 ||
                    vm.siteDetailForm.contactEmail != vm.siteData.Installation.Customer.contact.email) {
                    result = true;
                }
            } else {
                if(vm.siteDetailForm.contactName ||
                    vm.siteDetailForm.contactTitle ||
                    vm.siteDetailForm.contactPhone ||
                    vm.siteDetailForm.contactEmail) {
                    result = true;
                }
            }
        }
        return result;
    };

    /**
     * Open AddBadge dialog
     */
    vm.openAddBadgeDlg = function (ev, mode, badge) {

        var badgeData = {};

        if(mode === 'edit') {
            badgeData = angular.copy(badge);
        }

        $mdDialog.show({
            controller: AddBadgeDialogController,
            controllerAs: 'vm',
            locals: {
                mode: mode,
                badgeData: badgeData,
                siteData: vm.siteData
            },
            templateUrl: 'app/main/dashboard/site/add-badge-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            fullscreen: true,
            skipHide: true
        }).then(function(ret) {
            if(ret) {
                if(ret.mode === 'add') {
                    vm.siteData.SiteBadges.push(ret.data);
                } else if(ret.mode === 'edit') {
                    var index = _.findIndex(vm.siteData.SiteBadges, {id: ret.data.id});
                    if(index !== -1) {
                        vm.siteData.SiteBadges[index] = ret.data
                    }
                } else if(ret.mode === 'delete') {
                    var index = _.findIndex(vm.siteData.SiteBadges, {id: ret.data.id});
                    if(index !== -1) {
                        vm.siteData.SiteBadges.splice(index,1);
                    }
                }

                vm.isDataChanged = true;
            }
        }, function() {

        });
    };

    /**
     * Delete badge
     */
    vm.deleteBadge = function(ev, badge) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this badge?',
                okButton: 'Delete',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isDataChanged = true;

                vm.isLoading = true;
                bsLoadingOverlayService.start({referenceId: 'site_attr_loader'});

                api.adminSites.badges.actionById.remove(
                    {
                        siteId: vm.siteData.id,
                        id: badge.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'site_attr_loader'});

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Deleted successfully!')
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        var index = _.findIndex(vm.siteData.SiteBadges, {id: badge.id});
                        if(index !== -1) {
                            vm.siteData.SiteBadges.splice(index,1);
                        }

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'site_attr_loader'});

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Open ImportBadge dialog
     */
    vm.openImportBadgeDlg = function (ev) {

        $mdDialog.show({
            controller: ImportBadgeDialogController,
            controllerAs: 'vm',
            locals: {
                siteData: vm.siteData
            },
            templateUrl: 'app/main/dashboard/site/import-badge-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            fullscreen: true,
            skipHide: true
        }).then(function(ret) {
            if(ret) {
                if(ret.mode === 'upload') {
                    vm.siteData.SiteBadges = _.union(vm.siteData.SiteBadges, ret.data);
                }

                vm.isDataChanged = true;
            }
        }, function() {

        });
    };

    /**
     * Open AddShift dialog
     */
    vm.openAddShiftDlg = function (ev, mode, shift) {

        var shiftData = {};

        if(mode === 'edit') {
            shiftData = angular.copy(shift);
        }

        $mdDialog.show({
            controller: AddShiftDialogController,
            controllerAs: 'vm',
            locals: {
                mode: mode,
                shiftData: shiftData,
                siteData: vm.siteData
            },
            templateUrl: 'app/main/dashboard/site/add-shift-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            fullscreen: true,
            skipHide: true
        }).then(function(ret) {
            if(ret) {
                if(ret.mode === 'add') {
                    vm.siteData.SiteShifts.push(ret.data);
                } else if(ret.mode === 'edit') {
                    var index = _.findIndex(vm.siteData.SiteShifts, {id: ret.data.id});
                    if(index !== -1) {
                        vm.siteData.SiteShifts[index] = ret.data
                    }
                } else if(ret.mode === 'delete') {
                    var index = _.findIndex(vm.siteData.SiteShifts, {id: ret.data.id});
                    if(index !== -1) {
                        vm.siteData.SiteShifts.splice(index,1);
                    }
                }

                vm.isDataChanged = true;
            }
        }, function() {

        });
    };

    /**
     * Delete shift
     */
    vm.deleteShift = function(ev, shift) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this shift?',
                okButton: 'Delete',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isDataChanged = true;

                vm.isLoading = true;
                bsLoadingOverlayService.start({referenceId: 'site_attr_loader'});

                api.adminSites.shifts.actionById.remove(
                    {
                        siteId: vm.siteData.id,
                        shiftId: shift.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'site_attr_loader'});

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Deleted successfully!')
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        var index = _.findIndex(vm.siteData.SiteShifts, {id: shift.id});
                        if(index !== -1) {
                            vm.siteData.SiteShifts.splice(index,1);
                        }

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'site_attr_loader'});

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    vm.sendWelcomeEmail = function(user) {

        user.isLoading = true;
        var params = {
            sendWelcomeEmail: true,
            userId: user.id,
            siteId: vm.siteData.id
        };

        api.adminSites.users.actionById.save(
            params,
            // Success
            function (response)
            {
                user.isLoading = false;
                vm.msg = 'Sent successfully!';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Sent successfully!')
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );

            },
            // Error
            function (response)
            {
                console.log(response);
                user.isLoading = false;

                var errorMsg;
                if(response.data && response.data.message) {
                    errorMsg = response.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            }
        );
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Load data
     */
    function _loadData() {

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'site_attr_loader'});

        async.parallel({
            site: function(callback) {
                api.sites.actionById.get({siteId: siteId}, function (response) {
                    callback(null, response);
                }, function (error) {
                    callback(error);
                });
            }/*,
            metrics: function(callback) {
                api.siteMetrics.list.get(null, function (response) {
                    callback(null, response.rows);
                }, function (error) {
                    callback(error);
                });
            }*/
        }, function(error, results) {

            if(error) {

                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

            } else {

                vm.siteData = results.site;
                //vm.metrics = results.metrics;

                // Metrics
                /*var selectedMetrics = [];
                _.each(vm.metrics, function(metric) {
                    if(vm.siteData.metrics) {
                        if(vm.siteData.metrics[metric.name] === true) {
                            selectedMetrics.push(metric);
                        }
                    }
                });
                vm.siteData.selectedMetrics = selectedMetrics;*/

                // Benchmarking
                var noPublicBenchmarkings = 0;
                var noAnonymouseBenchmarkings = 0;
                var noAnonymouseBenchmarkingsByStats = {};

                _.each(vm.siteData.Benchmarkings, function(benchmarking) {
                    if(benchmarking.visibility === 'PUBLIC') {
                        noPublicBenchmarkings++;
                    } else if(benchmarking.visibility === 'ANONYMOUS') {
                        noAnonymouseBenchmarkings++;

                        benchmarking.BenchmarkingSite.Division.name = '-';
                        benchmarking.BenchmarkingSite.Division.Company.name = '-';

                        if(benchmarking.BenchmarkingSite.Installation) {
                            benchmarking.BenchmarkingSite.Installation.Customer.address = '-';
                            benchmarking.BenchmarkingSite.Installation.Customer.city = '-';
                            benchmarking.BenchmarkingSite.Installation.Customer.zipcode = '-';
                        }

                        //alias
                        var state;
                        if(benchmarking.BenchmarkingSite.Installation) {
                            state = benchmarking.BenchmarkingSite.Installation.Customer.state;
                        } else {
                            state = 'Anonymous';
                        }
                        if(!noAnonymouseBenchmarkingsByStats[state]) {
                            noAnonymouseBenchmarkingsByStats[state] = 0;
                        }
                        noAnonymouseBenchmarkingsByStats[state]++;
                        benchmarking.BenchmarkingSite.name = state + ' ' + noAnonymouseBenchmarkingsByStats[state];
                    }
                });
                vm.siteData.noPublicBenchmarkings = noPublicBenchmarkings;
                vm.siteData.noAnonymouseBenchmarkings = noAnonymouseBenchmarkings;


                //SiteDetail Form
                vm.siteDetailForm.siteName = vm.siteData.name;
                if(vm.siteData.Installation && vm.siteData.Installation.Customer.contact) {
                    vm.siteDetailForm.contactName = vm.siteData.Installation.Customer.contact.name;
                    vm.siteDetailForm.contactTitle = vm.siteData.Installation.Customer.contact.title;
                    vm.siteDetailForm.contactPhone = vm.siteData.Installation.Customer.contact.phone1;
                    vm.siteDetailForm.contactEmail = vm.siteData.Installation.Customer.contact.email;
                }

                //console.log(vm.siteData);
                //console.log(vm.metrics);
            }

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'site_attr_loader'});
        });
    }

    /**
     * Initialize
     */
    function _init() {
        _loadData();
    }

    _init();
}

/**
 * AddBadge Dialog Controller
 */
function AddBadgeDialogController($scope, $mdDialog, $mdToast, mode, badgeData, siteData, api, currentUser, bsLoadingOverlayService) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.mode = mode;
    vm.siteData = siteData;
    vm.badgeData = badgeData;
    vm.currentUser = currentUser;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update badge
     */
    vm.updateBadge = function() {

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'add_badge_loader'});

        if(vm.mode === 'add') {

            var params = {
                badgeId: vm.badgeData.badgeId,
                name: vm.badgeData.name,
                department: vm.badgeData.department,
                siteId: vm.siteData.id
            };

            api.adminSites.badges.list.save(
                params,
                // Success
                function (response)
                {
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_badge_loader'});
                    vm.badgeData = response;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Updated successfully!')
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'add',
                        data: vm.badgeData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_badge_loader'});

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'edit') {

            var params = {
                id: vm.badgeData.id,
                badgeId: vm.badgeData.badgeId,
                name: vm.badgeData.name,
                department: vm.badgeData.department,
                siteId: vm.siteData.id
            };

            api.adminSites.badges.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_badge_loader'});
                    vm.badgeData = response;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Updated successfully!')
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.badgeData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_badge_loader'});

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        }

    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}

/**
 * ImportBadge Dialog Controller
 */
function ImportBadgeDialogController($scope, $mdDialog, $mdToast, siteData, api, Upload, bsLoadingOverlayService) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.siteData = siteData;
    vm.badges = [];
    vm.step = 1;
    vm.csvSampleLink = api.siteBadgesCsvSample;
    vm.badgesTable = {
        order: 'ID'
    };

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };

    /**
     * File change listener
     */
    vm.onChangeFile = function($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
        if($newFiles && $newFiles.length > 0) {
            var file = $newFiles[0];
            if(!file.$error) {
                vm.file = file;
                Papa.parse(vm.file, {
                    header: true,
                    complete: function(results) {
                        vm.badges = results.data;
                        console.log(vm.badges);
                    },
                    error: function(err, file, inputElem, reason)
                    {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(err)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                });
            } else {
                var errorMsg = 'Something went wrong!';
                if(file.$error === 'maxSize') {
                    errorMsg = 'File size must be less than ' + file.$errorParam;
                } else if(file.$error === 'pattern') {
                    errorMsg = 'File type ' + file.$errorParam + ' only are available';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            }

        } else {
            //vm.file = null;
            //vm.badges = [];
        }
    };

    /**
     * Go to step
     */
    vm.gotoStep = function(step) {
        vm.step = step;
    };

    /**
     * Upload badges
     */
    vm.uploadBadges = function() {

        var params = {
            csv: vm.file
        };

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'import_badge_loader'});

        api.adminSites.badges.upload(vm.siteData.id, params).then(function(response) {

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'import_badge_loader'});

            $mdToast.show(
                $mdToast.simple()
                    .textContent('Uploaded successfully!')
                    .position('top right')
                    .hideDelay(3000)
                    .theme('success-toast')
            );

            vm.close({
                mode: 'upload',
                data: response.data
            });

        }, function(response) {
            console.log(response);

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'import_badge_loader'});

            var errorMsg;
            if(response.data && response.data.message) {
                errorMsg = response.data.message;
            } else {
                errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
                $mdToast.simple()
                    .textContent(errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
            );

        });
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}


/**
 * AddShift Dialog Controller
 */
function AddShiftDialogController($scope, $mdDialog, $mdToast, mode, shiftData, siteData, api, bsLoadingOverlayService) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.mode = mode;
    vm.siteData = siteData;
    vm.shiftData = shiftData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update badge
     */
    vm.updateShift = function() {

        if(!vm.validateDaysSelected()) return;

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'add_shift_loader'});

        if(vm.mode === 'add') {

            var params = {
                name: vm.shiftData.name,
                startTime: moment(vm.shiftData.startTime).format('h:m a'),
                endTime: moment(vm.shiftData.endTime).format('h:m a'),
                days: {
                    Sunday: vm.shiftData.days.Sunday?true:false,
                    Monday: vm.shiftData.days.Monday?true:false,
                    Tuesday: vm.shiftData.days.Tuesday?true:false,
                    Wednesday: vm.shiftData.days.Wednesday?true:false,
                    Thursday: vm.shiftData.days.Thursday?true:false,
                    Friday: vm.shiftData.days.Friday?true:false,
                    Saturday: vm.shiftData.days.Saturday?true:false
                },
                siteId: vm.siteData.id
            };

            api.adminSites.shifts.list.save(
                params,
                // Success
                function (response)
                {
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_shift_loader'});
                    vm.shiftData = response;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Updated successfully!')
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'add',
                        data: vm.shiftData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_shift_loader'});

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'edit') {

            var params = {
                name: vm.shiftData.name,
                startTime: moment(vm.shiftData.startTime).format('h:m a'),
                endTime: moment(vm.shiftData.endTime).format('h:m a'),
                days: {
                    Sunday: vm.shiftData.days.Sunday?true:false,
                    Monday: vm.shiftData.days.Monday?true:false,
                    Tuesday: vm.shiftData.days.Tuesday?true:false,
                    Wednesday: vm.shiftData.days.Wednesday?true:false,
                    Thursday: vm.shiftData.days.Thursday?true:false,
                    Friday: vm.shiftData.days.Friday?true:false,
                    Saturday: vm.shiftData.days.Saturday?true:false
                },
                shiftId: vm.shiftData.id,
                siteId: vm.siteData.id
            };

            api.adminSites.shifts.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_shift_loader'});
                    vm.shiftData = response;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Updated successfully!')
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.shiftData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_shift_loader'});

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        }

    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };

    vm.selectEveryday = function() {
        if(vm.shiftData.days.Sunday && vm.shiftData.days.Monday && vm.shiftData.days.Tuesday && vm.shiftData.days.Wednesday && vm.shiftData.days.Thursday && vm.shiftData.days.Friday && vm.shiftData.days.Saturday) {
            vm.shiftData.days.Sunday = false;
            vm.shiftData.days.Monday = false;
            vm.shiftData.days.Tuesday = false;
            vm.shiftData.days.Wednesday = false;
            vm.shiftData.days.Thursday = false;
            vm.shiftData.days.Friday = false;
            vm.shiftData.days.Saturday = false;
        } else {
            vm.shiftData.days.Sunday = true;
            vm.shiftData.days.Monday = true;
            vm.shiftData.days.Tuesday = true;
            vm.shiftData.days.Wednesday = true;
            vm.shiftData.days.Thursday = true;
            vm.shiftData.days.Friday = true;
            vm.shiftData.days.Saturday = true;
        }
        vm.validateDaysSelected();
    };

    vm.validateDaysSelected = function() {

        if(vm.shiftData.days.Sunday || vm.shiftData.days.Monday || vm.shiftData.days.Tuesday || vm.shiftData.days.Wednesday || vm.shiftData.days.Thursday || vm.shiftData.days.Friday || vm.shiftData.days.Saturday) {
            vm.isDaysInvald = false;
        } else {
            vm.isDaysInvald = true;
        }
        return !vm.isDaysInvald;
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {
        if(vm.mode === 'add') {
            vm.shiftData.days = {};
        } else if(vm.mode === 'edit') {
            vm.shiftData.startTime = new Date(moment().format('YYYY-MM-DD ') + vm.shiftData.startTime);
            vm.shiftData.endTime = new Date(moment().format('YYYY-MM-DD ') + vm.shiftData.endTime);
        }
    }

    _init();

}

function SiteAccountDialogController($scope, $filter, $mdDialog, $mdToast, $q, api, bsLoadingOverlayService)
{

    var vm = this;
    vm.accTab = AccountsTabController(vm, $scope, $filter, $mdDialog, $mdToast, api, bsLoadingOverlayService);
    vm.visTab = VisibilityTabController(vm, $scope, $filter, $mdDialog, $mdToast, api, bsLoadingOverlayService);
    vm.benTab = BenchmarkingTabController(vm, $scope, $filter, $mdDialog, $mdToast, api, bsLoadingOverlayService);


    vm.companies = [];
    vm.installations = [];
    vm.metrics = [];
    vm.visibilities = [
        { name: 'ANONYMOUS', label: 'Anonymous'},
        { name: 'PUBLIC', label: 'Public'},
        { name: 'NONE', label: 'None'}
    ];
    vm.tabIndexSelected = 0;
    vm.isDataChanged = false;

    function BenchmarkingTabController(parent, $scope, $filter, $mdDialog, $mdToast, api, bsLoadingOverlayService) {
        // ******************************
        // Variables
        // ******************************
        var vm = {};
        vm.benchmarkings = [];
        vm.benchmarkingsBackup = []; // Used to detect visibility changes
        vm.divisions = [];
        vm.sites = [];

        // Filters
        vm.companiesFilter = [];
        vm.divisionsFilter = [];
        vm.sitesFilter = [];
        vm.citiesFilter = [];
        vm.statesFilter = [];
        vm.zipsFilter = [];

        vm.benchmarkingsTable = {
            pagination: {
                lengths: [10, 20, 50, 100],
                page: 1,
                limit: 10
            },
            order: 'name',
            filters: [{
                queries: [],
                field: 'Division.Company.name'
            },{
                queries: [],
                field: 'Division.name'
            },{
                queries: [],
                field: 'name'
            },{
                queries: [],
                field: 'Installation.Customer.city'
            },{
                queries: [],
                field: 'Installation.Customer.state'
            },{
                queries: [],
                field: 'Installation.Customer.zipcode'
            }],
            selected: []
        };

        // ******************************
        // Public Methods
        // ******************************

        /**
         * Init
         */
        vm.init = function() {

        };

        /**
         * Check the row is selected
         */
        vm.isSelectedBenchmarkingsTableRows = function(site) {
            return _.findIndex(vm.benchmarkingsTable.selected, {id: site.id}) !== -1;
        };

        /**
         * Select a row in Customer table
         */
        vm.chooseBenchmarkingsTableRows = function(site) {

            var idx = _.findIndex(vm.benchmarkingsTable.selected, {id: site.id});
            if (idx !== -1) vm.benchmarkingsTable.selected.splice(idx, 1);
            else vm.benchmarkingsTable.selected.push(site);
        };

        /**
         * Validate all the rows is checked in Customer table
         */
        vm.isSelectedAllBenchmarkingsTableRows = function() {

            if(vm.benchmarkings.length === 0) return false;

            var isAll = true;
            _.every(vm.benchmarkings, function(site) {
                var idx = _.findIndex(vm.benchmarkingsTable.selected, {id: site.id});
                if (idx === -1) {
                    isAll = false;
                }
                return isAll;
            });
            return isAll;
        };

        /**
         * Check all the rows in Customer table
         */
        vm.chooseAllBenchmarkingsTableRows = function() {

            if(vm.isSelectedAllBenchmarkingsTableRows()) {
                vm.benchmarkingsTable.selected = [];
            } else {
                vm.benchmarkingsTable.selected = [];
                _.each(vm.benchmarkings, function(site){
                    vm.benchmarkingsTable.selected.push(site);
                });
            }

        };

        /**
         * Refresh company sites data
         */
        vm.refreshCompanySites = function(companyId) {
            if(vm.selectedCompany && vm.selectedCompany.id === companyId) {
                vm.searchCompany = '';
            }
        };

        /**
         * Select a site
         */
        vm.selectSite = function(companyId, siteId) {

            if(vm.selectedCompany && vm.selectedCompany.id === companyId) {
                var site = _.findWhere(vm.sites, {id: siteId});
                if(site) {
                    vm.selectedSite = site;
                }
            } else {
                var company = _.findWhere(parent.companies, {id: companyId});
                if(company) {
                    vm.selectedCompany = company;

                    //setup a flag to select site after loading
                    vm.selectedSiteId = siteId;
                }
            }
        };

        /**
         * Query companies for auto complete box
         */
        vm.queryCompany = function(query) {
            var filteredCompanies = query ? parent.companies.filter( _createFilterFor(query, 'name') ) : parent.companies;
            var sortedCompanies = _sortCaseInsensitive(filteredCompanies, 'name');
            return sortedCompanies;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedCompanyChange = function(company) {
            vm.searchDivision = '';
            vm.searchSite = '';

            vm.divisions = [];
            vm.sites = [];

            if(company) {
                _loadSitesData();
            }
        };

        /**
         * Query divisions for auto complete box
         */
        vm.queryDivision = function(query) {
            var filteredDivisions = query ? vm.divisions.filter( _createFilterFor(query, 'name') ) : vm.divisions;
            var sortedDivisions = _sortCaseInsensitive(filteredDivisions, 'name');
            return sortedDivisions;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedDivisionChange = function(division) {

            if(division) {

            } else {
                vm.searchSite = '';
            }
            //console.log('Division', division);
        };

        /**
         * Query sites for auto complete box
         */
        vm.querySite = function(query) {

            var sites = [];

            if(vm.selectedDivision) {
                sites = _.filter(vm.sites, function(site) {
                    return site.DivisionId === vm.selectedDivision.id;
                });
            } else {
                sites = vm.sites;
            }

            var filteredSites = query ? sites.filter( _createFilterFor(query, 'name') ) : sites;
            var sortedSites = _sortCaseInsensitive(filteredSites, 'name');
            return sortedSites;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedSiteChange = function(site) {

            vm.benchmarkings = [];
            vm.benchmarkingsTable.selected = [];
            vm.benchmarkingsTable.filters[0].queries = [];
            vm.benchmarkingsTable.filters[1].queries = [];
            vm.benchmarkingsTable.filters[2].queries = [];
            vm.benchmarkingsTable.filters[3].queries = [];
            vm.benchmarkingsTable.filters[4].queries = [];
            vm.benchmarkingsTable.filters[5].queries = [];

            if(site) {
                _loadBenchmarkingsData();

                // select division in filter
                if(!vm.selectedDivision) {
                    vm.selectedDivision = site.Division;
                }
            }
            //console.log('Site', site);
        };

        /**
         * Query company filters for auto complete box
         */
        vm.queryCompanyFilter = function(query) {
            var restFilters = _.reject(vm.companiesFilter, function(filter) {
                return _.indexOf(vm.benchmarkingsTable.filters[0].queries, filter) !== -1;
            });
            return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
        };

        /**
         * Listener when changed company filter
         */
        vm.onChangeCompanyFilter = function() {
            //console.log(vm.benchmarkingsTable.filters);
        };

        /**
         * Query division filters for auto complete box
         */
        vm.queryDivisionFilter = function(query) {
            var restFilters = _.reject(vm.divisionsFilter, function(filter) {
                return _.indexOf(vm.benchmarkingsTable.filters[1].queries, filter) !== -1;
            });
            return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
        };

        /**
         * Listener when changed division filter
         */
        vm.onChangeDivisionFilter = function() {
            //console.log(vm.benchmarkingsTable.filters);
        };

        /**
         * Query site filters for auto complete box
         */
        vm.querySiteFilter = function(query) {
            var restFilters = _.reject(vm.sitesFilter, function(filter) {
                return _.indexOf(vm.benchmarkingsTable.filters[2].queries, filter) !== -1;
            });
            return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
        };

        /**
         * Listener when changed site filter
         */
        vm.onChangeSiteFilter = function() {
            //console.log(vm.benchmarkingsTable.filters);
        };

        /**
         * Query city filters for auto complete box
         */
        vm.queryCityFilter = function(query) {
            var restFilters = _.reject(vm.citiesFilter, function(filter) {
                return _.indexOf(vm.benchmarkingsTable.filters[3].queries, filter) !== -1;
            });
            return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
        };

        /**
         * Listener when changed city filter
         */
        vm.onChangeCityFilter = function() {
            //console.log(vm.benchmarkingsTable.filters);
        };

        /**
         * Query state filters for auto complete box
         */
        vm.queryStateFilter = function(query) {
            var restFilters = _.reject(vm.statesFilter, function(filter) {
                return _.indexOf(vm.benchmarkingsTable.filters[4].queries, filter) !== -1;
            });
            return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
        };

        /**
         * Listener when changed state filter
         */
        vm.onChangeStateFilter = function() {
            //console.log(vm.benchmarkingsTable.filters);
        };

        /**
         * Query zip filters for auto complete box
         */
        vm.queryZipFilter = function(query) {
            var restFilters = _.reject(vm.zipsFilter, function(filter) {
                return _.indexOf(vm.benchmarkingsTable.filters[5].queries, filter) !== -1;
            });
            return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
        };

        /**
         * Listener when changed zip filter
         */
        vm.onChangeZipFilter = function() {
            //console.log(vm.benchmarkingsTable.filters);
        };


        /**
         * Change Visibility
         */
        vm.onChangeVisibility = function(site) {
            vm.updateBenchmarkings([site], site.BenchMarking.visibility);
        };

        /**
         * Update Benchmarkings
         */
        vm.updateBenchmarkings = function(sites, newVisibility) {

            //Mark as data changed to refresh after close dialog
            parent.isDataChanged = true;

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

            var tasks = [];
            _.each(sites, function(site) {
                tasks.push(function(callback) {

                    var backupIndex = _.findIndex(vm.benchmarkingsBackup, {id: site.id});
                    var benchMarking = vm.benchmarkingsBackup[backupIndex].BenchMarking;

                    if(benchMarking.visibility !== newVisibility) {
                        site.BenchMarking.isUpdating = true;

                        if(benchMarking.visibility === 'NONE') {    // Create

                            api.adminSites.benchMarkings.list.save({
                                siteId: vm.selectedSite.id,
                                visibility: newVisibility,
                                benchmarkingSiteId: site.id
                            }, function(response) {

                                site.BenchMarking.isUpdating = false;
                                site.BenchMarking.id = response.id;
                                site.BenchMarking.visibility = newVisibility;

                                benchMarking.id = response.id;
                                benchMarking.visibility = newVisibility;

                                callback(null);
                            }, function(error) {
                                site.BenchMarking.visibility = benchMarking.visibility;
                                site.BenchMarking.isUpdating = false;
                                callback(error);
                            });

                        } else if(newVisibility === 'NONE') {   // Delete

                            api.adminSites.benchMarkings.actionById.remove({
                                siteId: vm.selectedSite.id,
                                benchmarkingId: benchMarking.id
                            }, function(response) {

                                site.BenchMarking.isUpdating = false;
                                site.BenchMarking.visibility = newVisibility;

                                benchMarking.visibility = newVisibility;

                                callback(null);
                            }, function(error) {
                                site.BenchMarking.visibility = benchMarking.visibility;
                                site.BenchMarking.isUpdating = false;
                                callback(error);
                            });

                        } else {    // Update

                            api.adminSites.benchMarkings.actionById.save({
                                siteId: vm.selectedSite.id,
                                benchmarkingId: benchMarking.id,
                                visibility: newVisibility
                            }, function(response) {

                                site.BenchMarking.isUpdating = false;
                                site.BenchMarking.visibility = newVisibility;

                                benchMarking.visibility = newVisibility;

                                callback(null);
                            }, function(error) {
                                site.BenchMarking.visibility = benchMarking.visibility;
                                site.BenchMarking.isUpdating = false;
                                callback(error);
                            });
                        }

                    } else {
                        callback(null);
                    }
                });
            });

            async.parallel(tasks, function(error, results) {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

                if(error) {
                    if(error.data && error.data.message) {
                        vm.errorMsg = error.data.message;
                    } else {
                        vm.errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            });

        };

        /**
         * Open change-visibility dialog
         */
        vm.openChangeVisibilityDlg = function (ev) {
            $mdDialog.show({
                controller: ChangeVisibilityDialogController,
                controllerAs: 'vm',
                locals: {
                    visibilitiesData: parent.visibilities
                },
                templateUrl: 'app/main/dashboard/site/change-visibility-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            })
            .then(function(ret) {
                if(ret) {
                    if(ret.mode === 'edit') {
                        var filteredSites = $filter('benchBy')(vm.benchmarkingsTable.selected, vm.benchmarkingsTable.filters);
                        vm.updateBenchmarkings(filteredSites, ret.data);
                    }
                }
            }, function() {

            });
        };

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Load Benchmarkings
         */
        function _loadBenchmarkingsData() {
            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

            var params = {
                siteId: vm.selectedSite.id
            };

            api.adminSites.benchMarkings.sites.get(params, function (response) {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

                vm.benchmarkings = response.rows;

                // Backup visibilities
                _.each(vm.benchmarkings, function(one) {
                    vm.benchmarkingsBackup.push({
                        id: one.id,
                        BenchMarking: {
                            id: one.BenchMarking.id,
                            visibility: one.BenchMarking.visibility
                        }
                    });
                });

                // Get companies filter list
                var companies = _.map(vm.benchmarkings, function(one) {
                    return one.Division.Company.name;
                });
                var uniqueCompanies = _.uniq(companies);
                vm.companiesFilter = _sortCaseInsensitive(uniqueCompanies);

                // Get division filter list
                var divisions = _.map(vm.benchmarkings, function(one) {
                    return one.Division.name;
                });
                var uniqueDivisions = _.uniq(divisions);
                vm.divisionsFilter = _sortCaseInsensitive(uniqueDivisions);

                // Get site filter list
                var sites = _.map(vm.benchmarkings, function(one) {
                    return one.name;
                });
                var uniqueSites = _.uniq(sites);
                vm.sitesFilter = _sortCaseInsensitive(uniqueSites);



                var assignedBenchmarkings = _.reject(vm.benchmarkings, function(row) {
                    return !row.Installation;
                });

                // Get cities for filter
                var cities = _.map(assignedBenchmarkings, function(one) {
                    return one.Installation.Customer.city;
                });
                var uniqueCities = _.uniq(cities);
                vm.citiesFilter = _sortCaseInsensitive(uniqueCities);

                // Get states for filter
                var states = _.map(assignedBenchmarkings, function(one) {
                    return one.Installation.Customer.state;
                });
                var uniqueStates = _.uniq(states);
                vm.statesFilter = _sortCaseInsensitive(uniqueStates);

                // Get zips for filter
                var zips = _.map(assignedBenchmarkings, function(one) {
                    return one.Installation.Customer.zipcode;
                });
                var uniqueZips = _.uniq(zips);
                vm.zipsFilter = _sortCaseInsensitive(uniqueZips);

            }, function (error) {
                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});
            });
        }

        /**
         * Load Sites
         */
        function _loadSitesData() {

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

            var params = {
                companyId: vm.selectedCompany.id
            };

            api.sites.list.get(params, function (response) {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

                vm.sites = response.rows;

                // Get divisions from sites for Division filter
                var sitesDivisions = _.pluck(vm.sites, 'Division');
                var uniqueDivisions = _.uniq(sitesDivisions, function(division){
                    return division.id;
                });
                vm.divisions = _sortCaseInsensitive(uniqueDivisions, 'name');

                // *** If there is a flag to select a site ***
                if(vm.selectedSiteId) {
                    var site = _.findWhere(vm.sites, {id: vm.selectedSiteId});
                    if(site) {
                        vm.selectedSite = site;
                    }
                    vm.selectedSiteId = null;
                }

            }, function (error) {
                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});
            });
        }

        /**
         * Initialize
         */
        function _init() {

        }

        _init();
        return vm;
    }

    function VisibilityTabController(parent, $scope, $filter, $mdDialog, $mdToast, api, bsLoadingOverlayService) {

        // ******************************
        // Variables
        // ******************************
        var vm = {};

        vm.sitesTable = {
            pagination: {
                lengths: [10, 20, 50, 100],
                page: 1,
                limit: 10
            },
            order: 'InstallationId'
        };

        vm.divisions = [];
        vm.sites = [];
        vm.expendedSite = null;
        vm.isVisibilityChanged = false;

        // ******************************
        // Public Methods
        // ******************************

        /**
         * Init
         */
        vm.init = function() {

        };

        /**
         * Refresh company sites data
         */
        vm.refreshCompanySites = function(companyId) {
            if(vm.selectedCompany && vm.selectedCompany.id === companyId) {
                vm.searchCompany = '';
            }
        };

        /**
         * Select a site
         */
        vm.selectSite = function(companyId, siteId) {

            if(vm.selectedCompany && vm.selectedCompany.id === companyId) {
                var site = _.findWhere(vm.sites, {id: siteId});
                if(site) {
                    vm.selectedSite = site;
                }
            } else {
                var company = _.findWhere(parent.companies, {id: companyId});
                if(company) {
                    vm.selectedCompany = company;

                    //setup a flag to select site after loading
                    vm.selectedSiteId = siteId;
                }
            }
        };

        /**
         * Query companies for auto complete box
         */
        vm.queryCompany = function(query) {
            var filteredCompanies = query ? parent.companies.filter( _createFilterFor(query, 'name') ) : parent.companies;
            var sortedCompanies = _sortCaseInsensitive(filteredCompanies, 'name');
            return sortedCompanies;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedCompanyChange = function(company) {
            vm.searchDivision = '';
            vm.searchSite = '';

            vm.divisions = [];
            vm.sites = [];

            if(company) {
                _loadSitesData();
            }
            vm.expendSite(null, false);
        };

        /**
         * Query divisions for auto complete box
         */
        vm.queryDivision = function(query) {
            var filteredDivisions = query ? vm.divisions.filter( _createFilterFor(query, 'name') ) : vm.divisions;
            var sortedDivisions = _sortCaseInsensitive(filteredDivisions, 'name');
            return sortedDivisions;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedDivisionChange = function(division) {
            //vm.expandAllSites(false);

            if(division) {

            } else {
                vm.searchSite = '';
            }
            vm.expendSite(null, false);
            //console.log('Division', division);
        };

        /**
         * Query sites for auto complete box
         */
        vm.querySite = function(query) {

            var sites = [];

            if(vm.selectedDivision) {
                sites = _.filter(vm.sites, function(site) {
                    return site.DivisionId === vm.selectedDivision.id;
                });
            } else {
                sites = vm.sites;
            }

            var filteredSites = query ? sites.filter( _createFilterFor(query, 'name') ) : sites;
            var sortedSites = _sortCaseInsensitive(filteredSites, 'name');
            return sortedSites;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedSiteChange = function(site) {

            if(site) {

                // select division in filter
                if(!vm.selectedDivision) {
                    //vm.selectedDivision = site.Division;
                }

                //site.isExpanded = true;
                vm.expendSite(site, true);

            } else {
                //vm.expandAllSites(false);
                vm.expendSite(null, false);
            }
            //console.log('Site', site);
        };

        /**
         * Expand all the sites under selected division
         */
        vm.expandAllSites = function(expand) {
            _.each(vm.sites, function(one) {
                one.isExpanded = expand;
            });
        };

        /**
         * Expand all the sites under selected division
         */
        vm.expendSite = function(site, expand) {

            if(vm.expendedSite !== null) {
                vm.expendedSite.isExpanded = false;
            }

            if(site !== null) {
                site.isExpanded = expand;
            }

            if(expand === false) {
                vm.expendedSite = null;
            } else {
                vm.expendedSite = site;
            }
        };

        /**
         * Check if there is change in visibilities
         */

        $scope.$watch(function() {
            return vm.expendedSite;
        }, function(current, original) {

            if(vm.expendedSite !== null && vm.expendedSite.selectedMetrics) {

                // Metrics
                var isEqual = angular.equals(vm.expendedSite.selectedMetrics.items, vm.expendedSite.metrics);
                if(isEqual === false) {
                    vm.isVisibilityChanged = true;
                    return;
                }

                // Medias
                if(vm.expendedSite.selectedMedias.length !== vm.expendedSite.Medias.length) {
                    vm.isVisibilityChanged = true;
                    return;
                }
                _.each(vm.expendedSite.selectedMedias, function(media) {
                    var index = _.findIndex(vm.expendedSite.Medias, {id: media.id});
                    if(index === -1) {
                        vm.isVisibilityChanged = true;
                        return;
                    }
                });

                vm.isVisibilityChanged = false;
            }
        }, true);

        /**
         * Update Site Metrics & Medias
         */
        vm.updateSiteVisibilities = function() {

            if(vm.expendedSite === null) return;

            //Mark as data changed to refresh after close dialog
            parent.isDataChanged = true;

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

            async.parallel({
                metrics: function(callback) {

                    var params = {
                        siteId: vm.expendedSite.id,
                        metrics: vm.expendedSite.selectedMetrics.items
                    };

                    api.adminSites.metrics.save(params, function (response) {

                        vm.expendedSite.metrics = vm.expendedSite.selectedMetrics.items;

                        callback(null, response);
                    }, function (error) {
                        callback(error);
                    });
                },
                medias: function(callback) {

                    var params = {
                        siteId: vm.expendedSite.id,
                        medias: _.pluck(vm.expendedSite.selectedMedias, 'id')
                    };

                    api.adminSites.medias.save(params, function (response) {

                        vm.expendedSite.Medias = angular.copy(vm.expendedSite.selectedMedias);

                        callback(null, response);
                    }, function (error) {
                        callback(error);
                    });
                }
            }, function(error, results) {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

                if(error) {

                    if(error.data && error.data.message) {
                        vm.errorMsg = error.data.message;
                    } else {
                        vm.errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                } else {

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Updated successfully!')
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );
                }
            });
        };

        /**
         * Update a Division
         */
        vm.updateAssignData = function(data) {

            var index = _.findIndex(vm.sites, {id: data.id});

            if(index !== -1) {
                vm.sites[index].Installation = data.Installation;
                vm.sites[index].InstallationId = data.InstallationId;
            }
        };

        /**
         * Open select-installation dialog
         */
        vm.openSelectInstallationDlg = function (ev, site) {

            var siteData = angular.copy(site);

            $mdDialog.show({
                controller: SelectInstallationDialogController,
                controllerAs: 'vm',
                locals: {
                    siteData: siteData,
                    installationsData: parent.installations
                },
                templateUrl: 'app/main/dashboard/site/select-installation-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            })
            .then(function(ret) {
                if(ret) {
                    if(ret.mode === 'assign' || ret.mode === 'unassign') {
                        vm.updateAssignData(ret.data);
                    }

                    //Mark as data changed to refresh after close dialog
                    parent.isDataChanged = true;
                }
            }, function() {

            });
        };

        /**
         * Update Site Metrics & Medias - Deprecated -
         */
        vm.updateSiteMetricsMedias = function(ev, site) {

            //Mark as data changed to refresh after close dialog
            parent.isDataChanged = true;

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

            async.parallel({
                metrics: function(callback) {

                    var params = {
                        siteId: site.id,
                        metrics: site.selectedMetrics.items
                    };

                    api.adminSites.metrics.save(params, function (response) {
                        callback(null, response);
                    }, function (error) {
                        callback(error);
                    });
                },
                medias: function(callback) {

                    var params = {
                        siteId: site.id,
                        medias: _.pluck(site.selectedMedias, 'id')
                    };

                    api.adminSites.medias.save(params, function (response) {
                        callback(null, response);
                    }, function (error) {
                        callback(error);
                    });
                }
            }, function(error, results) {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

                if(error) {

                    if(error.data && error.data.message) {
                        vm.errorMsg = error.data.message;
                    } else {
                        vm.errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                } else {

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Updated successfully!')
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );
                }
            });

        };


        // ******************************
        // Internal methods
        // ******************************

        /**
         * Load data
         */
        function _loadSitesData() {

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

            var params = {
                companyId: vm.selectedCompany.id,
                includes: ["medias","installation"]
            };

            api.sites.list.get(params, function (response) {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

                _.each(response.rows, function(site) {

                    // Update dates for sort
                    if(site.Installation && site.Installation.Tank && site.Installation.Tank.iotActivationDate) {
                        site.Installation.Tank.iotActivationDateObj = new Date(site.Installation.Tank.iotActivationDate + ' 00:00:00')
                    }

                    // Update selected medias
                    site.selectedMedias = [];
                    _.each(parent.medias, function(media) {
                        var index = _.findIndex(site.Medias, {id: media.id});
                        if(index !== -1) {
                            site.selectedMedias.push(media);
                        }
                    });

                });
                vm.sites = response.rows;

                // Get divisions from sites for Division filter
                var sitesDivisions = _.pluck(vm.sites, 'Division');
                var uniqueDivisions = _.uniq(sitesDivisions, function(division){
                    return division.id;
                });
                vm.divisions = _sortCaseInsensitive(uniqueDivisions, 'name');


                // *** If there is a flag to select a site ***
                if(vm.selectedSiteId) {
                    var site = _.findWhere(vm.sites, {id: vm.selectedSiteId});
                    if(site) {
                        vm.selectedSite = site;
                    }
                    vm.selectedSiteId = null;
                }

            }, function (error) {
                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});
            });
        }

        /**
         * Initialize
         */
        function _init() {

        }

        _init();
        return vm;
    }

    function AccountsTabController(parent, $scope, $filter, $mdDialog, $mdToast, api, bsLoadingOverlayService) {

        // ******************************
        // Variables
        // ******************************
        var vm = {};

        vm.selectedCompany  = null;
        vm.searchCompany = '';
        vm.selectedDivision = null;
        vm.searchDivision = '';
        vm.selectedSite = null;
        vm.searchSite = '';
        vm.isLoading = false;
        vm.divisions = [];

        vm.divisionsTable = {
            pagination: {
                lengths: [10, 20, 50, 100],
                page: 1,
                limit: 10
            },
            order: 'name'
        };

        vm.sitesTable = {
            order: 'name'
        };
        vm.usersTable = {
            order: 'firstName'
        };


        // ******************************
        // Public Methods
        // ******************************


        /**
         * Init
         */
        vm.init = function() {

        };

        /**
         * Query companies for auto complete box
         */
        vm.queryCompany = function(query) {
            var filteredCompanies = query ? parent.companies.filter( _createFilterFor(query, 'name') ) : parent.companies;
            var sortedCompanies = _sortCaseInsensitive(filteredCompanies, 'name');
            return sortedCompanies;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedCompanyChange = function(company) {
            vm.searchDivision = '';
            vm.searchSite = '';

            vm.divisions = [];

            if(company) {
                _loadDivisionsData();
            }
        };

        /**
         * Query divisions for auto complete box
         */
        vm.queryDivision = function(query) {
            var filteredDivisions = query ? vm.divisions.filter( _createFilterFor(query, 'name') ) : vm.divisions;
            var sortedDivisions = _sortCaseInsensitive(filteredDivisions, 'name');
            return sortedDivisions;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedDivisionChange = function(division) {

            if(division) {
                division.isExpanded = true;
            } else {
                vm.expandAllDivisions(false);
                vm.searchSite = '';
            }
            //console.log('Division',division);
        };

        /**
         * Query sites for auto complete box
         */
        vm.querySite = function(query) {

            var sites;

            if(vm.selectedDivision) {
                sites = vm.selectedDivision.Sites;
            } else {
                sites = [];
                _.each(vm.divisions, function(division) {
                    _.each(division.Sites, function(site) {
                        sites.push(site);
                    });
                });
            }

            var filteredSites = query ? sites.filter( _createFilterFor(query, 'name') ) : sites;
            var sortedSites = _sortCaseInsensitive(filteredSites, 'name');
            return sortedSites;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedSiteChange = function(site) {
            vm.expandAllSites(false, vm.selectedDivision);
            if(site) {
                site.isExpanded = true;

                // select division in filter
                if(!vm.selectedDivision) {
                    vm.selectedDivision = _.find(vm.divisions, {id: site.DivisionId});
                }
            }
            //console.log('Site', site);
        };

        /**
         * Expand all the divisions under selected company
         */
        vm.expandAllDivisions = function(expand) {
            if(vm.selectedCompany) {
                _.each(vm.divisions, function(one) {
                    one.isExpanded = expand;
                });
            }
        };

        /**
         * Expand all the sites under selected division
         */
        vm.expandAllSites = function(expand, division) {
            if(division) {
                _.each(division.Sites, function(one) {
                    one.isExpanded = expand;
                });
            }
        };

        /**
         * Get a Division By Id
         */
        vm.getDivisionById = function(id) {
            return _.findWhere(vm.divisions, {id: id});
        };

        /**
         * Update a Division
         */
        vm.updateDivisionData = function(data) {

            var index = _.findIndex(vm.divisions, {id: data.id});

            if(index !== -1) {

                // update
                vm.divisions[index].name = data.name;
                vm.divisions[index].description = data.description;
                vm.divisions[index].contact = data.contact;
                vm.divisions[index].email = data.email;
                vm.divisions[index].phone = data.phone;

                // selection
                //vm.expandAllDivisions(false);
                //vm.divisions[index].isExpanded = true;
            }
        };

        /**
         * Delete a Division
         */
        vm.deleteDivisionData = function(data) {

            var index = _.findIndex(vm.divisions, {id: data.id});

            if(index !== -1) {
                vm.divisions.splice(index, 1);

                // selection
                if(vm.selectedDivision) {
                    if(vm.selectedDivision.id === data.id) {
                        vm.searchDivision = '';
                    }
                }
            }

        };

        /**
         * Add a Division
         */
        vm.addDivisionData = function(data) {

            // update lengths for sort - children
            data.sites_length = data.Sites.length;

            vm.divisions.push(data);

            // selection
            //vm.selectedDivision = data;
        };

        /**
         * Update a Site
         */
        vm.updateSiteData = function(site, updatedData) {

            var divisionIndex = -1, siteIndex = -1;

            site.name = updatedData.name;

            if(site.DivisionId !== updatedData.DivisionId) {

                var oldDivisionId = site.DivisionId;

                site.DivisionId = updatedData.DivisionId;
                var new_site = angular.copy(site);

                // Remove site from old division
                divisionIndex = _.findIndex(vm.divisions, {id: oldDivisionId});
                if(divisionIndex !== -1) {
                    siteIndex = _.findIndex(vm.divisions[divisionIndex].Sites, {id: site.id});
                    if(siteIndex !== -1) {
                        vm.divisions[divisionIndex].Sites.splice(siteIndex, 1);

                        // selection
                        if(vm.selectedSite) {
                            if(vm.selectedSite.id === site.id) {
                                vm.searchSite = '';
                            }
                        }

                        // update lengths for sort - parent
                        vm.divisions[divisionIndex].sites_length = vm.divisions[divisionIndex].Sites.length;
                    }
                }

                // Add to new division
                divisionIndex = _.findIndex(vm.divisions, {id: new_site.DivisionId});
                if(divisionIndex !== -1) {
                    vm.divisions[divisionIndex].Sites.push(new_site);

                    // update lengths for sort - parent
                    vm.divisions[divisionIndex].sites_length = vm.divisions[divisionIndex].Sites.length;
                }

            }
        };

        /**
         * Delete a Site
         */
        vm.deleteSiteData = function(data) {

            var divisionIndex = _.findIndex(vm.divisions, {id: data.DivisionId});

            if(divisionIndex !== -1) {

                var siteIndex = _.findIndex(vm.divisions[divisionIndex].Sites, {id: data.id});

                if(siteIndex !== -1) {

                    vm.divisions[divisionIndex].Sites.splice(siteIndex, 1);

                    // selection
                    if(vm.selectedSite) {
                        if(vm.selectedSite.id === data.id) {
                            vm.searchSite = '';
                        }
                    }

                    // update lengths for sort - parent
                    vm.divisions[divisionIndex].sites_length = vm.divisions[divisionIndex].Sites.length;
                }

            }

        };

        /**
         * Add a Site
         */
        vm.addSiteData = function(data) {

            var divisionIndex = _.findIndex(vm.divisions, {id: data.DivisionId});

            if(divisionIndex !== -1) {

                // update lengths for sort - children
                data.users_length = 0;

                vm.divisions[divisionIndex].Sites.push(data);
                if(vm.selectedSite) {
                    vm.selectedSite = data;
                }

                //selection
                //vm.divisions[divisionIndex].isExpanded = true;
                //vm.expandAllSites(false, vm.divisions[divisionIndex]);
                //vm.divisions[divisionIndex].Sites[vm.divisions[divisionIndex].Sites.length - 1].isExpanded = true;

                // update lengths for sort - parent
                vm.divisions[divisionIndex].sites_length = vm.divisions[divisionIndex].Sites.length;

            }

        };

        /**
         * Update a SiteUser
         */
        vm.updateSiteUserData = function(site, user) {

            var divisionIndex = _.findIndex(vm.divisions, {id: site.DivisionId});

            if(divisionIndex !== -1) {

                var siteIndex = _.findIndex(vm.divisions[divisionIndex].Sites, {id: site.id});

                if(siteIndex !== -1) {

                    var userIndex = _.findIndex(vm.divisions[divisionIndex].Sites[siteIndex].Users, {id: user.id});

                    vm.divisions[divisionIndex].Sites[siteIndex].Users[userIndex] = user;
                }
            }
        };

        /**
         * Delete a SiteUser
         */
        vm.deleteSiteUserData = function(site, user) {

            var divisionIndex = _.findIndex(vm.divisions, {id: site.DivisionId});

            if(divisionIndex !== -1) {

                var siteIndex = _.findIndex(vm.divisions[divisionIndex].Sites, {id: site.id});

                if(siteIndex !== -1) {

                    var userIndex = _.findIndex(vm.divisions[divisionIndex].Sites[siteIndex].Users, {id: user.id});

                    if(userIndex !== -1) {

                        vm.divisions[divisionIndex].Sites[siteIndex].Users.splice(userIndex, 1);

                        // update lengths for sort - parent
                        vm.divisions[divisionIndex].Sites[siteIndex].users_length = vm.divisions[divisionIndex].Sites[siteIndex].Users.length;

                    }

                }

            }

        };

        /**
         * Add a SiteUser
         */
        vm.addSiteUserData = function(site, user) {

            var divisionIndex = _.findIndex(vm.divisions, {id: site.DivisionId});

            if(divisionIndex !== -1) {

                var siteIndex = _.findIndex(vm.divisions[divisionIndex].Sites, {id: site.id});

                if(siteIndex !== -1) {

                    vm.divisions[divisionIndex].Sites[siteIndex].Users.push(user);

                    // selection
                    //vm.divisions[divisionIndex].Sites[siteIndex].isExpanded = true;

                    // update lengths for sort - parent
                    vm.divisions[divisionIndex].Sites[siteIndex].users_length = vm.divisions[divisionIndex].Sites[siteIndex].Users.length;
                }

            }

        };

        /**
         * Open add-division dialog
         */
        vm.openAddDivisionDlg = function (ev, mode, division) {

            var divisionData = {};

            if(mode === 'edit') {
                divisionData = angular.copy(division);
            }

            $mdDialog.show({
                controller: AddDivisionDialogController,
                controllerAs: 'vm',
                locals: {
                    mode: mode,
                    divisionData: divisionData,
                    companyData: vm.selectedCompany
                },
                templateUrl: 'app/main/dashboard/site/add-division-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            })
            .then(function(ret) {
                if(ret) {
                    if(ret.mode === 'add') {
                        vm.addDivisionData(ret.data);
                    } else if(ret.mode === 'edit') {
                        vm.updateDivisionData(ret.data);
                    } else if(ret.mode === 'delete') {
                        vm.deleteDivisionData(ret.data);
                    }

                    //Mark as data changed to refresh after close dialog
                    parent.isDataChanged = true;

                    //Refresh another tabs info
                    parent.visTab.refreshCompanySites(vm.selectedCompany.id);
                    parent.benTab.refreshCompanySites(vm.selectedCompany.id);
                }
            }, function() {

            });
        };

        /**
         * Open add-site dialog
         */
        vm.openAddSiteDlg = function (ev, mode, division, site) {

            var siteData = {};

            if(mode === 'edit') {
                siteData = angular.copy(site);
            }

            $mdDialog.show({
                controller: AddSiteDialogController,
                controllerAs: 'vm',
                locals: {
                    mode: mode,
                    siteData: siteData,
                    divisionData: division,
                    divisionsData: vm.divisions
                },
                templateUrl: 'app/main/dashboard/site/add-site-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            })
            .then(function(ret) {
                if(ret) {
                    if(ret.mode === 'add') {
                        vm.addSiteData(ret.data);
                    } else if(ret.mode === 'edit') {
                        vm.updateSiteData(site, ret.data);
                    } else if(ret.mode === 'delete') {
                        vm.deleteSiteData(ret.data);
                    }

                    //Mark as data changed to refresh after close dialog
                    parent.isDataChanged = true;

                    //Refresh another tabs info
                    parent.visTab.refreshCompanySites(vm.selectedCompany.id);
                    parent.benTab.refreshCompanySites(vm.selectedCompany.id);
                }
            }, function() {

            });
        };

        /**
         * Open add-site-user dialog
         */
        vm.openAddSiteUserDlg = function (ev, mode, site, user) {

            var userData = {};

            if(mode === 'edit') {
                userData = angular.copy(user);
            }

            $mdDialog.show({
                controller: AddSiteUserDialogController,
                controllerAs: 'vm',
                locals: {
                    mode: mode,
                    userData: userData,
                    siteData: site
                },
                templateUrl: 'app/main/dashboard/site/add-siteuser-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            })
            .then(function(ret) {
                if(ret) {
                    if(ret.mode === 'add') {
                        vm.addSiteUserData(site, ret.data);
                    } else if(ret.mode === 'edit') {
                        vm.updateSiteUserData(site, ret.data);
                    } else if(ret.mode === 'delete') {
                        vm.deleteSiteUserData(site, ret.data);
                    }

                    //Mark as data changed to refresh after close dialog
                    parent.isDataChanged = true;
                }
            }, function() {

            });
        };

        /**
         * Open edit-parent-administrators dialog
         */
        vm.openEditParentAdminsDlg = function (ev, site) {

            $mdDialog.show({
                controller: EditParentAdminsDialogController,
                controllerAs: 'vm',
                locals: {
                    siteData: angular.copy(site)
                },
                templateUrl: 'app/main/dashboard/site/edit-parentadmins-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            })
            .then(function(isDataChanged) {

                if(isDataChanged) {
                    //Mark as data changed to refresh after close dialog
                    parent.isDataChanged = true;
                }

            }, function() {

            });
        };

        /**
         * Open site account management dialog
         */
        vm.openSiteAttrDlg = function(ev, site, tab)
        {
            $mdDialog.show({
                controller: SiteAttributeDialogController,
                controllerAs: 'vm',
                locals: {
                    siteId: site.id,
                    tab: tab
                },
                templateUrl: 'app/main/dashboard/site/site-attribute-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            }).then(function(ret) {
                if(ret) {

                    if(ret.mode === 'edit') {

                        //Update site name
                        var divisionIndex = _.findIndex(vm.divisions, {id: site.DivisionId});
                        if(divisionIndex !== -1) {
                            var siteIndex = _.findIndex(vm.divisions[divisionIndex].Sites, {id: site.id});
                            if(siteIndex !== -1) {
                                vm.divisions[divisionIndex].Sites[siteIndex].name = ret.data.name;
                            }
                        }
                    }

                    //Mark as data changed to refresh after close dialog
                    parent.isDataChanged = true;
                }
            }, function() {

            });
        };

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Load data
         */
        function _loadDivisionsData() {

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

            var params = {
                companyId: vm.selectedCompany.id
            };

            api.adminDivisions.list.get(params, function (response) {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});


                // update lengths for sort
                _.each(response.rows, function(division) {
                    division.sites_length = division.Sites.length;
                    _.each(division.Sites, function(site) {
                        site.users_length = site.Users.length;
                    });
                });
                vm.divisions = response.rows;
                //console.log(vm.divisions);

            }, function (error) {

                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});
            });
        }

        /**
         * Initialize
         */
        function _init() {

        }

        _init();
        return vm;
    }

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Close dialog
     */
    vm.close = function() {
        $mdDialog.hide(vm.isDataChanged);
    };

    /**
     * Select tab
     */
    vm.selectTab = function(tabIndex) {
        vm.tabIndexSelected = tabIndex;
    };

    /**
     * Go to Visibility Manager with site
     */
    vm.gotoVisibilityManager = function(companyId, siteId) {
        vm.selectTab(1);
        vm.visTab.selectSite(companyId, siteId);
    };

    /**
     * Go to Benchmarking with site
     */
    vm.gotoBenchMarking = function(companyId, siteId) {
        vm.selectTab(2);
        vm.benTab.selectSite(companyId, siteId);
    };

    // ******************************
    // Internal methods
    // ******************************


    vm.transformChip = function(chip) {
        // If it is an object, it's already a known chip
        //if (angular.isObject(chip)) {
        //    return chip;
        //}
        // Otherwise, create a new one
        //return { name: chip, type: 'new' }
        return chip;
    };

    function _loadBaseData() {

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'site_account_loader'});

        async.parallel({
            companies: function(callback) {
                api.adminCompanies.list.get(null, function (response) {
                    callback(null, response.rows);
                }, function (error) {
                    callback(error);
                });
            },
            installations: function(callback) {
                api.adminInstallations.list.get(null, function (response) {
                    callback(null, response.rows);
                }, function (error) {
                    callback(error);
                });
            },
            medias: function(callback) {
                api.adminMedias.list.get(null, function (response) {
                    callback(null, response.rows);
                }, function (error) {
                    callback(error);
                });
            }/*,
            metrics: function(callback) {
                api.siteMetrics.list.get(null, function (response) {
                    callback(null, response.metrics);
                }, function (error) {
                    callback(error);
                });
            }*/
        }, function(error, results) {

            if(error) {

                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

            } else {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'site_account_loader'});

                //vm.metrics = results.metrics;
                vm.medias = _sortCaseInsensitive(results.medias, 'title');
                vm.companies = _.filter(results.companies, function(company) {
                    return company.isActive === true;
                });
                vm.installations = _.filter(results.installations, function(installation) {
                    return installation.isActive === true;
                });

                //console.log(vm.metrics);
                //console.log(vm.companies);
                //console.log(vm.installations);
                //console.log(vm.medias);
            }
        });
    }

    /**
     * Initialize
     */
    function _init() {

        _loadBaseData();
    }

    _init();

}

/**
 * Add-Division Dialog Controller
 */
function AddDivisionDialogController($scope, $mdDialog, $mdToast, api, mode, divisionData, companyData) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.mode = mode;
    vm.divisionData = divisionData;
    vm.companyData = companyData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update division
     */
    vm.updateDivision = function() {

        vm.isSaving = true;
        vm.msg = 'Updating...';

        if(vm.mode === 'add') {

            var params = {
                companyId: vm.companyData.id,
                name: vm.divisionData.name,
                description: (vm.divisionData.description)?vm.divisionData.description:null,
                contact: (vm.divisionData.contact)?vm.divisionData.contact:null,
                phone: (vm.divisionData.phone)?vm.divisionData.phone:null,
                email: (vm.divisionData.email)?vm.divisionData.email:null // as api don't allow empty string
            };

            api.adminDivisions.list.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.divisionData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'add',
                        data: vm.divisionData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'edit') {

            var params = {
                divisionId: vm.divisionData.id,
                name: vm.divisionData.name,
                description: (vm.divisionData.description)?vm.divisionData.description:null,
                contact: (vm.divisionData.contact)?vm.divisionData.contact:null,
                phone: (vm.divisionData.phone)?vm.divisionData.phone:null,
                email: (vm.divisionData.email)?vm.divisionData.email:null // as api don't allow empty string
            };

            api.adminDivisions.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.divisionData = response;

                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.divisionData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        }

    };

    /**
     * Delete division
     */
    vm.deleteDivision = function(ev) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this regional divison?',
                okButton: 'Delete',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isSaving = true;
                vm.msg = 'Deleting...';

                api.adminDivisions.actionById.remove(
                    {
                        divisionId: vm.divisionData.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isSaving = false;
                        vm.msg = 'Deleted successfully!';

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.msg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        vm.close({
                            mode: 'delete',
                            data: vm.divisionData
                        });

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isSaving = false;
                        vm.msg = '';

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}

/**
 * Add-Site Dialog Controller
 */
function AddSiteDialogController($scope, $mdDialog, $mdToast, mode, siteData, divisionData, divisionsData, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.mode = mode;
    vm.siteData = siteData;
    vm.divisionData = divisionData;
    vm.divisionsData = divisionsData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update site
     */
    vm.updateSite = function() {

        vm.isSaving = true;
        vm.msg = 'Updating...';

        if(vm.mode === 'add') {

            var params = {
                name: vm.siteName,
                divisionId: vm.divisionId
            };

            api.adminSites.list.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.siteData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'add',
                        data: vm.siteData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'edit') {

            var params = {
                siteId: vm.siteData.id,
                divisionId: vm.divisionId,
                name: vm.siteName
            };

            api.adminSites.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.siteData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.siteData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        }

    };

    /**
     * Delete site
     */
    vm.deleteSite = function(ev) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this site?',
                okButton: 'Delete Site',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isSaving = true;
                vm.msg = 'Deleting...';

                api.adminSites.actionById.remove(
                    {
                        siteId: vm.siteData.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isSaving = false;
                        vm.msg = 'Deleted successfully!';

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.msg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        vm.close({
                            mode: 'delete',
                            data: vm.siteData
                        });

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isSaving = false;
                        vm.msg = '';

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {
        if(vm.mode === 'add') {
            vm.divisionId = vm.divisionData.id;
        } else if(vm.mode === 'edit') {
            vm.siteName = vm.siteData.name;
            vm.divisionId = vm.siteData.DivisionId;
        }
    }

    _init();

}

/**
 * Add-Site-User Dialog Controller
 */
function AddSiteUserDialogController($scope, $mdDialog, $mdToast, mode, userData, siteData, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;

    vm.mode = mode;
    vm.userData = userData;
    vm.siteData = siteData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update site user
     */
    vm.updateSiteUser = function(sendWelcomeEmail) {

        vm.isSaving = true;
        vm.msg = 'Updating...';

        if(vm.mode === 'add') {

            var params = {
                firstName: vm.userData.firstName,
                lastName: vm.userData.lastName,
                email: vm.userData.email,
                sendWelcomeEmail: sendWelcomeEmail,
                siteId: vm.siteData.id
            };

            if(vm.userPassword) {
                params.password = vm.userPassword;
            }

            api.adminSites.users.list.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.userData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'add',
                        data: vm.userData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'edit') {

            var params = {
                firstName: vm.userData.firstName,
                lastName: vm.userData.lastName,
                email: vm.userData.email,
                sendWelcomeEmail: sendWelcomeEmail,
                userId: vm.userData.id,
                siteId: vm.siteData.id
            };

            if(vm.userPassword && vm.userPassword !== vm.userData.updatedAt) {
                params.password = vm.userPassword;
            }

            api.adminSites.users.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.userData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.userData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        }

    };

    /**
     * Delete site user
     */
    vm.deleteSiteUser = function(ev) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this user?',
                okButton: 'Delete User',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isSaving = true;
                vm.msg = 'Deleting...';

                api.adminSites.users.actionById.remove(
                    {
                        userId: vm.userData.id,
                        siteId: vm.siteData.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isSaving = false;
                        vm.msg = 'Deleted successfully!';

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.msg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        vm.close({
                            mode: 'delete',
                            data: vm.userData
                        });

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isSaving = false;
                        vm.msg = '';

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Close customer dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };

    /**
     * Validate password is matching with confirmation
     */
    vm.validatePasswordConfirm = function() {

        if(vm.userPassword === vm.userPasswordConfirm) {
            vm.errMsg = '';
            return true;
        } else {
            vm.errMsg = 'Password(Confirm) is not matched!';
            return false;
        }
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

        if(vm.mode === 'edit') { // Tricky to show fake password
            vm.userPassword = vm.userData.updatedAt;
            vm.userPasswordConfirm = vm.userData.updatedAt;
        } else if(vm.mode === 'add') {
            vm.userPassword = '';
            vm.userPasswordConfirm = '';
        }
    }

    _init();

}

/**
 * Select-Installation Dialog Controller
 */
function SelectInstallationDialogController($scope, $mdDialog, $mdToast, siteData, installationsData, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.siteData = siteData;
    vm.installationsData = installationsData;

    vm.oldInstallationId = (vm.siteData.InstallationId)?vm.siteData.InstallationId:'null';
    vm.newInstallationId = vm.oldInstallationId;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Assign / Un-assign installation
     */
    vm.selectInstallation = function() {

        if(vm.oldInstallationId !== 'null' && vm.newInstallationId === 'null') { //Unassign

            vm.isSaving = true;
            vm.msg = 'Updating...';

            var params = {
                siteId: vm.siteData.id,
                installationId: vm.oldInstallationId
            };
            api.adminSites.unassign.save(params, function (response) {
                vm.isSaving = false;
                vm.siteData = response;
                vm.msg = 'Updated successfully!';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.msg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );

                vm.close({
                    mode: 'unassign',
                    data: vm.siteData
                });
            }, function (response) {
                console.log(response);
                vm.isSaving = false;
                vm.msg = '';

                var errorMsg;
                if(response.data && response.data.message) {
                    errorMsg = response.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            });

        } else if(vm.newInstallationId !== 'null') {

            vm.isSaving = true;
            vm.msg = 'Updating...';

            var params = {
                siteId: vm.siteData.id,
                installationId: vm.newInstallationId
            };
            api.adminSites.assign.save(params, function (response) {
                vm.isSaving = false;
                vm.siteData = response;
                vm.msg = 'Updated successfully!';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.msg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );

                vm.close({
                    mode: 'assign',
                    data: vm.siteData
                });
            }, function (response) {
                console.log(response);
                vm.isSaving = false;
                vm.msg = '';

                var errorMsg;
                if(response.data && response.data.message) {
                    errorMsg = response.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            });

        }

    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}

/**
 * Change-Visibility Dialog Controller
 */
function ChangeVisibilityDialogController($scope, $mdDialog, $mdToast, visibilitiesData, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.visibilitiesData = visibilitiesData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update visibility
     */
    vm.updateVisibility = function() {
        vm.close({
            mode: 'edit',
            data: vm.visibility
        });
    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}

/**
 * Edit-Parent-Administrators Dialog Controller
 */
function EditParentAdminsDialogController($scope, $mdDialog, $mdToast, siteData, api, bsLoadingOverlayService) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.isLoading = false;
    vm.siteData = siteData;
    vm.adminGroups = [];
    vm.adminUsers = [];
    vm.isDataChanged = false;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update a AdminGroup
     */
    vm.updateAdminGroupData = function(data) {

        var index = _.findIndex(vm.adminGroups, {id: data.id});

        if(index !== -1) {
            vm.adminGroups[index] = data;
        }
    };

    /**
     * Delete a AdminGroup
     */
    vm.deleteAdminGroupData = function(data) {

        var index = _.findIndex(vm.adminGroups, {id: data.id});

        if(index !== -1) {
            vm.adminGroups.splice(index, 1);
        }
    };

    /**
     * Delete a AdminGroupUser
     */
    vm.deleteAdminGroupUserData = function(groupData, userData) {

        var groupIndex = _.findIndex(vm.adminGroups, {id: groupData.id});

        if(groupIndex !== -1) {

            var userIndex = _.findIndex(vm.adminGroups[groupIndex].Users, {id: userData.id});

            if(userIndex !== -1) {

                vm.adminGroups[groupIndex].Users.splice(userIndex, 1);
            }
        }
    };

    /**
     * Add a AdminGroup
     */
    vm.addAdminGroupData = function(data) {

        vm.adminGroups.push(data);
    };

    /**
     * Remove a admin user
     */
    vm.removeAdminGroupUser = function(ev, groupData, userData) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Removal confirmation',
                message: 'Are you sure you want to unassign this administrator?',
                okButton: 'Delete',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk) {
            if(isOk) {

                vm.isDataChanged = true;

                vm.isLoading = true;
                bsLoadingOverlayService.start({referenceId: 'admin_groups_loader'});

                var params = {
                    siteId: vm.siteData.id,
                    groupId: groupData.id,
                    userId: userData.id
                };

                api.adminSites.adminGroups.users.actionById.remove(params, function (response) {

                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'admin_groups_loader'});

                    vm.deleteAdminGroupUserData(groupData, userData);

                }, function (response) {

                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'admin_groups_loader'});

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                });
            }
        });
    };

    /**
     * Open add-admin-group dialog
     */
    vm.openAddAdminGroupDlg = function (ev, mode, group) {

        var adminGroupData = {
            Users: []
        };

        if(mode === 'edit') {
            adminGroupData = angular.copy(group);
        }

        $mdDialog.show({
            controller: AddAdminGroupDialogController,
            controllerAs: 'vm',
            locals: {
                mode: mode,
                adminGroupData: adminGroupData,
                adminUsersData: vm.adminUsers,
                siteData: vm.siteData
            },
            templateUrl: 'app/main/dashboard/site/add-admingroup-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            fullscreen: true,
            skipHide: true
        })
        .then(function(ret) {
            if(ret) {
                if(ret.mode === 'add') {
                    vm.addAdminGroupData(ret.data);
                } else if(ret.mode === 'edit') {
                    vm.updateAdminGroupData(ret.data);
                } else if(ret.mode === 'delete') {
                    vm.deleteAdminGroupData(ret.data);
                }

                vm.isDataChanged = true;
            }
        }, function() {

        });
    };

    /**
     * Close dialog
     */
    vm.close = function() {
        $mdDialog.hide(vm.isDataChanged);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Load data
     */
    function _loadData() {

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'admin_groups_loader'});

        async.parallel({
            adminUsers: function(callback) {
                api.adminUsers.list.get(null, function (response) {
                    callback(null, response.rows);
                }, function (error) {
                    callback(error);
                });
            },
            adminGroups: function(callback) {
                var params = {
                    siteId: vm.siteData.id
                };

                api.adminSites.adminGroups.list.get(params, function (response) {
                    callback(null, response.rows);
                }, function (error) {
                    callback(error);
                });
            }
        }, function(error, results) {

            if(error) {

                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'admin_groups_loader'});

            } else {

                vm.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'admin_groups_loader'});

                vm.adminGroups = results.adminGroups;
                vm.adminUsers = results.adminUsers;

                //console.log(vm.adminGroups);
                //console.log(vm.adminUsers);
            }
        });

    }

    /**
     * Initialize
     */
    function _init() {

        _loadData();
    }

    _init();

}

/**
 * Add-AdminGroup Dialog Controller
 */
function AddAdminGroupDialogController($scope, $filter, $mdDialog, $mdToast, mode, adminGroupData, adminUsersData, siteData, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.mode = mode;
    vm.adminGroupData = adminGroupData;
    vm.adminUsersData = adminUsersData;
    vm.siteData = siteData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update admin group
     */
    vm.updateAdminGroup = function() {

        vm.isSaving = true;
        vm.msg = 'Updating...';

        if(vm.mode === 'add') {

            var params = {
                name: vm.adminGroupData.groupName,
                usersId: _.pluck(vm.adminGroupData.Users, 'id'),
                siteId: vm.siteData.id
            };

            api.adminSites.adminGroups.list.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.adminGroupData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'add',
                        data: vm.adminGroupData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        } else if(vm.mode === 'edit') {

            var params = {
                name: vm.adminGroupData.groupName,
                usersId: _.pluck(vm.adminGroupData.Users, 'id'),
                siteId: vm.siteData.id,
                groupId: vm.adminGroupData.id
            };

            api.adminSites.adminGroups.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isSaving = false;
                    vm.adminGroupData = response;
                    vm.msg = 'Updated successfully!';

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.msg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.adminGroupData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSaving = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        }

    };

    /**
     * Delete admin group
     */
    vm.deleteAdminGroup = function(ev) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this group?',
                okButton: 'Delete',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isSaving = true;
                vm.msg = 'Deleting...';

                api.adminSites.adminGroups.actionById.remove(
                    {
                        siteId: vm.siteData.id,
                        groupId: vm.adminGroupData.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isSaving = false;
                        vm.msg = 'Deleted successfully!';

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(vm.msg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        vm.close({
                            mode: 'delete',
                            data: vm.adminGroupData
                        });

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isSaving = false;
                        vm.msg = '';

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

        // Generate Roles as string for sort
        _.each(vm.adminUsersData, function(user) {
            user.role = $filter('pluckJoin')(user.Roles, 'id', 'title');
        });
    }

    _init();

}

/**
 * Support Contact Dialog Controller
 */
function SupportContactDialogController($scope, $mdDialog, group, contact) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.group = group;
    vm.contact = contact;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Close dialog
     */
    vm.close = function() {
        $mdDialog.hide();
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}

/**
 * Sort array case insensitive
 */
function _sortCaseInsensitive(arr, field) {
    if(field) {
        return _.sortBy(arr, function(one) {
            return one[field].toLowerCase();
        });
    } else {
        return _.sortBy(arr, function(one) {
            return one.toLowerCase();
        });
    }
}

/**
 * Create filter function for a query string
 */
function _createFilterFor(query, field) {
    var lowercaseQuery = angular.lowercase(query);

    if(field) {
        return function filterFn(item) {
            return (item[field].toLowerCase().indexOf(lowercaseQuery) !== -1);
        };
    } else {
        return function filterFn(item) {
            return (item.toLowerCase().indexOf(lowercaseQuery) !== -1);
        };
    }
}

function MediaManagerDialogController($scope, $mdDialog, $mdToast, $q, bsLoadingOverlayService, api, currentUser)
{

    // ******************************
    // Variables
    // ******************************

    var vm = this;
    vm.isDataChanged = false;
    vm.currentUser = currentUser;
    vm.hostUrl = api.hostUrl;
    vm.mediaTable = {
      order: 'title'
    };

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Open UploadMedia dialog
     */
    vm.openUploadMediaDlg = function (ev) {

      $mdDialog.show({
          controller: UploadMediaDialogController,
          controllerAs: 'vm',
          templateUrl: 'app/main/dashboard/media-manager/upload-media-dialog.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          escapeToClose: false,
          fullscreen: true,
          skipHide: true
        })
        .then(function(ret) {
            if(ret) {
                if(ret.mode === 'upload') {
                    vm.medias.push(ret.data);
                }
                vm.isDataChanged = true;
            }
        }, function() {

        });
    };

    /**
     * Open AddMedia dialog
     */
    vm.openAddMediaDlg = function (ev, mode, media) {

        var mediaData = {};

        if(mode === 'edit') {
            mediaData = angular.copy(media);
        }

        $mdDialog.show({
            controller: AddMediaDialogController,
            controllerAs: 'vm',
            locals: {
                mode: mode,
                mediaData: mediaData
            },
            templateUrl: 'app/main/dashboard/media-manager/add-media-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            fullscreen: true,
            skipHide: true
        }).then(function(ret) {
            if(ret) {
                if(ret.mode === 'edit') {
                    var index = _.findIndex(vm.medias, {id: ret.data.id});
                    if(index !== -1) {
                        vm.medias[index] = ret.data
                    }
                } else if(ret.mode === 'delete') {
                    var index = _.findIndex(vm.medias, {id: ret.data.id});
                    if(index !== -1) {
                        vm.medias.splice(index,1);
                    }
                }
                vm.isDataChanged = true;
            }
        }, function() {

        });
    };

    /**
     * Delete media
     */
    vm.deleteMedia = function(ev, media) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this training material?',
                okButton: 'Delete',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isDataChanged = true;

                vm.isLoading = true;
                bsLoadingOverlayService.start({referenceId: 'media_manager_loader'});

                api.adminMedias.actionById.remove(
                    {
                        mediaId: media.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'media_manager_loader'});

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Deleted successfully!')
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        var index = _.findIndex(vm.medias, {id: media.id});
                        if(index !== -1) {
                            vm.medias.splice(index,1);
                        }

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'media_manager_loader'});

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Close dialog
     */
    vm.close = function() {
        $mdDialog.hide(vm.isDataChanged);
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Load user data
     */
    function _loadMediasData() {

      vm.isLoading = true;
      bsLoadingOverlayService.start({referenceId: 'media_manager_loader'});

      api.adminMedias.list.get(
        null,
        // Success
        function (response)
        {
          vm.isLoading = false;
          bsLoadingOverlayService.stop({referenceId: 'media_manager_loader'});
          vm.medias = response.rows;

        },
        // Error
        function (response)
        {
          console.log(response);
          vm.isLoading = false;
          bsLoadingOverlayService.stop({referenceId: 'media_manager_loader'});

          var errorMsg;
          if(response.data && response.data.message) {
            errorMsg = response.data.message;
          } else {
            errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );
        }
      );
    }

    /**
     * Initialize
     */
    function _init() {

        _loadMediasData();
    }

    _init();

}

/**
 * Upload Media Dialog Controller
 */
function UploadMediaDialogController($scope, $mdDialog, $mdToast, $filter, bsLoadingOverlayService, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;
    vm.step = 1;
    vm.media = {};

    // ******************************
    // Public Methods
    // ******************************

    /**
     * File change listener
     */
    vm.onChangeFile = function($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {

        /*if($newFiles && $newFiles.length > 0 && !$newFiles[0].$error) {
            vm.media.file = $newFiles[0];
        } else {
            vm.media.file = null;
        }*/

        if($newFiles && $newFiles.length > 0) {
            var file = $newFiles[0];
            if(!file.$error) {
                vm.media.file = file;
            } else {
                var errorMsg = 'Something went wrong!';
                if(file.$error === 'maxSize') {
                    errorMsg = 'File size must be less than ' + file.$errorParam;
                } else if(file.$error === 'pattern') {
                    errorMsg = 'File type ' + file.$errorParam + ' only are available';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            }
        }
    };

    /**
     * Go to step
     */
    vm.gotoStep = function(step) {
        vm.step = step;

        if(step === 1) {

        } else if(step === 2) {
            vm.determinateValue = 0;
        }
    };


    /**
     * Upload media
     */
    vm.uploadMedia = function() {

        var params = {
            title: vm.media.title
        };

        if(vm.media.description) params.description = vm.media.description;
        if(vm.media.version) params.version = vm.media.version;

        if(vm.isLink === true) {
            params.videoUrl = vm.media.videoUrl;
        } else {
            params.file = vm.media.file;
            params.fileType = $filter('fileExt')(vm.media.file.name, true);
        }

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'upload_media_loader'});

        api.adminMedias.upload(params).then(function(response) {

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'upload_media_loader'});

            $mdToast.show(
                $mdToast.simple()
                    .textContent('Uploaded successfully!')
                    .position('top right')
                    .hideDelay(3000)
                    .theme('success-toast')
            );

            vm.close({
                mode: 'upload',
                data: response.data
            });

        }, function(response) {
            console.log(response);

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'upload_media_loader'});

            var errorMsg;
            if(response.data && response.data.message) {
                errorMsg = response.data.message;
            } else {
                errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
                $mdToast.simple()
                    .textContent(errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
            );

        }, function(evt) {
            vm.determinateValue = parseInt(100.0 * evt.loaded / evt.total);
        });
    };

    /**
     * Close customer dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}


/**
 * Add Media Dialog Controller
 */
function AddMediaDialogController($scope, $mdDialog, $filter, $mdToast, bsLoadingOverlayService, mode, mediaData, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.mode = mode;
    vm.mediaData = mediaData;

    vm.companies = [];
    vm.sites = [];
    vm.divisions = [];
    vm.selectedSite = null;
    vm.isLoading = true;
    vm.companiesFilter = [];
    vm.divisionsFilter = [];
    vm.sitesFilter = [];
    vm.sitesBackup = []; // Used to detect visibility changes

    vm.visibilities = [
        { name: 'NONE', label: 'None'},
        { name: 'VISIBLE', label: 'Visible'},
    ];

    vm.sitesTable = {
        pagination: {
            lengths: [10, 20, 50, 100],
            page: 1,
            limit: 10
        },
        order: 'name',
        filters: [{
            queries: [],
            field: 'Division.Company.name'
        },{
            queries: [],
            field: 'Division.name'
        },{
            queries: [],
            field: 'name'
        }],
        selected: []
    };

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update media
     */
    vm.updateMedia = function() {

        if(vm.mode === 'edit') {

            vm.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'add_media_loader'});

            var params = {
                mediaId: vm.mediaData.id,
                title: vm.mediaData.title,
                description: vm.mediaData.description,
                version: vm.mediaData.version
            };

            api.adminMedias.actionById.save(
                params,
                // Success
                function (response)
                {
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_media_loader'});
                    vm.mediaData = response;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Updated successfully!')
                            .position('top right')
                            .hideDelay(3000)
                            .theme('success-toast')
                    );

                    vm.close({
                        mode: 'edit',
                        data: vm.mediaData
                    });

                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'add_media_loader'});

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );

        }

    };

    /**
     * Delete media
     */
    vm.deleteMedia = function(ev) {

        $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
                title: 'Delete confirmation',
                message: 'Are you sure you want to delete this training material?',
                okButton: 'Delete',
                cancelButton: 'Cancel',
                okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
        }).then(function(isOk){

            if(isOk) {

                vm.isLoading = true;
                bsLoadingOverlayService.start({referenceId: 'add_media_loader'});

                api.adminMedias.actionById.remove(
                    {
                        mediaId: vm.mediaData.id
                    },
                    // Success
                    function (response)
                    {
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'add_media_loader'});

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Deleted successfully!')
                                .position('top right')
                                .hideDelay(3000)
                                .theme('success-toast')
                        );

                        vm.close({
                            mode: 'delete',
                            data: vm.mediaData
                        });

                    },
                    // Error
                    function (response)
                    {
                        console.log(response);
                        vm.isLoading = false;
                        bsLoadingOverlayService.stop({referenceId: 'add_media_loader'});

                        var errorMsg;
                        if(response.data && response.data.message) {
                            errorMsg = response.data.message;
                        } else {
                            errorMsg = 'Something went wrong!';
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(errorMsg)
                                .position('top right')
                                .hideDelay(3000)
                                .theme('error-toast')
                        );
                    }
                );

            }
        });
    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };

    // CO12
    /**
     * Validate all the rows is checked in Customer table
     */
    vm.isSelectedAllSitesTableRows = function() {

        if(vm.sites.length === 0) return false;

        var isAll = true;
        _.every(vm.sites, function(site) {
            var idx = _.findIndex(vm.sitesTable.selected, {id: site.id});
            if (idx === -1) {
                isAll = false;
            }
            return isAll;
        });
        return isAll;
    };

    /**
     * Check all the rows in Customer table
     */
    vm.chooseAllSitesTableRows = function() {

        if(vm.isSelectedAllSitesTableRows()) {
            vm.sitesTable.selected = [];
        } else {
            vm.sitesTable.selected = [];
            _.each(vm.sites, function(site){
                vm.sitesTable.selected.push(site);
            });
        }

    };

    /**
     * Open change-visibility dialog
     */
    vm.openChangeVisibilityDlg = function (ev) {
        $mdDialog.show({
            controller: ChangeVisibilityDialogController,
            controllerAs: 'vm',
            locals: {
                visibilitiesData: vm.visibilities
            },
            templateUrl: 'app/main/dashboard/site/change-visibility-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            fullscreen: true,
            skipHide: true
        })
        .then(function(ret) {
            if(ret) {
                if(ret.mode === 'edit') {
                    var filteredSites = $filter('benchBy')(vm.sitesTable.selected, vm.sitesTable.filters);
                    vm.updateSitesMedias(filteredSites, ret.data);
                }
            }
        }, function() {

        });
    };

    /**
     * Query companies for auto complete box
     */
    vm.queryCompany = function(query) {
        var filteredCompanies = query ? parent.companies.filter( _createFilterFor(query, 'name') ) : parent.companies;
        var sortedCompanies = _sortCaseInsensitive(filteredCompanies, 'name');
        return sortedCompanies;
    };

    function _loadCompanies() {
        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'add_media_loader'});

        api.adminCompanies.list.get(null, function (response) {
            vm.companies = _.filter(response.rows, function(company) {
                return company.isActive === true;
            });
            vm.companiesFilter = _sortCaseInsensitive(vm.companies, 'name').map(function(company) {
                return company.name
            })

            _loadSitesData()
            // vm.companiesFilter = _sortCaseInsensitive(vm.companies, 'name');
        }, function (error) {
            console.log('Error: ', error)
        });
    }

    /**
     * Query company filters for auto complete box
     */
    vm.queryCompanyFilter = function(query) {
        var restFilters = _.reject(vm.companiesFilter, function(filter) {
            return _.indexOf(vm.sitesTable.filters[0].queries, filter) !== -1;
        });
        return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
    };

    /**
     * Listener when changed company filter
     */
    vm.onChangeCompanyFilter = function() {
        //console.log(vm.sitesTable.filters);
    };

    /**
     * Query division filters for auto complete box
     */
    vm.queryDivisionFilter = function(query) {
        var restFilters = _.reject(vm.divisionsFilter, function(filter) {
            return _.indexOf(vm.sitesTable.filters[1].queries, filter) !== -1;
        });
        return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
    };

    /**
     * Listener when changed division filter
     */
    vm.onChangeDivisionFilter = function() {
        //console.log(vm.sitesTable.filters);
    };

    /**
     * Change Visibility
     */
    vm.onChangeVisibility = function(site) {
        vm.updateSitesMedias([site], site.visibility);
    };

    /**
     * Query site filters for auto complete box
     */
    vm.querySiteFilter = function(query) {
        var restFilters = _.reject(vm.sitesFilter, function(filter) {
            return _.indexOf(vm.sitesTable.filters[2].queries, filter) !== -1;
        });
        return query ? restFilters.filter( _createFilterFor(query) ) : restFilters;
    };

    /**
     * Listener when changed site filter
     */
    vm.onChangeSiteFilter = function() {
        //console.log(vm.sitesTable.filters);
    };

    /**
     * Check the row is selected
     */
    vm.isSelectedSitesTableRows = function(site) {
        return _.findIndex(vm.sitesTable.selected, {id: site.id}) !== -1;
    };

    /**
     * Select a row in Customer table
     */
    vm.chooseSitesTableRows = function(site) {
        var idx = _.findIndex(vm.sitesTable.selected, {id: site.id});
        if (idx !== -1) vm.sitesTable.selected.splice(idx, 1);
        else vm.sitesTable.selected.push(site);
    };

    /**
     * Load Sites
     */
    function _loadSitesData() {

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'add_media_loader'});

        var params = {
            mediaId: vm.mediaData.id
        };

        api.sites.list.get(params, function (response) {

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'add_media_loader'});

            // vm.sites = response.rows;
            var sites = []
            response.rows.forEach(function(site){
                site.Division.Company = vm.companies.find(function(company) {
                    return company.id == site.Division.CompanyId
                })
                site.visibility = 'NONE'
                if (site.Medias.length > 0) {
                    site.visibility = 'VISIBLE'
                }
                sites.push(site)
            })

            vm.sites = sites
            
            // Backup visibilities
            setupSitesBackup()
            

            /////
            // Get companies filter list
            var companies = _.map(vm.companies, function(company) {
                return company.name;
            });
            var uniqueCompanies = _.uniq(companies);
            vm.companiesFilter = _sortCaseInsensitive(uniqueCompanies);

            // Get division filter list
            var divisions = _.map(vm.sites, function(site) {
                return site.Division.name;
            });
            var uniqueDivisions = _.uniq(divisions);
            vm.divisionsFilter = _sortCaseInsensitive(uniqueDivisions);

            // Get site filter list
            var sites = _.map(vm.sites, function(site) {
                return site.name;
            });
            var uniqueSites = _.uniq(sites);
            vm.sitesFilter = _sortCaseInsensitive(uniqueSites);
            /////


            // Get divisions from sites for Division filter
            var sitesDivisions = _.pluck(vm.sites, 'Division');
            var uniqueDivisions = _.uniq(sitesDivisions, function(division){
                return division.id;
            });
            vm.divisions = _sortCaseInsensitive(uniqueDivisions, 'name');

            // *** If there is a flag to select a site ***
            if(vm.selectedSiteId) {
                var site = _.findWhere(vm.sites, {id: vm.selectedSiteId});
                if(site) {
                    vm.selectedSite = site;
                }
                vm.selectedSiteId = null;
            }

        }, function (error) {
            if(error.data && error.data.message) {
                vm.errorMsg = error.data.message;
            } else {
                vm.errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
            );

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'add_media_loader'});
        });
    }

    vm.updateSitesMedias = function(selectedSites, newVisibility) {
        //Mark as data changed to refresh after close dialog
        parent.isDataChanged = true;

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId: 'add_media_loader'});

        var visibleSiteIds = []
        _.each(vm.sitesBackup, function(site) {
            if (site.visibility === 'VISIBLE') {
                visibleSiteIds.push(site.id)
            }
        });

        _.each(selectedSites, function(sSite) {
            if(newVisibility === 'NONE') {
                visibleSiteIds = _.reject(visibleSiteIds, function(id) { return id === sSite.id })
            } else {
                visibleSiteIds.push(sSite.id)
            }
        })
        visibleSiteIds = _.uniq(visibleSiteIds)

        api.adminMedias.sites.save({
            mediaId: vm.mediaData.id,
            sites: visibleSiteIds
        }, function(response) {
            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId: 'add_media_loader'});


            vm.sites = _.map(vm.sites, function(site) {
                site.visibility = 'NONE';
                if (visibleSiteIds.indexOf(site.id) >= 0) {
                    site.visibility = 'VISIBLE';
                }
                return site;
            })

            // Backup updated visibilities
            setupSitesBackup()

            $mdToast.show(
                $mdToast.simple()
                    .textContent('Updated successfully!')
                    .position('top right')
                    .hideDelay(3000)
                    .theme('success-toast')
            );

            
        }, function(error) {
            if(error.data && error.data.message) {
                vm.errorMsg = error.data.message;
            } else {
                vm.errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
                $mdToast.simple()
                    .textContent(vm.errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
            );

        });
    };

    function setupSitesBackup() {
        vm.sitesBackup = [];
        _.each(vm.sites, function(site) {
            vm.sitesBackup.push({
                id: site.id,
                visibility: site.visibility
            });
        });
    }

    // END CO12


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {
        _loadCompanies()
        // _loadSitesData()
    }

    _init();

}

/**
 * Change-Visibility Dialog Controller
 */
function ChangeVisibilityDialogController($scope, $mdDialog, $mdToast, visibilitiesData, api) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.isSaving = false;
    vm.visibilitiesData = visibilitiesData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update visibility
     */
    vm.updateVisibility = function() {
        vm.close({
            mode: 'edit',
            data: vm.visibility
        });
    };

    /**
     * Close dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

    }

    _init();

}

/**
 * Sort array case insensitive
 */
function _sortCaseInsensitive(arr, field) {
    if(field) {
        return _.sortBy(arr, function(one) {
            return one[field].toLowerCase();
        });
    } else {
        return _.sortBy(arr, function(one) {
            return one.toLowerCase();
        });
    }
}

/**
 * Create filter function for a query string
 */
function _createFilterFor(query, field) {
    var lowercaseQuery = angular.lowercase(query);

    if(field) {
        return function filterFn(item) {
            return (item[field].toLowerCase().indexOf(lowercaseQuery) !== -1);
        };
    } else {
        return function filterFn(item) {
            return (item.toLowerCase().indexOf(lowercaseQuery) !== -1);
        };
    }
}

function HolidayDialogController($scope, $mdDialog, $mdToast, $q, api, currentUser)
{

    // ******************************
    // Variables
    // ******************************

    var vm = this;
    vm.currentUser = currentUser;
    vm.isHolidayChanged = false;

    vm.calendarUiConfig = {
      calendar: {
        editable          : false,
        eventLimit        : true,
        header            : '',
        handleWindowResize: false,
        aspectRatio       : 2,
        dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        viewRender        : function (view)
        {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;

          var currentYear = parseInt(vm.calendar.getDate().format('YYYY'));
          var currentMonth = parseInt(vm.calendar.getDate().format('M'));

          //Update repeat events for every year
          var rows_repeat = [];

          for(var i = vm.holidaysData.rows.length-1;i>=0;i--) {

              if(vm.holidaysData.rows[i].repeat && vm.holidaysData.rows[i].repeat == 1) {
                rows_repeat.push(vm.holidaysData.rows[i]);
                vm.holidaysData.rows.splice(i,1);
              }
          }

          _.each(rows_repeat, function(row) {

            var new_row = {};
            new_row.id = row.id;
            new_row.title = row.title;
            new_row.repeat = row.repeat;

            var eventMonth = moment(row.start).format('M');

            if(currentMonth == 1 && eventMonth == 12) {
              new_row.start = (currentYear-1) + moment(row.start).format('-MM-DD');
            } else if(currentMonth == 12 && eventMonth == 1) {
              new_row.start = (currentYear+1) + moment(row.start).format('-MM-DD');
            } else {
              new_row.start = currentYear + moment(row.start).format('-MM-DD');
            }

            if(row.end && row.end != null && row.end != 'Invalid date') {

              eventMonth = moment(row.end).format('M');

              if(currentMonth == 1 && eventMonth == 12) {
                new_row.end = (currentYear-1) + moment(row.end).format('-MM-DD');
              } else if(currentMonth == 12 && eventMonth == 1) {
                new_row.end = (currentYear+1) + moment(row.end).format('-MM-DD');
              } else {
                new_row.end = currentYear + moment(row.end).format('-MM-DD');
              }

            }
            vm.holidaysData.rows.push(new_row);

          });

          //console.log(vm.holidaysData.rows);

        },
        columnFormat      : {
          month: 'ddd',
          week : 'ddd D',
          day  : 'ddd M'
        },
        eventClick        : function(calendarObj, e) {
          //console.log(calendarObj);
          vm.openAddDlg(e, 'edit', {
            id: calendarObj.id,
            title: calendarObj.title,
            start: moment(calendarObj.start.format('YYYY-MM-DD')),
            end: calendarObj.end == null?null:moment(calendarObj.end.format('YYYY-MM-DD')).subtract(1,'days'),
            repeat: calendarObj.repeat
          });
        },
        selectable        : true,
        selectHelper      : true,
        select            : function(start, end, e) {
          vm.openAddDlg(e, 'add', {
            start: moment(start.format('YYYY-MM-DD')),
            repeat: 1
          });
        }
      }
    };

    // ******************************
    // Public Methods
    // ******************************


    /**
     * Event source function
     */
    vm.events = function(start, end, timezone, callback) {
      //console.log(start, end, timezone);
      callback(vm.holidaysData.rows);
    };

    /**
     * Open add dialog
     */
    vm.openAddDlg = function (ev, mode, data) {

      if(!vm.currentUser.hasAdminRole()) return;

      $mdDialog.show({
          controller: AddHolidayDialogController,
          controllerAs: 'vm',
          locals: {
            mode: mode,
            holidayData: data
          },
          templateUrl: 'app/main/dashboard/holiday/holiday-dialog-add.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          escapeToClose: false,
          fullscreen: true,
          skipHide: true
        })
        .then(function(ret) {
          if(ret) {
            if(ret.mode == 'add') {
              vm.addHolidayToCalendar(ret.data);
            } else if(ret.mode == 'edit') {
              vm.changeHolidayToCalendar(ret.data);
            } else if(ret.mode == 'delete') {
              vm.deleteHolidayFromCalendar(ret.data);
            }

            vm.isHolidayChanged = true;
          }
        }, function() {

        });
    };

    /**
     * Update holiday
     */
    vm.changeHolidayToCalendar = function(holiday) {
      var index = _.findIndex(vm.holidaysData.rows, function(row) {
        return row.id == holiday.id;
      });
      if(index != -1) {

        //This will solve disappear issue when you add new event
        holiday.stick = true;

        //This will solve issue which is not showing end date
        /*holiday.allDay = true;
        if(holiday.end && holiday.end != 'Invalid date') {
          holiday.end = moment(holiday.end).format('YYYY-MM-DD 12:00:00');
        } else {
          holiday.end = null;
        }*/

        vm.holidaysData.rows[index] = holiday;
      }
    };

    /**
     * Add holiday
     */
    vm.addHolidayToCalendar = function(holiday) {

      //This will solve disappear issue when you add new event
      holiday.stick = true;

      //This will solve issue which is not showing end date
      /*holiday.allDay = true;
      if(holiday.end && holiday.end != 'Invalid date') {
        holiday.end = moment(holiday.end).format('YYYY-MM-DD 12:00:00');
      } else {
        holiday.end = null;
      }*/

      vm.holidaysData.rows.push(holiday);
    };

    /**
     * Delete holiday
     */
    vm.deleteHolidayFromCalendar = function(holiday) {
      var index = _.findIndex(vm.holidaysData.rows, function(row) {
        return row.id == holiday.id;
      });
      if(index != -1) {
        vm.holidaysData.rows.splice(index, 1);
      }
    };

    /**
     * Close dialog
     */
    vm.close = function() {
      $mdDialog.hide(vm.isHolidayChanged);
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Load holiday data
     */
    function _loadHolidayData() {

      vm.isLoading = true;

      api.adminHolidays.list.get(
        null,
        // Success
        function (response)
        {

          vm.holidaysData = response;
          vm.eventSources = [vm.holidaysData.rows]; //[vm.events];
          vm.isLoading = false;

          //This will solve issue which is not showing end date
          /*_.each(vm.holidaysData.rows, function(row) {
            row.allDay = true;
            if(row.end && row.end != 'Invalid date') {
              row.end = moment(row.end).format('YYYY-MM-DD 12:00:00');
            } else {
              row.end = null;
            }
          });*/

        },
        // Error
        function (response)
        {
          console.log(response);
          vm.isLoading = false;

          var errorMsg;
          if(response.data && response.data.message) {
            errorMsg = response.data.message;
          } else {
            errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );
        }
      );
    }

    /**
     * Initialize
     */
    function _init() {

      _loadHolidayData();

    }

    _init();


    /**
     * Add Dialog Controller
     */
    function AddHolidayDialogController($scope, $mdDialog, mode, holidayData) {

        // ******************************
        // Variables
        // ******************************

        var vm = this;

        vm.isSaving = false;

        vm.mode = mode;
        vm.holidayData = holidayData;

        // ******************************
        // Public Methods
        // ******************************

        /**
         * Update holiday
         */
        vm.updateHoliday = function() {

          vm.isSaving = true;

          if(vm.startDate) {
            vm.holidayData.start = moment(vm.startDate).format('YYYY-MM-DD');
          } else {
            vm.holidayData.start = null;
          }

          if(vm.endDate) {
            vm.holidayData.end = moment(vm.endDate).add(1,'days').format('YYYY-MM-DD');
          } else {
            vm.holidayData.end = null;
          }

          if(vm.mode == 'add') {

            vm.msg = 'Creating...';
            api.adminHolidays.list.save(
              vm.holidayData,
              // Success
              function (response)
              {
                vm.isSaving = false;
                vm.holidayData = response;
                vm.msg = 'Created successfully!';

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(vm.msg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('success-toast')
                );

                vm.close({
                  mode: 'add',
                  data: vm.holidayData
                });

              },
              // Error
              function (response)
              {
                console.log(response);
                vm.isSaving = false;
                vm.msg = '';

                var errorMsg;
                if(response.data && response.data.message) {
                  errorMsg = response.data.message;
                } else {
                  errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
                );
              }
            );

          } else if(vm.mode == 'edit') {

            vm.msg = 'Updating...';
            api.adminHolidays.actionById.save(
              vm.holidayData,
              // Success
              function (response)
              {
                vm.isSaving = false;
                vm.msg = 'Updated successfully!';

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(vm.msg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('success-toast')
                );

                vm.close({
                  mode: 'edit',
                  data: vm.holidayData
                });

              },
              // Error
              function (response)
              {
                console.log(response);
                vm.isSaving = false;
                vm.msg = '';

                var errorMsg;
                if(response.data && response.data.message) {
                  errorMsg = response.data.message;
                } else {
                  errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
                );
              }
            );

          }

        };

        /**
         * Delete holiday
         */
        vm.deleteHoliday = function(ev) {

          $mdDialog.show({
            controller: CustomConfirmDialogController,
            controllerAs: 'vm',
            templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
            locals: {
              title: 'Delete confirmation',
              message: 'Are you sure you want to delete this holiday?',
              okButton: 'Delete',
              cancelButton: 'Cancel',
              okFunc: null
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            escapeToClose: false,
            skipHide: true
          }).then(function(isOk){
            if(isOk) {

              vm.isSaving = true;
              vm.msg = 'Deleting...';

              api.adminHolidays.actionById.remove(
                vm.holidayData,
                // Success
                function (response)
                {
                  vm.isSaving = false;
                  vm.msg = 'Deleted successfully!';

                  $mdToast.show(
                    $mdToast.simple()
                      .textContent(vm.msg)
                      .position('top right')
                      .hideDelay(3000)
                      .theme('success-toast')
                  );

                  vm.close({
                    mode: 'delete',
                    data: vm.holidayData
                  });

                },
                // Error
                function (response)
                {
                  console.log(response);
                  vm.isSaving = false;
                  vm.msg = '';

                  var errorMsg;
                  if(response.data && response.data.message) {
                    errorMsg = response.data.message;
                  } else {
                    errorMsg = 'Something went wrong!';
                  }

                  $mdToast.show(
                    $mdToast.simple()
                      .textContent(errorMsg)
                      .position('top right')
                      .hideDelay(3000)
                      .theme('error-toast')
                  );
                }
              );

            }
          });
        };

        /**
         * Close customer dialog
         */
        vm.close = function(data) {
          $mdDialog.hide(data);
        };


        // ******************************
        // Internal methods
        // ******************************


        /**
         * Initialize
         */
        function _init() {
          if(vm.holidayData.start) {
            vm.startDate = new Date(vm.holidayData.start);
          }

          if(vm.holidayData.end) {
            vm.endDate = new Date(vm.holidayData.end);
          }
        }

        _init();

    }

}


function NewDeviceDialogController($scope, $mdDialog, $mdToast, params, api)
{

    // ******************************
    // Variables
    // ******************************
    var vm = this;
    vm.registrationMode = 'EXIST';
    vm.stepIndex = 0;
    vm.newDevice = params;
    vm.steps = [
      {
        dialogWidth: 50,
        dialogTitle: 'Registration: Unassigned Install'
      },
      {
        dialogWidth: 80,
        dialogTitle: 'Choose an Existing Customer Location'
      }
    ];

    vm.dtOptions = {
      dom       : '<"top left"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      pageLength: 5,
      lengthMenu: [5, 10, 20, 50, 100],
      autoWidth : true,
      responsive: false
    };

    // ******************************
    // Public Methods
    // ******************************
    /**
     * Close customer dialog
     */
    vm.close = function() {
      $mdDialog.cancel();
    };

    vm.ok = function(res) {
      $mdDialog.hide(res);
    };

    vm.nextStep = function() {
      if(vm.stepIndex == 0) {
        if(vm.registrationMode == 'EXIST') {
          _loadInstallations();
          vm.stepIndex++;
        } else {
          vm.ok(null);
        }
      } else if(vm.stepIndex == 1) {
        _updateInstallation(vm.selectedCustomer, vm.newDevice);
      }
    };

    vm.selectCustomer = function(installation) {
      vm.selectedCustomerID = installation.id;
      vm.selectedCustomer = installation;
    };

    vm.validateStep = function() {
      if(vm.stepIndex == 0) {
        if(vm.registrationMode)
          return false;
        else
          return true;
      } else if(vm.stepIndex == 1) {
        if(vm.selectedCustomer) {
          return false;
        } else {
          return true;
        }
      }
    };

    // ******************************
    // Internal methods
    // ******************************


    /**
     * Assign device to existing customer
     */
    function _updateInstallation(selectedCustomer, newDevice) {

      vm.isSaving = true;

      api.adminInstallations.actionById.save(
        {
          installationId: selectedCustomer.id,
          serialNumber: newDevice.serialNumber,
          simCardHandle: newDevice.simCardHandle,
          isActive: true
        },
        // Success
        function (response)
        {
          vm.isSaving = false;

          $mdToast.show(
            $mdToast.simple()
              .textContent('New device assigned successfully!')
              .position('top right')
              .hideDelay(3000)
              .theme('success-toast')
          );

          vm.ok(response);

        },
        // Error
        function (response)
        {
          console.log(response);
          vm.isSaving = false;

          if(response.data && response.data.message) {
            vm.errorMsg = response.data.message;
          } else {
            vm.errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(vm.errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );
        }
      );
    }


    /**
     * Load installations data
     */
    function _loadInstallations() {

      vm.isLoading = true;

      api.adminInstallations.list.get(
        null,
        // Success
        function (response)
        {
          vm.isLoading = false;

          vm.installations = _.filter(response.rows, function(installation) {
            return (installation.isActive == false && installation.Company.isActive == true);
          });
        },
        // Error
        function (response)
        {
          console.log(response);
          vm.isLoading = false;

          if(response.data && response.data.message) {
            vm.errorMsg = response.data.message;
          } else {
            vm.errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(vm.errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );
        }
      );
    }

    /**
     * Initialize
     */
    function _init() {
    }
    _init();

}


function EventLogDialogController($rootScope, $scope, $mdDialog, $mdToast, $filter, G2E_CONST_API, bsLoadingOverlayService, params, api, currentUser)
{

    // ******************************
    // Variables
    // ******************************

    var vm = this;
    vm.installation = params.installation;
    vm.selectedInstallations = params.selectedInstallations; //
    vm.search_start_date = params.start_date;
    vm.search_end_date = params.end_date;
    vm.editable = params.editable;
    vm.selectable = params.selectable;
    vm.expended = params.expended;
    vm.tabs = params.tabs; // PICK_UP, TANK_LEVEL, SYSTEM_FAULT, NON_CRITICAL
    vm.status_by = params.defaultTab;
    vm.selectedInstallationId = vm.installation.id;
    vm.currentUser = currentUser;
    vm.invalidEventsChanged = [];
    vm.isLogChanged = false;
    vm.isAdminLogs = params.isAdminLogs; // if coming from dashboard then its admin facing logs
    vm.resolvedAtIndex = 5;

    vm.pickupTableTotalLogs = 0;
    vm.tankLevelTableTotalLogs = 0;
    vm.systemFaultTableTotalLogs = 0;
    vm.nonCriticalTableTotalLogs = 0;

    vm.tankLevelTableMain = { order: 'Customer.name' }; // for sorting main table
    vm.tankLevelTable = {}
    vm.tankLevelTableTemplate = {
      columns: [
        {title: "ID", model: {name:'id'}, hidden:true},
        {title: "Date of Occurrence", format: function(val){ return _formatDateTime(val);}},
        {title: "Tank Level (%)", export_format: function(val){ return _formatExportPercentage(val);}},
        {title: "Scheduled Pick-up", format: function(val){ return _formatDateOnly(val);}},
        //{title: "Confirmed?"},
        {title: "Appointment"},
        {title: "Date of Event Resolution", format: function(val){ return _formatDateTime(val);}}
      ],
      rows: [],
      order: '-0',
      dtOptions: {
        dom       : 'rt',
        paging: false,
        autoWidth : true,
        responsive: false,
        aaSorting: [0, 'desc'],
        columnDefs: [
          { targets: [0,2,3], type: "date" },
          { targets: "_all", className: "dt-center"}
        ]
      }
    };
    
    vm.systemFaultTableMain = { order: 'Customer.name' };
    vm.systemFaultTable = {}
    vm.systemFaultTableTemplate = {
      columns: [
        {title: "Date of Occurrence", format: function(val){ return _formatDateTime(val);}},
        {title: "Fault Description"},
        {title: "Date of Event Resolution", format: function(val){ return _formatDateTime(val);}},
        {title: "Acknowledged by"},
        {title: "Date of Acknowledgement", format: function(val){ return _formatDateTime(val);}},
        {title: "Fault Code"},
        {title: "Days between System Faults"}
      ],
      rows: [],
      order: '-0',
      dtOptions: {
        dom       : 'rt',
        paging: false,
        autoWidth : true,
        responsive: false,
        aaSorting: [0, 'desc'],
        columnDefs: [
          { targets: [0,4], type: "date" },
          { targets: "_all", className: "dt-center"}
        ]
      }
    };

    vm.nonCriticalTableMain = { order: 'Customer.name' };
    vm.nonCriticalTable = {}
    vm.nonCriticalTableTemplate = {
      columns: [
        {title: "Date of Occurrence", format: function(val){ return _formatDateTime(val);}},
        {title: "Fault Code"},
        {title: "Description"}
      ],
      rows: [],
      order: '-0',
      dtOptions: {
        dom       : 'rt',
        paging: false,
        autoWidth : true,
        responsive: false,
        aaSorting: [0, 'desc'],
        columnDefs: [
          { targets: [0], type: "date" },
          { targets: "_all", className: "dt-center"}
        ]
      }
    };

    vm.pickupTableMain = { order: 'Customer.name' };
    vm.pickupTable = {};
    vm.pickupTableTemplate = {
      columns: [
        {title: "ID", model: {name:'id'}, hidden:true},
        {title: "Invalid?", model: {name: 'isInvalid',required:true}, export_format: function(val){ return (val==true)?'Yes':''}, hidden:true},
        {title: "Billing Status", model: {name: 'billingExportedAt'}, hidden:!vm.expended},
        {title: "Date of Pick-up", model: {name:'issuedAt',required:true, type: 'date'}, format: function(val){ return _formatDateTime(val);}},
        {title: "Days between Pick-ups", model: {name:'daysBetweenPickups',required:true,min:0}},
        {title: "Tank Level at Pick-up (%)", model: {name:'tankLevelBeforePickup',required:true,min:0,max:100}, export_format: function(val){ return _formatExportPercentage(val);}},
        {title: "Left-over in Tank (%)", model: {name:'tankLevelAfterPickup',required:true,min:0,max:100}, export_format: function(val){ return _formatExportPercentage(val);}},
        {title: "Volume in Tank before Pick-up (gallons)", model: {name:'volumeInTankBeforePickup',required:true,min:0}},
        {title: "Left-over in Tank after Pick-up (gallons)", model: {name:'volumeInTankAfterPickup',required:true,min:0}},
        {title: "Collected Volume (gallons)", model: {name:'collectedVolume',required:true,min:0}},
        {title: "Water Meter Reading (gallons)", model: {name:'waterUsageBeforePickup',required:true,min:0}, hidden:!vm.expended},
        {title: "Run Time Reading (hours)", model: {name:'totalRuntimeBeforePickup',required:true,min:0}, format: function(val){ return _formatHoursDuration(val, 'hours');}, export_format: function(val){ return _formatExportHoursDuration(val, 'hours');}, hidden:!vm.expended},
        {title: "On/Offs Reading", model: {name:'onOffsBeforePickup',required:true,min:0}, hidden:!vm.expended},
        {title: "Slurry Water Content (% of volume)", model: {name:'percentOfSlurry',required:true,min:0}, export_format: function(val){ return _formatExportPercentage(val);}, hidden:!vm.expended},
        {title: "Waste Processed (tons/week)", model: {name:'wasteProcessed',required:true,min:0}, hidden:!vm.expended},
        {title: "Mean Run Time (minutes/run)", model: {name:'meanRuntime',required:true,min:0}, hidden:!vm.expended},
        {title: "Mean Daily Usage (times/day)", model: {name:'meanDailyUsage',required:true,min:0}, hidden:!vm.expended},
        {title: "Pump-out Duration (hours)", model: {name:'dischargeTime',required:true,min:0}, format: function(val){ return _formatHoursDuration(val, 'seconds');}, export_format: function(val){ return _formatExportHoursDuration(val, 'seconds');}, hidden:!vm.expended},
        {title: "Hauling Cost", model: {name:'haulingCost', type:'number'}, format: function(val){ return _formatCurrency(val);}, hidden:!vm.expended},
        {title: "Tipping Cost", model: {name:'tippingCost', type:'number'}, format: function(val){ return _formatCurrency(val);}, hidden:!vm.expended},
        {title: "Hauling and Tipping Cost", model: {name:'haulingTippingCost', type:'number'}, format: function(val){ return _formatCurrency(val);}, hidden:!vm.expended},
        {title: "Observation", model: {name:'observation'}, hidden:!vm.expended},
        {title: "Appointment", model: {name:'appointmentId', type:'number'}, hidden:!vm.expended},
        {title: "Billing Exported by", model: {name:'billingExportedBy'}, hidden:!vm.expended},
        {title: "Date of Billing Exportation", model: {name:'billingExportedAt', type:'date'}, hidden:!vm.expended, format: function(val){ return _formatDateTime(val);}}
      ],
      rows: [],
      order: '-3',
      dtOptions: {
        dom       : 'rt',
        paging: false,
        autoWidth : true,
        responsive: false,
        aaSorting: [0, 'desc'],
        columnDefs: [
          { targets: [0], type: "date" },
          { targets: "_all", className: "dt-center"}
        ]
      },

      editMode: '',
      addMode: '',
      selectedLogId: null,
      newPickupLog: {},
      newPickupLogError: {},
    };

    vm.selectedInstallations.forEach(function(inst){
      // pickupTable
      vm.pickupTableTemplate.installationId = inst.id
      vm.pickupTable[inst.id] = _.clone(vm.pickupTableTemplate)
      vm.pickupTable[inst.id].Customer = inst.Customer


      // tankLevelTable
      vm.tankLevelTableTemplate.installationId = inst.id
      vm.tankLevelTable[inst.id] = _.clone(vm.tankLevelTableTemplate)
      vm.tankLevelTable[inst.id].Customer = inst.Customer

      // systemFaultTable
      vm.systemFaultTableTemplate.installationId = inst.id
      vm.systemFaultTable[inst.id] = _.clone(vm.systemFaultTableTemplate)
      vm.systemFaultTable[inst.id].Customer = inst.Customer

      // nonCriticalTable
      vm.nonCriticalTableTemplate.installationId = inst.id
      vm.nonCriticalTable[inst.id] = _.clone(vm.nonCriticalTableTemplate)
      vm.nonCriticalTable[inst.id].Customer = inst.Customer
    })

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Close dialog
     */
    vm.close = function() {
      $mdDialog.hide(vm.isLogChanged);
    };

    /**
     * Status change listener
     */
    vm.onChangeStatus = function() {

    };

    /**
     * Date change listener
     */
    vm.onChangeDateRange = function() {

      if(vm.search_start_date && vm.search_end_date) {
        vm.filterChangedTimeHorizon = true;
      }
    };

    /**
     * Clear filter
     */
    vm.clearFilter = function() {
      vm.search_start_date = null;
      vm.search_end_date = null;
      vm.filterLogs();
    };

    /**
     * Rolling mode change listener
     */
    vm.onChangeInstallation = function() {
      vm.installation = _.findWhere(vm.installations, {id: parseInt(vm.selectedInstallationId)});
      vm.filterLogs();
    };

    /**
     * Load logs with time horizon
     */
    vm.filterLogs = function() {
      vm.filterChangedTimeHorizon = false;
      vm.refreshTable();
    };

    /**
     * Refresh tables
     */
    vm.refreshTable = function() {
      vm.selectedInstallations.forEach(function(inst){
        vm.pickupTable[inst.id].editMode = '';
      });
      _loadEventLogs(false);
    };

    /**
     * Get CSV File name
     * 
     * File name: existing date naming logic, i.e.: Pickup_all_"date".csv 
     * OR depending on time selection Pickup_”data”_”date”.csv,
     * TankLevel_...., SystemFault_...., NonCritical_....
     */
    vm.getCSVFilename = function(log_type) {
      var start = '';
      var end = '';
      var filename = log_type;
      if(vm.search_start_date && vm.search_end_date) {
        filename += '_data_' + moment(vm.search_start_date).format('YYYY-MM-DD') + '_' + moment(vm.search_end_date).format('YYYY-MM-DD');
      } else {
        filename += '_all_' + moment().format('YYYY-MM-DD');
      }

      return filename + '.csv';
    };

    /**
     * Get CSV Columns Header
     */
    vm.getCSVHeaders = function(log_type) {
      var instId = _getInstallationId()
      var columns = [];
      var headers = ['Installation Name'];
      if(log_type == 'TankLevel') {
        columns = vm.tankLevelTable[instId].columns;
      } else if(log_type == 'Pickup') {
        columns = vm.pickupTable[instId].columns;
      } else if(log_type == 'SystemFault') {
        columns = vm.systemFaultTable[instId].columns;
      } else if(log_type == 'NonCritical') {
        columns = vm.nonCriticalTable[instId].columns;
      }
      _.each(columns, function(col, index) {
        if(!col.hidden && index !== 2) { // 1 means invalid column hidden temporarily
          headers.push(col.title);
        }
      });
      return headers;
    };

    /**
     * Get CSV Rows
     */
    vm.getCSVRows = function(log_type) {
      var instId = _getInstallationId()
      var installations = null;
      var rows = [];
      if(log_type == 'TankLevel') {
        installations = vm.tankLevelTable;
      } else if(log_type == 'Pickup') {
        installations = vm.pickupTable;
      } else if(log_type == 'SystemFault') {
        installations = vm.systemFaultTable;
      } else if(log_type == 'NonCritical') {
        installations = vm.nonCriticalTable;
      }

      for (var instId in installations) {
        var installation = installations[instId]
        var orderedRows = $filter('orderBy')(installation.rows, installation.order);

        _.each(orderedRows, function(row) {
          // first column as installatin name
          var export_row = [installation.Customer.name];
          
          _.each(row, function(cell, cel_index) {
            if(!installation.columns[cel_index].hidden && cel_index !== 2) { // 1 means invalid column hidden temporarily
              if(installation.columns[cel_index].export_format) {
                export_row.push(installation.columns[cel_index].export_format(cell));
              } else if(installation.columns[cel_index].format) {
                export_row.push(installation.columns[cel_index].format(cell));
              } else {
                export_row.push(cell);
              }
            }
          });
          rows.push(export_row);
        });
      }
      return rows;
    };

    /**
     * Change invalid option
     */
    vm.onChangeInvalidEvents = function(log_id) {

      var index = _.indexOf(vm.invalidEventsChanged, log_id);

      if(index < 0) {
        vm.invalidEventsChanged.push(log_id);
      } else {
        vm.invalidEventsChanged.splice(index, 1);
      }
    };

    /**
     * Update invalid events
     */
    vm.updateInvalidEvents = function() {

      vm.isLoading = true;
      bsLoadingOverlayService.start({referenceId: 'log_loader'});

      api.adminEvents.pickup.invalid.save({installationId: vm.installation.id, ids: vm.invalidEventsChanged}, function (res){

        vm.isLoading = false;
        bsLoadingOverlayService.stop({referenceId: 'log_loader'});

        //update local data
        _.each(vm.invalidEventsChanged, function(id) {
          var event = _.findWhere(vm.eventLogs.pickup.rows, {id: id});
          if(event) {
            event.isInvalid = !event.isInvalid;
          }
        });
        vm.invalidEventsChanged = [];

        $mdToast.show(
          $mdToast.simple()
            .textContent('Updated successfully!')
            .position('top right')
            .hideDelay(3000)
            .theme('success-toast')
        );

      }, function (err) {

        vm.isLoading = false;
        bsLoadingOverlayService.stop({referenceId: 'log_loader'});

        if(err.data && err.data.message) {
          vm.errorMsg = err.data.message;
        } else {
          vm.errorMsg = 'Something went wrong!';
        }

        $mdToast.show(
          $mdToast.simple()
            .textContent(vm.errorMsg)
            .position('top right')
            .hideDelay(3000)
            .theme('error-toast')
        );

      });
    };

    /**
     * Add a Log
     */
    vm.addLog = function(instId) {
      vm.pickupTable[instId].editMode = 'ADD';
      vm.pickupTable[instId].selectedLogId = null;
      vm.pickupTable[instId].newPickupLog = {
        isInvalid: false,
        issuedAt: moment().format('YYYY-MM-DD HH:mm:ss')
      };
      if(!vm.expended) {
          vm.pickupTable[instId].newPickupLog.waterUsageBeforePickup = 0;
          vm.pickupTable[instId].newPickupLog.totalRuntimeBeforePickup = 0;
          vm.pickupTable[instId].newPickupLog.onOffsBeforePickup = 0;
          vm.pickupTable[instId].newPickupLog.percentOfSlurry = 0;
          vm.pickupTable[instId].newPickupLog.wasteProcessed = 0;
          vm.pickupTable[instId].newPickupLog.meanRuntime = 0;
          vm.pickupTable[instId].newPickupLog.meanDailyUsage = 0;
          vm.pickupTable[instId].newPickupLog.dischargeTime = 0;
          vm.pickupTable[instId].newPickupLog.haulingCost = 0;
          vm.pickupTable[instId].newPickupLog.tippingCost = 0;
          vm.pickupTable[instId].newPickupLog.haulingTippingCost = 0;
      }
      vm.pickupTable[instId].newPickupLogError = {};
    };

    /**
     * Edit Log
     */
    vm.editLog = function(instId) {
      if(vm.pickupTable[instId].selectedLogId) {

        var logData = _.find(vm.pickupTable[instId].rows, function(row) {
          return row[0] == vm.pickupTable[instId].selectedLogId;
        });

        if(logData) {
          vm.pickupTable[instId].editMode = 'EDIT';
          vm.pickupTable[instId].newPickupLog = {};
          vm.pickupTable[instId].newPickupLogError = {};
          _.each(vm.pickupTable[instId].columns, function(column, col_index) {
            if(!column.hidden) {
              if(column.model.type == 'date') {
                vm.pickupTable[instId].newPickupLog[column.model.name] = logData[col_index]?moment(logData[col_index]).format('YYYY-MM-DD HH:mm:ss'):'';
              } else if(column.model.name == 'dischargeTime') { //As the value is second, need to converto hours
                vm.pickupTable[instId].newPickupLog[column.model.name] = _formatExportHoursDuration(logData[col_index], 'seconds');
              } else {
                vm.pickupTable[instId].newPickupLog[column.model.name] = logData[col_index];
              }
            }
          });
        }
      }
    };

    /**
     * Delete Log
     */
    vm.deleteLog = function(ev, instId) {

      if(vm.pickupTable[instId].selectedLogId) {

        $mdDialog.show({
          controller: CustomConfirmDialogController,
          controllerAs: 'vm',
          templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
          locals: {
            title: 'Delete confirmation',
            message: 'Are you sure you want to delete the log?',
            okButton: 'Delete Log',
            cancelButton: 'Cancel',
            okFunc: null
          },
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          skipHide: true
        }).then(function (isOk) {
          if (isOk) {

            vm.isUpdating = true;
            bsLoadingOverlayService.start({referenceId: 'log_loader'});

            api.adminEvents.pickup.actionById.remove(
              {
                installationId: instId,
                eventId: vm.pickupTable[instId].selectedLogId
              },
              // Success
              function (response) {
                vm.isUpdating = false;
                bsLoadingOverlayService.stop({referenceId: 'log_loader'});
                vm.msg = 'Deleted successfully!';

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(vm.msg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('success-toast')
                );

                //Delete log from list
                vm.removeLogFromTable(instId);

                vm.isLogChanged = true;

              },
              // Error
              function (response) {
                console.log(response);
                vm.isUpdating = false;
                bsLoadingOverlayService.stop({referenceId: 'log_loader'});

                var errorMsg;
                if (response.data && response.data.message) {
                  errorMsg = response.data.message;
                } else {
                  errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
                );
              }
            );
          }
        });
      }
    };

    vm.removeLogFromTable = function(instId) {

      if(vm.pickupTable[instId].selectedLogId) {

        var index = _.findIndex(vm.eventLogs.pickup[instId].rows, {id: vm.pickupTable[instId].selectedLogId});
        if(index != -1) {
          vm.eventLogs.pickup[instId].rows.splice(index, 1);
        }

        index = _.findIndex(vm.pickupTable[instId].rows, function(row) {
          return row[0] == vm.pickupTable[instId].selectedLogId;
        });
        if(index != -1) {
          vm.pickupTable[instId].rows.splice(index, 1);
        }

        vm.pickupTable[instId].selectedLogId = null;
      }

    };
    vm.addLogToTable = function(data, instId) {

      var row = _generatePickupTableRow(data);
      vm.eventLogs.pickup[instId].rows.push(data);
      vm.pickupTable[instId].rows.push(row);
      vm.pickupTable[instId].selectedLogId = data.id;
    };
    vm.updateLogToTable = function(data, instId) {

        var index = _.findIndex(vm.eventLogs.pickup[instId].rows, {id: data.id});
        if(index != -1) {
          vm.eventLogs.pickup[instId].rows[index] = data;
        }

        index = _.findIndex(vm.pickupTable[instId].rows, function(row) {
          return row[0] == data.id;
        });
        if(index != -1) {
          vm.pickupTable[instId].rows[index] = _generatePickupTableRow(data);
        }
    };

    /**
     * Validate form
     */
    vm.validateColumnValue = function(value, column, instId) {
      var model = column.model;

      if(model.required == true && (value == null || value == undefined || (typeof value == 'string' && value.trim() == ''))) {
        vm.pickupTable[instId].newPickupLogError[model.name] = true;
        return column.title + ' is required';
      }

      if(model.min != null && model.min != undefined && (value < model.min || !isNumeric(value))) {
        vm.pickupTable[instId].newPickupLogError[model.name] = true;
        return column.title + ' should be equal or greater than ' + model.min;
      }

      if(model.max != null && model.max != undefined && (value > model.max || !isNumeric(value))) {
        vm.pickupTable[instId].newPickupLogError[model.name] = true;
        return column.title + ' should be equal or less than ' + model.max;
      }

      if(model.type == 'date' && value && moment(value).isValid() == false) {
        vm.pickupTable[instId].newPickupLogError[model.name] = true;
        return column.title + ' should be date/time format as YYYY-MM-DD HH:mm:ss';
      }

      if(model.type == 'number' && value && !isNumeric(value)) {
        vm.pickupTable[instId].newPickupLogError[model.name] = true;
        return column.title + ' should be number';
      }

      vm.pickupTable[instId].newPickupLogError[model.name] = false;
      return '';
    };

    /**
     * Export Billing
     */
    vm.exportBilling = function(installationId, eventId) {

        vm.isUpdating = true;
        bsLoadingOverlayService.start({referenceId: 'log_loader'});
        api.adminEvents.pickup.exportBilling.save(
            {
                installationId: installationId,
                eventId: eventId
            },
            // Success
            function (response) {
                vm.isUpdating = false;
                bsLoadingOverlayService.stop({referenceId: 'log_loader'});

                vm.updateLogToTable(response, installationId);

                vm.isLogChanged = true;

            },
            // Error
            function (response) {
                console.log(response);
                vm.isUpdating = false;
                bsLoadingOverlayService.stop({referenceId: 'log_loader'});

                var errorMsg;
                if (response.data && response.data.message) {
                    errorMsg = response.data.message;
                } else {
                    errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            }
        );
    };

    /**
     * Save Log
     */
    vm.saveLog = function(instId) {

      //validate values
      var firstErrorMsg = '';
      for(var i=0;i<vm.pickupTable[instId].columns.length;i++) {
        var column = vm.pickupTable[instId].columns[i];
        if(!column.hidden) {
            var errorMsg = vm.validateColumnValue(vm.pickupTable[instId].newPickupLog[column.model.name], column, instId);
            if(errorMsg != '' && firstErrorMsg == '') {
                firstErrorMsg = errorMsg;
            }
        }
      }

      if(firstErrorMsg != '') {
        $mdToast.show(
          $mdToast.simple()
            .textContent(firstErrorMsg)
            .position('top right')
            .hideDelay(3000)
            .theme('error-toast')
        );
      } else {

        vm.isUpdating = true;
        bsLoadingOverlayService.start({referenceId: 'log_loader'});

        var params = angular.copy(vm.pickupTable[instId].newPickupLog);
        params.installationId = instId;
        params.isOpen = false;
        params.dischargeTime = 3600 * params.dischargeTime;
        params.daysBetweenPickups = 24 * 3600 * params.daysBetweenPickups;
        params.issuedAt = moment(params.issuedAt).format('YYYY-MM-DDTHH:mm:ssZ');
        params.resolvedAt = moment(params.issuedAt).add(params.dischargeTime, 'seconds').format('YYYY-MM-DDTHH:mm:ssZ');
        if(params.billingExportedAt) {
            params.billingExportedAt = moment(params.billingExportedAt).format('YYYY-MM-DDTHH:mm:ssZ');
        } else {
            params.billingExportedAt = null;
        }

        //remove empty string values as number type
        _.each(vm.pickupTable[instId].columns, function(column) {
          var value = params[column.model.name];
          if(typeof value == 'string' && value.trim() == '' && column.model.type == 'number') {
            delete params[column.model.name];
          }
        });

        if(vm.pickupTable[instId].editMode == 'ADD') {

          api.adminEvents.pickup.list.save(
            params,
            // Success
            function (response) {
              vm.isUpdating = false;
              bsLoadingOverlayService.stop({referenceId: 'log_loader'});
              vm.msg = 'Created successfully!';

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.msg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('success-toast')
              );

              vm.pickupTable[instId].editMode = '';
              //Add log to list
              //console.log(response);
              vm.addLogToTable(response, instId);

              vm.isLogChanged = true;

            },
            // Error
            function (response) {
              console.log(response);
              vm.isUpdating = false;
              bsLoadingOverlayService.stop({referenceId: 'log_loader'});

              var errorMsg;
              if (response.data && response.data.message) {
                errorMsg = response.data.message;
              } else {
                errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );
            }
          );
        } else if(vm.pickupTable[instId].editMode == 'EDIT' && vm.pickupTable[instId].selectedLogId) {

          params.eventId = vm.pickupTable[instId].selectedLogId;

          api.adminEvents.pickup.actionById.save(
            params,
            // Success
            function (response) {
              vm.isUpdating = false;
              bsLoadingOverlayService.stop({referenceId: 'log_loader'});
              vm.msg = 'Updated successfully!';

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.msg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('success-toast')
              );

              vm.pickupTable[instId].editMode = '';
              //Update log to list
              //console.log(response);
              vm.updateLogToTable(response, instId);

              vm.isLogChanged = true;

            },
            // Error
            function (response) {
              console.log(response);
              vm.isUpdating = false;
              bsLoadingOverlayService.stop({referenceId: 'log_loader'});

              var errorMsg;
              if (response.data && response.data.message) {
                errorMsg = response.data.message;
              } else {
                errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );
            }
          );
        }
      }

    };

    /**
     * Cancel Edit
     */
    vm.cancelEdit = function(instId) {
      vm.pickupTable[instId].editMode = '';
    };

    /**
     * Select a log
     */
    vm.selectLog = function(id, instId) {
      if(vm.pickupTable[instId].editMode == 'ADD' || vm.pickupTable[instId].editMode == 'EDIT') return;
      if(vm.pickupTable[instId].selectedLogId == id) vm.pickupTable[instId].selectedLogId = null;
      else vm.pickupTable[instId].selectedLogId = id;
    };

    /**
     * Check the log is selected
     */
    vm.isSelectedLog = function(id, instId) {
      return vm.pickupTable[instId].selectedLogId == id;
    };

    /**
     * Listener to export billing
     */
    vm.onExportBilling = function(id, instId) {
        if(currentUser.hasAdminRole()) {
            var event = _.findWhere(vm.eventLogs.pickup[instId].rows, {id: id});
            var installation = _getSelectedInstById(instId)
            if(installation.isActive === true && event) {
                if(installation.Customer.contractType !== 'PAYG') {
                    $mdDialog.show({
                        controller: CustomConfirmDialogController,
                        controllerAs: 'vm',
                        templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
                        locals: {
                            title: 'Confirmation',
                            message: 'This is designed for PAYG customers, are you sure you want to proceed?',
                            okButton: 'Yes',
                            cancelButton: 'Cancel',
                            okFunc: null
                        },
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        skipHide: true
                    }).then(function (isOk) {
                        if(isOk) {
                            vm.openHaulerAppBilling(installation, event);
                        }
                    });
                } else {
                    vm.openHaulerAppBilling(installation, event);
                }
            }
        }
    };

    vm.resolveTankLevelEvent = function(eventId, instId) {
      console.log(instId, eventId)
      var index;
      var indexTable;
      var event = _.find(vm.eventLogs.tanklevel[instId].rows, function(row, i) {
        var matched = row.id == eventId;
        if (matched) {
          index = i;
          return true;
        }
      });
      
      _.find(vm.tankLevelTable[instId].rows, function(row, i) {
          var matched = row[0] == eventId;
          if (matched) {
            indexTable = i;
          }
      });
      
      // if already resolved, then no action
      if (!!event.resolvedAt) {
        return;
      }


      if(currentUser.hasAdminRole()) {
        $mdDialog.show({
          controller: CustomConfirmDialogController,
          controllerAs: 'vm',
          templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
          locals: {
              title: 'Confirmation',
              message: 'Are you sure you want to resolve this Tank Level Event?',
              okButton: 'Yes',
              cancelButton: 'Cancel',
              okFunc: null
          },
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          escapeToClose: false,
          skipHide: true
        }).then(function (isOk) {
            if(isOk) {
                vm.isLoading = true;
                bsLoadingOverlayService.start({referenceId: 'log_loader'});

                var params = {
                  installationId: instId,
                  eventId: event.id,
                }

                api.events.tanklevel.resolve.save(
                  params,
                  // Success
                  function (response) {
                    vm.isUpdating = false;
                    bsLoadingOverlayService.stop({referenceId: 'log_loader'});
                    vm.msg = 'Resolved successfully!';
      
                    $mdToast.show(
                      $mdToast.simple()
                        .textContent(vm.msg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                    );
      
                    vm.isLogChanged = true;
                    vm.eventLogs.tanklevel[instId].rows[index].resolvedAt = response.resolvedAt
                    vm.tankLevelTable[instId].rows[indexTable][vm.resolvedAtIndex] = response.resolvedAt;
                  },
                  // Error
                  function (response) {
                    console.log(response);
                    vm.isUpdating = false;
                    bsLoadingOverlayService.stop({referenceId: 'log_loader'});
      
                    var errorMsg;
                    if (response.data && response.data.message) {
                      errorMsg = response.data.message;
                    } else {
                      errorMsg = 'Something went wrong!';
                    }
      
                    $mdToast.show(
                      $mdToast.simple()
                        .textContent(errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                    );
                  }
                );
            }
        });
      }


    }

    /**
     * Open HBSS for billing
     */
    vm.openHaulerAppBilling = function(installation, event) {

        // save billingExportedAt, billingExportedBy
        if(!event.billingExportedAt) {
            vm.exportBilling(installation.id, event.id);
        }

        // open link
        var installationId = installation.id;
        var eventDate = moment(event.issuedAt).format('YYYY-MM-DD');
        var billingTypeCode = G2E_CONST_API.HAULER_BILLING_TYPE_CODE;
        var amount = installation.Customer.haulingCost.value;
        var url = G2E_CONST_API.HAULER_BASE_URL + '/admin/billing/' + installationId + '/' + eventDate + '/' + billingTypeCode + '/' + amount + '/auto';
        window.open(url, '_blank');
    };

    /**
     * Open Graph Dialog
     */
    vm.openGraphDlg = function(instId, ev) {
      $rootScope.isDashboard = false;
      var installation = _getSelectedInstById(instId)

      var selectedInstallations = [{
        id: installation.id,
        installationName: installation.Customer.name,
        serialNumber: installation.serialNumber,
        usefulTankVolume: installation.Tank.usefulVolume.value,
        color: randomColor()
      }];

      $mdDialog.show({
          controller: CustomerGraphDialogController,
          controllerAs: 'vm',
          templateUrl: 'app/main/dashboard/customer/graph-dialog.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          escapeToClose: false,
          fullscreen: true,
          skipHide: true,
          locals: {
            params: {
              selectedInstallations: selectedInstallations
            }
          },
        })
        .then(function(response) {
          $rootScope.isDashboard = true;
        }, function() {
          $rootScope.isDashboard = true;
        });
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Number validation
     */
    function isNumeric(num) {
      return !isNaN(num);
    }

    /**
     * Get a TankLevel Table Row from data
     */
    function _generateTankLevelTableRow(log, instId) {
      var scheduledAt = log.scheduledAt;
      var isConfirmed = log.isConfirmed;
      var appointmentId = log.appointmentId;
      var installation = _getSelectedInstById(instId)
      if(log.isOpen == true && !log.scheduledAt) {
        scheduledAt = installation.scheduledAt;
        isConfirmed = installation.isConfirmed;
        appointmentId = installation.appointmentId
      }

      var row = [
        log.id,
        new Date(log.createdAt),
        log.tankLevel,
        (scheduledAt)?new Date(scheduledAt):'',
        //(isConfirmed)?'Yes':'No',
        appointmentId,
        (log.resolvedAt)?new Date(log.resolvedAt):'' // vm.resolvedAtIndex
      ];
      return row;
    }

    /**
     * Get a Pickup Table Row from data
     */
    function _generatePickupTableRow(log) {
      var daysBetweenPickups = '';

      if (log.daysBetweenPickups) {
        daysBetweenPickups = log.daysBetweenPickups / 3600 / 24;
        daysBetweenPickups = parseFloat(daysBetweenPickups.toFixed(1));
      }
      var row = [
        log.id,
        log.isInvalid,
        (log.billingExportedAt) ? new Date(log.billingExportedAt) : '',
        new Date(log.issuedAt),
        daysBetweenPickups,
        log.tankLevelBeforePickup,
        log.tankLevelAfterPickup,
        log.volumeInTankBeforePickup,
        log.volumeInTankAfterPickup,
        log.collectedVolume,
        log.waterUsageBeforePickup,
        log.totalRuntimeBeforePickup,
        log.onOffsBeforePickup,
        log.percentOfSlurry,
        log.wasteProcessed,
        log.meanRuntime,
        log.meanDailyUsage,
        log.dischargeTime,
        log.haulingCost,
        log.tippingCost,
        log.haulingTippingCost,
        log.observation,
        log.appointmentId,
        log.billingExportedBy,
        (log.billingExportedAt) ? new Date(log.billingExportedAt) : ''
      ];
      return row;
    }

    /**
     * Get a SystemFault Table Row from data
     */
    function _generateSystemFaultTableRow(log) {
      var daysBetweenFault = '';
      if (log.daysBetweenFaults) {
        daysBetweenFault = log.daysBetweenFaults / 3600 / 24;
        daysBetweenFault = parseFloat(daysBetweenFault.toFixed(1));
      }

      var row = [
        new Date(log.issuedAt),
        log.faultDescription,
        (log.resolvedAt) ? new Date(log.resolvedAt) : '',
        log.acknowledgedBy,
        (log.acknowledgedAt) ? new Date(log.acknowledgedAt) : '',
        log.faultCode,
        daysBetweenFault
      ];
      return row;
    }

    /**
     * Get a NonCritical Table Row from data
     */
    function _generateNonCriticalTableRow(log) {
      var row = [
        new Date(log.issuedAt),
        log.faultCode,
        log.faultDescription
      ];
      return row;
    }


    /**
     * Generate all the events table rows from data
     */
    function _generateTableRows() {
      if(vm.eventLogs) {

        if(vm.eventLogs.tanklevel) {
          vm.selectedInstallations.map(function(inst) {
            var rows = []
            _.each(vm.eventLogs.tanklevel[inst.id].rows, function (log) {
              var row = _generateTankLevelTableRow(log, vm.selectedInstallations[0].id);
              rows.push(row);
              vm.tankLevelTableTotalLogs++
            });
            vm.tankLevelTable[inst.id].rows = rows
          });
        }

        if(vm.eventLogs.pickup) {
          vm.selectedInstallations.map(function(inst) {
            var rows = []
            _.each(vm.eventLogs.pickup[inst.id].rows, function (log) {
              var row = _generatePickupTableRow(log);
              rows.push(row);
              vm.pickupTableTotalLogs++
            });
            vm.pickupTable[inst.id].rows = rows
          });
        }

        if(vm.eventLogs.systemfault) {
          vm.selectedInstallations.map(function(inst) {
            var rows = []
            _.each(vm.eventLogs.systemfault[inst.id].rows, function (log) {
              var row = _generateSystemFaultTableRow(log);
              rows.push(row);
              vm.systemFaultTableTotalLogs++
            });
            vm.systemFaultTable[inst.id].rows = rows
          });
        }

        if(vm.eventLogs.noncritical) {
          vm.selectedInstallations.map(function(inst) {
            var rows = []
            _.each(vm.eventLogs.noncritical[inst.id].rows, function (log) {
              var row = _generateNonCriticalTableRow(log);
              rows.push(row);
              vm.nonCriticalTableTotalLogs++
            });
            vm.nonCriticalTable[inst.id].rows = rows
          });
        }
      }
    }

    /**
     * Load event logs
     */
    function _loadEventLogs(willLoadInstallations) {

      var start = null;
      var end = null;

      if(vm.search_start_date) {
        start = moment(vm.search_start_date).format('YYYY-MM-DDT00:00:00.000Z');
      }

      if(vm.search_end_date) {
        end = moment(vm.search_end_date).format('YYYY-MM-DDT23:59:59.999Z');
      }

      vm.isLoading = true;
      bsLoadingOverlayService.start({referenceId: 'log_loader'});

      var tasks = {};

      //TANK_LEVEL, PICK_UP, SYSTEM_FAULT, NON_CRITICAL
      if(vm.tabs['TANK_LEVEL']) {
          vm.selectedInstallations.forEach(function(inst) {
            tasks['tanklevel_'+inst.id] = function(callback) {
                api.events.tanklevel.list.get({installationId: inst.id, start:start, end: end, offset: 0, limit: 100}, function(res) {
                    callback(null, res);
                }, function(err) {
                    callback(err);
                });
            };
          })
      }
      if(vm.tabs['PICK_UP']) {
          vm.selectedInstallations.forEach(function(inst) {
              tasks['pickup_'+inst.id] = function(callback) {
                  api.events.pickup.list.get({installationId: inst.id, start:start, end: end, offset: 0, limit: 100}, function(res) {
                      callback(null, res);
                  }, function(err) {
                      callback(err);
                  });
              };
          })
      }
      if(vm.tabs['SYSTEM_FAULT']) {
          vm.selectedInstallations.forEach(function(inst) {
            tasks['systemfault_'+inst.id] = function(callback) {
                api.events.systemfault.list.get({installationId: inst.id, start:start, end: end, offset: 0, limit: 100}, function(res) {
                    callback(null, res);
                }, function(err) {
                    callback(err);
                });
            };
          })
      }
      if(vm.tabs['NON_CRITICAL']) {
          vm.selectedInstallations.forEach(function(inst) {
            tasks['noncritical_'+inst.id] = function(callback) {
                api.events.noncritical.list.get({installationId: inst.id, start:start, end: end, offset: 0, limit: 100}, function(res) {
                    callback(null, res);
                }, function(err) {
                    callback(err);
                });
            };
          })
      }

      if(willLoadInstallations) {
        tasks['installations'] = function(callback) {
          api.installations.list.get(null, function (res){
            if(res.rows) {
              callback(null, res.rows);
            } else {
              callback(null, []);
            }
          }, function (err) {
            callback(err);
          });
        };
      }

      async.parallel(tasks, function(err, results) {

        vm.isLoading = false;
        bsLoadingOverlayService.stop({referenceId: 'log_loader'});

        if(!err) {
          vm.eventLogs = _formatInstallationResults(results);
          if(willLoadInstallations) {
            vm.installations = results.installations;
          }
          _generateTableRows();
        } else {

          if(err.data && err.data.message) {
            vm.errorMsg = err.data.message;
          } else {
            vm.errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(vm.errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );
        }

      });
    }

    function _formatInstallationResults(results) {
      var dataResults = results
      
      if(vm.tabs['TANK_LEVEL']) {
        dataResults.tanklevel = {}
      }
      if(vm.tabs['PICK_UP']) {
        dataResults.pickup = {}
      }
      if(vm.tabs['SYSTEM_FAULT']) {
        dataResults.systemfault = {}
      }
      if(vm.tabs['NON_CRITICAL']) {
        dataResults.noncritical = {}
      }

      
      
      vm.selectedInstallations.forEach(function(inst) {
        if (results['pickup_'+inst.id]) {
          dataResults.pickup[inst.id] = results['pickup_'+inst.id]
          delete dataResults['pickup_'+inst.id]
        }

        if (results['tanklevel_'+inst.id]) {
          dataResults.tanklevel[inst.id] = results['tanklevel_'+inst.id]
          delete dataResults['tanklevel_'+inst.id]
        }

        if (results['systemfault_'+inst.id]) {
          dataResults.systemfault[inst.id] = results['systemfault_'+inst.id]
          delete dataResults['systemfault_'+inst.id]
        }

        if (results['noncritical_'+inst.id]) {
          dataResults.noncritical[inst.id] = results['noncritical_'+inst.id]
          delete dataResults['noncritical_'+inst.id]
        }
      });
      return dataResults
    }

    /**
     * Format DateTime
     */
    function _formatDateTime(dt) {
      if(dt !== null && dt !== '') {
        return moment(dt).format('MM/DD/YYYY, h:mm A');
      } else {
        return '';
      }
    }

    /**
     * Format Date Only
     */
    function _formatDateOnly(dt) {
      if(dt !== null && dt !== '') {
        return moment(dt).format('MM/DD/YYYY');
      } else {
        return '';
      }
    }

    /**
     * Format Hours duration
     */
    function _formatHoursDuration(val, val_units) {
      if(val !== null && val !== '') {
        return moment.duration(val, val_units).format('h:mm', { trim: false });
      } else {
        return '';
      }
    }

    /**
     * Format Hours duration to export csv
     */
    function _formatExportHoursDuration(val, val_units) {
      if(val !== null && val !== '') {
        if(val_units == 'seconds') {
          val = val/3600;
        }
        val = parseFloat(val.toFixed(1));
        return val;
      } else {
        return '';
      }
    }

    /**
     * Format Percentage to export csv
     */
    function _formatExportPercentage(val) {
      if(val !== null && val !== '') {
        return val/100;
      } else {
        return '';
      }
    }

    /**
     * Format Currency as '$##,###'
     */
    function _formatCurrency(val) {
      if(val !== null && val !== '') {
        return numeral(val).format('$0,0');
      } else {
        return '';
      }
    }

    /**
     * 
     * @param {*} instId 
     */
    function _getSelectedInstById(instId) {
      return _.findWhere(vm.selectedInstallations, { id: parseInt(instId) });
    }

    /**
     * Get First installation Id from selected ones
     */
    function _getInstallationId() {
      if (vm.selectedInstallations.length) {
        return vm.selectedInstallations[0].id
      }
    }

    /**
     * Initialize
     */
    function _init() {

      _loadEventLogs(true);

    }

    _init();

}


function CustomerGraphDialogController($rootScope, $scope, $mdToast, $timeout, bsLoadingOverlayService, api, m2x, params, $mdDialog)
{

    // ******************************
    // Variables
    // ******************************
    var vm = this;
    vm.selectedInstallations = params.selectedInstallations;
    vm.Metrics = [
      {value:'TANK_LEVEL', text:'Tank Level', unit: '%', src: 'M2X'},
      {value:'TANK_LEVEL', text:'Volume in Tank', unit: 'gallons', src: 'M2X', formatValue: function(value, installation) {
        return Math.round(installation.usefulTankVolume * value / 100);
      }},
      {value:'TOTAL_TANK_LEVEL', text:'Volume fed to Tank', unit: 'gallons', src: 'M2X', formatValue: function(value, installation) {
        return Math.round(installation.usefulTankVolume * value / 100);
      }},
      {value:'TANK_TEMPERATURE', text:'Temperature', unit: '⁰F', src: 'M2X'},
      {value:'DISCHARGE_PRESSURE', text:'Pump Discharge Pressure', unit: 'psi', src: 'M2X'},
      {value:'DISPOSER_CURRENT', text:'Current of Grinder', unit: 'A', src: 'M2X'},
      {value:'PUMP_CURRENT', text:'Current of Pump', unit: 'A', src: 'M2X'},
      {value:'POWERUP_COUNT', text:'Boot-up Count', src: 'M2X'},
      {value:'REVERSE_COUNT', text:'Reverse Cycle Count', src: 'M2X'},
      {value:'ON_COUNT', text:'On/Offs Count', src: 'M2X'},
      {value:'TOTAL_RUNTIME', text:'Run Time', unit: 'hours', src: 'M2X'},
      {value:'WATER_USAGE', text:'Water Meter Reading', unit: 'gallons', src: 'M2X'},
      {value:'DOUBLE_WATER_COUNT', text:'Double Water Count', src: 'M2X'},
      {value:'DI_DISCHARGE_VALVE', text:'Discharge Valve Switch', src: 'SQL'},
      /*{value:'tankLevelAfterPickup', text:'% Left-over in Tank', unit: '%', src: 'SQL'},
      {value:'daysBetweenPickups', text:'Days between Pick-ups', unit: 'days', src: 'SQL', formatValue: function(value) {
        return value/3600/24;
      }},
      {value:'percentOfSlurry', text:'% of Slurry that is Water', unit: '%', src: 'SQL'},
      {value:'meanRuntime', text:'Mean Run Time', unit: 'hrs', src: 'SQL'},
      {value:'wasteProcessed', text:'Waste Processed', unit: 'gallons', src: 'SQL'}*/
    ];
    vm.status_by = 'ALL';
    vm.search_metric = 0;
    vm.isLoading = false;

    vm.chart = {
      options: {
        chart: {
          type                   : 'lineChart',
          color                  : ['#2196F3'],
          height                 : 400,
          margin                 : {
            top   : 32,
            right : 32,
            bottom: 64,
            left  : 80
          },
          useInteractiveGuideline: false,
          duration               : 0,
          clipEdge               : true,
          clipVoronoi            : false,
          showLegend             : true,
          x                      : function (d)
          {
            if(d) return d.x;
            else return '';
          },
          y                      : function (d)
          {
            if(d) return d.y;
            else return '';
          },
          xAxis                  : {
            showMaxMin: false,
            tickSubdivide: 3600,
            tickFormat: function (d)
            {
              return moment.unix(d).format(vm.chart.tickConfigs.default.format);
              /*if(vm.status_by == 'HOURS') {
                return moment.unix(d).format('DD/MM h A');
              } else if(vm.status_by == 'DAYS') {
                return moment.unix(d).format('DD/MM');
              } else if(vm.status_by == 'WEEKS') {
                return moment.unix(d).format('DD/MM');
              } else if(vm.status_by == 'MONTHS') {
                return moment.unix(d).format('MMM/YY');
              } else {
                return moment.unix(d).format(vm.chart.tickConfigs.default.format);
              }*/
            }
          },
          yAxis                  : {
            showMaxMin: false,
            axisLabelDistance: 0,
            tickFormat: function (d)
            {
              //return d3.format('.02f')(d);
              return d;
            }
          },
          tooltip                : {
            headerFormatter: function(d, i) {
              if(vm.status_by == 'HOURS') {
                return moment.unix(d).format('ddd, DD MMM YYYY h A');
              } else if(vm.status_by == 'DAYS') {
                return moment.unix(d).format('ddd, DD MMM YYYY');
              } else if(vm.status_by == 'WEEKS') {
                return moment.unix(d).format('ddd, DD MMM YYYY');
              } else if(vm.status_by == 'MONTHS') {
                return moment.unix(d).format('MMM YYYY');
              } else {
                return moment.unix(d).format('ddd, DD MMM YYYY HH:mm:ss');
              }
            }
          },
          interactiveLayer       : {
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          },
          legend                 : {
            margin    : {
              top   : 8,
              right : 0,
              bottom: 32,
              left  : 0
            },
            rightAlign: false
          }
        }
      },
      tickConfigs: {
        default: {
          format: 'h:mm:ss A'
        },
        data:[
          {start: {val: 1,  unit: 'min'}, end: {val: 5,  unit: 'min'}, between: {val: 30, unit: 'sec'}, format: 'h:mm:ss A'},
          {start: {val: 5,  unit: 'min'}, end: {val: 10, unit: 'min'}, between: {val: 1,  unit: 'min'}, format: 'h:mm A'},
          {start: {val: 10, unit: 'min'}, end: {val: 30, unit: 'min'}, between: {val: 2,  unit: 'min'}, format: 'h:mm A'},
          {start: {val: 30, unit: 'min'}, end: {val: 1,  unit: 'hur'}, between: {val: 5,  unit: 'min'}, format: 'h:mm A'},
          {start: {val: 1,  unit: 'hur'}, end: {val: 4,  unit: 'hur'}, between: {val: 15, unit: 'min'}, format: 'h:mm A'},
          {start: {val: 4,  unit: 'hur'}, end: {val: 8,  unit: 'hur'}, between: {val: 30, unit: 'min'}, format: 'h:mm A'},
          {start: {val: 8,  unit: 'hur'}, end: {val: 24, unit: 'hur'}, between: {val: 1,  unit: 'hur'}, format: 'h A'},
          {start: {val: 1,  unit: 'day'}, end: {val: 7,  unit: 'day'}, between: {val: 8,  unit: 'hur'}, format: 'DD/MM h A'},
          {start: {val: 7,  unit: 'day'}, end: {val: 14, unit: 'day'}, between: {val: 12, unit: 'hur'}, format: 'DD/MM h A'},
          {start: {val: 14, unit: 'day'}, end: {val: 1,  unit: 'mon'}, between: {val: 1,  unit: 'day'}, format: 'MM/DD'},
          {start: {val: 1,  unit: 'mon'}, end: {val: 3,  unit: 'mon'}, between: {val: 7,  unit: 'day'}, format: 'DD/MM'},
          {start: {val: 3,  unit: 'mon'}, end: {val: 6,  unit: 'mon'}, between: {val: 14, unit: 'day'}, format: 'DD/MM'},
          {start: {val: 6,  unit: 'mon'}, end: {val: 1,  unit: 'yea'}, between: {val: 1,  unit: 'mon'}, format: 'MMM/YY'},
          {start: {val: 1,  unit: 'yea'}, end: {val: 3,  unit: 'yea'}, between: {val: 3,  unit: 'mon'}, format: 'MMM/YY'},
          {start: {val: 3,  unit: 'yea'}, end: {val: 5,  unit: 'yea'}, between: {val: 6,  unit: 'mon'}, format: 'MMM/YY'},
          {start: {val: 5,  unit: 'yea'}, end: {val: 10, unit: 'yea'}, between: {val: 1,  unit: 'yea'}, format: 'MMM/YY'}
        ],
        getSeconds: function(time_val) {
          if(time_val.unit == 'min') {
            return time_val.val * 60;
          } else if(time_val.unit == 'hur') {
            return time_val.val * 60 * 60;
          } else if(time_val.unit == 'day') {
            return time_val.val * 60 * 60 * 24;
          } else if(time_val.unit == 'mon') {
            return time_val.val * 60 * 60 * 24 * 30;
          } else if(time_val.unit == 'yea') {
            return time_val.val * 60 * 60 * 24 * 365;
          } else {
            return time_val.val;
          }
        },
        findTickConfig: function(val) {
          var tickConfig = _.find(vm.chart.tickConfigs.data, function(range) {
            var start = vm.chart.tickConfigs.getSeconds(range.start);
            var end = vm.chart.tickConfigs.getSeconds(range.end);
            return (start <= val && val < end)
          });
          if(tickConfig) vm.chart.tickConfigs.default = tickConfig;
          return tickConfig;
        }
      },
      data: []
    };

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Get array data to export CSV
     */
    vm.getCSVHeaders = function() {
      var headers = ['Time'];
      _.each(vm.chart.data, function(item) {
        headers.push(item.key);
      });
      return headers;
    };

    /**
     * Get headers to export CSV
     */
    vm.getCSVRows = function() {
      var rows = [];

      var graphValues = [];
      _.each(vm.chart.data, function(item, itemIndex) {
        _.each(item.values, function(value) {
          graphValues.push({x: value.x, y: value.y, i: itemIndex});
        });
      });

      var graphValuesGroupByTime = _.groupBy(graphValues, function(value) {
        return value.x;
      });

      _.each(graphValuesGroupByTime, function(values, time) {

        var row = [];
        var x;
        if(vm.status_by == 'HOURS') {
          x = moment.unix(time).format('ddd, DD MMM YYYY h A');
        } else if(vm.status_by == 'DAYS') {
          x = moment.unix(time).format('ddd, DD MMM YYYY');
        } else if(vm.status_by == 'WEEKS') {
          x = moment.unix(time).format('ddd, DD MMM YYYY');
        } else if(vm.status_by == 'MONTHS') {
          x = moment.unix(time).format('MMM YYYY');
        } else {
          x = moment.unix(time).format('ddd, DD MMM YYYY HH:mm:ss');
        }

        row.push(x);

        _.each(values, function(value) {
          row[value.i+1] = value.y;
        });

        rows.push(row);
      });

      return rows;
    };

    /**
     * Get CSV Filename
     */
    vm.getCSVFilename = function() {
      var start = moment(vm.search_start_date).format('YYYY-MM-DD');
      var end = moment(vm.search_end_date).format('YYYY-MM-DD');
      var installationNames = _.map(vm.selectedInstallations, function(inst) { return inst.installationName; });
      installationNames = installationNames.join('_');
      return vm.Metrics[vm.search_metric].text + '_' + installationNames + '_' + start + '_' + end + '.csv';
    };

    /**
     * Update yAxisLabel based on metric
     */
    vm.updateAxisLabel = function() {
      if(vm.Metrics[vm.search_metric].unit) {
        vm.chart.options.chart.yAxis.axisLabel = vm.Metrics[vm.search_metric].text + ' (' + vm.Metrics[vm.search_metric].unit + ')';
      } else {
        vm.chart.options.chart.yAxis.axisLabel = vm.Metrics[vm.search_metric].text;
      }
    };

    /**
     * Metric change listener
     */
    vm.onChangeMetric = function() {

      vm.updateAxisLabel();

      vm.refreshGraph();
    };

    /**
     * Date change listener
     */
    vm.onChangeDate = function() {
      vm.refreshGraph();
    };

    /**
     * Status change listener
     */
    vm.onChangeStatus = function() {
      vm.refreshGraph();
    };

    /**
     * Refresh graph
     */
    vm.refreshGraph = function() {

      if(vm.search_start_date && vm.search_end_date && !vm.isLoading) {

        vm.isLoading = true;
        bsLoadingOverlayService.start({referenceId:'graph_loader'});

        var newChartData = [];

        var start = moment(vm.search_start_date).format('YYYY-MM-DDT00:00:00.000Z');
        var end = moment(vm.search_end_date).format('YYYY-MM-DDT23:59:59.999Z');

        var graphStartDate = moment(end).unix();
        var graphEndDate = moment(start).unix();

        if(vm.status_by == 'MONTHS') {
          graphStartDate = moment(moment(end).format('YYYY-MM-01T00:00:00.000Z')).unix();
          graphEndDate = moment(moment(start).format('YYYY-MM-01T00:00:00.000Z')).unix();
        }

        var metric = vm.Metrics[vm.search_metric];

        if(metric.src == 'M2X') {

          if(vm.status_by == 'ALL') {

            async.each(vm.selectedInstallations, function(installation, callback) {

              console.log("installation id: " + installation.id);
              console.log("installation serial: " + installation.serialNumber);

              api.tanks.streamValues.get({tankId:installation.serialNumber, stream: metric.value, start:start, end:end, limit:'10000'},function(res) {

                var values = [];
                if(res.values && res.values.length > 0) {
                  //reset graph_start, graph_end date by limitation
                  var firstDate = moment(res.values[res.values.length-1].timestamp).unix();
                  var lastDate = moment(res.values[0].timestamp).unix();
                  if(graphStartDate > firstDate) {
                    graphStartDate = firstDate;
                  }
                  if(graphEndDate < lastDate) {
                    graphEndDate = lastDate;
                  }

                  // set chart values
                  for(var i = res.values.length-1;i >= 0;i--) {
                    values.push({
                      x: moment(res.values[i].timestamp).unix(),
                      y: (metric.formatValue)?metric.formatValue(res.values[i].value, installation):res.values[i].value
                    });
                  }
                }

                newChartData.push({
                  color: installation.color,
                  key: installation.installationName,
                  values: values
                });

                callback();

              }, function(err) {
                callback(err)
              });

            }, function(err) {

              if( err ) {
                console.log(err);

                if(err.data && err.data.message) {
                  vm.errorMsg = err.data.message;
                } else {
                  vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(vm.errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
                );

              } else {

                //Reset tick

                var tickConfig = vm.chart.tickConfigs.findTickConfig(graphEndDate - graphStartDate);

                if(tickConfig) {

                  var tickSize = vm.chart.tickConfigs.getSeconds(tickConfig.between);
                  var tickCount = (graphEndDate - graphStartDate) / tickSize;
                  var tickFirstTime = graphStartDate - ((graphStartDate + moment().utcOffset() * 60) % tickSize) + tickSize;

                  var tickValues = [];
                  for(var i=0;i<tickCount;i++) {
                    tickValues.push(tickFirstTime + i * tickSize);
                  }
                  vm.chart.options.chart.xAxis.tickValues = tickValues;

                  if(tickCount > 10) {
                    vm.chart.options.chart.xAxis.rotateLabels = 30;
                    vm.chart.options.chart.xAxis.rotateYLabel = true;
                  } else {
                    vm.chart.options.chart.xAxis.rotateLabels = 0;
                    vm.chart.options.chart.xAxis.rotateYLabel = true;
                  }

                } else if(vm.chart.options.chart.xAxis.tickValues) {

                  delete vm.chart.options.chart.xAxis.tickValues;

                  vm.chart.options.chart.xAxis.rotateLabels = 0;
                  vm.chart.options.chart.xAxis.rotateYLabel = true;
                }

                //set data
                vm.chart.data = newChartData;

              }

              vm.isLoading = false;
              bsLoadingOverlayService.stop({referenceId:'graph_loader'});

            });

          } else {

            var interval = 86400;
            if(vm.status_by == 'HOURS') {
              interval = 3600;
            }

            async.each(vm.selectedInstallations, function(installation, callback) {

              api.tanks.streamSampling.get({tankId:installation.serialNumber, stream: vm.Metrics[vm.search_metric].value, metric:'max', start:start, end:end, interval:interval},function(res) {
                if(res.values) {

                  // set chart values
                  var values = [];

                  //check first and last value is out date range
                  if(res.values.length > 0) {
                    if(moment(res.values[0].timestamp) > moment(end)) {
                      res.values.splice(0,1);
                    }
                    if(moment(res.values[res.values.length-1].timestamp) < moment(start)) {
                      res.values.splice(res.values.length-1,1);
                    }
                  }

                  if(res.values.length > 0) {

                    if (vm.status_by == 'WEEKS') {
                      var lastTimeValue = moment(res.values[0].timestamp).unix();
                      var weekUnit = 3600 * 24 * 7;

                      var weeks = _.groupBy(res.values, function (value) {
                        var weekIndex = Math.floor((lastTimeValue - moment(value.timestamp).unix()) / weekUnit);
                        return weekIndex;
                      });

                      _.each(weeks, function (weekValues, weekIndex) {

                        var weekValueSum = 0;
                        _.each(weekValues, function (value) {
                          weekValueSum += value.value;
                        });

                        var weekValueSumAvg = (weekValueSum / weekValues.length).toFixed(2);

                        values.push({
                          x: lastTimeValue - (weekIndex * weekUnit),
                          y: parseFloat((metric.formatValue)?metric.formatValue(weekValueSumAvg, installation):weekValueSumAvg)
                        });

                      });

                      values = values.reverse();

                    } else if (vm.status_by == 'MONTHS') {

                      var months = _.groupBy(res.values, function (value) {
                        var monthString = moment(value.timestamp).format('YYYY-MM-01T00:00:00.000Z');
                        return moment(monthString).unix();
                      });

                      _.each(months, function (monthValues, month) {

                        var monthValueSum = 0;
                        _.each(monthValues, function (value) {
                          monthValueSum += value.value;
                        });

                        var monthValueAvg = (monthValueSum / monthValues.length).toFixed(2);

                        values.push({
                          x: month,
                          y: parseFloat((metric.formatValue) ? metric.formatValue(monthValueAvg, installation):monthValueAvg)
                        });

                      });

                    } else {
                      for (var i = res.values.length - 1; i >= 0; i--) {
                        var unix_timestamp = moment(res.values[i].timestamp).unix();
                        values.push({
                          x: unix_timestamp,
                          y: (metric.formatValue)?metric.formatValue(res.values[i].value, installation):res.values[i].value
                        });
                      }
                    }

                    //reset graph_start, graph_end date by limitation
                    var firstDate = values[0].x;
                    var lastDate = values[values.length - 1].x;

                    if (graphStartDate > firstDate) {
                      graphStartDate = firstDate;
                    }
                    if (graphEndDate < lastDate) {
                      graphEndDate = lastDate;
                    }
                  }

                  newChartData.push({
                    color: installation.color,
                    key: installation.installationName,
                    values: values
                  });

                  callback();
                }
              }, function(err) {
                callback(err)
              });

            }, function(err) {

              if( err ) {
                console.log(err);

                if(err.data && err.data.message) {
                  vm.errorMsg = err.data.message;
                } else {
                  vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                  $mdToast.simple()
                    .textContent(vm.errorMsg)
                    .position('top right')
                    .hideDelay(3000)
                    .theme('error-toast')
                );

              } else {

                /*
                //reset tick
                var tickValues = [];
                var ticks = 12;
                var period;
                var unit;
                var tickSize;

                if(vm.status_by == 'DAYS') {
                  unit = 3600*24;
                } else if(vm.status_by == 'WEEKS') {
                  unit = 3600*24*7;
                } else if(vm.status_by == 'MONTHS') {
                  unit = 3600*24*30;
                } else {
                  unit = 3600;
                }

                //calculate tickSize
                period = parseInt((graphEndDate - graphStartDate) / unit);

                if(period < 12) ticks = period;

                var tickSizeAsHours = parseInt(period / ticks);
                tickSize = tickSizeAsHours * unit;

                for(var i=graphEndDate;i>=graphStartDate;i=i-tickSize) {
                  tickValues.push(i);
                }

                tickValues = tickValues.reverse();

                vm.chart.options.chart.xAxis.tickValues = tickValues;

                if(ticks > 10) {
                  vm.chart.options.chart.xAxis.rotateLabels = 30;
                  vm.chart.options.chart.xAxis.rotateYLabel = true;
                } else {
                  vm.chart.options.chart.xAxis.rotateLabels = 0;
                  vm.chart.options.chart.xAxis.rotateYLabel = true;
                }*/

                //Reset tick

                var tickConfig = vm.chart.tickConfigs.findTickConfig(graphEndDate - graphStartDate);

                if(tickConfig) {

                  var tickSize = vm.chart.tickConfigs.getSeconds(tickConfig.between);
                  var tickCount = (graphEndDate - graphStartDate) / tickSize;

                  var tickValues = [];
                  for(var i=graphEndDate;i>=graphStartDate;i=i-tickSize) {
                    tickValues.push(i);
                  }

                  tickValues = tickValues.reverse();
                  vm.chart.options.chart.xAxis.tickValues = tickValues;

                  if(tickCount > 10) {
                    vm.chart.options.chart.xAxis.rotateLabels = 30;
                    vm.chart.options.chart.xAxis.rotateYLabel = true;
                  } else {
                    vm.chart.options.chart.xAxis.rotateLabels = 0;
                    vm.chart.options.chart.xAxis.rotateYLabel = true;
                  }

                } else if(vm.chart.options.chart.xAxis.tickValues) {

                  delete vm.chart.options.chart.xAxis.tickValues;

                  vm.chart.options.chart.xAxis.rotateLabels = 0;
                  vm.chart.options.chart.xAxis.rotateYLabel = true;
                }

                //set data
                vm.chart.data = newChartData;

              }

              vm.isLoading = false;
              bsLoadingOverlayService.stop({referenceId:'graph_loader'});
            });
          }

        } else {

          async.each(vm.selectedInstallations, function(installation, callback) {

            api.events.pickup.list.get({installationId: installation.id, start:start, end: end}, function(res) {

              var values = [];
              if(res.rows && res.rows.length > 0) {

                if(vm.status_by == 'HOURS' || vm.status_by == 'DAYS' || vm.status_by == 'MONTHS') {

                  var timeFormatForGrouping = 'YYYY-MM-DDTHH:mm:ss.000Z';
                  if(vm.status_by == 'HOURS') {
                    timeFormatForGrouping = 'YYYY-MM-DDTHH:00:00.000Z';
                  } else if(vm.status_by == 'DAYS') {
                    timeFormatForGrouping = 'YYYY-MM-DDT00:00:00.000Z';
                  } else if(vm.status_by == 'MONTHS') {
                    timeFormatForGrouping = 'YYYY-MM-01T00:00:00.000Z';
                  }

                  var groups = _.groupBy(res.rows, function (value) {
                    var time = moment(value.resolvedAt).format(timeFormatForGrouping);
                    return moment(time).unix();
                  });

                  _.each(groups, function (groupValues, time) {

                    var groupValueSum = 0;
                    _.each(groupValues, function (value) {
                      groupValueSum += value[metric.value];
                    });

                    var groupValueAvg = (groupValueSum / groupValues.length).toFixed(2);

                    values.push({
                      x: time,
                      y: (metric.formatValue)?metric.formatValue(groupValueAvg):groupValueAvg
                    });
                  });
                } else if(vm.status_by == 'WEEKS') {

                  var lastTimeValue = moment(res.rows[0].resolvedAt).unix();
                  var weekUnit = 3600 * 24 * 7;

                  var weeks = _.groupBy(res.rows, function (value) {
                    var weekIndex = Math.floor((lastTimeValue - moment(value.resolvedAt).unix()) / weekUnit);
                    return weekIndex;
                  });

                  _.each(weeks, function (weekValues, weekIndex) {

                    var weekValueSum = 0;
                    _.each(weekValues, function (value) {
                      weekValueSum += value[metric.value];
                    });

                    var weekValueSumAvg = (weekValueSum / weekValues.length).toFixed(2);

                    values.push({
                      x: lastTimeValue - (weekIndex * weekUnit),
                      y: (metric.formatValue)?metric.formatValue(weekValueSumAvg):weekValueSumAvg
                    });

                  });

                  values = values.reverse();

                } else {
                  // set chart values
                  for(var i = res.rows.length-1;i >= 0;i--) {
                    values.push({
                      x: moment(res.rows[i].resolvedAt).unix(),
                      y: (metric.formatValue)?metric.formatValue(res.rows[i][metric.value]):res.rows[i][metric.value]
                    });
                  }
                }

                //reset graph_start, graph_end date by limitation
                var firstDate = values[0].x;
                var lastDate = values[values.length - 1].x;

                if (graphStartDate > firstDate) {
                  graphStartDate = firstDate;
                }
                if (graphEndDate < lastDate) {
                  graphEndDate = lastDate;
                }

              }

              newChartData.push({
                color: installation.color,
                key: installation.installationName,
                values: values
              });

              callback();
            }, function(err) {
              callback(err);
            });

          }, function(err) {

            if( err ) {
              console.log(err);

              if(err.data && err.data.message) {
                vm.errorMsg = err.data.message;
              } else {
                vm.errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );

            } else {

              if(vm.status_by == 'ALL') {
                //remove tickValues
                if(vm.chart.options.chart.xAxis.tickValues)
                  delete vm.chart.options.chart.xAxis.tickValues;

                vm.chart.options.chart.xAxis.rotateLabels = 0;
                vm.chart.options.chart.xAxis.rotateYLabel = true;

                //set data
                vm.chart.data = newChartData;

              } else {
                //set data
                vm.chart.data = newChartData;

                //reset tick
                var tickValues = [];
                var ticks = 12;
                var period;
                var unit;
                var tickSize;

                if(vm.status_by == 'DAYS') {
                  unit = 3600*24;
                } else if(vm.status_by == 'WEEKS') {
                  unit = 3600*24*7;
                } else if(vm.status_by == 'MONTHS') {
                  unit = 3600*24*30;
                } else {
                  unit = 3600;
                }

                //calculate tickSize
                period = parseInt((graphEndDate - graphStartDate) / unit);

                if(period < 12) ticks = period;

                var tickSizeAsHours = parseInt(period / ticks);
                tickSize = tickSizeAsHours * unit;

                for(var i=graphEndDate;i>=graphStartDate;i=i-tickSize) {
                  tickValues.push(i);
                }

                tickValues = tickValues.reverse();

                vm.chart.options.chart.xAxis.tickValues = tickValues;

                if(ticks > 10) {
                  vm.chart.options.chart.xAxis.rotateLabels = 30;
                  vm.chart.options.chart.xAxis.rotateYLabel = true;
                } else {
                  vm.chart.options.chart.xAxis.rotateLabels = 0;
                  vm.chart.options.chart.xAxis.rotateYLabel = true;
                }
              }

            }

            vm.isLoading = false;
            bsLoadingOverlayService.stop({referenceId:'graph_loader'});

          });

        }

      }
    };

    /**
     * Close customer dialog
     */
    vm.close = function() {
      $mdDialog.hide(false);
    };



    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

      if($rootScope.search_period) {
        vm.search_start_date = moment().subtract($rootScope.search_period, "days").toDate();
        vm.search_end_date = new Date();
      } else {
        vm.search_start_date = $rootScope.search_start_date;
        vm.search_end_date = $rootScope.search_end_date;
      }

      vm.updateAxisLabel();

      vm.refreshGraph();
    }

    _init();

}

function CustomerDialogController($scope, $mdDialog, $mdToast, US_STATES, params, api, gmapapi, Timezones)
{
    var vm = this;


    // ******************************
    // Variables
    // ******************************

    vm.States = US_STATES;
    vm.Timezones = Timezones.getTimezonesUS();
    vm.selectedCompany  = null;
    vm.searchCompany    = null;
    vm.PaymentPeriodUnits = ['Days', 'Weeks', 'Months', 'Years'];
    vm.IndoorOutdoors = ['Indoor', 'Outdoor'];
    vm.SystemVoltages = ['230V', '460V'];
    vm.ContractTypes = ['All-in', 'PAYG', 'Sold Equip.', 'Distribution'];
    vm.FrostProtection = [
      {
        value: true,
        label: 'Yes'
      },
      {
        value: false,
        label: 'No'
      }
    ];

    //Initialize default value for selected installation
    vm.selectedInstallation = {
      id: params.selectedInstallation.id,
      serialNumber: params.selectedInstallation.serialNumber,
      simCardHandle: params.selectedInstallation.simCardHandle,
      Customer: {
        lat: (params.selectedInstallation.Customer)?params.selectedInstallation.Customer.lat:'',
        lng: (params.selectedInstallation.Customer)?params.selectedInstallation.Customer.lng:'',
        timezone: 'America/Chicago',
        paymentPeriodInterval: {
          units: 'Months'
        },
        pricePerPayPeriod: {
          units: 'Dollars'
        },
        paymentsPerYear: '',
        annualRevenue: {
          units: 'Dollars'
        },
        contractType: 'All-in',
        allocatedServiceCost: {
          units: 'Dollars'
        },
        haulingCost: {
          units: 'Dollars'
        }/*,
        adCost: {
          units: 'Dollars'
        }*/
      },
      Tank: {
        contractLength: {
          units: 'Months'
        },
        nominalVolume: {
          units: 'Gallons'
        },
        usefulVolume: {
          units: 'Gallons'
        },
        highThreshold: {
          units: '%'
        },
        criticalThreshold: {
          units: '%'
        },
        isAutoHighThreshold: false,
        isAutoCriticalThreshold: false,
        isAutoLeadTimeForSchedulingPickUp: false,
        isAutoConsiderSaturday: false,
        contractWasteProductionEstimate: {
          units: 'Tons/week'
        },
        expectedSlurryYield: {
          value: 240,
          units: 'Gallons/week'
        },
        //tankLocation: vm.IndoorOutdoors[0],
        //systemVoltage: vm.SystemVoltages[0]
      }
    };
    vm.mode = params.mode;
    vm.isGoogleMapLoaded =  params.isGoogleMapLoaded;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * refresh auto values
     */
    vm.refreshAutoReadOnlyValues = function() {
      vm.onChangeIsAutoHighThreshold();
      vm.onChangeIsAutoCriticalThreshold();
      vm.onChangeIsAutoConsiderSaturday();
      vm.onChangeIsAutoLeadTimeForSchedulingPickUp();
    };

    /**
     * isAutoHighThreshold change listener
     */
    vm.onChangeIsAutoHighThreshold = function() {
      if(vm.selectedInstallation.Tank.highThreshold.value == null || vm.selectedInstallation.Tank.highThreshold.value == undefined) {
        vm.selectedInstallation.Tank.isAutoHighThreshold = false;
      }

      if(vm.selectedInstallation.Tank.isAutoHighThreshold == true) {
        if(vm.selectedInstallation.Tank.highThresholdAuto == null || vm.selectedInstallation.Tank.highThresholdAuto == undefined) {
          vm.highThresholdAutoReadOnly = vm.selectedInstallation.Tank.highThreshold.value;
        } else {
          vm.highThresholdAutoReadOnly = vm.selectedInstallation.Tank.highThresholdAuto;
        }
      }
    };

    /**
     * isAutoCriticalThreshold change listener
     */
    vm.onChangeIsAutoCriticalThreshold = function() {
      if(vm.selectedInstallation.Tank.criticalThreshold.value == null || vm.selectedInstallation.Tank.criticalThreshold.value == undefined) {
        vm.selectedInstallation.Tank.isAutoCriticalThreshold = false;
      }

      if(vm.selectedInstallation.Tank.isAutoCriticalThreshold == true) {
        if(vm.selectedInstallation.Tank.criticalThresholdAuto == null || vm.selectedInstallation.Tank.criticalThresholdAuto == undefined) {
          vm.criticalThresholdAutoReadOnly = vm.selectedInstallation.Tank.criticalThreshold.value;
        } else {
          vm.criticalThresholdAutoReadOnly = vm.selectedInstallation.Tank.criticalThresholdAuto;
        }
      }
    };

    /**
     * isAutoConsiderSaturday change listener
     */
    vm.onChangeIsAutoConsiderSaturday = function() {

      if(vm.selectedInstallation.Tank.considerSaturday == null || vm.selectedInstallation.Tank.considerSaturday == undefined) {
        vm.selectedInstallation.Tank.isAutoConsiderSaturday = false;
      }

      if(vm.selectedInstallation.Tank.isAutoConsiderSaturday == true) {
        if(vm.selectedInstallation.Tank.considerSaturdayAuto == null || vm.selectedInstallation.Tank.considerSaturdayAuto == undefined) {
          vm.considerSaturdayAutoReadOnly = vm.selectedInstallation.Tank.considerSaturday;
        } else {
          vm.considerSaturdayAutoReadOnly = vm.selectedInstallation.Tank.considerSaturdayAuto;
        }
      }
    };

    /**
     * isAutoLeadTimeForSchedulingPickUp change listener
     */
    vm.onChangeIsAutoLeadTimeForSchedulingPickUp = function() {
      if(vm.selectedInstallation.Tank.leadTimeForSchedulingPickUp == null || vm.selectedInstallation.Tank.leadTimeForSchedulingPickUp == undefined) {
        vm.selectedInstallation.Tank.isAutoLeadTimeForSchedulingPickUp = false;
      }

      if(vm.selectedInstallation.Tank.isAutoLeadTimeForSchedulingPickUp == true) {
        if(vm.selectedInstallation.Tank.leadTimeForSchedulingPickUpAuto == null || vm.selectedInstallation.Tank.leadTimeForSchedulingPickUpAuto == undefined) {
          vm.leadTimeForSchedulingPickUpAutoReadOnly = vm.selectedInstallation.Tank.leadTimeForSchedulingPickUp;
        } else {
          vm.leadTimeForSchedulingPickUpAutoReadOnly = vm.selectedInstallation.Tank.leadTimeForSchedulingPickUpAuto;
        }
      }
    };

    /**
     * Update installation
     */
    vm.updateInstallation = function() {

      vm.isSaving = true;

      var params = angular.copy(vm.selectedInstallation);

      delete params.id;
      delete params.Company;
      delete params.createdAt;
      delete params.updatedAt;
      delete params.deActivatedAt;
      delete params.isActive;

      if(params.Customer) {

        delete params.Customer.id;
        delete params.Customer.InstallationId;
        delete params.Customer.createdAt;
        delete params.Customer.updatedAt;

        if(!params.Customer.contact) {
          delete params.Customer.contact;
        }

        if(params.Customer.minHaulsAnnual === null || params.Customer.minHaulsAnnual === undefined) {
          delete params.Customer.minHaulsAnnual;
        }

      }
      if(params.Tank) {

        delete params.Tank.id;
        delete params.Tank.InstallationId;
        delete params.Tank.createdAt;
        delete params.Tank.updatedAt;

        if(!params.Tank.installerContact) {
          delete params.Tank.installerContact;
        }

        if(vm.customerFormInstallDate) {
          params.Tank.installDate = moment(vm.customerFormInstallDate).format('YYYY-MM-DD');
          params.Tank.expectedRenewalDate = moment(vm.customerFormInstallDate).add(vm.selectedInstallation.Tank.contractLength.value, "months").format('YYYY-MM-DD');
        } else {
          delete params.Tank.installDate;
          delete params.Tank.expectedRenewalDate;
        }

        if(vm.customerFormIotActivationDate) {
          params.Tank.iotActivationDate = moment(vm.customerFormIotActivationDate).format('YYYY-MM-DD');
        } else {
          params.Tank.iotActivationDate = null;
        }
        if(vm.customerFormClientSinceDate) {
          params.Tank.clientSinceDate = moment(vm.customerFormClientSinceDate).format('YYYY-MM-DD');
        } else {
          params.Tank.clientSinceDate = null;
        }
      }

      if(vm.mode == 'add') {

        api.adminInstallations.list.save(
          params,
          // Success
          function (response)
          {
            vm.isSaving = false;
            vm.msg = 'New device assigned successfully!';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.msg)
                .position('top right')
                .hideDelay(3000)
                .theme('success-toast')
            );

            vm.ok({
              mode: 'add',
              data: response
            });

          },
          // Error
          function (response)
          {
            console.log(response);
            vm.isSaving = false;

            if(response.data && response.data.message) {
              vm.errMsg = response.data.message;
            } else {
              vm.errMsg = 'Something went wrong!';
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.errMsg)
                .position('top right')
                .hideDelay(3000)
                .theme('error-toast')
            );
          }
        );

      } else if(vm.mode == 'edit') {

        params.installationId = vm.selectedInstallation.id;

        api.adminInstallations.attributes.save(
          params,
          // Success
          function (response)
          {
            vm.isSaving = false;
            vm.msg = 'Updated successfully!';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.msg)
                .position('top right')
                .hideDelay(3000)
                .theme('success-toast')
            );

            vm.ok({
              mode: 'edit',
              data: response
            });

          },
          // Error
          function (response)
          {
            console.log(response);
            vm.isSaving = false;

            if(response.data && response.data.message) {
              vm.errorMsg = response.data.message;
            } else {
              vm.errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.errorMsg)
                .position('top right')
                .hideDelay(3000)
                .theme('error-toast')
            );
          }
        );

      }

    };

    /**
     * Deactivate installation
     */
    vm.deactivateInstallation = function(ev) {

      $mdDialog.show({
        controller: CustomConfirmDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
        locals: {
          title: 'Deactivate Confirmation',
          message: 'Are you sure you want to deactivate this installation?',
          okButton: 'Deactivate',
          cancelButton: 'Cancel',
          okFunc: null
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        escapeToClose: false,
        skipHide: true
      }).then(function(isOk){
        if(isOk) {

          vm.isSaving = true;

          api.adminInstallations.actionById.save(
            {
              installationId: vm.selectedInstallation.id,
              serialNumber: null,
              simCardHandle: null,
              isActive: false
            },
            // Success
            function (response)
            {
              vm.isSaving = false;
              vm.msg = 'Deactivated successfully!';

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.msg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('success-toast')
              );

              vm.ok({
                mode: 'deactivate',
                data: response
              });

            },
            // Error
            function (response)
            {
              console.log(response);
              vm.isSaving = false;

              if(response.data && response.data.message) {
                vm.errorMsg = response.data.message;
              } else {
                vm.errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );
            }
          );
        }
      });

    };

    /**
     * Deleate installation
     */
    vm.deleteInstallation = function(ev) {

      $mdDialog.show({
        controller: CustomConfirmDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
        locals: {
          title: 'Deactivate & Delete Confirmation',
          message: 'Are you sure you want to deactivate and delete this installation?',
          okButton: 'Deactivate & Delete',
          cancelButton: 'Cancel',
          okFunc: null
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        escapeToClose: false,
        skipHide: true
      }).then(function(isOk){
        if(isOk) {

          vm.isSaving = true;

          api.adminInstallations.actionById.delete(
            {
              installationId: vm.selectedInstallation.id
            },
            // Success
            function (response)
            {
              vm.isSaving = false;
              vm.msg = 'Deactivated and deleted successfully!';

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.msg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('success-toast')
              );

              vm.ok({
                mode: 'delete',
                data: response
              });

            },
            // Error
            function (response)
            {
              console.log(response);
              vm.isSaving = false;

              if(response.data && response.data.message) {
                vm.errorMsg = response.data.message;
              } else {
                vm.errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );
            }
          );
        }
      });

    };

    /**
     * Open Company Dialog
     */
    vm.openCompanyDlg = function() {

    };

    /**
     * Get latitude, longitude from address using google map api
     */
    vm.geocode = function() {

      if(vm.isGoogleMapLoaded) {

        var address = [
          vm.selectedInstallation.Customer.address,
          vm.selectedInstallation.Customer.city,
          vm.selectedInstallation.Customer.state,
          vm.selectedInstallation.Customer.zipcode
        ].join();

        var geocoder = new google.maps.Geocoder();

        geocoder.geocode( { 'address': address}, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if(results.length > 0) {

              var lat = results[0].geometry.location.lat();
              var lng = results[0].geometry.location.lng();

              $scope.$apply(function() {
                vm.selectedInstallation.Customer.lat = lat;
                vm.selectedInstallation.Customer.lng = lng;
              });

              // Get Timezone
              /*gmapapi.getTimezone.get({location: lat+','+lng, timestamp: moment().unix()}, function(result) {
                if(result.status === 'OK') {
                    vm.selectedInstallation.Customer.timezone = result.timeZoneId;
                    vm.onChangeTimezone();
                }
              });*/
            }
          } else {
            console.log(status);
          }
        });
      }
    };

    /**
     * Listen for timezone
     */
    /*vm.onChangeTimezone = function() {
        if(vm.selectedInstallation.Customer.timezone) {
            vm.customerFormTimezoneName = moment().tz(vm.selectedInstallation.Customer.timezone).format('z( Z )');
        }
    };*/

    /**
     * Query companies for auto complete box
     */
    vm.queryCompany = function(query) {

      var results = query ? vm.companies.filter( _createFilterFor(query) ) : vm.companies;
      return results;
    };

    /**
     * Listener when changed company selection in auto complete box
     */
    vm.selectedCompanyChange = function(company) {
      if(company) {
        vm.selectedInstallation.CompanyId = company.id;
      }

    };

    /**
     * Listener when changed query text in auto complete box
     */
    vm.searchTextChange = function(searchCompany) {
      var filtered_companies = _.filter(vm.companies, function(company) {
        return company.name == searchCompany;
      });
      if(filtered_companies.length == 1) {
        vm.selectedCompany = filtered_companies[0];
      }
    };

    /**
     * Close customer dialog
     */
    vm.close = function() {
      $mdDialog.cancel();
    };

    /**
     * Close customer dialog with response
     */
    vm.ok = function(res) {
      $mdDialog.hide(res);
    };

    /**
     * Calculate payments per year
     */
    vm.calculatePaymentsPerYear = function() {
      if(vm.selectedInstallation.Customer) {
        if(vm.selectedInstallation.Customer.paymentPeriodInterval &&
          vm.selectedInstallation.Customer.paymentPeriodInterval.value > 0) {

          if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Days') {
            vm.selectedInstallation.Customer.paymentsPerYear = 365 / vm.selectedInstallation.Customer.paymentPeriodInterval.value;
          } else if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Weeks') {
            vm.selectedInstallation.Customer.paymentsPerYear = 54 / vm.selectedInstallation.Customer.paymentPeriodInterval.value;
          } else if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Months') {
            vm.selectedInstallation.Customer.paymentsPerYear = 12 / vm.selectedInstallation.Customer.paymentPeriodInterval.value;
          } else if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Years') {
            vm.selectedInstallation.Customer.paymentsPerYear = 1 / vm.selectedInstallation.Customer.paymentPeriodInterval.value;
          }
          if(vm.selectedInstallation.Customer.paymentsPerYear) {
            vm.selectedInstallation.Customer.paymentsPerYear = parseInt(vm.selectedInstallation.Customer.paymentsPerYear);
            return;
          }
        }
      }

      vm.selectedInstallation.Customer.paymentsPerYear = 0;
    };


    /**
     * Calculate payments per year
     */
    vm.calculateAnnualRevenue = function() {

      if(vm.selectedInstallation.Customer) {
        if(vm.selectedInstallation.Customer.pricePerPayPeriod &&
          vm.selectedInstallation.Customer.pricePerPayPeriod.value > 0 &&
          vm.selectedInstallation.Customer.paymentPeriodInterval &&
          vm.selectedInstallation.Customer.paymentPeriodInterval.value > 0) {

          if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Days') {
            vm.selectedInstallation.Customer.annualRevenue.value = 365 / vm.selectedInstallation.Customer.paymentPeriodInterval.value * vm.selectedInstallation.Customer.pricePerPayPeriod.value;
          } else if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Weeks') {
            vm.selectedInstallation.Customer.annualRevenue.value = 54 / vm.selectedInstallation.Customer.paymentPeriodInterval.value * vm.selectedInstallation.Customer.pricePerPayPeriod.value;
          } else if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Months') {
            vm.selectedInstallation.Customer.annualRevenue.value = 12 / vm.selectedInstallation.Customer.paymentPeriodInterval.value * vm.selectedInstallation.Customer.pricePerPayPeriod.value;
          } else if(vm.selectedInstallation.Customer.paymentPeriodInterval.units == 'Years') {
            vm.selectedInstallation.Customer.annualRevenue.value = 1 / vm.selectedInstallation.Customer.paymentPeriodInterval.value * vm.selectedInstallation.Customer.pricePerPayPeriod.value;
          }

          if(vm.selectedInstallation.Customer.annualRevenue.value) {
            vm.selectedInstallation.Customer.annualRevenue.value = parseFloat(vm.selectedInstallation.Customer.annualRevenue.value.toFixed(2));
            return;
          }

        }
      }

      vm.selectedInstallation.Customer.annualRevenue.value = 0;
    };

    /**
     * Calculate renewal date from installed date & contract length
     */
    vm.calculateRenewalDate = function() {

      if(vm.customerFormInstallDate && vm.selectedInstallation.Tank.contractLength.value > 0) {
        vm.customerFormExpectedRenewalDate = moment(vm.customerFormInstallDate).add(vm.selectedInstallation.Tank.contractLength.value, "months").format('MM/DD/YYYY');
      } else {
        vm.customerFormExpectedRenewalDate = '';
      }

    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {

      _loadData();

    }

    /**
     * Build `states` list of key/value pairs
     */
    function _loadData() {

      vm.isLoading = true;

      async.parallel({
        companies: function(callback) {

          api.adminCompanies.list.get(
            null,
            // Success
            function (response)
            {

              vm.companies = _.filter(response.rows, function(company) {
                return company.isActive == true;
              });

              callback(null);
            },
            // Error
            function (err)
            {
              callback(err);
            }
          );

        },
        installation: function(callback) {
          if(vm.mode == 'edit') {
            api.adminInstallations.actionById.get(
              {installationId: vm.selectedInstallation.id},
              // Success
              function (response)
              {

                vm.selectedInstallation = response;

                vm.selectedCompany = vm.selectedInstallation.Company;

                if(vm.selectedInstallation.Tank.installDate && vm.selectedInstallation.Tank.installDate !== null) {
                  vm.customerFormInstallDate = new Date(vm.selectedInstallation.Tank.installDate + ' 00:00:00');
                  vm.calculateRenewalDate();
                }

                if(vm.selectedInstallation.Tank.iotActivationDate && vm.selectedInstallation.Tank.iotActivationDate !== null) {
                  vm.customerFormIotActivationDate = new Date(vm.selectedInstallation.Tank.iotActivationDate + ' 00:00:00');
                }

                if(vm.selectedInstallation.Tank.clientSinceDate && vm.selectedInstallation.Tank.clientSinceDate !== null) {
                  vm.customerFormClientSinceDate = new Date(vm.selectedInstallation.Tank.clientSinceDate + ' 00:00:00');
                }

                //init auto readonly values for threashold, consider saturday, lead time
                vm.refreshAutoReadOnlyValues();

                //init timezone
                //vm.onChangeTimezone();

                callback(null);

                //The case that the installation was already deactivated by someone
                if(vm.selectedInstallation.isActive != true) {
                  $mdToast.show(
                    $mdToast.simple()
                      .textContent('This was deactivated installation!')
                      .position('top right')
                      .hideDelay(3000)
                      .theme('error-toast')
                  );
                  vm.ok({
                    mode: 'deactivate',
                    data: vm.selectedInstallation
                  });
                }

              },
              // Error
              function (err)
              {
                callback(err);
              }
            );
          } else {
            callback(null);
          }
        }
      }, function(err, results) {
        if(err) {
          console.log(err);
          if(err.data && err.data.message) {
            vm.errorMsg = err.data.message;
          } else {
            vm.errorMsg = 'Something went wrong!';
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(vm.errorMsg)
              .position('top right')
              .hideDelay(3000)
              .theme('error-toast')
          );

          vm.close();

        } else {

        }
        vm.isLoading = false;

      });

    }
    /**
     * Create filter function for a query string
     */
    function _createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(company) {
        return (company.name.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }

    _init();

}


function CustomConfirmDialogController($scope, $mdDialog, title, message, okButton, cancelButton, okFunc)
{

    var vm = this;

    vm.title = title;
    vm.message = message;
    vm.okButton = okButton;
    vm.cancelButton = cancelButton;

    // ******************************
    // Methods Declaration
    // ******************************

    /**
     * Ok
     */
    vm.ok = function() {
      if(okFunc) {
        okFunc()
          .then(function(res) {
            $mdDialog.hide({return_code:true, data:res});
          })
          .catch(function(err) {
            $mdDialog.hide({return_code:false, data:err});
          });
      } else {
        $mdDialog.hide({return_code:true});
      }
    };

    /**
     * Cancel
     */
    vm.cancel = function() {
      $mdDialog.hide(false);
    };


    init();


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function init() {

    }

}


function CompanyDialogController($scope, $mdDialog, $mdToast, $q, api, currentUser)
{

  // ******************************
  // Variables
  // ******************************

  var vm = this;
  vm.isDataChanged = false;
  vm.currentUser = currentUser;
  vm.companiesData = {};
  vm.companiesTable = {
    columns:[
      {
        title: 'Company Name'
      },
      {
        title: 'Corporate Contact Name'
      },
      {
        title: 'Corporate Contact Title'
      },
      {
        title: 'Phone #'
      },
      {
        title: 'Email'
      },
      {
        title: 'No of Installs'
      },
      {
        title: 'Status'
      }
    ],
    rows:[],
    dtOptions: {
      dom       : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      pageLength: 10,
      lengthMenu: [10, 20, 50, 100],
      autoWidth : true,
      responsive: false,
      aaSorting: [0, 'asc'],
      columnDefs: [
        { targets: [3, 5], className: "dt-center"}
      ]
    }
  };

  // ******************************
  // Public Methods
  // ******************************

  /**
   * Open add dialog
   */
  vm.openAddDlg = function (ev, mode, id) {

    if(!vm.currentUser.hasAdminRole()) return;

    var companyData = {};

    if(mode == 'edit') {
      companyData = vm.getCompanyDataById(id);
    }

    $mdDialog.show({
        controller: AddCompanyDialogController,
        controllerAs: 'vm',
        locals: {
          mode: mode,
          companyData: companyData
        },
        templateUrl: 'app/main/dashboard/company/company-dialog-add.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        escapeToClose: false,
        fullscreen: true,
        skipHide: true
      })
      .then(function(ret) {
        if(ret) {

          if(ret.mode == 'add') {
            vm.addCompanyData(ret.data);
          } else if(ret.mode == 'edit') {
            vm.setCompanyData(ret.data);
          } else if(ret.mode == 'deactivate') {
            vm.setCompanyData(ret.data);
          } else if(ret.mode == 'delete') {
            vm.deleteCompanyData(ret.data);
          }

          vm.isDataChanged = true;

        }
      }, function() {

      });
  };

  /**
   * Close dialog
   */
  vm.close = function() {
      $mdDialog.hide(vm.isDataChanged);
  };

  /**
   * Get CompanyData By Id
   */
  vm.getCompanyDataById = function(id) {
    return _.find(vm.companiesData.rows, function(company) {
      return company.id == id;
    });
  };

  /**
   * Set CompanyData
   */
  vm.setCompanyData = function(data) {

    var index = _.findIndex(vm.companiesData.rows, {id: data.id});

    if(index != -1) {
      vm.companiesData.rows[index] = data;
    }

    var index = _.findIndex(vm.companiesTable.rows, {id: data.id});

    if(index != -1) {
      vm.companiesTable.rows[index] = _getCompaniesTableRow(data);
    }

  };

  /**
   * Delete CompanyData
   */
  vm.deleteCompanyData = function(data) {

    var index = _.findIndex(vm.companiesData.rows, {id: data.id});

    if(index != -1) {
      vm.companiesData.rows.splice(index, 1);
    }

    var index = _.findIndex(vm.companiesTable.rows, {id: data.id});

    if(index != -1) {
      vm.companiesTable.rows.splice(index, 1);
    }

  };

  /**
   * Add CompanyData
   */
  vm.addCompanyData = function(data) {

    vm.companiesData.rows.push(data);
    vm.companiesTable.rows.push(_getCompaniesTableRow(data));

  };

  // ******************************
  // Internal methods
  // ******************************

  /**
   * Load companies data
   */
  function _loadCompaniesData() {

    vm.isLoading = true;

    api.adminCompanies.list.get(
      null,
      // Success
      function (response)
      {
        //console.log(response);
        vm.isLoading = false;
        vm.companiesData = response;

        vm.companiesTable.rows = [];

        if(vm.companiesData && vm.companiesData.rows) {

          _.each(vm.companiesData.rows, function(companyData) {

            var row = _getCompaniesTableRow(companyData);

            vm.companiesTable.rows.push(row);

          });
        }

      },
      // Error
      function (response)
      {
        console.log(response);
        vm.isLoading = false;

        var errorMsg;
        if(response.data && response.data.message) {
          errorMsg = response.data.message;
        } else {
          errorMsg = 'Something went wrong!';
        }

        $mdToast.show(
          $mdToast.simple()
            .textContent(errorMsg)
            .position('top right')
            .hideDelay(3000)
            .theme('error-toast')
        );
      }
    );
  }

  /**
   * Get Table Row for render from data
   */
  function _getCompaniesTableRow(companyData) {

    var row = {id: companyData.id, cells:[]};

    row.cells[0] = {
      value: companyData.name,
      isEditLink: true
    };
    row.cells[1] = {
      value: companyData.contactName
    };
    row.cells[2] = {
      value: companyData.contactTitle
    };
    row.cells[3] = {
      value: companyData.contactPhone
    };
    row.cells[4] = {
      value: companyData.contactEmail
    };
    row.cells[5] = {
      value: companyData.InstallationsCount
    };
    row.cells[6] = {
      value: (companyData.isActive === true)?'ACTIVE':'DEACTIVATED'
    };

    return row;
  }

  /**
   * Get full addreess
   */
  function _getFullAddress(address, city, state, zipcode) {
    var addr = address;
    if(city != '') {
      addr += (', ' + city);
    }
    if(state != '') {
      addr += (', ' + state);
    }
    if(zipcode != '') {
      addr += (', ' + zipcode);
    }
    return addr;
  }

  /**
   * Initialize
   */
  function _init() {

    _loadCompaniesData();

  }

  _init();


  /**
   * Add Dialog Controller
   */
  function AddCompanyDialogController($scope, $mdDialog, mode, companyData, US_STATES) {

    // ******************************
    // Variables
    // ******************************

    var vm = this;

    vm.States = US_STATES;
    vm.isSaving = false;

    vm.mode = mode;
    vm.companyData = companyData;

    // ******************************
    // Public Methods
    // ******************************

    /**
     * Update company
     */
    vm.updateCompany = function() {

      vm.isSaving = true;
      vm.msg = 'Updating...';

      var params = {
        name: vm.companyData.name,
        contactName: vm.companyData.contactName,
        contactTitle: vm.companyData.contactTitle,
        contactPhone: vm.companyData.contactPhone,
        contactEmail: vm.companyData.contactEmail
      };

      if(vm.mode == 'add') {

        api.adminCompanies.list.save(
          params,
          // Success
          function (response)
          {
            vm.isSaving = false;
            vm.companyData = response;
            vm.msg = 'Updated successfully!';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.msg)
                .position('top right')
                .hideDelay(3000)
                .theme('success-toast')
            );

            vm.close({
              mode: 'add',
              data: vm.companyData
            });

          },
          // Error
          function (response)
          {
            console.log(response);
            vm.isSaving = false;
            vm.msg = '';

            var errorMsg;
            if(response.data && response.data.message) {
              errorMsg = response.data.message;
            } else {
              errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent(errorMsg)
                .position('top right')
                .hideDelay(3000)
                .theme('error-toast')
            );
          }
        );

      } else if(vm.mode == 'edit') {

        params.companyId = vm.companyData.id;

        api.adminCompanies.actionById.save(
          params,
          // Success
          function (response)
          {
            vm.isSaving = false;
            vm.companyData = response;
            vm.msg = 'Updated successfully!';

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.msg)
                .position('top right')
                .hideDelay(3000)
                .theme('success-toast')
            );

            vm.close({
              mode: 'edit',
              data: vm.companyData
            });

          },
          // Error
          function (response)
          {
            console.log(response);
            vm.isSaving = false;
            vm.msg = '';

            var errorMsg;
            if(response.data && response.data.message) {
              errorMsg = response.data.message;
            } else {
              errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent(errorMsg)
                .position('top right')
                .hideDelay(3000)
                .theme('error-toast')
            );
          }
        );

      }


    };

    /**
     * Deactivate company
     */
    vm.deactivateCompany = function(ev) {

      $mdDialog.show({
        controller: CustomConfirmDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
        locals: {
          title: (vm.companyData.isActive === true)?'Deactivate Confirmation':'Activate Confirmation',
          message: (vm.companyData.isActive === true)?'Are you sure you want to deactivate this company?':'Are you sure you want to activate this company?',
          okButton: (vm.companyData.isActive === true)?'Deactivate':'Activate',
          cancelButton: 'Cancel',
          okFunc: null
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        escapeToClose: false,
        skipHide: true
      }).then(function(isOk){
        if(isOk) {

          vm.isSaving = true;
          vm.msg = (vm.companyData.isActive === true)?'Deactivating...':'Activating...';

          api.adminCompanies.status.save(
            {
              companyId: vm.companyData.id,
              isActive: !(vm.companyData.isActive)
            },
            // Success
            function (response)
            {
              vm.companyData = response;
              vm.isSaving = false;
              vm.msg = (vm.companyData.isActive === true)?'Activated successfully!':'Deactivated successfully!';

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.msg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('success-toast')
              );

              vm.close({
                mode: 'deactivate',
                data: vm.companyData
              });

            },
            // Error
            function (response)
            {
              console.log(response);
              vm.isSaving = false;
              vm.msg = '';

              var errorMsg;
              if(response.data && response.data.message) {
                errorMsg = response.data.message;
              } else {
                errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );
            }
          );

        }
      });

    };

    /**
     * Delete company
     */
    vm.deleteCompany = function(ev) {

      $mdDialog.show({
        controller: CustomConfirmDialogController,
        controllerAs: 'vm',
        templateUrl: 'app/main/dashboard/custom-confirm/custom-confirm.tmpl.html',
        locals: {
          title: 'Delete confirmation',
          message: 'Are you sure you want to delete this company?',
          okButton: 'Delete Company',
          cancelButton: 'Cancel',
          okFunc: null
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        escapeToClose: false,
        skipHide: true
      }).then(function(isOk){
        if(isOk) {

          vm.isSaving = true;
          vm.msg = 'Deleting...';

          api.adminCompanies.actionById.remove(
            {
              companyId: vm.companyData.id
            },
            // Success
            function (response)
            {
              vm.isSaving = false;
              vm.msg = 'Deleted successfully!';

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.msg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('success-toast')
              );

              vm.close({
                mode: 'delete',
                data: vm.companyData
              });

            },
            // Error
            function (response)
            {
              console.log(response);
              vm.isSaving = false;
              vm.msg = '';

              var errorMsg;
              if(response.data && response.data.message) {
                errorMsg = response.data.message;
              } else {
                errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );
            }
          );

        }
      });

    };

    /**
     * Close customer dialog
     */
    vm.close = function(data) {
        $mdDialog.hide(data);
    };


    // ******************************
    // Internal methods
    // ******************************

    /**
     * Initialize
     */
    function _init() {


    }

    _init();

  }

}

(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_reset-password', {
            url      : '/auth/reset-password/:token',
            params   : {
                token: 'invalid'
            },
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_reset-password': {
                    templateUrl: 'app/main/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/reset-password');

        // Navigation
        msNavigationServiceProvider.saveItem('auth.reset-password', {
            title : 'Reset Password',
            state : 'app.auth_reset-password',
            weight: 3
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($scope, $stateParams, api)
    {
        // ******************************
        // Variables
        // ******************************

        var vm = this;

        vm.isWorking = false;
        vm.isResetDone = false;
        vm.msg = '';

        // ******************************
        // Public Methods
        // ******************************

        vm.submit = function() {

          vm.isWorking = true;

          api.resetPassword.save(
            {
              token: vm.resetToken,
              newPassword: vm.form.password,
              verifyPassword: vm.form.passwordConfirm
            },
            // Success
            function (response)
            {
              console.log(response);
              vm.msg = response.message || 'Password was successfully changed';

              vm.isResetDone = true;

              vm.isWorking = false;

            },
            // Error
            function (response)
            {
              console.log(response);
              if(response.data && response.data.message) {
                vm.msg = response.data.message;
              } else {
                vm.msg = 'Something went wrong!';
              }
              vm.isWorking = false;

            }
          );

        };

        vm.checkPasswordConfirm = function() {

          if(vm.form.password && vm.form.passwordConfirm) {
            if(vm.form.password != vm.form.passwordConfirm) {
              vm.msg = 'Password(Confirm) is not matched!';
            } else {
              vm.msg = '';
            }
          }

        };

        // ******************************
        // Internal methods
        // ******************************

        function _init() {

            if($stateParams.token) {
              if($stateParams.token.toLowerCase() != 'invalid') {
                vm.resetToken = $stateParams.token;
              }
            }

            if(!vm.resetToken) {
              vm.msg = 'This link has expired!';
            }
        }

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');

        // Navigation

        msNavigationServiceProvider.saveItem('auth.login', {
            title : 'Login',
            state : 'app.auth_login',
            weight: 1
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($state, $cookies, $location, $mdToast, deviceDetector, api, currentUser)
    {
      // ******************************
      // Variables
      // ******************************
      var vm = this;
      vm.isLogin = false;
      vm.msg = '';

      // ******************************
      // Public Methods
      // ******************************

      vm.submit = function() {

        vm.msg = 'Log in ...';
        vm.isLogin = true;

        api.signin.save(
          {
            email: vm.form.email,
            password: vm.form.password
          },
          // Success
          function (response)
          {
            //console.log(response);
            if(vm.form.rememberMe) {
              $cookies.put('g2e_email',vm.form.email);
              $cookies.put('g2e_password',vm.form.password);
            } else {
              $cookies.remove('g2e_email');
              $cookies.remove('g2e_password');
            }

            vm.isLogin = false;
            currentUser.set(response);

            // Check if it's supported browser
            var isUnsupportedBrowser = false;
            if(!deviceDetector.isDesktop() || (deviceDetector.browser !== 'chrome' && deviceDetector.browser !== 'firefox')) {
                isUnsupportedBrowser = true;
            }

            if(isUnsupportedBrowser) {
                $state.go('app.unsupported-browser');
            } else if(!currentUser.data.isReadTC) {
                $state.go('app.terms-conditions', {showAccept: true});
            } else if(currentUser.data.isWelcome) {
                $state.go('app.change-password');
            } else {
                if(currentUser.isAdminUser()) {
                    $state.go('app.dashboard');
                } else if(currentUser.isSiteUser()) {
                    $state.go('app.dashboard-site.home');
                }
            }
          },
          // Error
          function (response)
          {

            if(response.data && response.data.message) {
              vm.msg = response.data.message;
            } else {
              vm.msg = 'Something went wrong!';
            }
            vm.isLogin = false;
          }
        );

      };


      // ******************************
      // Internal methods
      // ******************************

      function _checkFromExpired() {
        var queryParams = $location.search();
        if(queryParams.isExpired) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Token has expired!')
              .position('top right')
              .hideDelay(3000)
          );
        }
      }

      function _init() {

        vm.form = {};

        var g2e_email = $cookies.get('g2e_email');
        var g2e_password = $cookies.get('g2e_password');

        if(g2e_email) vm.form.email = g2e_email;
        if(g2e_password) vm.form.password = g2e_password;

        if(g2e_email || g2e_password) vm.form.rememberMe = true;

        _checkFromExpired();

      }

      _init();

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_forgot-password', {
            url      : '/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.auth_forgot-password',
            weight: 2
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(api)
    {
        // ******************************
        // Variables
        // ******************************

        var vm = this;

        vm.isWorking = false;
        vm.msg = '';

        // ******************************
        // Public Methods
        // ******************************

        vm.submit = function() {

          vm.isWorking = true;

          api.forgotPassword.save(
            {
              email: vm.form.email
            },
            // Success
            function (response)
            {
              if(response.message) {
                vm.msg = response.message;
              }
            },
            // Error
            function (response)
            {
              if(response.data && response.data.message) {
                vm.msg = response.data.message;
              } else {
                vm.msg = 'Something went wrong!';
              }
              vm.isWorking = false;
            }
          );

        };


        // ******************************
        // Internal methods
        // ******************************

        function _init() {

        }

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'angular-chartist',
                'chart.js',
                'datatables',
                'gridshore.c3js.chart',
                'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                'uiGmapgoogle-maps',
                'textAngular',
                'ui.sortable',
                'ng-sortable',
                'xeditable',
                'moment-picker'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.unsupported-browser', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.unsupported-browser', {
            url      : '/unsupported-browser',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.unsupported-browser': {
                    templateUrl: 'app/main/unsupported-browser/unsupported-browser.html',
                    controller : 'UnsupportedBrowserController as vm'
                }
            },
            bodyClass: 'unsupported-browser'
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.unsupported-browser')
        .controller('UnsupportedBrowserController', UnsupportedBrowserController);

    /** @ngInject */
    function UnsupportedBrowserController($scope, $state, currentUser)
    {
        // ******************************
        // Variables
        // ******************************

        var vm = this;

        // ******************************
        // Public Methods
        // ******************************

        vm.submit = function() {

            if(!currentUser.data.isReadTC) {
                $state.go('app.terms-conditions', {showAccept: true});
            } else if(currentUser.data.isWelcome) {
                $state.go('app.change-password');
            } else {
                if(currentUser.isAdminUser()) {
                    $state.go('app.dashboard');
                } else if(currentUser.isSiteUser()) {
                    $state.go('app.dashboard-site.home');
                }
            }
        };

        // ******************************
        // Internal methods
        // ******************************

        function _init() {


        }

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.terms-conditions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.terms-conditions', {
            url      : '/terms-conditions',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.terms-conditions': {
                    templateUrl: 'app/main/terms-conditions/terms-conditions.html',
                    controller : 'TermsConditionsController as vm'
                }
            },
            params: {
                showAccept: false
            },
            bodyClass: 'terms-conditions'
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.terms-conditions')
        .controller('TermsConditionsController', TermsConditionsController);

    /** @ngInject */
    function TermsConditionsController($scope, $state, $stateParams, $mdToast, api, currentUser)
    {
        // ******************************
        // Variables
        // ******************************

        var vm = this;

        vm.isWorking = false;
        vm.showAccept = $stateParams.showAccept;
        vm.msg = '';

        // ******************************
        // Public Methods
        // ******************************

        vm.submit = function() {

          vm.isWorking = true;
          vm.msg = 'Updating...';

          api.profile.update.save(
            {
                isReadTC: true
            },
            // Success
            function (response)
            {

                vm.isWorking = false;
                vm.msg = '';

                if(currentUser.data.isWelcome) {
                    $state.go('app.change-password');
                } else {
                    if(currentUser.isAdminUser()) {
                        $state.go('app.dashboard');
                    } else if(currentUser.isSiteUser()) {
                        $state.go('app.dashboard-site.home');
                    }
                }
            },
            // Error
            function (response)
            {
                console.log(response);
                var error_msg = '';
                if(response.data && response.data.message) {
                    error_msg = response.data.message;
                } else {
                    error_msg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(error_msg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isWorking = false;
                vm.msg = '';
            }
          );

        };

        // ******************************
        // Internal methods
        // ******************************

        function _init() {


        }

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sample');

        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title : 'SAMPLE',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('fuse.sample', {
            title    : 'Sample',
            icon     : 'icon-tile-four',
            state    : 'app.sample',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SAMPLE.SAMPLE_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site', [
            'app.dashboard-site.home',
            'app.dashboard-site.analytics',
            'app.dashboard-site.materials'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.dashboard-site', {
                abstract: true,
                url    : '/dashboard-site',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/dashboard-site/dashboard-site.html',
                        controller : 'DashboardSiteController as vm'
                    }
                }
            })
            .state('app.dashboard-site.home', {
                url    : '/home',
                views  : {
                    'tab-content': {
                        templateUrl: 'app/main/dashboard-site/home/home.html',
                        controller : 'HomeController as vm'
                    }
                }
            })
            .state('app.dashboard-site.analytics', {
                url    : '/analytics',
                views  : {
                    'tab-content': {
                        templateUrl: 'app/main/dashboard-site/analytics/analytics.html',
                        controller : 'AnalyticsController as vm'
                    }
                }
            })
            .state('app.dashboard-site.materials', {
                url    : '/materials',
                views  : {
                    'tab-content': {
                        templateUrl: 'app/main/dashboard-site/materials/materials.html',
                        controller : 'MaterialsController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard-site')
        .controller('DashboardSiteController', DashboardSiteController);

    /** @ngInject */
    function DashboardSiteController($scope, $rootScope, $state, $window, $interval, $mdToast, $mdDialog, $mdSidenav, G2E_CONST_API, api, currentUser, formatUtils, bsLoadingOverlayService)
    {

        // ******************************
        // Variables
        // ******************************

        var vm = this;
        vm.hostUrl = api.hostUrl;
        vm.currentUser = currentUser;
        vm.Now = new Date();
        vm.Colors = ['#00558B', '#78A22F', '#F7941D', '#D22333', '#CFEDF8', '#D1D3D4'];
        vm.autoRefreshHandler = null;
        $rootScope.isDashboard = true;
        $scope.MetricsUnits = {
            "Rolling Waste Processed Rate": "tons/week",
            "Rolling Daily Usage": "times/day",
            "Rolling Mean Run Time": "mins/run",
            "Rolling Total Waste Processed": "tons",
            "Rolling Run Time": "hours",
            "Rolling Tank Volume": "gallons",
            "Rolling Water Usage": "gallons",
            "Rolling Water Content": "%",
            "Rolling On/Offs Count": "",
            "Rolling Reverse Cycles": "",
            "Rolling Boot-up Count": ""
        };
        vm.privacyNoticeUrl = G2E_CONST_API.PRIVACY_NOTICE_URL;

        // ******************************
        // Public Methods
        // ******************************

        /**
         * Open site account management dialog
         */
        vm.openSiteAttrDlg = function(ev)
        {
            $rootScope.isDashboard = false;
            $mdDialog.show({
                controller: SiteAttributeDialogController,
                controllerAs: 'vm',
                locals: {
                    siteId: vm.selectedSite.id,
                    tab: 1
                },
                templateUrl: 'app/main/dashboard/site/site-attribute-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            }).then(function(ret) {
                if(ret) {
                    if(ret.mode === 'edit') {

                        // Update site name on site filter
                        var siteIndex = _.findIndex(vm.sites, {id: ret.data.id});
                        if(siteIndex !== -1) {
                            vm.sites[siteIndex].name = ret.data.name;
                            vm.searchSite = ret.data.name;
                        }

                        // Update site name on site detail - stats object
                        $scope.stats.name = ret.data.name;
                    }
                }
                $rootScope.isDashboard = true;
            }, function() {
                $rootScope.isDashboard = true;
            });
        };

        /**
         * Open Support Contact Dialog
         */
        vm.openSupportContactDlg = function (ev, group, user) {

            $mdDialog.show({
                controller: SupportContactDialogController,
                controllerAs: 'vm',
                locals: {
                    group: group,
                    contact: user
                },
                templateUrl: 'app/main/dashboard/site/support-contact-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            }).then(function(ret) {

            }, function() {

            });
        };

        /**
         * Open Edit Company Logo Dialog
         */
        vm.openEditCompanyLogoDlg = function(ev) {
            $mdDialog.show({
                controller: 'CompanyLogoDialogController as vm',
                locals: {
                    companyId: vm.selectedCompany.id,
                    logo: vm.selectedCompany.logo?vm.hostUrl+vm.selectedCompany.logo:null
                },
                templateUrl: 'app/main/dashboard/company/company-logo/company-logo-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            }).then(function(ret) {
                if(ret) {
                    if(ret.mode === 'upload') {
                        vm.selectedCompany.logo = ret.data;
                    }
                }
            }, function() {

            });
        };

        /**
         * Query companies for auto complete box
         */
        vm.queryCompany = function(query) {
            var filteredCompanies = query ? vm.companies.filter( _createFilterFor(query, 'name') ) : vm.companies;
            var sortedCompanies = _sortCaseInsensitive(filteredCompanies, 'name');
            return sortedCompanies;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedCompanyChange = function(company) {

            if(vm.screenMode === 'Site') return;

            if(company) {
                _loadSitesData();
            } else {
                vm.searchDivision = '';
                vm.searchSite = '';
                vm.divisions = [];
                vm.sites = [];
            }
        };

        /**
         * Query divisions for auto complete box
         */
        vm.queryDivision = function(query) {
            var filteredDivisions = query ? vm.divisions.filter( _createFilterFor(query, 'name') ) : vm.divisions;
            var sortedDivisions = _sortCaseInsensitive(filteredDivisions, 'name');
            return sortedDivisions;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedDivisionChange = function(division) {

            if(vm.screenMode === 'Site') return;

            if(division) {

            } else {
                vm.searchSite = '';
            }
        };

        /**
         * Query sites for auto complete box
         */
        vm.querySite = function(query) {

            var sites = [];

            if(vm.selectedDivision) {
                sites = _.filter(vm.sites, function(site) {
                    return site.DivisionId === vm.selectedDivision.id;
                });
            } else {
                sites = vm.sites;
            }

            var filteredSites = query ? sites.filter( _createFilterFor(query, 'name') ) : sites;
            var sortedSites = _sortCaseInsensitive(filteredSites, 'name');
            return sortedSites;
        };

        /**
         * Listener when changed company selection in auto complete box
         */
        vm.selectedSiteChange = function(site) {

            if(vm.screenMode === 'Site') return;

            if(site) {

                // select division in filter
                if(!vm.selectedDivision) {
                    vm.selectedDivision = site.Division;
                }

                _loadStatData(site.id);

            } else {

                _initScopeVars();
            }
        };

        /**
         * Toggle left menu
         */
        vm.toggleLeft = function() {
            $mdSidenav('dashboard-site-left-side')
                .toggle()
                .then(function () {

                });
        };

        /**
         * Check if home state
         */
        vm.isHomeState = function() {
            return $state.current.name === 'app.dashboard-site.home';
        };

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Load Sites
         */
        function _loadSitesData() {

            vm.isLoading = true;
            $scope.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'content_loader'});

            var params = {
                companyId: vm.selectedCompany.id
            };

            api.sites.list.get(params, function (response) {
                response = _convertNegativeValsInto0(response)

                vm.isLoading = false;
                $scope.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'content_loader'});

                vm.sites = response.rows;

                // Get divisions from sites for Division filter
                var sitesDivisions = _.pluck(vm.sites, 'Division');
                var uniqueDivisions = _.uniq(sitesDivisions, function(division){
                    return division.id;
                });
                vm.divisions = _sortCaseInsensitive(uniqueDivisions, 'name');

                // Select a site/division if there is a previous selection
                if(vm.previousSiteId) {

                    vm.selectedSite = _.find(vm.sites, {id: vm.previousSiteId});
                    if(vm.selectedSite) {
                        _loadStatData(vm.selectedSite.id);
                    }

                } else if(vm.previousDivisionId) {
                    vm.selectedDivision = _.find(vm.divisions, {id: vm.previousDivisionId});
                }

            }, function (error) {
                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isLoading = false;
                $scope.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'content_loader'});
            });
        }

        /**
         * Load data
         */
        function _loadBaseData() {

            if(currentUser.isAdminUser()) {

                vm.screenMode = 'Admin';
                $scope.screenMode = 'Admin';

                vm.isLoading = true;
                $scope.isLoading = true;
                bsLoadingOverlayService.start({referenceId: 'content_loader'});

                api.companies.list.get(null, function (response) {
                    vm.companies = _.filter(response.rows, function(company) {
                        return company.isActive === true;
                    });

                    vm.isLoading = false;
                    $scope.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'content_loader'});

                    // Select a company if there is a previous selection
                    if(vm.previousCompanyId) {
                        vm.selectedCompany = _.find(vm.companies, {id: vm.previousCompanyId});
                    }

                }, function (error) {

                    vm.isLoading = false;
                    $scope.isLoading = false;
                    bsLoadingOverlayService.stop({referenceId: 'content_loader'});

                    if(error.data && error.data.message) {
                        vm.errorMsg = error.data.message;
                    } else {
                        vm.errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(vm.errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                });
            } else if(currentUser.hasSiteEditRole()) {

                vm.screenMode = 'Site';
                $scope.screenMode = 'Site';
                var siteId = currentUser.data.Sites[0].id;
                _loadStatData(siteId);
            }
        }

        /**
         * Load stats
         */
        function _loadStatData(siteId) {

            vm.isLoading = true;
            $scope.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'content_loader'});

            var params = {
                siteId: siteId,
                timezone: moment.tz.guess()
            };

            if($scope.search_period) {
                params.type = 'rolling';
                params.days = $scope.search_period;
            } else {
                params.type = 'range';
                params.start = moment($scope.search_start_date).format('YYYY-MM-DDT00:00:00.000Z');
                params.end = moment($scope.search_end_date).format('YYYY-MM-DDT23:59:59.999Z');
            }

            if($scope.shiftFilter.length > 0) {
                params.shifts = _.pluck($scope.shiftFilter, 'id');
                params.shifts = '[' + params.shifts + ']';
            }

            var paramBadges = [];
            _.each($scope.benchmarkings, function(one) {
                if(one.selectedBadges && one.selectedBadges.length > 0) {
                    var selectedBadges = _.pluck(one.selectedBadges, 'badgeId');
                    paramBadges.push({siteId: one.Site.id, badges: selectedBadges});
                }
            });
            params.badges = JSON.stringify(paramBadges);

            api.sites.stats.get(params, function (response) {
                response = _convertNegativeValsInto0(response)
                if(vm.screenMode === 'Site') {
                    vm.companies = [response.Division.Company];
                    vm.divisions = [response.Division];
                    vm.sites = [response];

                    vm.selectedCompany = response.Division.Company;
                    vm.selectedDivision = response.Division;
                    vm.selectedSite = response;

                    // update ListSrv Visibility
                    vm.currentUser.updateListservAvailability(response.metrics);
                }

                _cookStats(response);

                vm.isLoading = false;
                $scope.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'content_loader'});

            }, function (error) {
                vm.isLoading = false;
                $scope.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'content_loader'});

                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            });
        }

        function _downloadPdf(year) {

            var start, end;
            if(year) {
                start = year;
            } else {
                if($scope.reports.length > 0) {
                    end = $scope.reports[0].year;
                    start = $scope.reports[$scope.reports.length-1].year;
                } else {
                    return;
                }
            }

            vm.isLoading = true;
            $scope.isLoading = true;
            bsLoadingOverlayService.start({referenceId: 'content_loader'});

            var anonymous_benchmarkings = _.where($scope.benchmarkings, {visibility: 'ANONYMOUS', ticked: true});

            var params = {
                siteId: vm.selectedSite.id,
                start: start,
                end: end,
                benchmarkings: '[' + (_.pluck(_.where($scope.benchmarkings, {ticked: true}), 'id')).toString() + ']',
                include_anonymous: anonymous_benchmarkings.length > 0 ? true : false
            };

            api.sustainabilityReports.download.get(params, function (response) {

                if(response && response.filePath) {
                    $window.open(api.hostUrl + response.filePath, '_blank');
                }

                vm.isLoading = false;
                $scope.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'content_loader'});

            }, function (error) {

                vm.isLoading = false;
                $scope.isLoading = false;
                bsLoadingOverlayService.stop({referenceId: 'content_loader'});

                if(error.data && error.data.message) {
                    vm.errorMsg = error.data.message;
                } else {
                    vm.errorMsg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(vm.errorMsg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );
            });
        }

        function _initScopeVars() {

            $scope.stats = null;
            $scope.benchmarkings = [];
            $scope.reports = [];
            $scope.pickups = [];
            $scope.shiftFilter = [];
            $scope.metricFilter = 0;
            $scope.search_period = 30;
            $scope.search_start_date = null;
            $scope.search_end_date = null;

            $scope.chart = {
                options: {
                    chart: {
                        type              : 'multiBarHorizontalChart',
                        height            : 360,
                        margin            : {
                            top   : 20,
                            right : 40,
                            bottom: 40,
                            left  : 20
                        },
                        x                 : function (d)
                        {
                            return d.label;
                        },
                        y                 : function (d)
                        {
                            return d.value;
                        },
                        showControls      : false,
                        showLegend        : false,
                        showValues        : false,
                        transitionDuration: 500,
                        xAxis             : {
                            showMaxMin: false,
                            height: 36,
                            orient: 'right',
                            /*tickFormat: function(d){
                                if (typeof this != 'undefined') {
                                    var el = d3.select(this);
                                    var p = d3.select(this.parentNode);
                                    p.append("foreignObject")
                                        .attr('x', -50)
                                        .attr('y', -50)
                                        .attr("width", 50)
                                        .attr("height", 200)
                                        .append("xhtml:p")
                                        .attr('style','word-wrap: break-word;')
                                        .html(d);

                                    el.remove();
                                    return d;
                                }
                            }*/
                        },
                        yAxis             : {
                            axisLabel : 'Waste Processed Rate',
                            tickFormat: function (d)
                            {
                                return d3.format(',.2f')(d);
                            }
                        },
                        barColor: [],
                        groupSpacing: 0.3,
                        fillOpacity: 0.9
                    }
                },
                data   : [
                    {
                        'key'   : 'Waste Processed Rate',
                        'values': []
                    }
                ]
            };
        }

        /**
         * Refresh Graph
         */
        function _refreshGraph() {

            if(!$scope.visibilities.systemUsageMetrics.length) return;

            var metric = $scope.visibilities.systemUsageMetrics[$scope.metricFilter];
            var metricUnit = $scope.MetricsUnits[metric.name]?' ('+$scope.MetricsUnits[metric.name]+')':'';

            $scope.chart.options.chart.yAxis.axisLabel = metric.label + metricUnit;
            $scope.chart.options.chart['barColor'] = [];
            $scope.chart.data[0]['key'] = metric.label;
            $scope.chart.data[0]['values'] = [];

            var tickedCount = 0;
            _.each($scope.benchmarkings, function(filter) {
                if(filter.ticked === true) {
                    tickedCount++;
                    $scope.chart.options.chart['barColor'].push(filter.color);
                    $scope.chart.data[0]['values'].push({
                        label: filter.aliasName,
                        value: filter.Site.Stats?filter.Site.Stats[metric.name]:0 //Math.random() * 100
                    });
                }
            });

            // set graph spacing according to the number of sites
            if(tickedCount < 2) {
                $scope.chart.options.chart.groupSpacing = 0.7;
            } else if(tickedCount < 3) {
                $scope.chart.options.chart.groupSpacing = 0.6;
            } else if(tickedCount < 4) {
                $scope.chart.options.chart.groupSpacing = 0.5;
            } else if(tickedCount < 5) {
                $scope.chart.options.chart.groupSpacing = 0.4;
            } else if(tickedCount < 6) {
                $scope.chart.options.chart.groupSpacing = 0.3;
            } else if(tickedCount < 7) {
                $scope.chart.options.chart.groupSpacing = 0.2;
            } else {
                $scope.chart.options.chart.groupSpacing = 0.1;
            }
        }

        /**
         * Refresh Pickups & Reports
         */
        function _refreshPickupsAndReports() {

            var reports = [];
            var pickups = [];
            var reportRangeStart = moment();
            var reportRangeEnd = moment();
            var reportRangeYearStart = reportRangeStart.year();
            var reportRangeYearEnd = reportRangeEnd.year();
            var iotActivationSites = {};
            var iotActivationMonth = {};

            _.each($scope.benchmarkings, function(one) {

                if(one.ticked === true) {

                    if(one.Site.Installation && one.Site.Installation.Tank.iotActivationDate) {

                        // Pre-handling : Determine report range
                        var mtIotActivationDate = moment(one.Site.Installation.Tank.iotActivationDate);
                        if(mtIotActivationDate < reportRangeStart) {
                            reportRangeStart = mtIotActivationDate;
                            reportRangeYearStart = reportRangeStart.year();
                        }

                        // Pre-handling : Pickup History
                        iotActivationMonth['site#'+one.Site.id] = moment(one.Site.Installation.Tank.iotActivationDate).format('YYYY-MM');
                    }
                }
            });

            // Sustainability Reporting, Pick-up History
            var monthStart, monthEnd;

            for(var year=reportRangeYearEnd;year>=reportRangeYearStart;year--) {

                var yearlyReporting = {
                    isExpanded: true,
                    year: year,
                    value: {
                        total: 0
                    },
                    months: []
                };

                _.each($scope.benchmarkings, function(one) {
                    if(one.ticked === true) {
                        yearlyReporting.value['site#'+one.Site.id] = 0;
                    }
                });

                if(year === reportRangeYearEnd) {
                    monthStart = 0;
                    monthEnd = reportRangeEnd.month()-1;
                } else if(year === reportRangeYearStart) {
                    monthStart = reportRangeStart.month();
                    monthEnd = 11;
                } else {
                    monthStart = 0;
                    monthEnd = 11;
                }

                for(var month=monthEnd;month>=monthStart;month--) {

                    var monthlyReporting = {
                        month: month,
                        value: {
                            total: 0
                        }
                    };

                    var monthlyPickup = {
                        year: year,
                        month: month,
                        yearMonth: formatUtils.formatYearMonthLong(year, month),
                        value: {},
                        iotActivationDates: {}
                    };

                    _.each($scope.benchmarkings, function(one) {

                        if(one.ticked === true) {

                            if(one.Site.Installation) {

                                var siteKey = 'site#' + one.Site.id;

                                // report
                                var dataReport = _.findWhere(one.Site.Installation.MonthlyReportsByYear[year], {month: month});
                                if(dataReport) {
                                    monthlyReporting.value['total'] += dataReport.wasteProcessed;
                                    yearlyReporting.value[siteKey] += dataReport.wasteProcessed;
                                    monthlyReporting.value[siteKey] = dataReport.wasteProcessed;
                                }

                                // pickup
                                if(!iotActivationSites[siteKey]) {

                                    var yearMonth = formatUtils.formatYearMonth(year, month);
                                    if(iotActivationMonth[siteKey] === yearMonth) {
                                        iotActivationSites[siteKey] = true;
                                        monthlyPickup.iotActivationDates[siteKey] = moment(one.Site.Installation.Tank.iotActivationDate).format('MM/DD/YYYY');
                                    }

                                    var dataPickup = _.findWhere(one.Site.Installation.PickupHistory, {yearMonth: yearMonth});
                                    if(dataPickup) {
                                        monthlyPickup.value[siteKey] = dataPickup['PickupCount'];
                                    } else {
                                        monthlyPickup.value[siteKey] = 0;
                                    }
                                }
                            }
                        }

                    });

                    yearlyReporting.value['total'] += monthlyReporting.value['total'];
                    yearlyReporting.months.push(monthlyReporting);

                    pickups.push(monthlyPickup);
                }

                reports.push(yearlyReporting);
            }

            $scope.reports = reports;
            $scope.pickups = pickups;
        }

        /**
         * Process stats data to display
         */
        function _cookStats(stats) {

            var benchmarkings = [];
            var countColors = vm.Colors.length;
            var noPublicBenchmarkings = 0;
            var noAnonymouseBenchmarkings = 0;
            var noAnonymouseBenchmarkingsByStats = {};

            var visibilities = {};

            // visibilities
            var systemUsage = vm.currentUser.getMetricItem(stats.metrics, 'System Usage');
            var tankStatusLevel = vm.currentUser.getMetricItem(stats.metrics, 'Tank Status.Tank Level');
            var tankStatusTemperature = vm.currentUser.getMetricItem(stats.metrics, 'Tank Status.Temperature');
            var tankStatusUseful = vm.currentUser.getMetricItem(stats.metrics, 'Tank Status.Useful Tank Volume');
            var tankStatusNominal = vm.currentUser.getMetricItem(stats.metrics, 'Tank Status.Nominal Tank Volume');
            var pickupHistory = vm.currentUser.getMetricItem(stats.metrics, 'Hauling and Finance.Pick-up History');
            var pickupHistoryView = vm.currentUser.getMetricItem(stats.metrics, 'Hauling and Finance.Pick-up History.Access to detailed Pick-up History');
            var pickupHistoryEdit = vm.currentUser.getMetricItem(stats.metrics, 'Hauling and Finance.Pick-up History.Ability to add/edit/delete entries');
            var finance = vm.currentUser.getMetricItem(stats.metrics, 'Hauling and Finance.Access to detailed Data');

            visibilities.systemUsage = systemUsage.value;
            visibilities.systemUsageMetrics = _.where(systemUsage.items, {value: true});
            visibilities.tankStatusLevel = tankStatusLevel.value;
            visibilities.tankStatusTemperature = tankStatusTemperature.value;
            visibilities.tankStatusUseful = tankStatusUseful.value;
            visibilities.tankStatusNominal = tankStatusNominal.value;
            visibilities.pickupHistory = pickupHistory.value;
            visibilities.pickupHistoryView = pickupHistoryView.value;
            visibilities.pickupHistoryEdit = pickupHistoryEdit.value;
            visibilities.finance = finance.value;

            // aliasName, order, Hauling & Finance Details
            _.each(stats.Benchmarkings, function(benchmarking) {

                if(benchmarking.BenchmarkingSite.Installation) {

                    var one = {
                        id: benchmarking.BenchmarkingSite.id,
                        visibility: benchmarking.visibility,
                        Site: benchmarking.BenchmarkingSite
                    };

                    // aliasName, order
                    if(benchmarking.BenchmarkingSite.id === stats.id) {
                        one.aliasName = 'Your site';
                        one.order = '0' + one.aliasName;
                    } else {
                        if(benchmarking.visibility === 'PUBLIC') {
                            noPublicBenchmarkings++;

                            one.aliasName = benchmarking.BenchmarkingSite.name;

                            one.order = '1' + one.aliasName;

                        } else if(benchmarking.visibility === 'ANONYMOUS') {
                            noAnonymouseBenchmarkings++;

                            var state;
                            if(benchmarking.BenchmarkingSite.Installation) {
                                state = benchmarking.BenchmarkingSite.Installation.Customer.state;
                            } else {
                                state = 'Anonymous';
                            }
                            if(!noAnonymouseBenchmarkingsByStats[state]) {
                                noAnonymouseBenchmarkingsByStats[state] = 0;
                            }
                            noAnonymouseBenchmarkingsByStats[state]++;
                            one.aliasName = state + ' ' + noAnonymouseBenchmarkingsByStats[state];

                            one.order = '2' + one.aliasName;
                        }
                    }

                    // selectedBadges
                    one.selectedBadges = [];
                    one.isBadgeExpanded = false;
                    if($scope.benchmarkings.length > 0) { // If there is a previous selected badges, use it

                        var siteFound = _.findWhere($scope.benchmarkings, {id: benchmarking.BenchmarkingSite.id});
                        if(siteFound) {
                            _.each(siteFound.selectedBadges, function(badge) {
                                var badgeFound = _.findWhere(benchmarking.BenchmarkingSite.SiteBadges, {badgeId: badge.badgeId});
                                if(badgeFound) {
                                    one.selectedBadges.push(badgeFound);
                                }
                            });
                            one.isBadgeExpanded = siteFound.isBadgeExpanded;
                        }
                    }

                    // Hauling & Finance Details
                    if(one.Site.Installation) {

                        // Hauling & Finance Details
                        one.FinanceDetails = {
                            a: {
                                value: one.Site.Stats['Status'],
                                image: _getStatusImageClass(one.Site.Stats['Status']),
                                classes: 'g2e-icon-text-hide'
                            },
                            b: {
                                value: one.Site.Stats['Tank Level'],
                                image: _getTankLevelImageClass(one.Site.Stats['Tank Level Status']),
                            },
                            c: {
                                value: one.Site.Stats['Average Fill Rate']
                            },
                            d: {
                                value: one.Site.Stats['Days to Trigger']
                            },
                            e: {
                                value: one.Site.Stats['Days to Capacity']
                            },
                            f: {
                                value: (one.Site.Stats['PickupTargetDate']) ? new Date(one.Site.Stats['PickupTargetDate'] + ' 00:00:00') : '',
                                format: function (val) {
                                    return formatUtils.formatDateOnly(val);
                                }
                            },
                            g: {
                                value: one.Site.Installation.Customer.contractType
                            }
                        };

                        // Pre-handling : Sustainability Reporting group by year
                        one.Site.Installation.MonthlyReportsByYear = _.groupBy(one.Site.Installation.MonthlyReports, 'year');

                    }

                    benchmarkings.push(one);

                }
            });


            // sort & color & grouping
            benchmarkings = _.sortBy(benchmarkings, 'order');

            var groupName = '';
            var hasGroup = false;
            var colorIndex = 0;
            for(var index=0;index<benchmarkings.length;index++) {
                var one = benchmarkings[index];

                // coloring
                one.color = vm.Colors[colorIndex%countColors];
                one.colorTag = '<span class="site-color-icon" style="background: '+one.color+'"></span>';
                colorIndex++;

                // ticked
                if($scope.benchmarkings.length > 0) {
                    // Get previous ticked
                    var site = _.findWhere($scope.benchmarkings, {id: one.id, ticked: true});
                    if(site) {
                        one.ticked = true;
                    } else {
                        one.ticked = false;
                    }
                } else {
                    /*if(one.id === stats.id) {
                        one.ticked = true;
                    } else {
                        one.ticked = false;
                    }*/

                    one.ticked = true; // Select all by default
                }

                // grouping
                if(one.id !== stats.id && one.visibility !== groupName) {
                    if(groupName !== '') {
                        benchmarkings.splice(index, 0, {msGroup: false, groupTag: true});
                        index++;
                    }

                    var groupAliasName = '';
                    if(one.visibility === 'PUBLIC') groupAliasName = 'Other Available Sites';
                    else if(one.visibility === 'ANONYMOUS') groupAliasName = 'Peer Sites for Benchmarking';
                    else groupAliasName = one.visibility;

                    benchmarkings.splice(index, 0, {msGroup: true, groupTag: true, aliasName: '<strong>'+groupAliasName+'</strong>'});
                    groupName = one.visibility;
                    hasGroup = true;
                    index++;
                }
            }
            if(hasGroup) {
                benchmarkings.push({msGroup: false, groupTag: true});
            }


            // scope variables - visibilities, benchmarkings, stats, reports, pickups
            $scope.visibilities = visibilities;
            $scope.benchmarkings = benchmarkings;
            $scope.stats = stats;

            _refreshGraph();
            _refreshPickupsAndReports();
        }

        /**
         * Start auto refresh
         */
        function _startAutoRefresh() {
            vm.autoRefreshHandler = $interval(function() {
                if($rootScope.isDashboard && vm.selectedSite && !vm.isLoading && !vm.autoRefreshing) {

                    vm.autoRefreshing = true;

                    var params = {
                        siteId: vm.selectedSite.id,
                        auto: true
                    };

                    if($scope.search_period) {
                        params.type = 'rolling';
                        params.days = $scope.search_period;
                    } else {
                        params.type = 'range';
                        params.start = moment($scope.search_start_date).format('YYYY-MM-DDT00:00:00.000Z');
                        params.end = moment($scope.search_end_date).format('YYYY-MM-DDT23:59:59.999Z');
                    }

                    if($scope.shiftFilter.length > 0) {
                        params.shifts = _.pluck($scope.shiftFilter, 'id');
                        params.shifts = '[' + params.shifts + ']';
                    }

                    var paramBadges = [];
                    _.each($scope.benchmarkings, function(one) {
                        if(one.selectedBadges && one.selectedBadges.length > 0) {
                            var selectedBadges = _.pluck(one.selectedBadges, 'badgeId');
                            paramBadges.push({siteId: one.Site.id, badges: selectedBadges});
                        }
                    });
                    params.badges = JSON.stringify(paramBadges);
                    console.log(params);

                    api.sites.stats.get(params, function (response) {
                        response = _convertNegativeValsInto0(response)
                        //Copy metrics from old if isLiveOnly
                        _.each(response.Benchmarkings, function(benchmarking) {

                            if(benchmarking.BenchmarkingSite.Installation) {

                                if(benchmarking.BenchmarkingSite.Stats['isLiveOnly']) {
                                    var old = _.findWhere($scope.benchmarkings, {id: benchmarking.BenchmarkingSite.id});
                                    if(old && old.Site.Installation) {
                                        benchmarking.BenchmarkingSite.Stats['Rolling Boot-up Count'] = old.Site.Stats['Rolling Boot-up Count'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Reverse Cycles'] = old.Site.Stats['Rolling Reverse Cycles'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling On/Offs Count'] = old.Site.Stats['Rolling On/Offs Count'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Run Time'] = old.Site.Stats['Rolling Run Time'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Water Usage'] = old.Site.Stats['Rolling Water Usage'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Double Water Count'] = old.Site.Stats['Rolling Double Water Count'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Tank Volume'] = old.Site.Stats['Rolling Tank Volume'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Mean Run Time'] = old.Site.Stats['Rolling Mean Run Time'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Daily Usage'] = old.Site.Stats['Rolling Daily Usage'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Total Waste Processed'] = old.Site.Stats['Rolling Total Waste Processed'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Waste Processed Rate'] = old.Site.Stats['Rolling Waste Processed Rate'];
                                        benchmarking.BenchmarkingSite.Stats['Rolling Water Content'] = old.Site.Stats['Rolling Water Content'];
                                    }
                                }
                            }
                        });

                        _cookStats(response);

                        vm.autoRefreshing = false;

                    }, function (error) {

                        vm.autoRefreshing = false;
                    });
                }
            }, 300000);
        }

        /**
         * Stop auto refresh
         */
        function _stopAutoRefresh() {
            if(vm.autoRefreshHandler !== null) {
                $interval.cancel(vm.autoRefreshHandler);
            }
        }

        /**
         * Get Status image class name
         */
        function _getStatusImageClass(status) {
            if(status === 0) {
                return 'g2e-icon-status-running';
            } else if(status === 1) {
                return 'g2e-icon-status-standby';
            } else if(status === 2){
                return 'g2e-icon-status-off';
            } else {
                return 'g2e-icon-status-unassigned';
            }
        }

        /**
         * Get Tank Level image class name
         */
        function _getTankLevelImageClass(level) {
            if(level === 0) {
                return 'g2e-icon-tank-low';
            } else if(level === 1) {
                return 'g2e-icon-tank-medium';
            } else if(level === 2) {
                return 'g2e-icon-tank-critical';
            } else {
                return 'g2e-icon-tank-unassigned';
            }
        }

        /**
         * Convert negative benchmarking values into 0
         * For now, convert:
         * 'Rolling Total Waste Processed'
         * 'Rolling Waste Processed Rate'
         */
        function _convertNegativeValsInto0(stats) {
            var Benchmarkings = _.map(stats.Benchmarkings, function(benchmarking) {
                if (benchmarking.BenchmarkingSite && benchmarking.BenchmarkingSite.Stats) {
                    benchmarking.BenchmarkingSite.Stats['Rolling Total Waste Processed'] = _minTo0(benchmarking.BenchmarkingSite.Stats['Rolling Total Waste Processed'])
                    benchmarking.BenchmarkingSite.Stats['Rolling Waste Processed Rate'] = _minTo0(benchmarking.BenchmarkingSite.Stats['Rolling Waste Processed Rate'])
                }
                return benchmarking
            })
            stats.Benchmarkings = Benchmarkings
            return stats
        }

        function _minTo0(val) {
            if (val < 0) {
                return 0
            } else {
                return val
            }
        }

        /**
         * Initialize
         */
        function _init() {
            _initScopeVars();
            _loadBaseData();
            _startAutoRefresh();
        }

        // ******************************
        // Event Listeners
        // ******************************

        //Listener for controller destroy
        $scope.$on('$destroy', function() {
            _stopAutoRefresh();
        });

        //Listener to refresh dashboard by data changes
        $scope.$on('refreshSiteDashboard', function(evnet, args) {

            // Backup previous selection
            if(vm.selectedCompany) {
                vm.previousCompanyId = vm.selectedCompany.id;
            } else {
                vm.previousCompanyId = null;
            }

            if(vm.selectedDivision) {
                vm.previousDivisionId = vm.selectedDivision.id;
            } else {
                vm.previousDivisionId = null;
            }

            if(vm.selectedSite) {
                vm.previousSiteId = vm.selectedSite.id;
            } else {
                vm.previousSiteId = null;
            }

            _loadBaseData();
        });

        $scope.onSelectMetric = function(index) {
            $scope.metricFilter = index;
            _refreshGraph();
        };

        $scope.onChangeSiteFilter = function() {

            _refreshGraph();
            _refreshPickupsAndReports();
        };

        $scope.onRefresh = function() {
            _loadStatData($scope.stats.id);
        };

        $scope.onUpdatedMonthlyReport = function() {

            _refreshPickupsAndReports();
        };

        $scope.onDownloadPdf = function(year) {
            _downloadPdf(year);
        };

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($rootScope, $scope, uiGmapGoogleMapApi, $mdDialog, $mdMedia, $mdToast, $timeout, $q, $interval, $filter, bsLoadingOverlayService, G2E_CONST_API, api, currentUser)
    {

        // ******************************
        // Variables
        // ******************************

        var vm = this;
        vm.currentUser = currentUser;
        vm.installationsStats = [];
        vm.selectedInstallation = null;
        vm.status_by = 0; //0: ALL, 1: Running, 2: System Faults, 3: Hauling Status
        vm.autoRefreshHandler = null;
        $rootScope.isDashboard = true;

        // Customer Table Widget
        vm.customerTableWidget = {
          columns: [
            {title:"Status"},
            {title:"System Fault"},
            {title:"Hauling Status"},
            {title:"Installation Name"},
            {title:"Serial Number"},
            {title:"Region"},
            {title:"Contract Type"},
            {title:"Tank Level (%)"},
            {title:"Days to Capacity"},
            {title:"Days to Trigger"},
            {title:"Next Pick-up Target Date"},
            {title:"Next Scheduled Pick-up"},
            {title:"Volume in Tank (gallons)"},
            {title:"Fill Rate (p.p./day)"},
            {title:"Temperature (⁰F)"},
            {title:"Pump Discharge Pressure (psi)"},
            {title:"Current of Grinder (A)"},
            {title:"Current of Pump (A)"},
            {title:"Boot-up Count"},
            {title:"Rolling Boot-up Count"},
            {title:"Reverse Cycle Count"},
            {title:"Rolling Reverse Cycle Count"},
            {title:"On/Offs Count"},
            {title:"Rolling On/Offs Count"},
            {title:"Run Time (hours)"},
            {title:"Rolling Run Time (hours)"},
            {title:"Water Meter Reading (gallons)"},
            {title:"Rolling Water Usage (gallons)"},
            {title:"Double Water Count"},
            {title:"Rolling Double Water Count"},
            {title:"Rolling Pick-up Count"},
            {title:"Rolling Waste Processed Rate (tons/week)"},
            {title:"Rolling Daily Usage (times/day)"},
            {title:"Rolling Mean Run Time (mins/run)"},
            {title:"Rolling Volume fed to Tank (gallons)"},
            {title:"Rolling Total Waste Processed (tons)"},
            {title:"Rolling Water Content (%)"},
            {title:"Average Days between System Faults"},
            {title:"Average Days between Pick-ups"},
            {title:"Average Tank Level at Pick-up (%)"},
            {title:"Average Left-over in Tank (%)"},
            {title:"Average Slurry Water Content (% of volume)"},
            {title:"Average Mean Run Time (minutes/run)"},
            {title:"Average Waste Processed (tons/week)"},
            {title:"Average Mean Daily Usage (times/day)"},
            {title:"Projected Annual Number of Pick-ups"},
            {title:"Rolling Total Tipping Cost"},
            {title:"Rolling Total Hauling Cost"},
            {title:"Rolling Total Hauling and Tipping Cost"},
            {title:"Projected Annual Revenue"},
            {title:"Company"},
            {title:"Street Address"},
            {title:"City"},
            {title:"ZIP"},
            {title:"Site Contact Name"},
            {title:"Site Contact Title"},
            {title:"Site Contact Phone #1"},
            {title:"Site Contact Phone #2"},
            {title:"Site Contact Email"},
            {title:"Contract Price per Pay Period"},
            {title:"Payment Period is Every"},
            {title:"Payments per Year"},
            {title:"Contract Credit/Surcharge for Hauls"},
            {title:"Contract Est. Annual Service Cost"},
            {title:"Contract Est. Annual Max Number of Hauls"},
            {title:"Contract Est. Annual Min Number of Hauls"},
            {title:"Contract Est. Waste Processed (tons/week)"},
            {title:"Contract Start Date"},
            {title:"Contract Length (months)"},
            {title:"Expected Renewal Date"},
            {title:"IoT Activation Date"},
            {title:"Client Since"},
            {title:"Nominal Tank Volume (gallons)"},
            {title:"Useful Tank Volume (gallons)"},
            {title:"Tank High Threshold (%)"},
            {title:"Tank High Threshold [default] (%)"},
            {title:"Tank Critical Threshold (%)"},
            {title:"Tank Critical Threshold [default] (%)"},
            {title:"Safety Window for Pick-up Trigger (days)"},
            {title:"Consider Saturday for Pick-up?"},
            {title:"Consider Saturday for Pick-up? [default]"},
            {title:"Lead Time for Scheduling a Pick-up (days)"},
            {title:"Lead Time for Scheduling a Pick-up (days) [default]"},
            {title:"Expected Slurry Yield (gallons/ton)"},
            {title:"Indoor/Outdoor Tank"},
            {title:"Frost Protection"},
            {title:"System Voltage"},
            {title:"SIM card handle"},
            {title:"Installation ID"},
            {title:"Installer Company Name"},
            {title:"Installer Contact Name"},
            {title:"Installer Contact Phone #1"},
            {title:"Installer Contact Phone #2"},
            {title:"Installer Contact Email"}
          ],
          rows: [],
          pagination: {
            lengths: [10, 20, 50, 100, {
              label: 'All',
              value: function () {
                return vm.customerTableWidget.rows.length;
              }
            }],
            total: 0,
            page: 1,
            limit: 10
          },
          order: '-0'
        };

        vm.defaultListColumns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11];
        vm.defaultExpendedListColumns = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,19,21,23,25,27,29,30,31,32,33,34,35,36,39,40];

        vm.selectedCustomerTableColumns = currentUser.data.dashboardSimpleListColumns?currentUser.data.dashboardSimpleListColumns:vm.defaultListColumns;
        vm.selectedCustomerTableColumnsExpended = currentUser.data.dashboardExpandListColumns?currentUser.data.dashboardExpandListColumns:vm.defaultExpendedListColumns;

        vm.selectedCustomerTableRows = [];


        //Google Map View
        vm.mapWidget = {
          isGoogleMapLoaded: false,
          center: {
            latitude: 39.50,
            longitude: -98.35
          },
          zoom: 4,
          options: {
            minZoom: 1,
            scrollwheel: false
          },
          markers: [],
          events: {
            click: function(marker, eventName, model) {
              vm.selectInstallationById(model.id);
            }
          }
        };

        uiGmapGoogleMapApi.then(function ()
        {
          vm.mapWidget.isGoogleMapLoaded = true;

        });


        // Dashboard View
        vm.mertricWidget = {
          title: '',
          format: function(item) {
            if(vm.mertricWidget.items[item].value && vm.mertricWidget.items[item].unit) {
              return vm.mertricWidget.items[item].value + ' ' + vm.mertricWidget.items[item].unit;
            } else {
              return vm.mertricWidget.items[item].value;
            }
          },
          items : {
            "Average Tank Level at Pick-up": {
              "columns": [{
                "id": "data1",
                "type": "gauge",
                "color": "#fcb24a"
              }],
              "values": [{
                "data1": ""
              }]
            },
            "Projected Annual Number of Pick-ups": {
              "columns": [{
                "id": "data1",
                "type": "gauge",
                "color": "#4c4c4c"
              }],
              "values": [{
                "data1": ""
              }]
            },
            "Average % Left-over in Tank": {
              "columns": [{
                "id": "data1",
                "type": "gauge",
                "color": "#4c4c4c"
              }],
              "values": [{
                "data1": ""
              }]
            },
            "Average % of Slurry that is Water": {
              "columns": [{
                "id": "data1",
                "type": "gauge",
                "color": "#4c4c4c"
              }],
              "values": [{
                "data1": ""
              }]
            },
            "Rolling Waste Processed Rate": {
              "title": "Rolling Waste Processed Rate",
              "value": "",
              "unit": "tons/week",
              format: function() {
                if(vm.mertricWidget.items["Rolling Waste Processed Rate"].value) {
                  if(vm.mertricWidget.items["Rolling Waste Processed Rate"].value >= 0)
                    return vm.mertricWidget.items["Rolling Waste Processed Rate"].value + ' ' + vm.mertricWidget.items["Rolling Waste Processed Rate"].unit;
                  else
                    return '-';
                } else {
                  return vm.mertricWidget.items["Rolling Waste Processed Rate"].value;
                }
              }
            },
            "Rolling Daily Usage": {
              "title": "Rolling Daily Usage",
              "value": "",
              "unit": "times/day"
            },
            "Rolling Mean Run Time": {
              "title": "Rolling Mean Run Time",
              "value": "",
              "unit": "mins/run"
            },
            "Rolling Pick-up Count": {
              "title": "Rolling Pick-up Count",
              "value": ""
            },
            "Rolling Tank Volume": {
              "title": "Rolling Volume fed to Tank",
              "value": "",
              "unit": "gallons"
            },
            "Rolling Water Usage": {
              "title": "Rolling Water Usage",
              "value": "",
              "unit": "gallons"
            },
            "Rolling Total Waste Processed": {
              "title": "Rolling Total Waste Processed",
              "value": "",
              "unit": "tons",
              format: function() {
                if(vm.mertricWidget.items["Rolling Total Waste Processed"].value) {
                  if(vm.mertricWidget.items["Rolling Total Waste Processed"].value >= 0)
                    return vm.mertricWidget.items["Rolling Total Waste Processed"].value + ' ' + vm.mertricWidget.items["Rolling Total Waste Processed"].unit;
                  else
                    return '-';
                } else {
                  return vm.mertricWidget.items["Rolling Total Waste Processed"].value;
                }
              }
            },
            "Rolling Water Content": {
              "title": "Rolling Water Content",
              "value": "",
              "unit": "%",
              format: function() {
                if(vm.mertricWidget.items["Rolling Water Content"].value) {
                  if(vm.mertricWidget.items["Rolling Water Content"].value <= 100)
                    return vm.mertricWidget.items["Rolling Water Content"].value + ' ' + vm.mertricWidget.items["Rolling Water Content"].unit;
                  else
                    return '-';
                } else {
                  return vm.mertricWidget.items["Rolling Water Content"].value;
                }
              }
            },
            "Rolling Boot-up Count": {
              "title": "Rolling Boot-up Count",
              "value": ""
            },
            "Rolling On/Offs Count": {
              "title": "Rolling On/Offs Count",
              "value": ""
            },
            "Rolling Reverse Cycles": {
              "title": "Rolling Reverse Cycle Count",
              "value": ""
            },
            "Rolling Run Time": {
              "title": "Rolling Run Time",
              "value": "",
              "unit": "hours"
            },
            "Average Days between Critical Fault": {
              "title": "Average Days between System Faults",
              "value": ""
            },
            "Temperature": {
              "title": "Temperature",
              "value": "",
              "unit": "⁰F"
            }
          }
        };


        // Alarm View
        vm.alarmWidget = {
          systemFault: {
            columns: [
              {title: 'EventData', hidden: true},
              {title: "Date of Occurrence", format: function(val){ return _formatDateTime(val);}},
              {title: "Fault Code"},
              {title: "Description"}
            ],
            rows: [],
            order: '-1'
          },
          tankLevel: {
            columns: [
              {title: "Date of Occurrence", format: function(val){ return _formatDateTime(val);}},
              {title: "Tank Level (%)"},
              {title: "Scheduled Pick-up", format: function(val){ return _formatDateOnly(val);}},
              //{title: "Confirmed?"},
              {title: "Appointment"}
            ],
            rows: [],
            order: '-0'
          }
        };

        //Layouts

        vm.layoutLeft = '40';
        vm.layoutRight = '60';
        vm.layoutMapVisible = true;
        vm.layoutCustomerVisible = true;
        vm.layoutDashboardVisible = true;
        vm.layoutAlarmVisible = true;
        vm.layoutExpandCustomerView = false;

        // ******************************
        // Public Methods
        // ******************************

        //Open Customer Dialog / Open New Device Dialog
        vm.openInstallation = function(rowIndex) {

          if(currentUser.hasAdminRole()) {
            vm.getSelectedInstallation(rowIndex);
            if(vm.selectedInstallation.isActive === true) {
              vm.openCustomerDlg('edit');
            } else if(vm.selectedInstallation.isActive === false) {
              vm.openNewDeviceDlg();
            }
          }

        };

        //Open Hauler Application
        vm.openHaulerApp = function(rowIndex) {

          if(currentUser.hasAdminRole()) {
            vm.getSelectedInstallation(rowIndex);
            if(vm.selectedInstallation.isActive === true) {
              var url = G2E_CONST_API.HAULER_BASE_URL + '/admin/newAppt/' + vm.selectedInstallation.id;
              window.open(url, '_blank');
            }
          }

        };

        //Get Selected Installation Object from index
        vm.getSelectedInstallation = function(rowIndex) {
          if(rowIndex >=0 && rowIndex < vm.customerTableWidget.rows.length) {
            vm.selectedInstallation = vm.customerTableWidget.rows[rowIndex].data;
          } else {
            vm.selectedInstallation = null;
          }
        };

        //Format guage
        vm.gaugeFormat1 = function(value, ratio) {
          return value;
        };

        //Open Event Log Dialog
        vm.openEventLogDlg = function(ev) {

            var selectedInstallations = [];

            if(vm.layoutExpandCustomerView) {
                var rowsFiltered = vm.getRowsFiltered();

                _.each(vm.selectedCustomerTableRows, function(rowIndex) {
                    if(_.findWhere(rowsFiltered, {index: rowIndex})) {  //Check the selection is in filtered
                        if(vm.customerTableWidget.rows[rowIndex].data.isActive == true) {
                            selectedInstallations.push(vm.customerTableWidget.rows[rowIndex].data);
                        }
                    }
                });

            } else {

                if(vm.selectedInstallation && vm.selectedInstallation.isActive == true) {
                    selectedInstallations.push(vm.selectedInstallation);
                }
            }

            var error = '';
            if(selectedInstallations.length == 0) {
                error = 'No installations selected!';
            // } else if(selectedInstallations.length > 1) {
            //     error = 'Only one installation can be selected!';
            }

            if(error) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(error)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('warning-toast')
                );
                return;
            }


            $rootScope.isDashboard = false;

            $mdDialog.show({
                controller: EventLogDialogController,
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/customer/log-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                locals: {
                  params: {
                      installation: selectedInstallations[0],
                      selectedInstallations: selectedInstallations,
                      start_date: $rootScope.search_start_date,
                      end_date: $rootScope.search_end_date,
                      editable: vm.currentUser.hasAdminRole(),
                      selectable: false,
                      expended: true,
                      isAdminLogs: true,
                      tabs: {
                          TANK_LEVEL: true,
                          PICK_UP: true,
                          SYSTEM_FAULT: true,
                          NON_CRITICAL: true
                      },
                      defaultTab: 'PICK_UP'
                  }
                }
            }).then(function(isLogChanged) {
                if(isLogChanged === true) {
                  vm.loadInstallationsStats();
                }
                $rootScope.isDashboard = true;
            }, function() {
                $rootScope.isDashboard = true;
            });
        };

        //Open Customer Dialog
        vm.openCustomerDlg = function(mode) {

          $rootScope.isDashboard = false;

          var params = {
            mode: mode,
            isGoogleMapLoaded: vm.mapWidget.isGoogleMapLoaded,
            selectedInstallation: vm.selectedInstallation
          };

          $mdDialog.show({
              controller: CustomerDialogController,
              controllerAs: 'vm',
              templateUrl: 'app/main/dashboard/customer/customer-dialog.tmpl.html',
              parent: angular.element(document.body),
              clickOutsideToClose:false,
              escapeToClose: false,
              fullscreen: true,
              locals: {
                params: params
              }
            })
            .then(function(response) {
              if(response) {
                vm.loadInstallationsStats();
              }

              $rootScope.isDashboard = true;
            }, function() {

              $rootScope.isDashboard = true;
            });
        };

        //New Device Registration Dialog
        vm.openNewDeviceDlg = function() {

          $rootScope.isDashboard = false;

          $mdDialog.show({
              controller: NewDeviceDialogController,
              controllerAs: 'vm',
              templateUrl: 'app/main/dashboard/customer/new-device-dialog.tmpl.html',
              parent: angular.element(document.body),
              clickOutsideToClose:false,
              fullscreen: true,
              locals: {
                params: vm.selectedInstallation
              }
            })
            .then(function(response) {

              if(response) {

                vm.loadInstallationsStats();

                $rootScope.isDashboard = true;

              } else {
                vm.openCustomerDlg('add');
              }
            }, function() {

              $rootScope.isDashboard = true;
            });
        };

        //Open Graph Dialog
        vm.openGraphDlg = function(ev) {

          $rootScope.isDashboard = false;

          var selectedInstallations = [];
          var rowsFiltered = vm.getRowsFiltered();

          _.each(vm.selectedCustomerTableRows, function(rowIndex) {

            if(_.findWhere(rowsFiltered, {index: rowIndex})) {  //Check the selection is in filtered

              if(vm.customerTableWidget.rows[rowIndex].data.isActive == true) {
                selectedInstallations.push({
                  id: vm.customerTableWidget.rows[rowIndex].data.id,
                  installationName: vm.customerTableWidget.rows[rowIndex].data.Customer.name,
                  serialNumber: vm.customerTableWidget.rows[rowIndex].data.serialNumber,
                  usefulTankVolume: vm.customerTableWidget.rows[rowIndex].data.Tank.usefulVolume.value,
                  color: randomColor()
                });
              }

            }

          });

          if(selectedInstallations.length == 0) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('No installations selected!')
                .position('top right')
                .hideDelay(3000)
                .theme('warning-toast')
            );
            return;
          }

          $mdDialog.show({
              controller: CustomerGraphDialogController,
              controllerAs: 'vm',
              templateUrl: 'app/main/dashboard/customer/graph-dialog.tmpl.html',
              locals: {
                params: {
                  selectedInstallations: selectedInstallations
                }
              },
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              fullscreen: true
            })
            .then(function(response) {
              $rootScope.isDashboard = true;
            }, function() {
              $rootScope.isDashboard = true;
            });
        };

        //Save selection to the profile
        vm.saveCustomerTableColumns = function() {

            var params;

            if(vm.layoutExpandCustomerView) {
                params = {
                    dashboardExpandListColumns: vm.selectedCustomerTableColumnsExpended
                };
            } else {
                params = {
                    dashboardSimpleListColumns: vm.selectedCustomerTableColumns
                };
            }

            vm.isSavingColumns = true;

            api.profile.update.save(
                params,
                // Success
                function (response)
                {
                    vm.isSavingColumns = false;
                    currentUser.set(response);
                    vm.refreshCustomerTableColumns();
                },
                // Error
                function (response)
                {
                    console.log(response);
                    vm.isSavingColumns = false;
                    vm.msg = '';

                    var errorMsg;
                    if(response.data && response.data.message) {
                        errorMsg = response.data.message;
                    } else {
                        errorMsg = 'Something went wrong!';
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(errorMsg)
                            .position('top right')
                            .hideDelay(3000)
                            .theme('error-toast')
                    );
                }
            );
        };

        //Choose Customer table columns
        vm.chooseCustomerTableColumns = function() {
          vm.refreshCustomerTableColumns();
        };

        //Choose Customer table columns as default
        vm.chooseCustomerTableColumnsDefault = function() {

          if(vm.layoutExpandCustomerView) {
            vm.selectedCustomerTableColumnsExpended = vm.defaultExpendedListColumns;
          } else {
            vm.selectedCustomerTableColumns = vm.defaultListColumns;
          }
          vm.refreshCustomerTableColumns();
        };

        //Uncheck all columns
        vm.chooseCustomerTableColumnsRemove = function() {

          if(vm.layoutExpandCustomerView) {
            vm.selectedCustomerTableColumnsExpended = [];
          } else {
            vm.selectedCustomerTableColumns = [];
          }
          vm.refreshCustomerTableColumns();
        };

        //Choose Customer table columns as all
        vm.chooseCustomerTableColumnsAll = function() {

          var selectedColumns = [];
          _.each(vm.customerTableWidget.columns, function(column, index) {
            selectedColumns.push(index);
          });

          if(vm.layoutExpandCustomerView) {
            vm.selectedCustomerTableColumnsExpended = selectedColumns;
          } else {
            vm.selectedCustomerTableColumns = selectedColumns;
          }
          vm.refreshCustomerTableColumns();
        };

        //Refresh Customer table columns from data
        vm.refreshCustomerTableColumns = function() {

          //New
          var selectedColumns;
          if(vm.layoutExpandCustomerView) {
              selectedColumns = vm.selectedCustomerTableColumnsExpended;
              vm.isColumnsChanged = !angular.equals(currentUser.data.dashboardExpandListColumns, vm.selectedCustomerTableColumnsExpended);
          } else {
              selectedColumns = vm.selectedCustomerTableColumns;
              vm.isColumnsChanged = !angular.equals(currentUser.data.dashboardSimpleListColumns, vm.selectedCustomerTableColumns);
          }

          _.each(vm.customerTableWidget.columns, function(column, index) {
            if(_.indexOf(selectedColumns, index) == -1) {
              column.visible = false;
            } else {
              column.visible = true;
            }
          });

        };

        //Check the row is selected
        vm.isSelectedCustomerTableRows = function(rowIndex) {
          return vm.selectedCustomerTableRows.indexOf(rowIndex) > -1;
        };

        //Select a row in Customer table
        vm.chooseCustomerTableRows = function(rowIndex) {

          if(vm.layoutExpandCustomerView) {
            var idx = vm.selectedCustomerTableRows.indexOf(rowIndex);
            if (idx > -1) vm.selectedCustomerTableRows.splice(idx, 1);
            else vm.selectedCustomerTableRows.push(rowIndex);
          } else {
            vm.selectInstallationByIndex(rowIndex);
          }
        };

        //Update map makers by filter
        vm.filterMap = function(status) {
          if(status != vm.status_by) {
            vm.status_by = status;
            _generateMapMarkers();
          }
        };

        //Defaults map center and zoom
        vm.setDefaultMapCenterZoom = function() {
          vm.mapWidget.center = {
            latitude: 39.50,
            longitude: -98.35
          };
          vm.mapWidget.zoom = 4;
        };

        //Update map maker for selected installation
        vm.selectInstallationOnMap = function(installationId) {
          if(installationId) {

            //clear selected before
            var selectedMarker = _.findWhere(vm.mapWidget.markers, {'selected': true});
            if(selectedMarker) {
              selectedMarker.options.icon.url = _getMarkerImageUrl(selectedMarker.status, false);
              selectedMarker.selected = false;
            }

            //set new selected
            selectedMarker = _.findWhere(vm.mapWidget.markers, {'id': installationId});
            if(selectedMarker) {
              selectedMarker.options.icon.url = _getMarkerImageUrl(selectedMarker.status, true);
              selectedMarker.selected = true;
              vm.mapWidget.center = {
                latitude: selectedMarker.coords.latitude,
                longitude: selectedMarker.coords.longitude
              };
            }
            //vm.setDefaultMapCenterZoom();
            /*
            _.each(vm.mapWidget.markers, function(marker) {
              if(marker.id == installationId) {
                marker.options.icon.url = _getMarkerImageUrl(marker.status, true);
                marker.selected = true;
                vm.mapWidget.center = {
                  latitude: marker.coords.latitude,
                  longitude: marker.coords.longitude
                };
              } else {
                marker.options.icon.url = _getMarkerImageUrl(marker.status, false);
                marker.selected = false;
              }
            });*/
          }
        };

        //Update alarms table for selected installation
        vm.selectInstallationOnAlarm = function(rowIndex) {
          if(rowIndex>=0 && rowIndex < vm.customerTableWidget.rows.length) {
            var installation = vm.customerTableWidget.rows[rowIndex].data;

            var alarmSystemFaultRows = [];
            _.each(installation.SystemFaultEvents, function(event) {
              alarmSystemFaultRows.push([
                event,
                new Date(event.issuedAt),
                event.faultCode,
                event.faultDescription
              ]);
            });
            vm.alarmWidget.systemFault.rows = alarmSystemFaultRows;

            var alarmTankLevelRows = [];
            _.each(installation.TankLevelEvents, function(event) {

              //var tankLevel = (event.tankLevel)?parseInt(event.tankLevel) + '%':'null';

              var scheduledAt = event.scheduledAt;
              var isConfirmed = event.isConfirmed;
              var appointmentId = event.appointmentId;
              if(!event.scheduledAt) {
                scheduledAt = installation.scheduledAt;
                isConfirmed = installation.isConfirmed;
                appointmentId = installation.appointmentId;
              }

              alarmTankLevelRows.push([
                new Date(event.createdAt),
                event.tankLevel,
                (scheduledAt)?new Date(scheduledAt):'',
                //(isConfirmed)?'Yes':'No',
                appointmentId
              ]);
            });
            vm.alarmWidget.tankLevel.rows = alarmTankLevelRows;
          }
        };

        //Remove alarms data in alarm table view
        vm.clearAlarmWidgetData = function() {
          vm.alarmWidget.systemFault.rows = [];
          vm.alarmWidget.tankLevel.rows = [];
        };

        //Update dashboard view for selected installtion
        vm.selectInstallationOnDashboard = function(rowIndex) {
          if(rowIndex>=0 && rowIndex < vm.customerTableWidget.rows.length) {
            var installation = vm.customerTableWidget.rows[rowIndex].data;
            vm.mertricWidget.title = installation.Customer.name;
            vm.mertricWidget.items['Average Tank Level at Pick-up'].values[0].data1 = installation.Stats['Average Tank Level at Pick-up'];
            vm.mertricWidget.items['Projected Annual Number of Pick-ups'].values[0].data1 = installation.Stats['Projected Annual Number of Pick-ups'];
            vm.mertricWidget.items['Average % Left-over in Tank'].values[0].data1 = installation.Stats['Average % Left-over in Tank'];
            vm.mertricWidget.items['Average % of Slurry that is Water'].values[0].data1 = installation.Stats['Average % of Slurry that is Water'];
            vm.mertricWidget.items['Rolling Waste Processed Rate'].value = installation.Stats['Rolling Waste Processed Rate'];
            vm.mertricWidget.items['Rolling Daily Usage'].value = installation.Stats['Rolling Daily Usage'];
            vm.mertricWidget.items['Rolling Mean Run Time'].value = installation.Stats['Rolling Mean Run Time'];
            vm.mertricWidget.items['Rolling Pick-up Count'].value = installation.Stats['Rolling Pick-up Count'];
            vm.mertricWidget.items['Rolling Tank Volume'].value = installation.Stats['Rolling Tank Volume'];
            vm.mertricWidget.items['Rolling Water Usage'].value = installation.Stats['Rolling Water Usage'];
            vm.mertricWidget.items['Rolling Total Waste Processed'].value = installation.Stats['Rolling Total Waste Processed'];
            vm.mertricWidget.items['Rolling Water Content'].value = installation.Stats['Rolling Water Content'];
            vm.mertricWidget.items['Rolling Boot-up Count'].value = installation.Stats['Rolling Boot-up Count'];
            vm.mertricWidget.items['Rolling On/Offs Count'].value = installation.Stats['Rolling On/Offs Count'];
            vm.mertricWidget.items['Rolling Reverse Cycles'].value = installation.Stats['Rolling Reverse Cycles'];
            vm.mertricWidget.items['Rolling Run Time'].value = installation.Stats['Rolling Run Time'];
            vm.mertricWidget.items['Average Days between Critical Fault'].value = installation.Stats['Average Days between Critical Fault'];
            vm.mertricWidget.items['Temperature'].value = installation.Stats['Temperature'];
          }
        };

        //Remove metric data in dashboard
        vm.clearMerticWidgetData = function() {
          vm.mertricWidget.title = '';
          vm.mertricWidget.items['Average Tank Level at Pick-up'].values[0].data1 = '';
          vm.mertricWidget.items['Projected Annual Number of Pick-ups'].values[0].data1 = '';
          vm.mertricWidget.items['Average % Left-over in Tank'].values[0].data1 = '';
          vm.mertricWidget.items['Average % of Slurry that is Water'].values[0].data1 = '';
          vm.mertricWidget.items['Rolling Waste Processed Rate'].value = '';
          vm.mertricWidget.items['Rolling Daily Usage'].value = '';
          vm.mertricWidget.items['Rolling Mean Run Time'].value = '';
          vm.mertricWidget.items['Rolling Pick-up Count'].value = '';
          vm.mertricWidget.items['Rolling Tank Volume'].value = '';
          vm.mertricWidget.items['Rolling Water Usage'].value = '';
          vm.mertricWidget.items['Rolling Total Waste Processed'].value = '';
          vm.mertricWidget.items['Rolling Water Content'].value = '';
          vm.mertricWidget.items['Rolling Boot-up Count'].value = '';
          vm.mertricWidget.items['Rolling On/Offs Count'].value = '';
          vm.mertricWidget.items['Rolling Reverse Cycles'].value = '';
          vm.mertricWidget.items['Rolling Run Time'].value = '';
          vm.mertricWidget.items['Average Days between Critical Fault'].value = '';
          vm.mertricWidget.items['Temperature'].value = '';
        };

        //Check if Acknowledge All is available
        vm.isAcknowledgeAllAvailable = function() {
            if(vm.alarmWidget.systemFault.rows.length == 0) return false;
            for(var index=0;index<vm.alarmWidget.systemFault.rows.length;index++) {
                if(!vm.alarmWidget.systemFault.rows[index][0].isAck) {
                    return true;
                }
            }
            return false;
        };

        //Acknowledge all SystemFaults
        vm.acknowledgeAllSystemFaults = function() {
            _.each(vm.alarmWidget.systemFault.rows, function(row) {
                vm.acknowledgeSystemFault(row);
            });
        };

        //Acknowledge a SystemFault
        vm.acknowledgeSystemFault = function(alarmSystemFaultRow) {

          var eventData = alarmSystemFaultRow[0];//0 element has object reference to installation.SystemFaultEvents
          eventData.isAck = true;


          api.events.systemfault.acknowledge.save({installationId: eventData.InstallationId, eventId: eventData.id}, function (res){

            var index = _.findIndex(vm.alarmWidget.systemFault.rows, function(row) {
              return row[0].id == eventData.id;
            });

            if(index !== -1) {
              vm.alarmWidget.systemFault.rows.splice(index, 1);
            }

            var inst = _.findWhere(vm.installationsStats, {id: eventData.InstallationId});

            if(inst) {
              index = _.findIndex(inst.SystemFaultEvents, function(row) {
                return row.id == eventData.id;
              });
              if(index !== -1) {
                inst.SystemFaultEvents.splice(index, 1);

                if(inst.SystemFaultEvents.length == 0) {
                  _generateCustomerTableRows();
                }
              }
            }

          }, function (err) {

            if(err.data && err.data.message) {
              vm.errorMsg = err.data.message;
            } else {
              vm.errorMsg = 'Something went wrong!';
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent(vm.errorMsg)
                .position('top right')
                .hideDelay(3000)
                .theme('error-toast')
            );

          });

        };

        //Select a installation by rowIndex
        vm.selectInstallationByIndex = function(rowIndex) {

          var selectedActiveOne = false;

          if(rowIndex >=0 && rowIndex < vm.customerTableWidget.rows.length) {
            vm.selectedInstallation = vm.customerTableWidget.rows[rowIndex].data;
            vm.selectedCustomerTableRows = [rowIndex];
            if(vm.selectedInstallation.isActive) {
              vm.selectInstallationOnMap(vm.selectedInstallation.id);
              vm.selectInstallationOnDashboard(rowIndex);
              vm.selectInstallationOnAlarm(rowIndex);
              selectedActiveOne = true;
            }
          } else {
            vm.selectedInstallation = null;
            vm.selectedCustomerTableRows = [];
            vm.mapWidget.markers = [];
          }

          if(!selectedActiveOne) {
            vm.selectInstallationOnMap(-1);
            vm.clearAlarmWidgetData();
            vm.clearMerticWidgetData();
          }
        };

        //Select a installation by installationId
        vm.selectInstallationById = function(installationId) {

          var selectedActiveOne = false;

          var index = _.findIndex(vm.customerTableWidget.rows, function(row) {
            return row.data.id == installationId;
          });

          if(index != -1) {
            vm.selectedInstallation = vm.customerTableWidget.rows[index].data;
            vm.selectedCustomerTableRows = [index];
            if(vm.selectedInstallation.isActive) {
              vm.selectInstallationOnMap(installationId);
              vm.selectInstallationOnDashboard(index);
              vm.selectInstallationOnAlarm(index);
              selectedActiveOne = true;
            }
          } else {
            vm.selectedInstallation = null;
            vm.selectedCustomerTableRows = [];
            vm.mapWidget.markers = [];
          }

          if(!selectedActiveOne) {
            vm.selectInstallationOnMap(-1);
            vm.clearAlarmWidgetData();
            vm.clearMerticWidgetData();
          }

        };

        //Validate all the rows is checked in Customer table
        vm.isSelectedAllCustomerTableRows = function() {

          var isAll = true;
          _.every(vm.customerTableWidget.rows, function(row, rowIndex){
            var idx = vm.selectedCustomerTableRows.indexOf(rowIndex);
            if (idx == -1) {
              isAll = false;
            }
            return isAll;
          });

          return isAll;

        };

        //Check all the rows in Customer table
        vm.chooseAllCustomerTableRows = function() {

          if(vm.isSelectedAllCustomerTableRows()) {
            vm.selectedCustomerTableRows = [];
          } else {
            vm.selectedCustomerTableRows = [];
            _.each(vm.customerTableWidget.rows, function(row, rowIndex){
              vm.selectedCustomerTableRows.push(rowIndex);
            });
          }

        };

        //Get array data to export CSV
        vm.getCSVHeadersForCustomerTable = function() {
          return _.map(vm.selectedCustomerTableColumnsExpended, function(columnIndex){
            return vm.customerTableWidget.columns[columnIndex].title;
          });
        };

        //Get headers to export CSV
        vm.getCSVRowsForCustomerTable = function() {
          var rows = [];
          // var filterRows = $filter('filterBy')(vm.customerTableWidget.rows, $rootScope.search_location, $rootScope.search_company, $rootScope.search_contract_type, vm.status_by);
          var filterRows = vm.getRowsFiltered()
          var orderedRows = $filter('sortBy')(filterRows, vm.customerTableWidget.order);
          _.each(orderedRows, function(tableRow) {
            var row = [];
            _.each(vm.selectedCustomerTableColumnsExpended, function(columnIndex) {

              if(tableRow.cells[columnIndex].export_format) {
                row.push(tableRow.cells[columnIndex].export_format(tableRow.cells[columnIndex].value));
              } else if(tableRow.cells[columnIndex].format) {
                row.push(tableRow.cells[columnIndex].format(tableRow.cells[columnIndex].value));
              } else {
                row.push(tableRow.cells[columnIndex].value);
              }

            });
            rows.push(row);
          });
          return rows;
        };

        //Get filtered rows count
        vm.getRowsFiltered = function() {
          var filterRows =  $filter('filterBy')(vm.customerTableWidget.rows, $rootScope.search_location, $rootScope.search_company, $rootScope.search_contract_type, vm.status_by);
          return filterRows
        };

        //Get CSV File name
        vm.getCSVFilenameForCustomerTable = function() {
          var start = '';
          var end = '';
          var filename;
          if($rootScope.search_period) {
            start = moment().subtract($rootScope.search_period, "days").format('YYYY-MM-DD');
            end = moment().format('YYYY-MM-DD');
          } else {
            start = moment($rootScope.search_start_date).format('YYYY-MM-DD');
            end = moment($rootScope.search_end_date).format('YYYY-MM-DD');
          }
          filename = 'Stats_' + start + '_' + end + '.csv';
          return filename;
        };

        //Expand Customer View
        vm.expandCustomerView = function() {

          if(vm.layoutExpandCustomerView) {

            vm.layoutLeft = '40';
            vm.layoutRight = '60';
            vm.layoutMapVisible = true;
            vm.layoutCustomerVisible = true;
            vm.layoutDashboardVisible = true;
            vm.layoutAlarmVisible = true;

            vm.selectInstallationDefault();

          } else {
            vm.layoutLeft = '0';
            vm.layoutRight = '100';
            vm.layoutMapVisible = false;
            vm.layoutCustomerVisible = true;
            vm.layoutDashboardVisible = false;
            vm.layoutAlarmVisible = false;

          }

          vm.layoutExpandCustomerView = !vm.layoutExpandCustomerView;

          vm.refreshCustomerTableColumns();
        };

        //Select a active installation in listview
        vm.selectInstallationDefault = function() {
          var rowIndex;
          if(vm.selectedCustomerTableRows.length > 0) {
            rowIndex = vm.selectedCustomerTableRows[vm.selectedCustomerTableRows.length-1];
            vm.selectInstallationByIndex(rowIndex);
          } else {
            /*
            rowIndex = _.findIndex(vm.customerTableWidget.rows, function(row) {
              return row.data.isActive == true;
            });
            if(rowIndex != -1) {
              vm.selectInstallationByIndex(rowIndex);
            }*/
          }
        };

        //Pagination callback in customer table
        vm.loadPage = function() {
          vm.loadInstallationsStats();
        };

        /**
         * Load installations statistics
         */
        vm.loadInstallationsStats = function() {

          bsLoadingOverlayService.start({referenceId: 'installations_loader'});
          vm.isLoadingInstallations = true;

          //Config parameters
          var params = {
            //page: vm.customerTableWidget.pagination.page,
            //limit: vm.customerTableWidget.pagination.limit
          };

          if($rootScope.search_period) {
            params.type = 'rolling';
            params.days = $rootScope.search_period;
          } else {
            params.type = 'range';
            params.start = moment($rootScope.search_start_date).format('YYYY-MM-DDT00:00:00.000Z');
            params.end = moment($rootScope.search_end_date).format('YYYY-MM-DDT23:59:59.999Z');
          }

          console.log(params);

          api.installations.listStats.get(params, function (response) {
              //console.log(response);
              vm.installationsStats = response.rows;
              _generateCustomerTableRows();
              _generateMapMarkers();

              if(!vm.layoutExpandCustomerView) {
                  vm.selectInstallationDefault();
              }

              vm.isLoadingInstallations = false;
              bsLoadingOverlayService.stop({referenceId: 'installations_loader'});

            }, function (error) {

              if(error.data && error.data.message) {
                vm.errorMsg = error.data.message;
              } else {
                vm.errorMsg = 'Something went wrong!';
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent(vm.errorMsg)
                  .position('top right')
                  .hideDelay(3000)
                  .theme('error-toast')
              );

              vm.isLoadingInstallations = false;
              bsLoadingOverlayService.stop({referenceId: 'installations_loader'});
            }
          );
        };

        // Stop Auto refresh
        vm.stopAutoRefresh = function() {
            if(vm.autoRefreshHandler !== null) {
                $interval.cancel(vm.autoRefreshHandler);
            }
        };

        // Start Auto refresh
        vm.startAutoRefresh = function() {

          vm.autoRefreshHandler = $interval(function() {
            if($scope.isDashboard && !vm.isLoadingInstallations && !vm.autoRefreshing) {

              //var deferred = $q.defer();
              //vm.installationsLoader = deferred.promise;
              vm.autoRefreshing = true;

              var params = {auto: true};

              if($rootScope.search_period) {
                params.type = 'rolling';
                params.days = $rootScope.search_period;
              } else {
                params.type = 'range';
                params.start = moment($rootScope.search_start_date).format('YYYY-MM-DDT00:00:00.000Z');
                params.end = moment($rootScope.search_end_date).format('YYYY-MM-DDT23:59:59.999Z');
              }

              console.log(params);

              api.installations.listStats.get(params, function (response) {

                if(response.isLiveOnly) {

                  //Copy 5.3 rolling calculations from old
                  _.each(response.rows, function(row) {

                    if(row.isActive) {
                      var inst = _.findWhere(vm.installationsStats, {id: row.id});
                      if(inst) {
                        row.Stats['Boot-up Count'] = inst.Stats['Boot-up Count'];
                        row.Stats['Rolling Boot-up Count'] = inst.Stats['Rolling Boot-up Count'];
                        row.Stats['Reverse Cycle Count'] = inst.Stats['Reverse Cycle Count'];
                        row.Stats['Rolling Reverse Cycles'] = inst.Stats['Rolling Reverse Cycles'];
                        row.Stats['System On/Offs Count'] = inst.Stats['System On/Offs Count'];
                        row.Stats['Rolling On/Offs Count'] = inst.Stats['Rolling On/Offs Count'];
                        row.Stats['System Run Time'] = inst.Stats['System Run Time'];
                        row.Stats['Rolling Run Time'] = inst.Stats['Rolling Run Time'];
                        row.Stats['Water Meter Reading'] = inst.Stats['Water Meter Reading'];
                        row.Stats['Rolling Water Usage'] = inst.Stats['Rolling Water Usage'];
                        row.Stats['Double Water Count'] = inst.Stats['Double Water Count'];
                        row.Stats['Rolling Double Water Count'] = inst.Stats['Rolling Double Water Count'];
                        row.Stats['Total Tank Volume'] = inst.Stats['Total Tank Volume'];
                        row.Stats['Rolling Tank Volume'] = inst.Stats['Rolling Tank Volume'];
                        row.Stats['Rolling Mean Run Time'] = inst.Stats['Rolling Mean Run Time'];
                        row.Stats['Rolling Daily Usage'] = inst.Stats['Rolling Daily Usage'];
                        row.Stats['Rolling Total Waste Processed'] = inst.Stats['Rolling Total Waste Processed'];
                        row.Stats['Rolling Waste Processed Rate'] = inst.Stats['Rolling Waste Processed Rate'];
                        row.Stats['Rolling Water Content'] = inst.Stats['Rolling Water Content'];
                      }
                    }
                  });
                }

                vm.installationsStats = response.rows;

                _generateCustomerTableRows();
                _generateMapMarkers();

                if(!vm.layoutExpandCustomerView) {
                    vm.selectInstallationDefault();
                }

                //deferred.resolve();
                vm.autoRefreshing = false;

              },function(error) {

                if(!vm.layoutExpandCustomerView) {
                    vm.selectInstallationDefault();
                }

                //deferred.resolve();
                vm.autoRefreshing = false;
              });
            }
          }, 60000);

        };

        // ******************************
        // Internal methods
        // ******************************

        /**
         * Get Status image class name
         */
        function _getStatusImageClass(status) {
          if(status === 0) {
            return 'g2e-icon-status-running';
          } else if(status === 1) {
            return 'g2e-icon-status-standby';
          } else if(status === 2){
            return 'g2e-icon-status-off';
          } else {
            return 'g2e-icon-status-unassigned';
          }
        }

        /**
         * Get map marker image
         */
        function _getMarkerImageUrl(status, isSelected) {
          if(isSelected) {
            if(status === 0) {
              return '/assets/images/icons/icon-map-running.png';
            } else if(status === 1) {
              return '/assets/images/icons/icon-map-standby.png';
            } else {
              return '/assets/images/icons/icon-map-off.png';
            }
          } else {
            if(status === 0) {
              return '/assets/images/icons/icon-status-running.png';
            } else if(status === 1) {
              return '/assets/images/icons/icon-status-standby.png';
            } else {
              return '/assets/images/icons/icon-status-off.png';
            }
          }
        }

        /**
         * Get Alarm image class name
         */
        function _getAlarmImageClass(alarm) {
          if(alarm) {
            return 'g2e-icon-alarm';
          } else {
            return '';
          }
        }

        /**
         * Get Tank Level image class name
         */
        function _getTankLevelImageClass(level) {
          if(level === 0) {
            return 'g2e-icon-tank-low';
          } else if(level === 1) {
            return 'g2e-icon-tank-medium';
          } else if(level === 2) {
            return 'g2e-icon-tank-critical';
          } else {
            return 'g2e-icon-tank-unassigned';
          }
        }

        /**
         * Get Truck image class name
         */
        function _getTruckImageClass(truck) {
          if(truck === 0) {
            return 'g2e-icon-truck-pickup-not-needed-checked';
          } else if(truck === 1) {
            return 'g2e-icon-truck-pickup-not-needed';
          } else if(truck === 2) {
            return 'g2e-icon-truck-pickup-needed-checked';
          } else if(truck === 3) {
            return 'g2e-icon-truck-pickup-needed';
          } else if(truck === 4) {
            return 'g2e-icon-truck-pickup-critical-checked';
          } else if(truck === 5) {
            return 'g2e-icon-truck-pickup-critical';
          } else {
            return '';
          }
        }

        /**
         * Format DateTime
         */
        function _formatDateTime(dt) {
          if(dt !== null && dt !== '') {
            return moment(dt).format('MM/DD/YYYY, h:mm A');
          } else {
            return '';
          }
        }

        /**
         * Format Date Only
         */
        function _formatDateOnly(dt) {
          if(dt !== null && dt !== '') {
            return moment(dt).format('MM/DD/YYYY');
          } else {
            return '';
          }
        }

        /**
         * Format Hours duration
         */
        function _formatHoursDuration(val, val_units) {
          if(val !== null && val !== '') {
            return moment.duration(val, val_units).format('h:mm', { trim: false });
          } else {
            return '';
          }
        }

        /**
         * Format Currency as '$##,##0'
         */
        function _formatCurrencyAnnual(val) {
          if(val !== null && val !== '') {
            val = Math.round(val/10) * 10;
            return numeral(val).format('$0,0');
          } else {
            return '';
          }
        }

        /**
         * Format Currency as '$##,###'
         */
        function _formatCurrency(val) {
          if(val !== null && val !== '') {
            return numeral(val).format('$0,0');
          } else {
            return '';
          }
        }

        /**
         * Format Status to export csv
         */
        function _formatExportSystemStatus(status) {
          if(status == 0) {
            return 'Running';
          } else if(status == 1) {
            return 'Standby';
          } else if(status == 2){
            return 'Off';
          } else {
            return 'Unassigned';
          }
        }

        /**
         * Format Alarm to export csv
         */
        function _formatExportAlarm(alarm) {
          if(alarm > 0) {
            return 'Yes';
          } else {
            return '';
          }
        }

        /**
         * Format Truck to export csv
         */
        function _formatExportTruck(truck) {
          if(truck == 0) {
            return 'Pickup-not-needed-checked';
          } else if(truck == 1) {
            return 'Pickup-not-needed';
          } else if(truck == 2) {
            return 'Pickup-needed-checked';
          } else if(truck == 3) {
            return 'Pickup-needed';
          } else if(truck == 4) {
            return 'Pickup-critical-checked';
          } else if(truck == 5) {
            return 'Pickup-critical';
          } else {
            return '';
          }
        }

        /**
         * Format Percentage to export csv
         */
        function _formatExportPercentage(val) {
          if(val !== null && val !== '' && val !== undefined) {
            return val/100;
          } else {
            return '';
          }
        }

        /**
         * Format Hours duration to export csv
         */
        function _formatExportHoursDuration(val, val_units) {
          if(val !== null && val !== '') {
            if(val_units == 'seconds') {
              val = val/3600;
            }
            val = parseFloat(val.toFixed(1));
            return val;
          } else {
            return '';
          }
        }

        /**
         * Format Currency as '$##,###'
         */
        function _convertDays(val, units) {
          if(val != null && val != '') {
            units = units.toLowerCase();
            if(units == 'years' || units == 'year') {
              return 365*val;
            } else if(units == 'months' || units == 'month') {
              return 31*val;
            } else if(units == 'weeks' || units == 'week') {
              return 7*val;
            } else if(units == 'days' || units == 'day') {
              return 1*val;
            } else {
              return '';
            }
          } else {
            return '';
          }
        }

        /**
         * Generate map markers
         */
        function _generateMapMarkers() {

          var markers = [];

          // var filterRows = $filter('filterBy')(vm.customerTableWidget.rows, $rootScope.search_location, $rootScope.search_company, $rootScope.search_contract_type, vm.status_by);
          var filterRows = vm.getRowsFiltered()

          _.each(filterRows, function(row) {
            var installation = row.data;
            if(installation.isActive === true) {

                var selectedMarker = false;
                if(vm.selectedInstallation && vm.selectedInstallation.id == installation.id) {
                  selectedMarker = true;
                }

                var marker = {
                  id: installation.id,
                  status: installation.Stats['Status'],
                  selected: selectedMarker,
                  coords: {
                    latitude: installation.Customer.lat,
                    longitude: installation.Customer.lng
                  },
                  options: {
                    icon: {
                      url: _getMarkerImageUrl(installation.Stats['Status'], selectedMarker)
                    }
                  }
                };
                markers.push(marker);
            }
          });
          vm.mapWidget.markers = markers;
          vm.setDefaultMapCenterZoom();
        }

        /**
         * Generate customer table rows
         */
        function _generateCustomerTableRows() {

          var rows = [];

          _.each(vm.installationsStats, function(installation, index) {

              var row = {
                index: index,
                data: installation
              };
              if(installation.isActive === true) {

                row.cells = [
                  {
                    value: installation.Stats['Status'],
                    image: _getStatusImageClass(installation.Stats['Status']),
                    classes: 'g2e-icon-text-hide',
                    export_format: function(val){ return _formatExportSystemStatus(val);}
                  },
                  {
                    value: installation.SystemFaultEvents.length,
                    image: _getAlarmImageClass(installation.SystemFaultEvents.length),
                    classes: 'g2e-icon-text-hide',
                    export_format: function(val){ return _formatExportAlarm(val);}
                  },
                  {
                    value: installation.Stats['Truck'],
                    image: _getTruckImageClass(installation.Stats['Truck']),
                    classes: "g2e-icon-text-hide",
                    export_format: function(val){ return _formatExportTruck(val);}
                  },
                  {
                    value: installation.Customer.name
                  },
                  {
                    value: installation.serialNumber
                  },
                  {
                    value: installation.Customer.state
                  },
                  {
                    value: installation.Customer.contractType
                  },
                  {
                    value: installation.Stats['Tank Level'],
                    image: _getTankLevelImageClass(installation.Stats['Tank Level Status']),
                    export_format: function(val){ return _formatExportPercentage(val);}
                  },
                  {
                    value: installation.Stats['Days to Capacity']
                  },
                  {
                    value: installation.Stats['Days to Trigger']
                  },
                  {
                    value: (installation.Stats['PickupTargetDate'])?new Date(installation.Stats['PickupTargetDate'] + ' 00:00:00'):'',
                    format: function(val){ return _formatDateOnly(val);}
                  },
                  {
                    value: (installation.scheduledAt)?new Date(installation.scheduledAt):'',
                    format: function(val){ return _formatDateOnly(val);}
                  },
                  {
                    value: installation.Stats['Volume in Tank']
                  },
                  {
                    value: installation.Stats['Average Fill Rate'],
                    export_format: function(val){ return _formatExportPercentage(val);}
                  },
                  {
                    value: installation.Stats['Temperature']
                  },
                  {
                    value: installation.Stats['Discharge Pressure']
                  },
                  {
                    value: installation.Stats['Current of grinder']
                  },
                  {
                    value: installation.Stats['Current of pump']
                  },
                  {
                    value: installation.Stats['Boot-up Count']
                  },
                  {
                    value: installation.Stats['Rolling Boot-up Count']
                  },
                  {
                    value: installation.Stats['Reverse Cycle Count']
                  },
                  {
                    value: installation.Stats['Rolling Reverse Cycles']
                  },
                  {
                    value: installation.Stats['System On/Offs Count']
                  },
                  {
                    value: installation.Stats['Rolling On/Offs Count']
                  },
                  {
                    value: installation.Stats['System Run Time'],
                    format: function(val){ return _formatHoursDuration(val, 'hours');},
                    export_format: function(val){ return _formatExportHoursDuration(val);}
                  },
                  {
                    value: installation.Stats['Rolling Run Time'],
                    format: function(val){ return _formatHoursDuration(val, 'hours');},
                    export_format: function(val){ return _formatExportHoursDuration(val);}
                  },
                  {
                    value: installation.Stats['Water Meter Reading']
                  },
                  {
                    value: installation.Stats['Rolling Water Usage']
                  },
                  {
                    value: installation.Stats['Double Water Count']
                  },
                  {
                    value: installation.Stats['Rolling Double Water Count']
                  },
                  {
                    value: installation.Stats['Rolling Pick-up Count']
                  },
                  {
                    value: installation.Stats['Rolling Waste Processed Rate'],
                    format: function(val){ return val>=0?val:'-';}
                  },
                  {
                    value: installation.Stats['Rolling Daily Usage']
                  },
                  {
                    value: installation.Stats['Rolling Mean Run Time']
                  },
                  {
                    value: installation.Stats['Rolling Tank Volume']
                  },
                  {
                    value: installation.Stats['Rolling Total Waste Processed'],
                    format: function(val){ return val>=0?val:'-';}
                  },
                  {
                    value: installation.Stats['Rolling Water Content'],
                    format: function(val){ return val<=100?val:'-';},
                    export_format: function(val){ return val<=100?_formatExportPercentage(val):'-';}
                  },
                  {
                    value: installation.Stats['Average Days between Critical Fault']
                  },
                  {
                    value: installation.Stats['Average Days between Pick-ups']
                  },
                  {
                    value: installation.Stats['Average Tank Level at Pick-up']
                  },
                  {
                    value: installation.Stats['Average % Left-over in Tank'],
                    export_format: function(val){ return _formatExportPercentage(val);}
                  },
                  {
                    value: installation.Stats['Average % of Slurry that is Water'],
                    export_format: function(val){ return _formatExportPercentage(val);}
                  },
                  {
                    value: installation.Stats['Average Mean Run Time']
                  },
                  {
                    value: installation.Stats['Average Waste Processed']
                  },
                  {
                    value: installation.Stats['Average Mean Daily Usage']
                  },
                  {
                    value: installation.Stats['Projected Annual Number of Pick-ups']
                  },
                  {
                    value: installation.Stats['Projected Annual Tipping Cost'],
                    format: function(val){ return _formatCurrency(val);}
                  },
                  {
                    value: installation.Stats['Projected Annual Hauling Cost'],
                    format: function(val){ return _formatCurrency(val);}
                  },
                  {
                    value: installation.Stats['Projected Annual Combined Cost'],
                    format: function(val){ return _formatCurrency(val);}
                  },
                  {
                    value: installation.Customer.annualRevenue.value,
                    format: function(val){ return _formatCurrency(val);}
                  },
                  {
                    value: installation.Company.name
                  },
                  {
                    value: installation.Customer.address
                  },
                  {
                    value: installation.Customer.city
                  },
                  {
                    value: installation.Customer.zipcode
                  },
                  {
                    value: (installation.Customer.contact)?installation.Customer.contact.name:''
                  },
                  {
                    value: (installation.Customer.contact)?installation.Customer.contact.title:''
                  },
                  {
                    value: (installation.Customer.contact)?installation.Customer.contact.phone1:''
                  },
                  {
                    value: (installation.Customer.contact)?installation.Customer.contact.phone2:''
                  },
                  {
                    value: (installation.Customer.contact)?installation.Customer.contact.email:''
                  },
                  {
                    value: installation.Customer.pricePerPayPeriod.value,
                    format: function(val){ return _formatCurrency(val);}
                  },
                  {
                    value: _convertDays(installation.Customer.paymentPeriodInterval.value,installation.Customer.paymentPeriodInterval.units),
                    format: function(val) {
                      return installation.Customer.paymentPeriodInterval.value + ' ' +installation.Customer.paymentPeriodInterval.units.toLowerCase();
                    }
                  },
                  {
                    value: installation.Customer.paymentsPerYear
                  },
                  {
                    value: installation.Customer.haulingCost.value,
                    format: function(val){ return _formatCurrency(val);}
                  },
                  {
                    value: installation.Customer.allocatedServiceCost.value,
                    format: function(val){ return _formatCurrency(val);}
                  },
                  {
                    value: installation.Customer.maxHaulsAnnual
                  },
                  {
                    value: (installation.Customer.minHaulsAnnual)?installation.Customer.minHaulsAnnual:''
                  },
                  {
                    value: installation.Tank.contractWasteProductionEstimate.value
                  },
                  {
                    value: (installation.Tank.installDate)?new Date(installation.Tank.installDate + ' 00:00:00'):'',
                    format: function(val){ return _formatDateOnly(val);}
                  },
                  {
                    value: installation.Tank.contractLength.value
                  },
                  {
                    value: (installation.Tank.expectedRenewalDate)?new Date(installation.Tank.expectedRenewalDate + ' 00:00:00'):'',
                    format: function(val){ return _formatDateOnly(val);}
                  },
                  {
                    value: (installation.Tank.iotActivationDate)?new Date(installation.Tank.iotActivationDate + ' 00:00:00'):'',
                    format: function(val){ return _formatDateOnly(val);}
                  },
                  {
                    value: (installation.Tank.clientSinceDate)?new Date(installation.Tank.clientSinceDate + ' 00:00:00'):'',
                    format: function(val){ return _formatDateOnly(val);}
                  },
                  {
                    value: installation.Tank.nominalVolume.value
                  },
                  {
                    value: installation.Tank.usefulVolume.value
                  },
                  {
                    value: installation.Tank.highThresholdAuto!=null?installation.Tank.highThresholdAuto:installation.Tank.highThreshold.value
                  },
                  {
                    value: installation.Tank.highThreshold.value
                  },
                  {
                    value: installation.Tank.criticalThresholdAuto!=null?installation.Tank.criticalThresholdAuto:installation.Tank.criticalThreshold.value
                  },
                  {
                    value: installation.Tank.criticalThreshold.value
                  },
                  {
                    value: installation.Tank.safetyWindowDays
                  },
                  {
                    value: (installation.Tank.considerSaturdayAuto!=null)?(installation.Tank.considerSaturdayAuto==true?'Yes':'No'):(installation.Tank.considerSaturday==true?'Yes':'No')
                  },
                  {
                    value: (installation.Tank.considerSaturday==true)?'Yes':'No'
                  },
                  {
                    value: installation.Tank.leadTimeForSchedulingPickUpAuto!=null?installation.Tank.leadTimeForSchedulingPickUpAuto:installation.Tank.leadTimeForSchedulingPickUp
                  },
                  {
                    value: installation.Tank.leadTimeForSchedulingPickUp
                  },
                  {
                    value: installation.Tank.expectedSlurryYield.value
                  },
                  {
                    value: installation.Tank.tankLocation
                  },
                  {
                    value: (installation.Tank.frostProtection == true)?'Yes':'No'
                  },
                  {
                    value: installation.Tank.systemVoltage
                  },
                  {
                    value: installation.simCardHandle
                  },
                  {
                    value: installation.id
                  },
                  {
                    value: (installation.Tank.installerContact)?installation.Tank.installerContact.name:''
                  },
                  {
                    value: (installation.Tank.installerContact)?installation.Tank.installerContact.title:''
                  },
                  {
                    value: (installation.Tank.installerContact)?installation.Tank.installerContact.phone1:''
                  },
                  {
                    value: (installation.Tank.installerContact)?installation.Tank.installerContact.phone2:''
                  },
                  {
                    value: (installation.Tank.installerContact)?installation.Tank.installerContact.email:''
                  }
                ];
              } else {
                row.cells = [
                  {
                    value: '',
                    image: _getStatusImageClass(''),
                    classes: 'g2e-icon-text-hide',
                    export_format: function(val){ return _formatExportSystemStatus(val);}
                  },
                  {
                    value: 0,
                    image: _getAlarmImageClass(0),
                    classes: 'g2e-icon-text-hide',
                    export_format: function(val){ return _formatExportAlarm(val);}
                  },
                  {
                    value: ''
                  },
                  {
                    value: 'Unassigned Install'
                  },
                  {
                    value: installation['serialNumber']
                  },
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'},{value: '-'},{value: '-'},
                  {value: '-'},{value: '-'},{value: '-'}
                ];
              }
              rows.push(row);
          });

          vm.customerTableWidget.rows = rows;

        }

        function _init() {
          vm.refreshCustomerTableColumns();
          vm.loadInstallationsStats();
          vm.startAutoRefresh();
        }

        // ******************************
        // Event Listeners
        // ******************************

        //Listener for controller destroy
        $scope.$on('$destroy', function() {
            vm.stopAutoRefresh();
        });

        //Listener when click refresh button
        $scope.$on('refreshDashboard', function(evnet, args) {

          if(!vm.isLoadingInstallations) {
            vm.loadInstallationsStats();
          }

        });

        //Listener when change location filter
        $scope.$watch('search_location', function(newVal, oldVal) {
          _generateMapMarkers();
        }, true);

        //Listener when change company filter
        $scope.$watch('search_company', function(newVal, oldVal) {
          _generateMapMarkers();
        }, true);

        //Listener when change company filter
        $scope.$watch('search_contract_type', function(newVal, oldVal) {
          _generateMapMarkers();
        }, true);

        _init();

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.change-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.change-password', {
            url      : '/change-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.change-password': {
                    templateUrl: 'app/main/change-password/change-password.html',
                    controller : 'ChangePasswordController as vm'
                }
            },
            bodyClass: 'change-password'
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.change-password')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($scope, $state, $mdToast, api, currentUser)
    {
        // ******************************
        // Variables
        // ******************************

        var vm = this;

        vm.isWorking = false;
        vm.msg = '';

        // ******************************
        // Public Methods
        // ******************************

        vm.submit = function() {

          vm.isWorking = true;
          vm.msg = 'Updating...';

          api.profile.update.save(
            {
                password: vm.form.password,
                isWelcome: false
            },
            // Success
            function (response)
            {

                vm.isWorking = false;
                vm.msg = '';
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Your password has been updated successfully!')
                        .position('top right')
                        .hideDelay(3000)
                        .theme('success-toast')
                );

                if(currentUser.isAdminUser()) {
                    $state.go('app.dashboard');
                } else if(currentUser.isSiteUser()) {
                    $state.go('app.dashboard-site.home');
                }
            },
            // Error
            function (response)
            {
                console.log(response);
                var error_msg = '';
                if(response.data && response.data.message) {
                    error_msg = response.data.message;
                } else {
                    error_msg = 'Something went wrong!';
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(error_msg)
                        .position('top right')
                        .hideDelay(3000)
                        .theme('error-toast')
                );

                vm.isWorking = false;
                vm.msg = '';
            }
          );

        };

        vm.checkPasswordConfirm = function() {

          if(vm.form.password && vm.form.passwordConfirm) {
            if(vm.form.password !== vm.form.passwordConfirm) {
              vm.msg = 'Password(Confirm) is not matched!';
            } else {
              vm.msg = '';
            }
          }

        };

        // ******************************
        // Internal methods
        // ******************************

        function _init() {


        }

        _init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', ['ngMaterial'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast, $mdDialog, $state, US_STATES, api, currentUser)
    {

        // ******************************
        // Variables
        // ******************************

        var vm = this;
        vm.States = US_STATES;
        vm.currentUser = currentUser;
        $rootScope.search_location = [];
        $rootScope.search_company = [];
        $rootScope.search_contract_type = [];
        $rootScope.ContractTypes = [
          {text:"PAYG", value:'PAYG'},
          {text:"Distribution", value:'Distribution'},
          {text:"Solid Equip.", value:'Sold Equip.'},
          {text:"All-in", value:'All-in'},
        ];
        $rootScope.search_period = 30;
        $rootScope.search_start_date = null;
        $rootScope.search_end_date = null;
        $rootScope.RollingPeriods = [
            {text:"Rolling 30 Days", value:30},
            {text:"Rolling 60 Days", value:60},
            {text:"Rolling 90 Days", value:90}
        ];
        vm.showSearchByLocation = false;
        vm.showSearchByCompany = false;
        vm.showSearchByContractType = false;


        // ******************************
        // Public Methods
        // ******************************

        /**
         * Open user management dialog
         */
        vm.openUserDlg = function(ev)
        {
          $rootScope.isDashboard = false;

          $mdDialog.show({
              controller: UserDialogController,
              controllerAs: 'vm',
              templateUrl: 'app/main/dashboard/user/user-dialog.tmpl.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              escapeToClose: false,
              fullscreen: true
            })
            .then(function(isDataChanged) {

                if(isDataChanged) {
                    $rootScope.$broadcast('refreshSiteDashboard');
                }

                $rootScope.isDashboard = true;

            }, function() {
                $rootScope.isDashboard = true;
            });
        };

        /**
         * Open company management dialog
         */
        vm.openCompanyDlg = function(ev)
        {

          $rootScope.isDashboard = false;

          $mdDialog.show({
              controller: CompanyDialogController,
              controllerAs: 'vm',
              templateUrl: 'app/main/dashboard/company/company-dialog.tmpl.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              escapeToClose: false,
              fullscreen: true
            })
            .then(function(isDataChanged) {

                if(isDataChanged) {
                    _loadCompaniesData();
                    $rootScope.$broadcast('refreshDashboard');
                    $rootScope.$broadcast('refreshSiteDashboard');
                }

                $rootScope.isDashboard = true;
            }, function() {
                $rootScope.isDashboard = true;
            });
        };

        /**
         * Open site account management dialog
         */
        vm.openSiteAccountDlg = function(ev)
        {
            $rootScope.isDashboard = false;

            $mdDialog.show({
                controller: SiteAccountDialogController,
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/site/site-account-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true
            })
            .then(function(isDataChanged) {

                if(isDataChanged) {
                    $rootScope.$broadcast('refreshSiteDashboard');
                }

                $rootScope.isDashboard = true;
            }, function() {
                $rootScope.isDashboard = true;
            });
        };

        /**
         * Open holiday management dialog
         */
        vm.openHolidayDlg = function(ev)
        {

          $rootScope.isDashboard = false;

          $mdDialog.show({
              controller: HolidayDialogController,
              controllerAs: 'vm',
              templateUrl: 'app/main/dashboard/holiday/holiday-dialog.tmpl.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              escapeToClose: false,
              fullscreen: true
            })
            .then(function(isHolidayChanged) {
              if(isHolidayChanged === true) {
                $rootScope.$broadcast('refreshDashboard');
              }
              $rootScope.isDashboard = true;
            }, function() {
              $rootScope.isDashboard = true;
            });
        };

        /**
         * Open media manager dialog
         */
        vm.openMediaManagerDlg = function(ev)
        {

            $rootScope.isDashboard = false;

            $mdDialog.show({
                controller: MediaManagerDialogController,
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/media-manager/media-manager-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true
            }).then(function(isDataChanged) {

                if(isDataChanged) {
                    $rootScope.$broadcast('refreshSiteDashboard');
                }

                $rootScope.isDashboard = true;
            }, function() {
                $rootScope.isDashboard = true;
            });
        };

        /**
         * Open Profile dialog
         */
        vm.openProfileDlg = function (ev) {

            var userData = angular.copy(vm.currentUser.data);

            $mdDialog.show({
                controller: AddUserDialogController,
                controllerAs: 'vm',
                locals: {
                    mode: 'profile',
                    userData: userData
                },
                templateUrl: 'app/main/dashboard/user/user-dialog-add.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:false,
                escapeToClose: false,
                fullscreen: true,
                skipHide: true
            }).then(function(ret) {
                if(ret) {
                    if(ret.mode === 'profile') {
                        currentUser.set(ret.data);
                    }
                }
            }, function() {

            });
        };

        /**
         * Open Sustainability settings dialog
         */
        vm.openSustainabilityDlg = function(ev)
        {
          $rootScope.isDashboard = false;

          $mdDialog.show({
              controller: SustainabilityDialogController,
              controllerAs: 'vm',
              templateUrl: 'app/main/dashboard/sustainability/sustainability-dialog.tmpl.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:false,
              escapeToClose: false,
              fullscreen: true
            })
            .then(function(answer) {
              $rootScope.isDashboard = true;
            }, function() {
              $rootScope.isDashboard = true;
            });
        };

        /**
         * Logout Function
         */
        vm.logout = function()
        {

          api.signout.get(
            {
              token:currentUser.getLoginToken()
            },
            // Success
            function (response)
            {
            },
            // Error
            function (response)
            {
            }
          );

          currentUser.unset();
          $state.go('app.auth_login');

        };

        /**
         * View as a Site or View as a Administrator
         */
        vm.switchViewMode = function() {
            if($rootScope.viewMode === 'admin') {
                $state.go('app.dashboard-site.analytics');
            } else {
                $state.go('app.dashboard');
            }
        };

        vm.onChangeDateRange = function() {

          if($rootScope.search_start_date && $rootScope.search_end_date) {
            $rootScope.search_period = '';
            vm.filterChangedTimeHorizon = true;
            //vm.filterInstallations();
          }
        };

        vm.onChangeRolling = function() {
          if($rootScope.search_period) {
            $rootScope.search_start_date = null;
            $rootScope.search_end_date = null;
            vm.filterChangedTimeHorizon = true;
            vm.filterInstallations();
          }
        };

        vm.onChangeContractType = function() {

        };

        vm.onChangeCompany = function() {

        };

        vm.onChangeLocation = function() {

        };

        vm.filterInstallations = function() {
          vm.filterChangedTimeHorizon = false;
          /*vm.filterChangedCompany = false;
          vm.filterChangedLocation = false;*/
          $rootScope.$broadcast('refreshDashboard');
        };

        /**
         * Search for states
         */
        vm.queryLocation = function(query) {

          var results = query ? vm.States.filter( _createFilterFor(query) ) : [];
          return results;
        };

        /**
         * Search for companies
         */
        vm.queryCompany = function(query) {

          var results = query ? vm.companies.filter( _createFilterFor(query) ) : [];
          return results;
        };

        vm.transformChip = function(chip) {
          // If it is an object, it's already a known chip
          if (angular.isObject(chip)) {
            return chip;
          }
          // Otherwise, create a new one
          return { name: chip, type: 'new' }
        };


        // ******************************
        // Internal methods
        // ******************************

        /**
         * Initialize
         */
        function _init()
        {
          _loadCompaniesData();
        }

        /**
         * Create filter function for a query string
         */
        function _createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);
          return function filterFn(location) {
            return (location.name.toLowerCase().indexOf(lowercaseQuery) === 0);
          };
        }

        /**
         * Load companies data
         */
        function _loadCompaniesData() {

          vm.isLoading = true;

          api.companies.list.get(
            null,
            // Success
            function (response)
            {
              //console.log(response);
              vm.isLoading = false;
              vm.companies = _.filter(response.rows, function(company) {
                return company.isActive == true;
              });
            },
            // Error
            function (response)
            {
              console.log(response);
              vm.isLoading = false;
            }
          );
        }

        _init();

    }

})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('g2e', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Apps
            'app.sample',
            'app.dashboard',
            'app.dashboard-site',
            'app.change-password',
            'app.terms-conditions',
            'app.unsupported-browser',
            'app.auth',

            //Third
            'angular-jwt',
            'ngCsv',
            'md.data.table',
            'fixed.table.header',
            'ui.calendar',
            'bsLoadingOverlay',
            'bsLoadingOverlaySpinJs',
            'mdPickers',
            'ngFileUpload',
            'uiCropper',
            'isteven-multi-select',
            'ui.mask',
            'ng.deviceDetector'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('US_STATES', usStatesService);

    /** @ngInject */
    function usStatesService()
    {
      var StatesAbbrev = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY').split(' ');
      var StatesName = ('Alabama,Alaska,Arizona,Arkansas,California,Colorado,Connecticut,Delaware,Florida,Georgia,'+
        'Hawaii,Idaho,Illinois,Indiana,Iowa,Kansas,Kentucky,Louisiana,Maine,Maryland,'+
        'Massachusetts,Michigan,Minnesota,Mississippi,Missouri,Montana,Nebraska,Nevada,New Hampshire,New Jersey,'+
        'New Mexico,New York,North Carolina,North Dakota,Ohio,Oklahoma,Oregon,Pennsylvania,Rhode Island,South Carolina,'+
        'South Dakota,Tennessee,Texas,Utah,Vermont,Virginia,Washington,West Virginia,Wisconsin,Wyoming').split(',');

      return StatesAbbrev.map(function (abbrev, index) { return { abbrev: abbrev, name: StatesName[index]}; });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('Timezones', timezonesService);

    /** @ngInject */
    function timezonesService()
    {
        var service = {};

        // get timezones list
        service.getTimezones = function() {
            var timezones = moment.tz.names();
            var fullNames = [];
            _.each(timezones, function(tz) {
                fullNames.push({
                    timezone: tz,
                    timezoneFull: moment().tz(tz).format('(zZ) ') + tz
                });
            });
            return fullNames;
        };

        // get US Timezones
        service.getTimezonesUS = function() {
            var timezones = [
                'America/New_York',
                'America/Chicago',
                'America/Denver',
                'America/Phoenix',
                'America/Los_Angeles',
                'America/Anchorage',
                'America/Adak',
                'Pacific/Honolulu'
            ];
            var fullNames = [];
            _.each(timezones, function(tz) {
                fullNames.push({
                    timezone: tz,
                    timezoneFull: moment().tz(tz).format('z (UTCZ) ') + tz
                });
            });
            return fullNames;
        };

        return service;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('parseVideoUrl', parseVideoUrlService);

    /** @ngInject */
    function parseVideoUrlService(G2E_CONST_API)
    {
        var service = {};

        service.parse = function(url) {
            // - Supported YouTube URL formats:
            //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
            //   - http://youtu.be/My2FRPA3Gf8
            //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
            // - Supported Vimeo URL formats:
            //   - http://vimeo.com/25451551
            //   - http://player.vimeo.com/video/25451551
            // - Also supports relative URLs:
            //   - //player.vimeo.com/video/25451551

            url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

            if (RegExp.$3.indexOf('youtu') > -1) {
                var type = 'youtube';
            } else if (RegExp.$3.indexOf('vimeo') > -1) {
                var type = 'vimeo';
            }

            return {
                type: type,
                id: RegExp.$6
            };
        };

        service.getThumbnailUrl = function(videoObj, cb) {

            if (videoObj.type == 'youtube') {
                cb('http://img.youtube.com/vi/' + videoObj.id + '/maxresdefault.jpg');
            } else if (videoObj.type == 'vimeo') {
                // Requires jQuery
                $.get('http://vimeo.com/api/v2/video/' + videoObj.id + '.json', function(data) {
                    cb(data[0].thumbnail_large);
                });
            }
        };

        service.getEmbeddedUrl = function(videoObj) {

            if (videoObj.type == 'youtube') {
                return 'http://www.youtube.com/embed/' + videoObj.id;
            } else if (videoObj.type == 'vimeo') {
                return 'http://player.vimeo.com/video/' + videoObj.id;
            }
        };

        return service;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('m2x', m2xService);

    /** @ngInject */
    function m2xService($resource, G2E_CONST_API)
    {
        var api = {};

        //Data Streams Values
        api.streamValues = $resource(G2E_CONST_API.M2X_BASE_URL + '/devices/serial/:serial/streams/:stream/values', {serial: '@serial', name:'@stream'}, {
          get: {headers:{'X-M2X-KEY':G2E_CONST_API.M2X_KEY}}
        });

        //Data Stream Sampling
        api.streamSampling = $resource(G2E_CONST_API.M2X_BASE_URL + '/devices/serial/:serial/streams/:stream/sampling', {serial: '@serial', name:'@stream'}, {
          get: {headers:{'X-M2X-KEY':G2E_CONST_API.M2X_KEY}}
        });

        return api;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('gmapapi', gmapapiService);

    /** @ngInject */
    function gmapapiService($resource, G2E_CONST_API)
    {
        var api = {};

        //Data Streams Values
        api.getTimezone = $resource(G2E_CONST_API.GOOGLE_MAP_API_BASE_URL + '/timezone/json', {location: '@location', timestamp: '@timestamp', key: G2E_CONST_API.GOOGLE_MAP_API_KEY});

        return api;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('formatUtils', formatUtilsService);

    /** @ngInject */
    function formatUtilsService()
    {

        var monthsShort = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var monthsLong = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var service = {};

        service.convertDays = function(val, units) {
            if(val != null && val != '') {
                units = units.toLowerCase();
                if(units == 'years' || units == 'year') {
                    return 365*val;
                } else if(units == 'months' || units == 'month') {
                    return 31*val;
                } else if(units == 'weeks' || units == 'week') {
                    return 7*val;
                } else if(units == 'days' || units == 'day') {
                    return 1*val;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        };

        service.formatDateOnly = function(dt) {
            if(dt !== null && dt !== '') {
                return moment(dt).format('MM/DD/YYYY');
            } else {
                return '';
            }
        };

        service.formatCurrency = function(val) {
            if(val !== null && val !== '') {
                return numeral(val).format('$0,0');
            } else {
                return '';
            }
        };

        service.formatYearMonth = function(year, month) {
            var mm = month + 1;
            if(mm < 10) {
                return year + '-0' + mm;
            } else {
                return year + '-' + mm;
            }
        };

        service.formatYearMonthLong = function(year, month) {
            return monthsLong[month] + ' ' + year;
        };

        return service;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('currentUser', currentUserService);

    /** @ngInject */
    function currentUserService($cookies)
    {
        var cu = {
          data: $cookies.getObject('currentUser')
        };

        cu.set = function(data) {


          // Listserv Availability
          data.ListservAvailability = {
              SYSTEM_FAULT: true,
              PICK_UP: true,
              TANK_LEVEL: true
          };

          var isSiteUser = _.findIndex(data.Roles, {name: 'SITE_EDIT'}) !== -1;

          if(isSiteUser && data.Sites.length > 0) {

              var systemFaultAvailability = cu.getMetricItem(data.Sites[0].metrics, 'Listserv Availability.SYSTEM_FAULT');
              var pickupAvailability = cu.getMetricItem(data.Sites[0].metrics, 'Listserv Availability.PICK_UP');
              var tankLevelAvailability = cu.getMetricItem(data.Sites[0].metrics, 'Listserv Availability.TANK_LEVEL');

              data.ListservAvailability = {
                  SYSTEM_FAULT: systemFaultAvailability?systemFaultAvailability.value:false,
                  PICK_UP: pickupAvailability?pickupAvailability.value:false,
                  TANK_LEVEL: tankLevelAvailability?tankLevelAvailability.value:false
              };
          }

          // Remove site metrics data, since it's over to store in cookie
          _.each(data.Sites, function(site) {
              delete site.metrics;
          });

          cu.data = data;
          $cookies.putObject('currentUser',cu.data);
        };

        cu.unset = function() {
          delete cu.data;
          $cookies.remove('currentUser');
        };

        cu.isExist = function(){
          if(cu.data){
            return true;
          } else {
            return false;
          }
        };

        cu.getLoginToken = function() {

          if(cu.data) {
            return cu.data.loginToken;
          } else {
            return '';
          }

        };

        cu.getFullname = function() {
          if(cu.data) {
            return cu.data.firstName + ' ' + cu.data.lastName;
          } else {
            return '';
          }
        };

        cu.getUsername = function() {
          if(cu.data) {
            return cu.data.username;
          } else {
            return '';
          }
        };

        cu.hasAdminRole = function() {

          if(cu.data) {

            if(_.findIndex(cu.data.Roles, {name: 'ADMIN_EDIT'}) != -1) {
              return true;
            }
          }
          return false;
        };

        cu.hasViewerRole = function() {

          if(cu.data) {
            if(_.findIndex(cu.data.Roles, {name: 'ADMIN_VIEW'}) != -1) {
              return true;
            }
          }
          return false;

        };

        cu.hasSiteEditRole = function() {

            if(cu.data) {
                if(_.findIndex(cu.data.Roles, {name: 'SITE_EDIT'}) != -1) {
                    return true;
                }
            }
            return false;

        };

        cu.isAdminUser = function() {
            return cu.hasAdminRole() || cu.hasViewerRole();
        };

        cu.isSiteUser = function() {

            if(cu.data) {
                if(_.findIndex(cu.data.Roles, {name: 'SITE_EDIT'}) != -1) {
                    return true;
                }
            }
            return false;

        };

        cu.updateListservAvailability = function(metrics) {

            var data = cu.data;

            var isSiteUser = _.findIndex(data.Roles, {name: 'SITE_EDIT'}) !== -1;

            if(isSiteUser && metrics) {

                var systemFaultAvailability = cu.getMetricItem(metrics, 'Listserv Availability.SYSTEM_FAULT');
                var pickupAvailability = cu.getMetricItem(metrics, 'Listserv Availability.PICK_UP');
                var tankLevelAvailability = cu.getMetricItem(metrics, 'Listserv Availability.TANK_LEVEL');

                data.ListservAvailability = {
                    SYSTEM_FAULT: systemFaultAvailability?systemFaultAvailability.value:false,
                    PICK_UP: pickupAvailability?pickupAvailability.value:false,
                    TANK_LEVEL: tankLevelAvailability?tankLevelAvailability.value:false
                };

                $cookies.putObject('currentUser',data);
            }
        };

        cu.getMetricItem = function(metrics, key) {
            var itemNames = key.split('.');
            var result = null;
            var childItems = metrics;
            for(var i=0;i<itemNames.length;i++) {
                var obj = _.find(childItems, {name: itemNames[i]});
                if(obj) {
                    childItems = obj.items;
                    result = obj;
                } else {
                    break;
                }
            }
            return result;
        };

        return cu;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('g2e')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data
        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {

            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('trustAsHTML', trustAsHTMLFilter);

    /** @ngInject */
    function trustAsHTMLFilter($sce)
    {
        return function (text)
        {
            return $sce.trustAsHtml(text);
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('timeFormat', timeFormatFilter);

    /** @ngInject */
    function timeFormatFilter($filter)
    {
        return function (t, format)
        {
            var dt = new Date(moment().format('YYYY-MM-DD ') + t);
            return $filter('date')(dt, format);
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('sustainabilityFormula', sustainabilityFormulaFilter);

    /** @ngInject */

    /**
     * calculate value with putting values into give formula, like <<A>>*<<C>>/12
     */
    function sustainabilityFormulaFilter()
    {
        return function (formula, key, settings) {

          _.each(settings, function(s){
            if (s.keyType != 'text') {
              var key = s.key;
              var value = s.conversionFactor || 0;

              value = evaluateValue(value);

              if (s.keyType == 'formula') {
                value = getValueFromFormula(s.conversionFormula, settings);
                s.formulaValue = value;
              }

              formula = formula.replace(key, value);
            }
          });
          return eval(formula).toFixed(3);
        };

        // if some formula key is depending on other value, then calculate that value first
        function getValueFromFormula(formula, settings) {

          _.each(settings, function(s){
            if (s.keyType != 'text') {
              var key = s.key;
              var value = s.formulaValue || s.conversionFactor || 0;

              value = evaluateValue(value);

              formula = formula.replace(key, value);
            }
          });

          // console.log('formula: ', formula)
          return eval(formula);
        }

        // if value is string, and have % symbol in it
        // Only supporting % for now
        function evaluateValue(val) {
          if (val.indexOf && val.indexOf('%') >= 0) { // only support %
            val = parseFloat(val)/100;
          }
          return val;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('sortByWithEmpty', sortByWithEmptyFilter);

    /** @ngInject */
    function sortByWithEmptyFilter($filter)
    {
        return function (rows, key)
        {
          if(key) {

              var ascending;
              if(key.substring(0, 1) == '-') {
                 ascending = false;
                 key = key.substring(1);
              } else {
                 ascending = true;
              }

              var present = _.filter(rows, function (row) {
                  return getDescendantProp(row,key);
              });
              var empty = _.filter(rows, function (row) {
                  return !getDescendantProp(row,key);
              });

              var sorted = $filter('orderBy')(present, key);

              if(ascending) {
                  return sorted.concat(empty);
              } else {
                  return empty.concat(sorted.reverse());
              }

          } else {
            return rows;
          }
        };

        function getDescendantProp(obj, desc) {
            var arr = desc.split(".");
            while(arr.length && (obj = obj[arr.shift()]));
            return obj;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('shiftDays', shiftDaysFilter);

    /** @ngInject */
    function shiftDaysFilter()
    {
        return function (obj)
        {
            var result = [];
            if(obj.Sunday && obj.Monday && obj.Tuesday && obj.Wednesday && obj.Thursday && obj.Friday && obj.Saturday) {
                return 'Everyday';
            } else {
                if(obj.Sunday) result.push('Sun');
                if(obj.Monday) result.push('Mon');
                if(obj.Tuesday) result.push('Tues');
                if(obj.Wednesday) result.push('Wed');
                if(obj.Thursday) result.push('Thur');
                if(obj.Friday) result.push('Fri');
                if(obj.Saturday) result.push('Sat');
                return result.join(', ');
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('pluckJoin', pluckJoinFilter);

    /** @ngInject */
    function pluckJoinFilter()
    {
        return function (obj_arr, order_field, pluck_field)
        {
            return _.pluck(_.sortBy(obj_arr, order_field), pluck_field).join(',');
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('monthShort', monthShortFilter);

    /** @ngInject */
    function monthShortFilter()
    {
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        return function (month)
        {
            return months[month];
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('sortBy', sortByFilter);

    /** @ngInject */
    function sortByFilter()
    {
        return function (rows, index)
        {
          if(index) {
            var ascending;
            if(index.substring(0, 1) == '-') {
              ascending = false;
              index *= -1;
            } else {
              ascending = true;
            }

            var activeRows = [];
            var unassignedRows = [];

            if(index == 4) {
              activeRows = rows;
            } else {
              _.each(rows, function(row) {
                if(row.data.isActive) {
                  activeRows.push(row);
                } else {
                  unassignedRows.push(row);
                }
              });
            }

            var sorted = _.sortBy(activeRows, function(row) {
              return row.cells[index].value;
            });

            if(ascending) {
              return sorted.concat(unassignedRows);
            } else {
              return sorted.reverse().concat(unassignedRows);
            }

          } else {
            return rows;
          }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('filterBy', filterByFilter);

    /** @ngInject */
    function filterByFilter()
    {
        return function (rows, search_location, search_company, search_contract_type, status_by)
        {
          //status_by 0: ALL, 1: Running, 2: System Faults, 3: Hauling Status
          if(search_location.length > 0 || search_company.length > 0 || search_contract_type.length > 0 || status_by != 0) {

            var results = rows;

            //filter active devices
            results = _.reject(results, function(row) { return !row.data.isActive });

            //filter by location
            if(search_location.length > 0) {
              results = _.reject(results, function(row) {
                var obj = _.findWhere(search_location, {name: row.data.Customer.state});
                return !obj;
              });
            }

            //filter by company
            if(search_company.length > 0) {
              results = _.reject(results, function(row) {
                var obj = _.findWhere(search_company, {id: row.data.CompanyId});
                return !obj;
              });
            }

            //filter by contract type
            if(search_contract_type.length > 0) {
              results = _.reject(results, function(row) {
                var obj = _.findWhere(search_contract_type, {value: row.data.Customer.contractType});
                return !obj;
              });
            }

            //filter by map
            if(status_by == 1) { //Running
              results = _.reject(results, function(row) { return row.data.Stats['Status'] != 0 });
            } else if(status_by == 2) { //System Faults
              results = _.reject(results, function(row) { return row.data.Stats['Alarm'] == 0 });
            } else if(status_by == 3) { //Hauling Status
              results = _.reject(results, function(row) { return row.data.Stats['Truck'] < 2 });
            }

            return results;

          } else {
            return rows;
          }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('fileExt', fileExtFilter);

    /** @ngInject */
    function fileExtFilter()
    {
        return function (file_name, upper)
        {
            var ext = '';
            if(file_name) {
                var tokens = file_name.split('.');
                if(tokens.length > 0) {
                    ext = tokens[tokens.length-1];
                    if(upper) {
                        ext = ext.toUpperCase();
                    }
                }
            }
            return ext;
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .filter('benchBy', benchByFilter);

    /** @ngInject */
    function benchByFilter()
    {
        /**
         * filter schema
         *  queries
         *  field
         */
        return function (rows, filters)
        {

            if(rows.length === 0) return [];
            if(filters.length === 0) return rows;

            var results = rows;

            _.each(filters, function(filter) {
                if(filter.queries.length > 0) {
                    results = _.reject(results, function(row) {
                        var val = getDescendantProp(row, filter.field);
                        var obj = _.find(filter.queries, function(query) {
                            return query === val;
                        });
                        return !obj;
                    });
                }
            });

            return results;
        };

        function getDescendantProp(obj, desc) {
            var arr = desc.split(".");
            while(arr.length && (obj = obj[arr.shift()]));
            return obj;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .directive('textareaLimit', textareaLimitDirective);

    /** @ngInject */
    function textareaLimitDirective() {
      return function (scope, element, attrs) {
          var maxRows = attrs.rows;
          var maxChars = attrs.cols;
          element.bind("keypress", function (event) {
            var text = element.val();
            const lines = text.split('\n');
            if (event.keyCode === 13){
                return lines.length < maxRows;
            }
            else{ //Should check for backspace/del/etc.
                const caret = element.get(0).selectionStart;

                var line = 0;
                var charCount = 0;
                $.each(lines, function(i,e){
                    charCount += e.length;
                    if (caret <= charCount){
                        line = i;
                        return false;
                    }
                    //\n count for 1 char;
                    charCount += 1;
                });

                const theLine = lines[line];
                return theLine.length < maxChars;
            }
          });
      };
  }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .directive('tankGauge', tankGaugeDirective);

    /** @ngInject */
    function tankGaugeDirective($timeout)
    {
        return {
            restrict: 'A',
            scope: {
                level: '=level',
                id: '@id'
            },
            controller: function($scope) {
                $scope.$watch("level", function (newValue) {
                    if(newValue && $scope.chart) {
                        $scope.chart.update(newValue);
                    }
                }, true);
            },
            link: function($scope, element, attrs) {
                $scope.$watch("id", function (newValue) {
                    if(newValue) {

                        var level;
                        if($scope.level) level = $scope.level;
                        else level = 0;

                        $scope.chart = loadLiquidFillGauge($scope.id, level);
                    }
                }, true);
            }
        };
    }

    function liquidFillGaugeDefaultSettings(){
        return {
            minValue: 0, // The gauge minimum value.
            maxValue: 100, // The gauge maximum value.
            circleThickness: 0.1, // The outer circle thickness as a percentage of it's radius.
            circleFillGap: 0.05, // The size of the gap between the outer circle and wave circle as a percentage of the outer circles radius.
            circleColor: "#178BCA", // The color of the outer circle.
            waveHeight: 0.05, // The wave height as a percentage of the radius of the wave circle.
            waveCount: 1, // The number of full waves per width of the wave circle.
            waveRiseTime: 1000, // The amount of time in milliseconds for the wave to rise from 0 to it's final height.
            waveAnimateTime: 3000, // The amount of time in milliseconds for a full wave to enter the wave circle.
            waveRise: true, // Control if the wave should rise from 0 to it's full height, or start at it's full height.
            waveHeightScaling: true, // Controls wave size scaling at low and high fill percentages. When true, wave height reaches it's maximum at 50% fill, and minimum at 0% and 100% fill. This helps to prevent the wave from making the wave circle from appear totally full or empty when near it's minimum or maximum fill.
            waveAnimate: true, // Controls if the wave scrolls or is static.
            waveColor: "#178BCA", // The color of the fill wave.
            waveOffset: 0, // The amount to initially offset the wave. 0 = no offset. 1 = offset of one full wave.
            textVertPosition: .5, // The height at which to display the percentage text withing the wave circle. 0 = bottom, 1 = top.
            textSize: 1, // The relative height of the text to display in the wave circle. 1 = 50%
            valueCountUp: true, // If true, the displayed value counts up from 0 to it's final value upon loading. If false, the final value is displayed.
            displayPercent: true, // If true, a % symbol is displayed after the value.
            textColor: "#045681", // The color of the value text when the wave does not overlap it.
            waveTextColor: "#A4DBf8" // The color of the value text when the wave overlaps it.
        };
    }

    function loadLiquidFillGauge(elementId, value, config) {
        if(config == null) config = liquidFillGaugeDefaultSettings();

        var gauge = d3.select("#" + elementId);
        var radius = Math.min(parseInt(gauge.style("width")), parseInt(gauge.style("height")))/2;
        var locationX = parseInt(gauge.style("width"))/2 - radius;
        var locationY = parseInt(gauge.style("height"))/2 - radius;
        var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value))/config.maxValue;

        var waveHeightScale;
        if(config.waveHeightScaling){
            waveHeightScale = d3.scale.linear()
                .range([0,config.waveHeight,0])
                .domain([0,50,100]);
        } else {
            waveHeightScale = d3.scale.linear()
                .range([config.waveHeight,config.waveHeight])
                .domain([0,100]);
        }

        /*var textPixels = (config.textSize*radius/2);
        var textFinalValue = parseFloat(value).toFixed(2);
        var textStartValue = config.valueCountUp?config.minValue:textFinalValue;
        var percentText = config.displayPercent?"%":"";*/
        var circleThickness = config.circleThickness * radius;
        var circleFillGap = config.circleFillGap * radius;
        var fillCircleMargin = circleThickness + circleFillGap;
        var fillCircleRadius = radius - fillCircleMargin;
        var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);

        var waveLength = fillCircleRadius*2/config.waveCount;
        var waveClipCount = 1+config.waveCount;
        var waveClipWidth = waveLength*waveClipCount;

        // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
        /*var textRounder = function(value){ return Math.round(value); };
        if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
            textRounder = function(value){ return parseFloat(value).toFixed(1); };
        }
        if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
            textRounder = function(value){ return parseFloat(value).toFixed(2); };
        }*/

        // Data for building the clip wave area.
        var data = [];
        for(var i = 0; i <= 40*waveClipCount; i++){
            data.push({x: i/(40*waveClipCount), y: (i/(40))});
        }

        // Scales for drawing the outer circle.
        var gaugeCircleX = d3.scale.linear().range([0,2*Math.PI]).domain([0,1]);
        var gaugeCircleY = d3.scale.linear().range([0,radius]).domain([0,radius]);

        // Scales for controlling the size of the clipping path.
        var waveScaleX = d3.scale.linear().range([0,waveClipWidth]).domain([0,1]);
        var waveScaleY = d3.scale.linear().range([0,waveHeight]).domain([0,1]);

        // Scales for controlling the position of the clipping path.
        var waveRiseScale = d3.scale.linear()
        // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
        // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
        // circle at 100%.
            .range([(fillCircleMargin+fillCircleRadius*2+waveHeight),(fillCircleMargin-waveHeight)])
            .domain([0,1]);
        var waveAnimateScale = d3.scale.linear()
            .range([0, waveClipWidth-fillCircleRadius*2]) // Push the clip area one full wave then snap back.
            .domain([0,1]);

        /*// Scale for controlling the position of the text within the gauge.
        var textRiseScaleY = d3.scale.linear()
            .range([fillCircleMargin+fillCircleRadius*2,(fillCircleMargin+textPixels*0.7)])
            .domain([0,1]);*/

        // Center the gauge within the parent SVG.
        var gaugeGroup = gauge.append("g")
            .attr('transform','translate('+locationX+','+locationY+')');

        // Draw the outer circle.
        var gaugeCircleArc = d3.svg.arc()
            .startAngle(gaugeCircleX(0))
            .endAngle(gaugeCircleX(1))
            .outerRadius(gaugeCircleY(radius))
            .innerRadius(gaugeCircleY(radius-circleThickness));
        gaugeGroup.append("path")
            .attr("d", gaugeCircleArc)
            .style("fill", config.circleColor)
            .attr('transform','translate('+radius+','+radius+')');

        /*// Text where the wave does not overlap.
        var text1 = gaugeGroup.append("text")
            .text(textRounder(textStartValue) + percentText)
            .attr("class", "liquidFillGaugeText")
            .attr("text-anchor", "middle")
            .attr("font-size", textPixels + "px")
            .style("fill", config.textColor)
            .attr('transform','translate('+radius+','+textRiseScaleY(config.textVertPosition)+')');*/

        // The clipping wave area.
        var clipArea = d3.svg.area()
            .x(function(d) { return waveScaleX(d.x); } )
            .y0(function(d) { return waveScaleY(Math.sin(Math.PI*2*config.waveOffset*-1 + Math.PI*2*(1-config.waveCount) + d.y*2*Math.PI));} )
            .y1(function(d) { return (fillCircleRadius*2 + waveHeight); } );
        var waveGroup = gaugeGroup.append("defs")
            .append("clipPath")
            .attr("id", "clipWave" + elementId);
        var wave = waveGroup.append("path")
            .datum(data)
            .attr("d", clipArea)
            .attr("T", 0);

        // The inner circle with the clipping wave attached.
        var fillCircleGroup = gaugeGroup.append("g")
            .attr("clip-path", "url("+ window.location.href +"#clipWave" + elementId + ")"); // give full path since safari is not working in angular app
        fillCircleGroup.append("circle")
            .attr("cx", radius)
            .attr("cy", radius)
            .attr("r", fillCircleRadius)
            .style("fill", config.waveColor);

        /*// Text where the wave does overlap.
        var text2 = fillCircleGroup.append("text")
            .text(textRounder(textStartValue) + percentText)
            .attr("class", "liquidFillGaugeText")
            .attr("text-anchor", "middle")
            .attr("font-size", textPixels + "px")
            .style("fill", config.waveTextColor)
            .attr('transform','translate('+radius+','+textRiseScaleY(config.textVertPosition)+')');

        // Make the value count up.
        if(config.valueCountUp){
            var textTween = function(){
                var i = d3.interpolate(this.textContent, textFinalValue);
                return function(t) { this.textContent = textRounder(i(t)) + percentText; }
            };
            text1.transition()
                .duration(config.waveRiseTime)
                .tween("text", textTween);
            text2.transition()
                .duration(config.waveRiseTime)
                .tween("text", textTween);
        }*/

        // Make the wave rise. wave and waveGroup are separate so that horizontal and vertical movement can be controlled independently.
        var waveGroupXPosition = fillCircleMargin+fillCircleRadius*2-waveClipWidth;
        if(config.waveRise){
            waveGroup.attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(0)+')')
                .transition()
                .duration(config.waveRiseTime)
                .attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(fillPercent)+')')
                .each("start", function(){ wave.attr('transform','translate(1,0)'); }); // This transform is necessary to get the clip wave positioned correctly when waveRise=true and waveAnimate=false. The wave will not position correctly without this, but it's not clear why this is actually necessary.
        } else {
            waveGroup.attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(fillPercent)+')');
        }

        // Ticks
        gaugeGroup.append("line")
            .style("stroke-dasharray", "4,4")
            .attr("x1", 0)
            .attr("y1", radius)
            .attr("x2", 2 * radius)
            .attr("y2", radius)
            .attr("stroke", config.waveColor)
            .attr("stroke-width", 1);

        var x1 = radius - Math.cos(Math.PI/6)*radius;
        var y1 = radius - Math.sin(Math.PI/6)*radius;
        var x2 = radius + Math.cos(Math.PI/6)*radius;
        var y2 = y1;
        gaugeGroup.append("line")
            .style("stroke-dasharray", "4,4")
            .attr("x1", x1)
            .attr("y1", y1)
            .attr("x2", x2)
            .attr("y2", y2)
            .attr("stroke", config.waveColor)
            .attr("stroke-width", 1);

        y1 = radius + Math.sin(Math.PI/6)*radius;
        y2 = y1;
        gaugeGroup.append("line")
            .style("stroke-dasharray", "4,4")
            .attr("x1", x1)
            .attr("y1", y1)
            .attr("x2", x2)
            .attr("y2", y2)
            .attr("stroke", config.waveColor)
            .attr("stroke-width", 1);

        if(config.waveAnimate) animateWave();

        function animateWave() {
            wave.attr('transform','translate('+waveAnimateScale(wave.attr('T'))+',0)');
            wave.transition()
                .duration(config.waveAnimateTime * (1-wave.attr('T')))
                .ease('linear')
                .attr('transform','translate('+waveAnimateScale(1)+',0)')
                .attr('T', 1)
                .each('end', function(){
                    wave.attr('T', 0);
                    animateWave(config.waveAnimateTime);
                });
        }

        function GaugeUpdater(){
            this.update = function(value){
                var newFinalValue = parseFloat(value).toFixed(2);
                /*var textRounderUpdater = function(value){ return Math.round(value); };
                if(parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))){
                    textRounderUpdater = function(value){ return parseFloat(value).toFixed(1); };
                }
                if(parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))){
                    textRounderUpdater = function(value){ return parseFloat(value).toFixed(2); };
                }

                var textTween = function(){
                    var i = d3.interpolate(this.textContent, parseFloat(value).toFixed(2));
                    return function(t) { this.textContent = textRounderUpdater(i(t)) + percentText; }
                };

                text1.transition()
                    .duration(config.waveRiseTime)
                    .tween("text", textTween);
                text2.transition()
                    .duration(config.waveRiseTime)
                    .tween("text", textTween);*/

                var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value))/config.maxValue;
                var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);
                var waveRiseScale = d3.scale.linear()
                // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
                // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
                // circle at 100%.
                    .range([(fillCircleMargin+fillCircleRadius*2+waveHeight),(fillCircleMargin-waveHeight)])
                    .domain([0,1]);
                var newHeight = waveRiseScale(fillPercent);
                var waveScaleX = d3.scale.linear().range([0,waveClipWidth]).domain([0,1]);
                var waveScaleY = d3.scale.linear().range([0,waveHeight]).domain([0,1]);
                var newClipArea;
                if(config.waveHeightScaling){
                    newClipArea = d3.svg.area()
                        .x(function(d) { return waveScaleX(d.x); } )
                        .y0(function(d) { return waveScaleY(Math.sin(Math.PI*2*config.waveOffset*-1 + Math.PI*2*(1-config.waveCount) + d.y*2*Math.PI));} )
                        .y1(function(d) { return (fillCircleRadius*2 + waveHeight); } );
                } else {
                    newClipArea = clipArea;
                }

                var newWavePosition = config.waveAnimate?waveAnimateScale(1):0;
                wave.transition()
                    .duration(0)
                    .transition()
                    .duration(config.waveAnimate?(config.waveAnimateTime * (1-wave.attr('T'))):(config.waveRiseTime))
                    .ease('linear')
                    .attr('d', newClipArea)
                    .attr('transform','translate('+newWavePosition+',0)')
                    .attr('T','1')
                    .each("end", function(){
                        if(config.waveAnimate){
                            wave.attr('transform','translate('+waveAnimateScale(0)+',0)');
                            animateWave(config.waveAnimateTime);
                        }
                    });
                waveGroup.transition()
                    .duration(config.waveRiseTime)
                    .attr('transform','translate('+waveGroupXPosition+','+newHeight+')')
            }
        }

        return new GaugeUpdater();
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .directive('metricTable', metricTableDirective);

    /** @ngInject */
    function metricTableDirective($compile)
    {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                result: '=result',
                readonly: '@readonly'
            },
            terminal: true,
            priority: 1000,
            controller: function($scope) {

                $scope.onItemChanged = function(parent, item) {

                    // Update children
                    if(item.items) {

                        if(!item.value) {
                            _.each(item.items, function(one) {
                                if(!one.always) {
                                    one.value = false;
                                }
                            });
                        }
                    }

                    // Update parent
                    if(!parent.always) {
                        if(item.value === true) {
                            parent.value = true;
                        } else {
                            /*var uncheckedAll = true;
                            _.each(parent.items, function(one) {
                                if(one.value === true) {
                                    uncheckedAll = false;
                                }
                            });
                            parent.value = !uncheckedAll;*/
                        }
                    }
                };
            },
            link: function($scope, $element, $attrs, $ctrl) {

                $scope.$watch('data', function() {
                    $scope.result = { items: angular.copy($scope.data) };

                    $scope.html = '';
                    $scope.html += '<table class="simple" ms-responsive-table>';
                    generateElements($scope, $scope.result, 'result', 0);
                    $scope.html += '</table>';
                    var content = $compile($scope.html)($scope);
                    $element.empty();
                    $element.append(content);
                }, true);
            }
        };

        function generateElements($scope, parent, model, step) {
            _.each(parent.items, function(item, $index) {

                var style_font_weight = '';
                var style_background = '';
                var style_border_bottom = '';
                var class_always = '';
                var ng_checked = '';
                var style_padding_left = 'padding-left:' + step * 24 + 'px;';

                if(step == 0) {
                    style_font_weight = 'font-weight: 700;';
                    style_background = 'background-color: #eeeeee;';
                    style_border_bottom = 'border-bottom: none;';
                }

                if(item.always == 1) {
                    class_always = 'always';
                    ng_checked = 'ng-checked="1"';
                    item.value = true;
                }

                var mm = model + '.items[' + $index + ']';
                var ng_model = 'ng-model="' + mm + '.value"';

                if($scope.readonly) {
                    if(item.value) {
                        $scope.html += '<tr style="height:36px;'+style_background+'"><td style="'+style_border_bottom+'"><div style="'+style_padding_left+'"><span style="'+style_font_weight+'">' + item.label + '</span></div></td></tr>';
                    }
                } else {
                    $scope.html += '<tr style="height:36px;"><td><div style="'+style_padding_left+'"><md-checkbox class="' + class_always + '" aria-label="Enable Metric" style="margin-bottom: 0px;" '+ ng_checked +' '+ ng_model +' ng-change="onItemChanged('+ model +', '+ mm +')"><span style="'+style_font_weight+'">' + item.label + '</span></md-checkbox></div></td></tr>';
                }

                if(item.items) {
                    generateElements($scope, item, mm, step+1);
                }
            });
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .directive('mediaButton', mediaButtonDirective);

    /** @ngInject */
    function mediaButtonDirective(parseVideoUrl)
    {
        return {
            restrict: 'E',
            scope: {
                media: '=media',
                type: '@type'
            },
            controller: function($scope) {

                $scope.iconType = 0;

                var videoFormats = ['3g2','3gp','asf','avi','flv','m4v','mov','mp4','mpg','rm','srt','swf','vob','wmv'];
                var textFormats = ['doc','docx','pages','rtf','txt','wpd','wps','pdf','ppt','pptx','pps','xml','xlr','xls','xlsx','odt'];

                var ext = '';

                /*var tokens = $scope.fileName.split('.');
                if(tokens.length > 0) {
                    ext = tokens[tokens.length-1];
                    ext = ext.toLowerCase();
                }*/

                if($scope.media.fileType) {
                    ext = $scope.media.fileType.toLowerCase();
                    if(_.indexOf(videoFormats, ext) !== -1) {
                        $scope.iconType = 1;
                    } else if(_.indexOf(textFormats, ext) !== -1) {
                        $scope.iconType = 2;
                    }
                } else if($scope.media.videoUrl) {
                    var videoObj = parseVideoUrl.parse($scope.media.videoUrl);
                    if(videoObj.type == 'youtube' || videoObj.type == 'vimeo') {
                        $scope.iconType = 1;
                    }

                    if($scope.type == 'large') {
                        parseVideoUrl.getThumbnailUrl(videoObj, function(thumbnail) {
                            $scope.thumbnail = thumbnail;
                        });
                    }
                }

            },
            template: '<md-button class="md-icon-button md-accent" aria-label="Media Icon" ng-if="type==\'small\'">' +
                      '<i ng-class="{\'icon-file-outline\':iconType==0, \'icon-play-circle\':iconType==1, \'icon-file-document\':iconType==2}"></i>' +
                      '</md-button>' +
                      '<div ng-if="type==\'large\'">' +
                      '<md-icon class="md-accent" style="font-size:80px;width:80px;height:80px;line-height:80px;" ng-class="{\'icon-file-outline\':iconType==0, \'icon-play-circle\':iconType==1, \'icon-file-document\':iconType==2}" ng-if="!thumbnail"></md-icon>' +
                      '<img ng-src="{{ thumbnail }}" ng-if="thumbnail"></img>' +
                      '</div>'
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .directive('mdBlur', mdBlurDirective);

    /** @ngInject */
    function mdBlurDirective($timeout)
    {
        return {
          restrict: 'A',
          link: function(scope, element, attributes){
            $timeout(function(){
              angular.element(element[0].querySelector("input.md-input")).bind("blur", function() {
                $timeout(function() {
                  scope.$eval(attributes.mdBlur);
                }, 100);
              });
            },0);
          }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .directive('onClickOutside', onClickOutsideDirective);

    /** @ngInject */
    function onClickOutsideDirective($timeout)
    {
      return {
        restrict: 'A',
        scope: {
          onClickOutside: "&"
        },
        link: function(scope, element, attr) {

          angular.element(document).bind('click', function(event) {

            var isDropDown = event.target.hasAttribute('md-virtual-repeat');
            var isChild = childOf(event.target, element[0]);
            if (!isChild && !isDropDown) {
              scope.$apply(scope.onClickOutside);
            }

          });

          function childOf(c, p) {
            while ((c = c.parentNode) && c !== p);
            return !!c;
          }
        }

      };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, uiGmapGoogleMapApiProvider, $translateProvider, $provide, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyCC3vNsimM35jKWf4g959-ss1w1uieAjU8',
            v: '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.quote.iconclass = 'icon-format-quote';

                return taTools;
            }
        ]);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $cookies, authManager, jwtHelper, bsLoadingOverlayService, currentUser)
    {
        //Redirecting the User On Unauthorized Requests
        authManager.redirectWhenUnauthenticated();

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams)
        {
            $rootScope.loadingProgress = true;

            checkAuthOnStateChange(toState);

            checkRoleOnStateChange(toState);
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        //Overlay config
        bsLoadingOverlayService.setGlobalConfig({
          templateUrl: 'app/main/dashboard/loading-overlay-template.html'
        });

        function checkAuthOnStateChange(toState) {

            if(toState.name.indexOf('app.auth_') === -1) {

              var token = currentUser.getLoginToken();

              if(!token || jwtHelper.isTokenExpired(token)) {
                  location.href = '/auth/login?isExpired=true';
              }

            }
        }

        function checkRoleOnStateChange(toState) {

            if(toState.name === 'app.dashboard') {
                if(currentUser.isSiteUser()) {
                    location.href = '/dashboard-site/home';
                    $rootScope.viewMode = 'site';
                } else if(currentUser.isAdminUser()) {
                    $rootScope.viewMode = 'admin';
                }
            } else if(toState.name.indexOf('app.dashboard-site') !== -1) {
                $rootScope.viewMode = 'site';
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider)
    {
        $locationProvider.html5Mode(true);

        $urlMatcherFactoryProvider.strictMode(false);

        $urlRouterProvider.otherwise('/auth/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        //var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Set default layout as contentWithToolbar
        var layoutStyle = 'contentWithToolbar';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .constant('G2E_CONST_API', {

          //Google MAP API Key
          GOOGLE_MAP_API_KEY: 'AIzaSyCC3vNsimM35jKWf4g959-ss1w1uieAjU8',
          GOOGLE_MAP_API_BASE_URL: 'https://maps.googleapis.com/maps/api',

          //Privacy Notice Link
          PRIVACY_NOTICE_URL: 'http://www.emerson.com/en-us/privacy-notice',

          //Hauler
          HAULER_BASE_URL: 'https://sp.grind2energy.com',
          HAULER_BILLING_TYPE_CODE: 'TASK150',

          //Backend Server
          protocal: 'https',
          host: 'dashboard.grind2energy.com',
          port: ''
        });
})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .config(config);

    /** @ngInject */
    function config($httpProvider, $mdThemingProvider, jwtOptionsProvider, G2E_CONST_API)
    {
        // JWT Interceptor
        jwtOptionsProvider.config({
          tokenGetter: ['$state', '$cookies', 'currentUser',
            function ($state, $cookies, currentUser) {

              if(!currentUser.isExist()) {
                return null;
              }

              return currentUser.getLoginToken();

            }],
          whiteListedDomains:['localhost', G2E_CONST_API.host],
          unauthenticatedRedirector: ['$state', '$location', function($state, $location) {
            location.href = '/auth/login?isExpired=true';
          }]
        });

        $httpProvider.interceptors.push('jwtInterceptor');


        //Register custom toast theme
        $mdThemingProvider.theme('warning-toast');
        $mdThemingProvider.theme('error-toast');
        $mdThemingProvider.theme('success-toast');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('g2e')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, G2E_CONST_API, Upload)
    {
        var api = {};

        // Base Url
        if(G2E_CONST_API.port) {
          api.hostUrl = G2E_CONST_API.protocal + '://' + G2E_CONST_API.host +':' + G2E_CONST_API.port;
          api.baseUrl = api.hostUrl + '/api';
        } else {
          api.hostUrl = G2E_CONST_API.protocal + '://' + G2E_CONST_API.host;
          api.baseUrl = api.hostUrl + '/api';
        }

        //Auth
        api.signin = $resource(api.baseUrl + '/auth/token/signin');
        api.signout = $resource(api.baseUrl + '/auth/token/signout');
        api.forgotPassword = $resource(api.baseUrl + '/auth/forgot');
        api.resetPassword = $resource(api.baseUrl + '/auth/reset/:token', {token: '@token'});

        //Users
        api.adminUsers = {
          list: $resource(api.baseUrl + '/admin/users'),
          actionById: $resource(api.baseUrl + '/admin/users/:userId', {userId: '@userId'}, {
            save:{method:'PUT'}
          })
        };

        //profile
        api.profile = {
            update: $resource(api.baseUrl + '/users/profile', null, {
                save:{method:'PUT'}
            })
        };

        //Roles
        api.adminRoles = $resource(api.baseUrl + '/admin/roles');

        //ListServs
        api.adminServs = $resource(api.baseUrl + '/admin/listservs');


        //Companies
        api.adminCompanies = {
          list: $resource(api.baseUrl + '/admin/companies'),
          actionById: $resource(api.baseUrl + '/admin/companies/:companyId', {companyId: '@companyId'}, {
            save:{method:'PUT'}
          }),
          logo: $resource(api.baseUrl + '/admin/companies/:companyId/logo', {companyId: '@companyId'}, {
            save:{method:'PUT'}
          }),
          status: $resource(api.baseUrl + '/admin/companies/:companyId/status', {companyId: '@companyId'}, {
            save:{method:'PUT'}
          })
        };

        api.companies = {
          list: $resource(api.baseUrl + '/companies'),
          actionById: $resource(api.baseUrl + '/companies/:companyId', {companyId: '@companyId'})
        };

        //Installations
        api.adminInstallations = {
          list: $resource(api.baseUrl + '/admin/installations'),
          listStats: $resource(api.baseUrl + '/admin/installations/stats'),
          actionById: $resource(api.baseUrl + '/admin/installations/:installationId', {installationId: '@installationId'}, {
            save:{method:'PUT'}
          }),
          attributes: $resource(api.baseUrl + '/admin/installations/:installationId/attributes', {installationId: '@installationId'}, {
            save:{method:'PUT'}
          }),
          customers: {
              list: $resource(api.baseUrl + '/admin/installations/:installationId', {installationId: '@installationId'}),
              actionById: $resource(api.baseUrl + '/admin/installations/:installationId/customers/:customerId', {installationId: '@installationId', customerId: '@customerId'}, {
                  save:{method:'PUT'}
              })
          }
        };

        api.installations = {
          list: $resource(api.baseUrl + '/installations'),
          listStats: $resource(api.baseUrl + '/installations/stats'),
          actionById: $resource(api.baseUrl + '/installations/:installationId', {installationId: '@installationId'}),
          stats: $resource(api.baseUrl + '/installations/:installationId/stats', {installationId: '@installationId'}),
          attributes: $resource(api.baseUrl + '/installations/:installationId/attributes', {installationId: '@installationId'})
        };

        api.tanks = {
          streamValues: $resource(api.baseUrl + '/tanks/:tankId/stream/:stream/streamValues/', {tankId: '@tankId', stream:'@streamId' }),
          streamSampling: $resource(api.baseUrl + '/tanks/:tankId/stream/:stream/streamSampling/', {tankId: '@tankId', stream:'@streamId'})
        };

        //Events
        api.adminEvents = {
          pickup: {
            list: $resource(api.baseUrl + '/admin/installations/:installationId/events/pickup', {installationId: '@installationId'}),
            actionById: $resource(api.baseUrl + '/admin/installations/:installationId/events/pickup/:eventId', {installationId: '@installationId', eventId: '@eventId'}, {
              save:{method:'PUT'}
            }),
            exportBilling: $resource(api.baseUrl + '/admin/installations/:installationId/events/pickup/:eventId/export_billing', {installationId: '@installationId', eventId: '@eventId'}, {
              save:{method:'PUT'}
            }),
            invalid: $resource(api.baseUrl + '/admin/installations/:installationId/events/invalid_pickups', {installationId: '@installationId'}, {
              save:{method:'PUT'}
            })
          }
        };

        api.events = {
          pickup: {
            list: $resource(api.baseUrl + '/installations/:installationId/events/pickup', {installationId: '@installationId'})
          },
          tanklevel: {
            list: $resource(api.baseUrl + '/installations/:installationId/events/tanklevel', {installationId: '@installationId'}),
            resolve: $resource(api.baseUrl + '/installations/:installationId/events/tanklevel/:eventId/resolve', {installationId: '@installationId', eventId: '@eventId'}, {
              save:{method:'PUT'}
            }),
          },
          systemfault: {
            list: $resource(api.baseUrl + '/installations/:installationId/events/systemfault', {installationId: '@installationId'}),
            acknowledge: $resource(api.baseUrl + '/installations/:installationId/events/systemfault/:eventId/acknowledge', {installationId: '@installationId', eventId: '@eventId'}, {
              save:{method:'PUT'}
            })
          },
          noncritical: {
            list: $resource(api.baseUrl + '/installations/:installationId/events/noncritical', {installationId: '@installationId'})
          }
        };

        //Holidays
        api.adminHolidays = {
          list: $resource(api.baseUrl + '/admin/holidays'),
          actionById: $resource(api.baseUrl + '/admin/holidays/:id', {id: '@id'}, {
            save:{method:'PUT'}
          })
        };

        //Divisions
        api.adminDivisions = {
            list: $resource(api.baseUrl + '/admin/divisions'),
            actionById: $resource(api.baseUrl + '/admin/divisions/:divisionId', {divisionId: '@divisionId'}, {
                save:{method:'PUT'}
            })
        };

        //Medias
        api.adminMedias = {
            list: $resource(api.baseUrl + '/admin/medias'),
            upload: function(data) {
                return Upload.upload({
                    url: api.baseUrl + '/admin/medias',
                    data: data});
            },
            actionById: $resource(api.baseUrl + '/admin/medias/:mediaId', {mediaId: '@mediaId'}, {
                save:{method:'PUT'}
            }),
            sites: $resource(api.baseUrl + '/admin/medias/:mediaId/sites', {mediaId: '@mediaId'}, {
                save:{method:'PUT'}
            })
        };

        //Sites
        api.adminSites = {
            list: $resource(api.baseUrl + '/admin/sites'),
            actionById: $resource(api.baseUrl + '/admin/sites/:siteId', {siteId: '@siteId'}, {
                save:{method:'PUT'}
            }),
            users: {
                list: $resource(api.baseUrl + '/admin/sites/:siteId/users', {siteId: '@siteId'}),
                actionById: $resource(api.baseUrl + '/admin/sites/:siteId/users/:userId', {siteId: '@siteId', userId: '@userId'}, {
                    save:{method:'PUT'}
                })
            },
            adminGroups: {
                list: $resource(api.baseUrl + '/admin/sites/:siteId/admin_groups', {siteId: '@siteId'}),
                actionById: $resource(api.baseUrl + '/admin/sites/:siteId/admin_groups/:groupId', {siteId: '@siteId', groupId: '@groupId'}, {
                    save:{method:'PUT'}
                }),
                users: {
                    list: $resource(api.baseUrl + '/admin/sites/:siteId/admin_groups/:groupId/administrators', {siteId: '@siteId', groupId: '@groupId'}),
                    actionById: $resource(api.baseUrl + '/admin/sites/:siteId/admin_groups/:groupId/administrators/:userId', {siteId: '@siteId', groupId: '@groupId', userId: '@userId'}, {
                        save:{method:'PUT'}
                    })
                }
            },
            benchMarkings: {
                list: $resource(api.baseUrl + '/admin/sites/:siteId/bench_markings', {siteId: '@siteId'}),
                actionById: $resource(api.baseUrl + '/admin/sites/:siteId/bench_markings/:benchmarkingId', {siteId: '@siteId', benchmarkingId: '@benchmarkingId'}, {
                    save:{method:'PUT'}
                }),
                sites: $resource(api.baseUrl + '/admin/sites/:siteId/bench_marking_sites', {siteId: '@siteId'})
            },
            metrics: $resource(api.baseUrl + '/admin/sites/:siteId/metrics', {siteId: '@siteId'}, {
                save:{method:'PUT'}
            }),
            medias: $resource(api.baseUrl + '/admin/sites/:siteId/medias', {siteId: '@siteId'}, {
                save:{method:'PUT'}
            }),
            assign: $resource(api.baseUrl + '/admin/sites/:siteId/assign/:installationId', {siteId: '@siteId', installationId: '@installationId'}, {
                save:{method:'PUT'}
            }),
            unassign: $resource(api.baseUrl + '/admin/sites/:siteId/unassign/:installationId', {siteId: '@siteId', installationId: '@installationId'}, {
                save:{method:'PUT'}
            }),
            badges: {
                list: $resource(api.baseUrl + '/admin/sites/:siteId/badges', {siteId: '@siteId'}),
                upload: function(siteId, data) {
                    return Upload.upload({
                        url: api.baseUrl + '/admin/sites/'+siteId+'/badges/csv',
                        data: data});
                },
                actionById: $resource(api.baseUrl + '/admin/sites/:siteId/badges/:id', {siteId: '@siteId', id: '@id'}, {
                    save:{method:'PUT'}
                })
            },
            shifts: {
                list: $resource(api.baseUrl + '/admin/sites/:siteId/shifts', {siteId: '@siteId'}),
                actionById: $resource(api.baseUrl + '/admin/sites/:siteId/shifts/:shiftId', {siteId: '@siteId', shiftId: '@shiftId'}, {
                    save:{method:'PUT'}
                })
            }
        };

        api.sites = {
            list: $resource(api.baseUrl + '/sites'),
            actionById: $resource(api.baseUrl + '/sites/:siteId', {siteId: '@siteId'}),
            stats: $resource(api.baseUrl + '/sites/:siteId/stats', {siteId: '@siteId'})
        };

        //Site Metrics
        api.siteMetrics = {
            list: $resource(api.baseUrl + '/site_metrics')
        };

        //Site Badges CSV Sample
        api.siteBadgesCsvSample = api.baseUrl + '/site_badges_sample';


        // Sustainability Report
        api.adminSustainabilitySettings = {
            list: $resource(api.baseUrl + '/admin/sustainability/settings', null, {
                save:{method:'PUT'}
            })
        };
        api.adminSustainabilityReports = {
            list: $resource(api.baseUrl + '/admin/sustainability/reports', null, {
                save:{method:'PUT'}
            })
        };
        api.sustainabilityReports = {
            download: $resource(api.baseUrl + '/sustainability/reports/generate')
        };

        return api;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login',
            'app.auth.forgot-password',
            'app.auth.reset-password'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('auth', {
            title : 'AUTH',
            group : true,
            weight: 1
        });
    }
})();

angular.module("g2e").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex class=\"loading-overlay\" \nbs-loading-overlay=\"content_loader\"></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/change-password/change-password.html","<div id=\"change-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"change-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"change-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img src=\"assets/images/logos/g2e.png\"></div><div class=\"title\" ng-show=\"!vm.msg\">Change your password\n</div><div class=\"title\" ng-show=\"vm.msg\">{{vm.msg}}</div><form name=\"changePasswordForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" ng-change=\"vm.checkPasswordConfirm()\" required><div \nng-messages=\"changePasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \nng-change=\"vm.checkPasswordConfirm()\" required><div ng-messages=\"changePasswordForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Save\" \nng-disabled=\"changePasswordForm.$invalid || changePasswordForm.$pristine || vm.form.password != vm.form.passwordConfirm || vm.isWorking\" \nng-click=\"vm.submit()\">Save</md-button></form></div></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard\"><div id=\"widgets\"><div layout=\"row\" flex=\"100\" layout-wrap><div class=\"widget-group\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"{{vm.layoutLeft}}\"><ms-widget ng-show=\"vm.layoutMapVisible\"><ms-widget-front \nclass=\"white-bg\"><div class=\"widget-head\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">Map</div>\n<div class=\"widget-toolbar\"><strong class=\"pr-16\">Status</strong><div class=\"groupX-container\"><section layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-background-fg groupX left\" \nng-class=\"vm.status_by==0?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" ng-click=\"vm.filterMap(0);\">All</md-button>\n<md-button class=\"md-raised md-background-fg groupX middle\" \nng-class=\"vm.status_by==1?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" ng-click=\"vm.filterMap(1);\">Running</md-button>\n<md-button class=\"md-raised md-background-fg groupX middle\" \nng-class=\"vm.status_by==2?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" ng-click=\"vm.filterMap(2);\">System Faults\n</md-button><md-button class=\"md-raised md-background-fg groupX right\" \nng-class=\"vm.status_by==3?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" ng-click=\"vm.filterMap(3);\">Hauling Status\n</md-button></section></div></div></div><div><ui-gmap-google-map center=\"vm.mapWidget.center\" zoom=\"vm.mapWidget.zoom\" \noptions=\"vm.mapWidget.options\"><ui-gmap-markers models=\"vm.mapWidget.markers\" coords=\"\'coords\'\" options=\"\'options\'\" \nevents=\"vm.mapWidget.events\" dorebuildall=\"true\"></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front>\n</ms-widget><ms-widget ng-show=\"vm.layoutDashboardVisible\"><ms-widget-front class=\"white-bg\"><div \nclass=\"widget-head border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">Dashboard</div><div \nclass=\"widget-toolbar\"><strong>{{vm.mertricWidget.title}}</strong></div></div><div layout=\"row\"><div layout=\"column\" \nflex=\"50\" layout-wrap><div class=\"p-20\"><h3 class=\"mv-0 text-center\">Average Tank Level<br>At Pick-up</h3><c3chart \nbindto-id=\"gauge-plot1-chart\" chart-data=\"vm.mertricWidget.items[\'Average Tank Level at Pick-up\'].values\" \nchart-columns=\"vm.mertricWidget.items[\'Average Tank Level at Pick-up\'].columns\"><chart-legend show-legend=\"false\">\n<chart-tooltip show-tooltip=\"false\"><chart-gauge min=\"0\" max=\"100\" units=\" Full\" width=\"29\" expand=\"true\"></c3chart>\n</div></div><div layout=\"column\" flex=\"50\" layout-wrap><div class=\"p-20\"><h3 class=\"mv-0 text-center\">\nProjected Annual Number<br>of Pick-ups</h3><c3chart bindto-id=\"gauge-plot2-chart\" \nchart-data=\"vm.mertricWidget.items[\'Projected Annual Number of Pick-ups\'].values\" \nchart-columns=\"vm.mertricWidget.items[\'Projected Annual Number of Pick-ups\'].columns\"><chart-legend \nshow-legend=\"false\"><chart-tooltip show-tooltip=\"false\"><chart-gauge min=\"0\" max=\"100\" units=\" \" width=\"29\" \nlabel-format-function=\"vm.gaugeFormat1\"></c3chart></div></div></div><div layout=\"row\"><div layout=\"column\" flex=\"50\" \nlayout-wrap><div class=\"p-20\"><h3 class=\"mv-0 text-center\">Average Left-over<br>in Tank</h3><c3chart \nbindto-id=\"gauge-plot3-chart\" chart-data=\"vm.mertricWidget.items[\'Average % Left-over in Tank\'].values\" \nchart-columns=\"vm.mertricWidget.items[\'Average % Left-over in Tank\'].columns\"><chart-legend show-legend=\"false\">\n<chart-tooltip show-tooltip=\"false\"><chart-gauge min=\"0\" max=\"100\" units=\" Left Over\" width=\"29\"></c3chart></div></div>\n<div layout=\"column\" flex=\"50\" layout-wrap><div class=\"p-20\"><h3 class=\"mv-0 text-center\">Average Slurry<br>\nWater Content</h3><c3chart bindto-id=\"gauge-plot4-chart\" \nchart-data=\"vm.mertricWidget.items[\'Average % of Slurry that is Water\'].values\" \nchart-columns=\"vm.mertricWidget.items[\'Average % of Slurry that is Water\'].columns\"><chart-legend show-legend=\"false\">\n<chart-tooltip show-tooltip=\"false\"><chart-gauge min=\"0\" max=\"100\" units=\" \" width=\"29\"></c3chart></div></div></div>\n<div class=\"simple-table-container md-whiteframe-4dp\"><div class=\"pt-24 pl-24 h3\"><div class=\"g2e-icon-metrics\"></div>\n<strong>Metrics</strong></div><table class=\"simple dashboard-matrix\" ms-responsive-table><thead><tr><th>Item</th><th>\nValue</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Waste Processed Rate\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.items[\'Rolling Waste Processed Rate\'].format()}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Daily Usage\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Daily Usage\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Mean Run Time\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Mean Run Time\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Pick-up Count\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Pick-up Count\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Tank Volume\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Tank Volume\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Water Usage\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Water Usage\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Total Waste Processed\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.items[\'Rolling Total Waste Processed\'].format()}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Water Content\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.items[\'Rolling Water Content\'].format()}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Boot-up Count\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Boot-up Count\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling On/Offs Count\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling On/Offs Count\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Reverse Cycles\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Reverse Cycles\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Rolling Run Time\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Rolling Run Time\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Average Days between Critical Fault\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Average Days between Critical Fault\')}}</td></tr><tr><td class=\"dashboard-matrix-item\">\n{{vm.mertricWidget.items[\'Temperature\'].title}}</td><td class=\"dashboard-matrix-value\">\n{{vm.mertricWidget.format(\'Temperature\')}}</td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"column\" flex=\"100\" flex-gt-sm=\"{{vm.layoutRight}}\"><ms-widget \nng-show=\"vm.layoutCustomerVisible\"><ms-widget-front class=\"white-bg\"><div class=\"widget-head border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">List</div><div class=\"widget-toolbar\"><md-button \nclass=\"md-icon-button\" aria-label=\"Open Graph\" ng-click=\"vm.openGraphDlg($event)\" ng-if=\"vm.layoutExpandCustomerView\">\n<img src=\"/assets/images/icons/btn-graph-display.png\"></md-button><md-button class=\"md-icon-button\" \naria-label=\"Export\" ng-csv=\"vm.getCSVRowsForCustomerTable()\" csv-header=\"vm.getCSVHeadersForCustomerTable()\" \nfilename=\"{{vm.getCSVFilenameForCustomerTable()}}\" ng-if=\"vm.layoutExpandCustomerView\"><img \nsrc=\"/assets/images/icons/btn-export.png\"></md-button><md-button class=\"md-icon-button\" aria-label=\"Open Logs\" \nng-click=\"vm.openEventLogDlg($event)\"><img src=\"/assets/images/icons/btn-alarm.png\"></md-button><md-input-container \nng-if=\"vm.layoutExpandCustomerView\"><md-select class=\"g2e-select-with-icon\" aria-label=\"Choose Columns\" \nng-model=\"vm.selectedCustomerTableColumnsExpended\" multiple=\"multiple\" ng-change=\"vm.chooseCustomerTableColumns()\"><div\n class=\"freeze-header\"><md-button class=\"md-raised\" ng-click=\"vm.chooseCustomerTableColumnsAll()\" \nng-disabled=\"vm.isSavingColumns\">Check All</md-button><md-button class=\"md-raised\" \nng-click=\"vm.chooseCustomerTableColumnsDefault()\" ng-disabled=\"vm.isSavingColumns\">Default</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.chooseCustomerTableColumnsRemove()\" ng-disabled=\"vm.isSavingColumns\">Uncheck All\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.saveCustomerTableColumns()\" \nng-disabled=\"vm.isSavingColumns || !vm.isColumnsChanged\">Save</md-button></div><div \nng-repeat=\"column in vm.customerTableWidget.columns\"><md-option ng-value=\"$index\">{{column.title}}</md-option><hr \nng-if=\"$index==49\"></div></md-select></md-input-container><md-input-container ng-if=\"!vm.layoutExpandCustomerView\">\n<md-select class=\"g2e-select-with-icon\" aria-label=\"Choose Columns\" ng-model=\"vm.selectedCustomerTableColumns\" \nmultiple=\"multiple\" ng-change=\"vm.chooseCustomerTableColumns()\"><div class=\"freeze-header\"><md-button \nclass=\"md-raised\" ng-click=\"vm.chooseCustomerTableColumnsAll()\" ng-disabled=\"vm.isSavingColumns\">Check All</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.chooseCustomerTableColumnsDefault()\" ng-disabled=\"vm.isSavingColumns\">Default\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.chooseCustomerTableColumnsRemove()\" \nng-disabled=\"vm.isSavingColumns\">Uncheck All</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.saveCustomerTableColumns()\" ng-disabled=\"vm.isSavingColumns || !vm.isColumnsChanged\">Save</md-button>\n</div><div ng-repeat=\"column in vm.customerTableWidget.columns\"><md-option ng-value=\"$index\">{{column.title}}\n</md-option><hr ng-if=\"$index==49\"></div></md-select></md-input-container><md-button class=\"md-icon-button\" \naria-label=\"Expand View\" ng-click=\"vm.expandCustomerView()\"><img src=\"/assets/images/icons/btn-contract-view.png\" \nng-if=\"vm.layoutExpandCustomerView\"> <img src=\"/assets/images/icons/btn-expand-view.png\" \nng-if=\"!vm.layoutExpandCustomerView\"></md-button></div></div><div class=\"loading-overlay\" \nbs-loading-overlay=\"installations_loader\"><md-table-container><table md-table md-progress=\"vm.installationsLoader\">\n<thead md-head md-order=\"vm.customerTableWidget.order\"><tr md-row><th md-column ng-if=\"vm.layoutExpandCustomerView\">\n<md-checkbox aria-label=\"Choose All Rows\" ng-click=\"vm.chooseAllCustomerTableRows()\" \nng-checked=\"vm.isSelectedAllCustomerTableRows()\"></md-checkbox></th><th md-column md-order-by=\"{{col_index}}\" \nng-repeat=\"(col_index, column) in vm.customerTableWidget.columns\" ng-if=\"column.visible\">{{column.title}}</th></tr>\n</thead><tbody md-body><tr md-row ng-if=\"vm.customerTableWidget.rows.length==0\"><td md-cell colspan=\"100\" \nstyle=\"height: 200px\" align=\"center\"><span ng-if=\"!vm.isLoadingInstallations\">No data available in table</span> <span \nng-if=\"vm.isLoadingInstallations\">Loading...</span></td></tr><tr md-row \nng-repeat=\"row in vm.customerTableWidget.rows | filterBy:search_location:search_company:search_contract_type:vm.status_by | sortBy: vm.customerTableWidget.order | limitTo: vm.customerTableWidget.pagination.limit: (vm.customerTableWidget.pagination.page - 1) * vm.customerTableWidget.pagination.limit\" \nng-class=\"{\'selected\':vm.isSelectedCustomerTableRows(row.index)}\" ng-click=\"vm.chooseCustomerTableRows(row.index)\" \nng-dblclick=\"vm.expandCustomerView()\"><td md-cell ng-if=\"vm.layoutExpandCustomerView\"><md-checkbox \naria-label=\"Choose Row\" ng-checked=\"vm.isSelectedCustomerTableRows(row.index)\"></md-checkbox></td><td md-cell \nng-repeat=\"(col_index, column) in vm.customerTableWidget.columns\" ng-if=\"column.visible\"><div ng-if=\"col_index==3\" \nclass=\"text-center\"><a href=\"#\" ng-click=\"vm.openInstallation(row.index)\">{{row.cells[col_index].value}}</a></div><div \nng-if=\"col_index==2\" class=\"text-center\"><div class=\"g2e-icon-in-table {{row.cells[col_index].image}}\" \nng-if=\"row.cells[col_index].image\" style=\"cursor:pointer\" ng-click=\"vm.openHaulerApp(row.index)\"></div></div><div \nng-if=\"col_index!=2 && col_index!=3\" class=\"text-center\"><div class=\"g2e-icon-in-table {{row.cells[col_index].image}}\" \nng-if=\"row.cells[col_index].image\"></div><span class=\"{{row.cells[col_index].classes}}\" \nng-class=\"{\'g2e-icon-text\':row.cells[col_index].image}\" ng-if=\"row.cells[col_index].format\">\n{{row.cells[col_index].format(row.cells[col_index].value)}} </span><span class=\"{{row.cells[col_index].classes}}\" \nng-class=\"{\'g2e-icon-text\':row.cells[col_index].image}\" ng-if=\"!row.cells[col_index].format\">\n{{row.cells[col_index].value}}</span></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.customerTableWidget.pagination.limit\" md-limit-options=\"vm.customerTableWidget.pagination.lengths\" \nmd-page=\"vm.customerTableWidget.pagination.page\" md-total=\"{{vm.getRowsFiltered().length}}\" \nng-disabled=\"vm.isLoadingInstallations\" md-page-select></md-table-pagination></div></ms-widget-front></ms-widget>\n<ms-widget ng-show=\"vm.layoutAlarmVisible\"><ms-widget-front class=\"white-bg\"><div class=\"widget-head border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">Alarms</div><div class=\"widget-toolbar\"></div></div>\n<div class=\"pt-24 pl-24 pr-24\"><span class=\"h3\"><strong>System Fault Alarms</strong></span> <a href=\"#\" \nstyle=\"float: right\" ng-if=\"vm.isAcknowledgeAllAvailable()\" ng-click=\"vm.acknowledgeAllSystemFaults()\">Acknowledge All\n</a></div><div class=\"border-bottom\"><md-table-container><table md-table><thead md-head \nmd-order=\"vm.alarmWidget.systemFault.order\"><tr md-row><th md-column md-order-by=\"{{col_index}}\" \nng-repeat=\"(col_index, column) in ::vm.alarmWidget.systemFault.columns\" ng-if=\"!column.hidden\"><span \nng-bind-html=\"column.title\"></span></th><th md-column ng-if=\"vm.currentUser.hasAdminRole()\">Action</th></tr></thead>\n<tbody md-body><tr md-row ng-if=\"vm.alarmWidget.systemFault.rows.length==0\"><td md-cell colspan=\"100\" align=\"center\">\n<span ng-if=\"!vm.isLoadingInstallations\">No data available in table</span> <span ng-if=\"vm.isLoadingInstallations\">\nLoading...</span></td></tr><tr md-row \nng-repeat=\"row in vm.alarmWidget.systemFault.rows | orderBy:vm.alarmWidget.systemFault.order\"><td md-cell \nng-repeat=\"(col_index, column) in ::vm.alarmWidget.systemFault.columns\" ng-if=\"!column.hidden\"><span \nng-if=\"column.format\">{{ column.format(row[col_index]) }}</span> <span ng-if=\"!column.format\">{{ row[col_index] }}\n</span></td><td md-cell ng-if=\"vm.currentUser.hasAdminRole()\"><a href=\"#\" ng-click=\"vm.acknowledgeSystemFault(row)\" \nng-if=\"!row[0].isAck\">Acknowledge</a><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"row[0].isAck\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></div></td>\n</tr></tbody></table></md-table-container></div><div class=\"pt-24 pl-24 h3\"><strong>Tank Level Alarms</strong></div>\n<div><md-table-container><table md-table><thead md-head md-order=\"vm.alarmWidget.tankLevel.order\"><tr md-row><th \nmd-column md-order-by=\"{{col_index}}\" ng-repeat=\"(col_index, column) in ::vm.alarmWidget.tankLevel.columns\"><span \nng-bind-html=\"column.title\"></span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.alarmWidget.tankLevel.rows.length==0\"><td md-cell colspan=\"100\" align=\"center\"><span \nng-if=\"!vm.isLoadingInstallations\">No data available in table</span> <span ng-if=\"vm.isLoadingInstallations\">Loading...\n</span></td></tr><tr md-row ng-repeat=\"row in vm.alarmWidget.tankLevel.rows | orderBy:vm.alarmWidget.tankLevel.order\">\n<td md-cell ng-repeat=\"cell in row track by $index\"><span ng-if=\"vm.alarmWidget.tankLevel.columns[$index].format\">\n{{ vm.alarmWidget.tankLevel.columns[$index].format(cell) }}</span> <span \nng-if=\"!vm.alarmWidget.tankLevel.columns[$index].format\">{{ cell }}</span></td></tr></tbody></table>\n</md-table-container></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/dashboard/loading-overlay-template.html","<div class=\"loading-container\"><div layout=\"row\" layout-align=\"center center\" class=\"loading-icon\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div></div>");
$templateCache.put("app/main/dashboard-site/dashboard-site.html","<md-content id=\"dashboard-site\"><div id=\"tab-bar\" layout=\"row\"><div hide-gt-sm><md-button \naria-label=\"Toggle Left Menu\" ng-click=\"vm.toggleLeft()\" class=\"md-icon-button md-primary\"><md-icon \nmd-font-icon=\"icon-menu\"></md-icon></md-button></div><div flex><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Home\" ui-sref=\".home\" md-active=\"state.current.name==\'app.dashboard-site.home\'\"></md-tab><md-tab \nlabel=\"Analytics and Reports\" ui-sref=\".analytics\" md-active=\"state.current.name==\'app.dashboard-site.analytics\'\">\n</md-tab><md-tab label=\"Training Materials\" ui-sref=\".materials\" \nmd-active=\"state.current.name==\'app.dashboard-site.materials\'\"></md-tab></md-tabs></div></div><section \nid=\"tab-content-container\" layout=\"row\" flex><md-sidenav class=\"md-sidenav-left\" \nmd-component-id=\"dashboard-site-left-side\" md-is-locked-open=\"$mdMedia(\'gt-sm\') && !vm.isHomeState()\"><md-content \nms-scroll><form><div class=\"filter-bar\" layout=\"column\"><div class=\"logo-holder\" layout=\"row\" \nlayout-align=\"center center\"><img \nng-src=\"{{(vm.selectedCompany && vm.selectedCompany.logo)?vm.hostUrl+vm.selectedCompany.logo:\'assets/images/logos/company.png\'}}\">\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Edit Company Logo\" \nng-click=\"vm.openEditCompanyLogoDlg($event)\" ng-if=\"vm.screenMode==\'Admin\'\" \nng-disabled=\"!vm.selectedCompany || vm.isLoading\"><i class=\"icon-pencil\"></i></md-button></div><md-autocomplete \nmd-input-name=\"company\" md-min-length=\"0\" md-no-cache=\"vm.noCache\" \nmd-selected-item-change=\"vm.selectedCompanyChange(item)\" md-selected-item=\"vm.selectedCompany\" \nmd-search-text=\"vm.searchCompany\" md-search-text-change=\"vm.searchCompanyTextChange(vm.searchCompany)\" \nmd-items=\"item in vm.queryCompany(vm.searchCompany)\" md-item-text=\"item.name\" md-floating-label=\"Company\" \nng-disabled=\"vm.isLoading || !vm.currentUser.isAdminUser()\"><md-item-template><span \nmd-highlight-text=\"vm.searchCompany\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"division\" md-min-length=\"0\" \nmd-no-cache=\"vm.noCache\" md-selected-item-change=\"vm.selectedDivisionChange(item)\" \nmd-selected-item=\"vm.selectedDivision\" md-search-text=\"vm.searchDivision\" \nmd-search-text-change=\"vm.searchDivisionTextChange(vm.searchDivision)\" \nmd-items=\"item in vm.queryDivision(vm.searchDivision)\" md-item-text=\"item.name\" md-floating-label=\"Regional Division\" \nng-disabled=\"!vm.selectedCompany || vm.isLoading || !vm.currentUser.isAdminUser()\"><md-item-template><span \nmd-highlight-text=\"vm.searchDivision\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"site\" md-min-length=\"0\" \nmd-no-cache=\"vm.noCache\" md-selected-item-change=\"vm.selectedSiteChange(item)\" md-selected-item=\"vm.selectedSite\" \nmd-search-text=\"vm.searchSite\" md-search-text-change=\"vm.searchSiteTextChange(vm.searchSite)\" \nmd-items=\"item in vm.querySite(vm.searchSite)\" md-item-text=\"item.name\" md-floating-label=\"Site\" \nng-disabled=\"!vm.selectedCompany || vm.isLoading || !vm.currentUser.isAdminUser()\"><md-item-template><span \nmd-highlight-text=\"vm.searchSite\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching...</md-not-found></md-autocomplete><span class=\"address\">\n{{stats.Installation?stats.Installation.Customer.address:\'\'}}<br>\n{{stats.Installation?stats.Installation.Customer.city+\', \'+stats.Installation.Customer.state+\' \'+stats.Installation.Customer.zipcode:\'\'}}\n<br></span><md-divider></md-divider><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.openSiteAttrDlg($event)\" ng-disabled=\"vm.isLoading || !vm.selectedSite\">\nVIEW SITE ATTRIBUTES</md-button></div><md-divider></md-divider><div class=\"support\"><div class=\"title\">\nGrind2Energy Support</div><div class=\"description\">Please use the following contacts for support.</div><div \nclass=\"admin-group\" ng-repeat=\"group in stats.SiteAdminGroups\"><div class=\"name\">{{group.groupName}}</div><div \nclass=\"user\" ng-repeat=\"user in group.Users\"><a href=\"\" ng-click=\"vm.openSupportContactDlg($event, group, user)\">\n{{ user.displayName }}</a></div></div></div><md-divider></md-divider><div class=\"terms-conditions-link\"><a \nui-sref=\"app.terms-conditions\" target=\"_blank\">Grind2Energy Terms and Conditions</a></div><div \nclass=\"privacy-notice-link\"><a href=\"{{vm.privacyNoticeUrl}}\" target=\"_blank\">Privacy Notice</a></div></div></form>\n</md-content></md-sidenav><md-content ms-scroll flex id=\"tab-content\" ui-view=\"tab-content\"></md-content></section>\n<md-divider></md-divider><div class=\"footer\">© {{ vm.Now | date:\'yyyy\' }} Grind2Energy Copyright Content</div>\n</md-content>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/terms-conditions/terms-conditions.html","<div id=\"terms-conditions\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"terms-conditions-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><md-content id=\"terms-conditions-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img src=\"assets/images/logos/g2e.png\"></div><div class=\"title\">Terms and Conditions</div><form \nname=\"termsConditionsForm\" novalidate><md-content class=\"terms-conditions-content\" ms-scroll><div class=\"text\"><p>\nDATA SERVICE TERMS AND CONDITIONS</p><p>\nPLEASE READ THESE TERMS AND CONDITIONS (\"TERMS\"). ACTIVATION AND/OR USE OF THE DATA SERVICES SIGNIFIES ASSENT TO THESE TERMS. IF YOU ARE ACTING ON BEHALF OF AN ENTITY, THEN YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO ENTER INTO THIS AGREEMENT ON BEHALF OF THAT ENTITY. IF YOU DO NOT ACCEPT THESE TERMS, THEN YOU MUST NOT USE THE DATA SERVICES.\n</p><p>\nThese Terms contain the terms and conditions under which InSinkErator, LLC (herein referred to as the \"Seller\") sells Data Services (as defined below) to you (the \"Customer\" or \"You\") in connection with Seller’s Grind2Energy System. These Terms govern over any terms or conditions stated in, referred to in, or attached in any purchase order or any acknowledgement issued by the Customer.\n</p><p><strong>1. Definitions:</strong><br>\n\"Grind2Energy System\" means the process offered and sold by and through Seller through which (i) food waste is ground on-site at Customer’s location using a customized, heavy-duty foodservice grinder, (ii) food waste is converted into energy-rich slurry, and (iii) the food waste slurry is transported to an anaerobic digestion facility where methane is extracted for natural gas and electricity production.\n<br>\n\"Equipment\" means the Grind2Energy System equipment supplied by Seller to Customer, including the food waste grinders/disposals, waste slurry storage tanks and ancillary piping, valves and the like.\n<br>\n\"M2M Service Component\" means the cellular communication service connecting Equipment to Seller’s data collection, storage, processing and website hosting computer systems.\n<br>\n\"SIM Card\" means the SIM card used with the Equipment to allow components of the Equipment to connect with the applicable cellular/mobile telephony service.\n<br>\n\"G2E Website\" means the Internet website hosted and maintained by, or on behalf of, Seller through which You are able to log in and monitor aspects of Your use of the Grind2Energy System.\n<br>\"Data Services\" means the provision of the M2M Service Component and G2E Website by Seller to Customer.<br>\n\"Customer Data\" means Customers name, logo, trade dress, trademark or service mark, the files or attachments submitted to Seller by Customer as part of the Data Services, information created by Customer with the use of the Data Services, data provided by Customer to Seller in order for Seller to provide Data Services, as well as the account and contact information submitted to Seller by Customer.\n<br></p><p><strong>2. Nature of the Data Service:</strong><br>\n(a) Seller’s Data Service gathers data from Equipment installed on Customer’s premises, makes it available to the Customer through the G2E Website, and Seller uses it in support of Customer’s operation and maintenance of Grind2Energy System and Equipment. The Data Services also may permit the Customer to send data, requests and/or commands and inquiries to Seller on a machine-to-machine basis through the M2M Component and via manual input through the G2E Website owned and controlled by Seller.\n<br>\n(b) Seller consumes telecommunications service in order to collect the data from the Equipment so that Seller can provide the Data Service, but Customer is not a purchaser of that telecommunications service, which is entirely arranged and paid for by Seller as a part of its costs of service. Customer acknowledges that Customer has no contractual relationship or right with respect to the carrier providing the telecommunications service between its Equipment and Seller or to the telephone numbers assigned to facilitate that service, that the carrier is in no event liable to Customer with respect to the performance or nonperformance of such telecommunications services, and that Seller is not a provider of telecommunications services and does not control the network over which the data passes from the Equipment to Seller’s computers.\n<br>\n(c) Data Service is only provided for assets belonging to Customer or its affiliates and furnished with Equipment. It is not designed to be or offered as compatible with any other data source and any attempt to connect any other data source to the Data Service is a violation of these license terms, and is cause for immediate termination of all Data Service to the Customer without refund of amounts previously paid.\n<br>\n(d) Seller provides You with SIM Cards necessary for You to use the M2M Service Component. Any SIM Card issued to You by Seller remains Seller’s property. You must provide access for Seller to retrieve the SIM Card if requested to do so, and Seller reserves the right to charge You a fee if you fail to do so. Any replacement costs associated with lost or damaged SIM Cards in Your possession are Your responsibility.\n<br></p><p><strong>3. Access to the Data Service:</strong><br>\n(a) Subject to these Terms, Seller will provide Customer with access to and use of the Data Service on a limited, non-exclusive, revocable basis, for use solely for Customer’s internal business purposes and those of Customer’s affiliates under Customer’s ownership or under common ownership or control with Customer.\n<br>\n(b) Seller will provide Customer with unique access credentials to: (a) enable the Customer’s application users to access the Data Service; and (b) provide Customer access to administrative customer service via the G2E Website (collectively, \"Access Credentials\"). Customer will not make its Access Credentials available to any third party other than a third party authorized to act on its behalf and agrees to safeguard the secrecy of its Access Credentials including making password changes periodically or upon material personnel changes. Customer is fully and primarily responsible for all use of the Data Service through its Access Credentials.\n<br>\n(c) Customer shall be solely responsible for providing, at its own cost and expense, all equipment and telecommunications service necessary to use the G2E Website component of the Data Service including computers, modems, and Internet access. Customer assumes the responsibility to make sure that its computers and related systems have the capacity to receive the Data Service through the G2E Website and to correct promptly any problems with such computers and related systems that interfere with or prevent the use of the same.\n<br></p><p><strong>4. Use and Support of the Data Service:</strong><br>\n(a) Customer does not have the right to resell the Data Service or act as a service bureau with respect to the Data Service or any component thereof. All rights, including rights of use, not specifically granted under this Agreement are reserved by Seller and its suppliers.\n<br>\n(b) Customer will not use the Data Service: (i) in connection with the transmission, sale, license or delivery of any infringing, defamatory, offensive, or illegal products, services or materials; (ii) in any manner that threatens the integrity, performance, or availability of the Data Service, including, without limitation, knowing transmission of any virus, worm, Trojan, or other harmful code, attempting to gain unauthorized access to any Seller systems or data, or engaging in any type of denial-of-service or other cyber-attack on the Seller systems; or (iii) in violation of local, state, federal or equivalent privacy or other regulations.\n<br>\n(c) To the extent that any data derived from Equipment is considered personal data subject to privacy laws or regulations by any country in which the Equipment is used, Customer represents and warrants that it has obtained and will continue to obtain, update, and maintain adequate consent from the individuals to whom such data relates for Seller to receive, process, and make such data available through the Data Service.\n<br>\n(d) The Data Service will be subject to the data practices set forth in the Seller Privacy Policy as posted from time to time on Seller’s website \n<a href=\"https://whirlpoolcorp.com/privacy-notice-united-states-and-canada\" target=\"_blank\">\nhttps://whirlpoolcorp.com/privacy-notice-united-states-and-canada</a>\n, provided, that Seller reserves the right to use the information generated from the data for statistical analysis or other industry purposes so long as Seller ensures that the source of such data is and remains anonymous.\n<br>\n(e) Customer agrees to accept the G2E Website reports in their existing format and system architecture as such may be reasonably modified by Seller from time to time as provided below. Any customization of the Equipment, Data Service or reports is not included in the Data Service. If requested by Customer, such customization shall be subject to a Professional Services Statement of Work and service order mutually agreed upon by the parties outlining the work to be performed, the applicable fees, the payment and other terms.\n<br>\n(f) Seller may, in its sole discretion, make feature or functionality updates to the Data Service from time to time. Seller will provide notice of such Data Service updates, and will make commercially reasonable efforts to identify Data Service updates that may require modifications to Customer’s applications that interface with it.\n<br>\n(g) Seller will make commercially reasonable efforts to maximize the availability of the G2E Website; however, Customer acknowledges that system maintenance and backups, as well as server and network malfunctions, may and do occur and Seller will not be liable to Customer for outages and Data Service issues that occur despite Seller’s commercially reasonable efforts\n<br>\n(h) Seller will provide technical support to Customer via telephone and email during Seller’s normal business hours. Seller assumes no responsibility to provide support for Customer’s applications or for Internet access issues or other issues not under Seller\'s direct control.\n<br></p><p><strong>5. G2E Website:</strong> Use of G2E Websites is also subject to the general terms of use located at \n<a href=\"https://whirlpoolcorp.com/legal-notice\" target=\"_blank\">https://whirlpoolcorp.com/legal-notice</a>\n; provided, however, that in the event of any conflict between those general terms of use and these Terms, these Terms shall control.\n</p><p><strong>6. Fees and Payment:</strong>\n Customer agrees to pay Seller the fees (\"Fees\") as stated in the applicable order form. Such Fees for the initial annual subscription period may be paid by Customer at the time of Equipment purchase. In that event, Fees for subsequent subscription periods will be invoiced by Seller approximately thirty (30) days prior to such subsequent subscription period and shall be due and payable by Customer upon receipt. If such Fees for the initial annual subscription were not paid by Customer at the time of Equipment purchase, Seller shall invoice Customer upon activation of Customer’s account by Customer and initiation of the Data Services. All invoices for Fees must be paid by Customer within thirty (30) days of receipt. Customer shall pay all sales, use, value added, withholding, excise taxes and other tax, duty, custom and similar fees levied upon the delivery or use of the Data Services. Payments are non-refundable and shall be made without right of set-off or chargeback. If Customer does not pay the invoices when due, Seller may charge interest at one percent (1%) per month on the unpaid balance. If Customer fails to pay Fees in accordance with this Section, Seller may, at its option, terminate or suspend fulfilling its obligations under these Terms until such payment is received by Seller.\n</p><p><strong>7. Term and Termination of Data Service:</strong><br>\n(a) The term of Data Service is determined on a unit-by-unit basis. Each unit of Equipment for which the Customer desires Data Service must be listed on a Data Service Order accepted by Seller.\n<br>(b) For each unit of Equipment within a Data Service Order, the term of Data Service commences upon Activation.<br>\nc) The term of Data Service for each asset is one (1) year and shall automatically renew from month to month until and unless either party gives notice to the other, at least ten (10) days prior to the end of a term, of intention not to renew. Data Service fees begin with the month of Activation and end with the month in, or at the end, of which deactivation occurs, without proration. Unless otherwise agreed to by Seller in writing, renewal terms may be adjusted by Seller upon fifteen (15) days written notice to Customer prior to the end of the previous term. In the event Data Service for any unit is terminated by Customer prior to completion of the initial one (1) year term, access to such Data Service shall be terminated at the effective time of such termination and Customer shall not be entitled to any refund of Data Service fees already paid.\n<br>\n(d) Data Service may be suspended immediately as to all of Customer’s units upon notice if the Customer is in material breach of 4(b), items (i), (ii) or (iii) or 4(c) of these Terms. Once Data Service has been suspended, such Data Service may be reactivated only upon receipt by Seller of all outstanding undisputed then owing (together with accrued interest thereon as applicable) together with payment of the then current reactivation fee for each unit of Equipment being reactivated. In addition, either Party may terminate this Agreement as to all, but not less than all, units, if the other Party is in breach of any material term of this Agreement and fails to cure such breach within 30 days after written notice thereof. Customer may terminate any Data Service Order hereunder within twenty (20) days following any material revision by Seller of the privacy policies referenced in Sections 4(c). or 4(d). of these Terms, if such revision is materially inconsistent with Customer’s then existing privacy policy. Upon termination of this Agreement for breach, (a) all rights granted to Customer under any Data Service Order will immediately terminate and Customer shall cease to use the Data Service and all intellectual property of Seller; and (b) Customer will pay any outstanding amounts owed to Seller. Upon proper termination by Customer based on Seller’s revision of its privacy policies, Seller will refund the unearned portion of the service fees paid. Termination for any other reason shall not excuse Customer obligation to pay any and all amounts due. Notwithstanding the foregoing, the terms of this Agreement will apply to continued use of the Data Service by Customer following the termination or expiration of any Data Service Order.\n<br></p><p><strong>8. Disclaimer of Warranties:</strong>\n SELLER MAKES NO WARRANTY WHATSOEVER, EITHER EXPRESS OR IMPLIED, WITH RESPECT TO THE DATA SERVCE AND SELLER DISCLAIMS ALL WARRANTIES INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR AGAINST CLAIMS OF PATENT INFRINGEMENT OR THE LIKE AND ACCESS TO THE SELLER G2E WEBSITES ARE PROVIDED \"AS IS.\" SELLER MAKES NO REPRESENTATIONS OR WARRANTIES THAT THE OPERATIONS OF THE DATA SERVICE WILL BE UNINTERRUPTED OR ERROR FREE AND SELLER MAKES NO WARRANTY THAT THE DATA SERVICE WILL OPERATE PROPERLY AS INTEGRATED WITH CUSTOMER’S SYSTEMS AND APPLICATIONS. CUSTOMER ACKNOWLEDGES THAT TEMPORARY INTERRUPTIONS OF THE DATA SERVICES AVAILABLE THROUGH THE SELLER WEBSITES OR OTHERWISE TO CUSTOMER MAY OCCUR AS NORMAL EVENTS.\n</p><p><strong>9. Confidentiality:</strong><br>\n(a) \"Confidential Information\" means all documents, software, reports, data, records, forms and other materials obtained by one party (the \"Receiving Party\") from the other party (the \"Disclosing Party\") or at the request or direction of the Disclosing Party in the course of performing or proposing the Data Services: (i) that have been marked as confidential; (ii) whose confidential nature has been made known by the Disclosing Party to the Receiving Party; or (iii) that due to their character and nature, a reasonable person under like circumstances would treat as confidential including, but not limited to, non-public information regarding a Disclosing Party’s products, features, marketing and promotions, as well as the terms of this Agreement and any pricing provided by Seller other than Seller’s published list prices. Notwithstanding the foregoing, Confidential Information does not include information which: (1) is already known to the Receiving Party at the time of disclosure by the Disclosing Party; (2) is or becomes publicly known through no wrongful act of the Receiving Party; (3) is independently developed by the Receiving Party without benefit of the Disclosing Party’s Confidential Information; (4)) is received by the Receiving Party from a third party without restriction and without a breach of an obligation of confidentiality.\n<br>\n(b) The Receiving Party will deliver to the Disclosing Party or destroy all Confidential Information of the Disclosing Party and all copies thereof when the Disclosing Party requests the same, except for copies retained in work paper files or records, anything that may be stored in back up media or other electronic data storage systems, latent data and metadata. Except as otherwise set forth in this section, the Receiving Party shall not disclose to any Person any Confidential Information of the Disclosing Party without the Disclosing Party’s express, prior written permission; provided, that notwithstanding the foregoing, the Receiving Party may disclose Confidential Information to the extent that it is required or necessary to perform the Data Services, or be disclosed pursuant to a statutory or regulatory provision or court or administrative order or to submit and process an insurance claim.\n<br>\n(c) The Receiving Party may disclose the Disclosing Party’s Confidential Information to its employees, contractors, consultants, advisors (collectively, \"Representatives\") subject to the confidentiality obligations imposed herein. Each party shall exercise the same level of care to protect the other’s information as it exercises to protect its own confidential information but in no event less than reasonable care. In the event of an actual or anticipated unauthorized disclosure, the Receiving Party will immediately notify the disclosing Party upon discovery of any such unauthorized use or disclosure and will cooperate in any reasonable way to help the other Party regain possession of the Confidential Information and prevent further unauthorized use or disclosure.\n<br>\n(d) If the Receiving Party receives a subpoena or other validly issued administrative or judicial demand requiring it to disclose the Disclosing Party’s Confidential Information, the Receiving Party shall, unless prohibited by law, provide prompt written notice to the Disclosing Party of such demand in order to permit it to seek a protective order. So long as the Receiving Party gives notice as provided herein, the Receiving Party shall be entitled to comply with such demand to the extent required by law, subject to any protective order or the like that may have been entered in the matter. In the event the Receiving Party is requested to testify or produce its documents relating to the Services hereunder pursuant to subpoena or other legal process in judicial or administrative proceedings to which it is not a party, or in connection with an informal inquiry or investigation with the consent of the Disclosing Party, the Disclosing Party shall reimburse the Receiving Party for its time and expenses, including reasonable attorney’s fees, time and expense, incurred in responding to such requests.\n<br></p><p><strong>10. Intellectual Property:</strong><br>\n(a) The Data Services, including but not limited to all materials, any computer software (in object code and source code form), data or information employed by Seller pursuant to these Terms, and any know-how, methodologies, equipment, or processes used by Seller to provide the Data Services, including without limitation all patent, copyright, trade secret and any other proprietary rights therein and any other deliverables provided by it hereunder, are and shall remain the sole and exclusive property of Seller. Nothing in these Terms grants Customer any rights in and to any such intellectual property rights except for the limited rights expressly granted herein. Customer will not reverse engineer, decompile, or disassemble the Data Service, except and only to the extent that such activity is expressly permitted by applicable law notwithstanding this limitation. Any feedback, suggestions, ideas or other inputs that Customer provides Seller in connection with the Data Services may be freely used by Seller to improve or enhance Seller’s products and services and, accordingly, all rights to such improvements and/or enhancements, howsoever arising, including as a result of any ideas, inputs or information provided by Customer as aforesaid, shall vest solely with Seller.\n<br>\n(b) Seller acknowledges and agrees that, as between Customer and Seller, Customer owns all rights, title and interest in the Customer Data. Notwithstanding the foregoing, Seller is entitled to use Customer Data for the purpose of providing the Data Services, providing Customer support, and for analyzing and improving the Data Services and the Grind2Energy System.\n<br></p><p><strong>11. No License or Warranties:</strong>\n Except as set forth in this Agreement, no license to the receiving party under any trade secrets or patents is granted or implied by conveying Proprietary Information or other information to such party, and none of the information transmitted or exchanged shall constitute any representation, warranty, assurance, guaranty or inducement with respect to the infringement of patents or other rights of others. In addition, the disclosure of Proprietary Information by the disclosing party shall not constitute or include any representation or warranty as to the accuracy or completeness of such information.\n</p><p><strong>12. Indemnity:</strong>\n Customer shall indemnify and save Seller harmless from and against losses, damages, liabilities, fines, penalties, and expenses (including reasonable attorneys\' fees) that arise out any third party claim alleging that the manner of using the Data Services not in accordance with these Terms, or through combining or integrating the Data Services with non-Seller products or services infringes its patent, copyright or trademark, including, but not limited to, improper, false, and/or invalid patent, trademark, and/or copyright markings, misappropriation of trade secrets or other rights occasioned thereby.\n</p><p><strong>13. Disclaimers:</strong><br>\n(a) CUSTOMER UNDERSTANDS THAT ITS USE OF THE DATA SERVICE ALLOWS USERS TO SEND COMMANDS TO MECHANICAL DEVICES BELONGING TO OR UNDER THE CONTROL OF CUSTOMER. CONSISTENT WITH AND/OR IN ADDITION TO THE LIMITATIONS AND DISCLAIMERS IN THIS SECTION AND SECTION 7, SELLER SHALL NOT BE LIABLE FOR THE MISUSE OR IMPROPER USE OF THE DATA SERVICE, FOR MISTAKES MADE BY OR ERRORS IN THE USE OF THE DATA SERVICE BY THE CUSTOMER’S USERS, OR FOR CONTROL COMMANDS WHICH ARE LOST, NOT DELIVERABLE, OR INAPPROPRIATE FOR ANY REASON, INCLUDING SAFETY ISSUES. CUSTOMER ACKNOWLEDGES THAT IT IS CUSTOMER’S RESPONSIBILITY, AND NOT SELLER’S, TO INSURE ITS ASSETS AND EQUIPMENT AGAINST LOSS OR DAMAGE, INCLUDING LOSS OR DAMAGE RESULTING FROM FAILURES, ERRORS, OR OTHER PROBLEMS WITH THE DATA SERVICE.\n<br>\n(b) SELLER SHALL NOT BE HELD LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, PUNITIVE OR OTHER SIMILAR DAMAGES, AS WELL AS LOSS OF PROFITS, LOSS OF SERVICE, BUSINESS INTERRUPTION, LOSS OF OR INCORRECT BUSINESS INFORMATION/DATA AND THE LIKE SUFFERED OR INCURRED BY CUSTOMER IN CONNECTION WITH THE PERFORMANCE OR NON-PERFORMANCE OF ANY FUNCTIONALITY OR DATA SERVICES TO BE PROVIDED HEREUNDER.\n<br>\n(c) CUSTOMER\'S SOLE AND EXCLUSIVE REMEDY AND SELLER\'S ENTIRE LIABILITY, IF ANY, FOR ANY CLAIMS ARISING OUT OF THESE TERMS, FUNCTIONALITY OR DATA SERVICE TO BE PROVIDED HEREUNDER OR CUSTOMER\'S USE OF THE SELLER WEBSITES OR A SELLER DATA FEED OR DATA SERVICE SHALL BE LIMITED TO THE AMOUNT THAT CUSTOMER PAID SELLER PURSUANT TO THE AGREEMENT FOR THE DATA SERVICE PER UNIT AFFECTED BY THE ACT OR OMISSION GIVING RISE TO SUCH LIABILITY, DURING THE TWELVE (12) MONTH PERIOD BEFORE THE ACT OR OMISSION GIVING RISE TO SUCH LIABILITY. THESE LIMITATIONS OF REMEDY ARE A MATERIAL PART OF THE ECONOMIC BARGAIN OF THE PARTIES AND WILL APPLY EVEN IF ANY REMEDY FAILS OF ITS ESSENTIAL PURPOSE.\n<br></p><p><strong>14. Governing Law:</strong>\n These Terms shall be governed by the Laws of the State of Michigan, without reference to the principles of conflicts of law.\n</p><p><strong>15. No Third Party Beneficiaries:</strong>\n These Terms are intended to be and are solely for the benefit of Seller and Customer and do not create any right in favor of any third party.\n</p><p><strong>16. Assignment:</strong>\n These Terms may not be assigned by Customer by operation of law or otherwise, without the prior written consent of Seller.\n</p><p><strong>17. Updates:</strong>\n Seller may make changes to these Terms and the other terms referenced herein and located at a designate URL (collectively, the \"URL Terms\") from time to time. Seller will post the amended terms and will update the \"Last Updated Date\" at the top. By continuing to access or use the Data Services after Seller has provided Customer with such notice of a change, Customer is indicating that it agrees to be bound by the modified terms.\n</p><p><strong>18. Dispute Resolution:</strong>\n Disputes arising between Seller and Buyer, including any disputes arising under or relating to these Terms and Conditions, shall be adjudicated exclusively in the U.S. District Court for the Western District of Michigan or, if there is no federal jurisdiction, in a state court sitting in Berrien County, Michigan. Buyer shall pay all reasonable costs and expenses incurred by Seller in connection with the enforcement of these Terms and Conditions, including all reasonable attorneys\' fees, court costs, and expenses.\n</p><p>[END OF DATA SERVICE TERMS]</p></div><md-checkbox aria-label=\"Accept\" ng-model=\"vm.isAccept\" \nng-if=\"vm.showAccept\">I accept these terms of use and conditions</md-checkbox></md-content><div \nclass=\"terms-conditions-buttons\"><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Next\" \nng-disabled=\"termsConditionsForm.$invalid || termsConditionsForm.$pristine || !vm.isAccept || vm.isWorking\" \nng-click=\"vm.submit()\" ng-if=\"vm.showAccept\">Next</md-button></div></form></md-content></div></div>");
$templateCache.put("app/main/unsupported-browser/unsupported-browser.html","<div id=\"unsupported-browser\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"unsupported-browser-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"unsupported-browser-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo\"><img src=\"assets/images/logos/g2e.png\"></div><div class=\"title\">\nUnsupported Browser</div><form name=\"unsupportedBrowserForm\" novalidate><div class=\"message\"><p>\nYour browser is currently not supported and may limit this application\'s performance.</p><p>\nGrind2Energy supports the latest versions of desktop Google Chrome and Mozilla Firefox</p></div><div class=\"buttons\">\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Access Application\" \nng-click=\"vm.submit()\">Access Application</md-button></div></form></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img src=\"assets/images/logos/g2e.png\"></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\" \nng-show=\"!vm.msg\">Recover your password</div><div class=\"title\" ng-show=\"vm.msg\">{{vm.msg}}</div><form \nname=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || vm.isWorking\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" \nng-click=\"vm.submit()\">SEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\">\n<a class=\"link\" ui-sref=\"app.auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div>\n</div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"assets/images/logos/g2e.png\"></div><div class=\"title\" translate=\"LOGIN.TITLE\" ng-show=\"!vm.msg\">\nLog in to your account</div><div class=\"title\" ng-show=\"vm.msg\">{{vm.msg}}</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Username must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"vm.form.rememberMe\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">\nRemember Me</span></md-checkbox><a ui-sref=\"app.auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || vm.isLogin\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.submit()\">LOG IN</md-button></form>\n</div></div></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\">\n<img src=\"assets/images/logos/g2e.png\"></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\" ng-show=\"!vm.msg\">\nReset your password</div><div class=\"title\" ng-show=\"vm.msg\">{{vm.msg}}</div><form name=\"resetPasswordForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" \nng-change=\"vm.checkPasswordConfirm()\" ng-disabled=\"!vm.resetToken || vm.isResetDone\" required><div \nng-messages=\"resetPasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" ng-change=\"vm.checkPasswordConfirm()\" \nng-disabled=\"!vm.resetToken || vm.isResetDone\" required><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"UPDATE MY PASSWORD\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine || !vm.resetToken || vm.form.password != vm.form.passwordConfirm || vm.isWorking\" \nng-show=\"!vm.isResetDone\" translate=\"RESETPASSWORD.UPDATE_PASSWORD\" \ntranslate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\" ng-click=\"vm.submit()\">RESET MY PASSWORD</md-button></form>\n<div class=\"login\" layout=\"row\" layout-align=\"center center\" ng-show=\"vm.isResetDone\"><a class=\"link\" \nui-sref=\"app.auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/dashboard/company/company-dialog-add.tmpl.html","<md-dialog aria-label=\"Add/Edit User\" ng-cloak flex=\"50\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>{{vm.mode==\'add\'?\'Add Company\':\'Edit Company\'}}</h1><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"h2\">Company Information</div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Company Name <span>*</span></label><input \nname=\"companyName\" ng-model=\"vm.companyData.name\" required><div ng-messages=\"saveForm.companyName.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Corporate Contact Name</label><input name=\"contactName\" \nng-model=\"vm.companyData.contactName\"></md-input-container><md-input-container class=\"md-block\" flex><label \nclass=\"g2e-required-label\">Corporate Contact Title</label><input name=\"contactTitle\" \nng-model=\"vm.companyData.contactTitle\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Phone #</label><input name=\"contactPhone\" ng-model=\"vm.companyData.contactPhone\" \nui-mask=\"(999) 999-9999\" model-view-value=\"true\" ui-options=\"{addDefaultPlaceholder:false}\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Email</label><input type=\"email\" name=\"contactEmail\" \nng-model=\"vm.companyData.contactEmail\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"saveForm.contactEmail.$error\"><div \nng-message-exp=\"[\'pattern\']\">Please enter a valid Email address.</div></div></md-input-container></div><div \nlayout=\"row\" layout-align=\"left center\" ng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span>{{vm.msg}}</span></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"border-top\"><md-button class=\"md-raised md-background-fg md-grey-700-bg\" \nng-click=\"vm.deactivateCompany($event)\" ng-show=\"vm.mode==\'edit\'\" ng-disabled=\"vm.isSaving\">\n{{vm.companyData.isActive===true?\'Deactivate Company\':\'Activate Company\'}}</md-button><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deleteCompany($event)\" \nng-show=\"vm.mode==\'edit\' && vm.companyData.isActive!==true\" ng-disabled=\"vm.isSaving\">Delete Company</md-button><span \nflex></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.updateCompany()\" \nng-disabled=\"saveForm.$invalid || vm.isSaving || (vm.mode==\'edit\' && vm.companyData.isActive!==true)\">Save</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/company/company-dialog.tmpl.html","<md-dialog class=\"fullscreen-anyway\" aria-label=\"Companies\" ng-cloak><form name=\"companyForm\"><md-toolbar \nclass=\"md-background-bg border-bottom\"><div class=\"md-toolbar-tools\"><h1>Companies</h1><span flex></span><md-button \nclass=\"pl-24 md-icon-button\" aria-label=\"Close\" ng-click=\"vm.close()\"><img src=\"/assets/images/icons/btn-close.png\">\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.openAddDlg($event,\'add\')\" \nng-disabled=\"vm.isLoading || !vm.currentUser.hasAdminRole()\">Add Company</md-button></div><div layout=\"row\" \nng-show=\"vm.isLoading\" layout-align=\"center center\"><md-progress-circular id=\"toolbar-progress\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span>Loading...</span></div><div layout=\"row\" \nng-show=\"!vm.isLoading\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.companiesTable.dtOptions\"><thead><tr><th class=\"secondary-text\" \nng-repeat=\"column in vm.companiesTable.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in vm.companiesTable.rows\"><td ng-repeat=\"cell in row.cells\">\n<a href=\"#\" class=\"{{cell.classes}}\" ng-if=\"cell.isEditLink\" ng-click=\"vm.openAddDlg($event,\'edit\', row.id)\">\n{{cell.value}} </a><span class=\"{{cell.classes}}\" ng-if=\"!cell.isEditLink\">{{cell.value}}</span></td></tr></tbody>\n</table></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dashboard/custom-confirm/custom-confirm.tmpl.html","<md-dialog aria-label=\"Confirm\" ng-cloak><form name=\"userForm\"><md-toolbar class=\"md-background-bg\"><div \nclass=\"md-toolbar-tools\"><h1>{{vm.title}}</h1><span flex></span><md-button class=\"md-icon-button\" aria-label=\"Close\" \nng-click=\"vm.cancel()\"><img src=\"/assets/images/icons/btn-close.png\"></md-button></div></md-toolbar><md-dialog-content>\n<div layout=\"row\">{{vm.message}}</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.ok()\">{{vm.okButton}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.cancel()\" md-autofocus>{{vm.cancelButton}}</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/dashboard/customer/customer-dialog.tmpl.html","<md-dialog id=\"customerDialog\" aria-label=\"Edit Customer\" ng-cloak flex=\"80\"><form name=\"customerForm\"><md-toolbar><div\n class=\"md-toolbar-tools\"><h2>Add/Edit Customer</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nng-show=\"vm.isLoading\" layout-align=\"center center\" class=\"p-60\"><md-progress-circular id=\"toolbar-progress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span>Loading...</span></div><div \nlayout=\"row\" ng-show=\"!vm.isLoading\"><div flex=\"50\" class=\"pr-24 border-right\"><div class=\"h2 pb-16\">\nCustomer Information</div><div layout=\"row\"><md-autocomplete flex required=\"true\" md-input-name=\"company\" \nmd-min-length=\"0\" md-no-cache=\"vm.noCache\" md-selected-item-change=\"vm.selectedCompanyChange(item)\" \nmd-selected-item=\"vm.selectedCompany\" md-search-text=\"vm.searchCompany\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchCompany)\" md-items=\"item in vm.queryCompany(vm.searchCompany)\" \nmd-item-text=\"item.name\" md-floating-label=\"Company\"><label class=\"g2e-required-label\">Company <span>*</span></label>\n<md-item-template><span md-highlight-text=\"vm.searchCompany\" md-highlight-flags=\"^i\">{{item.name}}</span>\n</md-item-template><md-not-found>No matching...</md-not-found><div class=\"dp-messages\" \nng-if=\"!vm.selectedCompany && customerForm.company.$touched\">No company matching.</div></md-autocomplete>\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Installation Name <span>*</span></label>\n<input required name=\"name\" ng-model=\"vm.selectedInstallation.Customer.name\"><div \nng-messages=\"customerForm.name.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n</div><md-input-container class=\"md-block\"><label class=\"g2e-required-label\">Street Address <span>*</span></label>\n<input required name=\"address\" ng-model=\"vm.selectedInstallation.Customer.address\"><div \nng-messages=\"customerForm.address.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">City <span>*</span>\n</label><input required name=\"city\" ng-model=\"vm.selectedInstallation.Customer.city\"><div \nng-messages=\"customerForm.city.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">State(Region) <span>*</span></label>\n<md-select name=\"state\" ng-model=\"vm.selectedInstallation.Customer.state\" required><md-option \nng-repeat=\"state in vm.States\" value=\"{{state.name}}\">{{state.abbrev + \' - \' + state.name}}</md-option></md-select><div\n ng-messages=\"customerForm.state.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">ZIP <span>*</span></label><input required \nname=\"zipCode\" ng-model=\"vm.selectedInstallation.Customer.zipcode\" ng-pattern=\"/^[0-9]{5}$/\"><div \nng-messages=\"customerForm.zipCode.$error\"><div ng-message=\"required\">This is required.</div><div ng-message=\"pattern\" \nclass=\"my-message\">Please enter a valid Zip Code.</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Latitude <span>*</span></label><input \ntype=\"number\" required name=\"lat\" ng-model=\"vm.selectedInstallation.Customer.lat\"><div \nng-messages=\"customerForm.lat.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Longitude <span>*</span></label><input \ntype=\"number\" required name=\"lng\" ng-model=\"vm.selectedInstallation.Customer.lng\"><div \nng-messages=\"customerForm.lng.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><a href=\"\" ng-click=\"vm.geocode()\">Get from address</a></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Timezone <span>*\n</span></label><md-select name=\"timezone\" ng-model=\"vm.selectedInstallation.Customer.timezone\" required><md-option \nng-repeat=\"one in vm.Timezones\" value=\"{{one.timezone}}\">{{one.timezoneFull}}</md-option></md-select><div \nng-messages=\"customerForm.timezone.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Site Contact Name</label>\n<input name=\"contactName\" ng-model=\"vm.selectedInstallation.Customer.contact.name\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Site Contact Title</label><input name=\"contactTitle\" \nng-model=\"vm.selectedInstallation.Customer.contact.title\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Site Contact Phone #1</label><input name=\"phone1\" \nng-model=\"vm.selectedInstallation.Customer.contact.phone1\" ui-mask=\"(999) 999-9999\" model-view-value=\"true\" \nui-options=\"{addDefaultPlaceholder:false}\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nSite Contact Phone #2</label><input name=\"phone2\" ng-model=\"vm.selectedInstallation.Customer.contact.phone2\" \nui-mask=\"(999) 999-9999\" model-view-value=\"true\" ui-options=\"{addDefaultPlaceholder:false}\"></md-input-container></div>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label>Site Contact Email</label><input type=\"email\" \nname=\"contactEmail\" ng-model=\"vm.selectedInstallation.Customer.contact.email\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"customerForm.contactEmail.$error\"><div ng-message-exp=\"[\'pattern\']\">Please enter a valid Email address.\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\" ng-show=\"vm.mode==\'edit\'\"><label>\nCustomer Status</label><input name=\"customerStatus\" readonly=\"readonly\" \nvalue=\"{{(vm.selectedInstallation.isActive)?\'ACTIVE\':\'INACTIVE\'}}\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block g2e-input-has-left-icon\" flex><label class=\"g2e-required-label\">\nContract Price per Pay Period <span>*</span></label><md-icon class=\"icon icon-currency-usd\"></md-icon><input required \ntype=\"number\" name=\"contractPrice\" ng-model=\"vm.selectedInstallation.Customer.pricePerPayPeriod.value\" \nng-change=\"vm.calculateAnnualRevenue();\" required min=\"0\"><div ng-messages=\"customerForm.contractPrice.$error\" \nmultiple=\"multiple\"><div ng-message=\"required\">This is required.</div><div ng-message=\"min\">Equal or greater than 0\n</div></div></md-input-container><md-input-container class=\"md-block g2e-input-has-right-unit\" flex><label \nclass=\"g2e-required-label\">Payment Period Is Every <span>*</span></label><input required type=\"number\" \nname=\"paymentPeriod\" ng-model=\"vm.selectedInstallation.Customer.paymentPeriodInterval.value\" \nng-change=\"vm.calculatePaymentsPerYear();vm.calculateAnnualRevenue();\" required min=\"1\"><div \nng-messages=\"customerForm.paymentPeriod.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.</div>\n<div ng-message=\"min\">Should be greater than 0</div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label></label><md-select name=\"paymentPeriodUnit\" aria-label=\"paymentPeriodUnit\" \nng-model=\"vm.selectedInstallation.Customer.paymentPeriodInterval.units\" \nng-change=\"vm.calculatePaymentsPerYear();vm.calculateAnnualRevenue();\" required><md-option \nng-repeat=\"unit in vm.PaymentPeriodUnits\" value=\"{{unit}}\">{{unit}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Payments per Year</label><input type=\"number\" \nname=\"paymentsPerYear\" readonly=\"readonly\" ng-model=\"vm.selectedInstallation.Customer.paymentsPerYear\">\n</md-input-container><md-input-container class=\"md-block g2e-input-has-left-icon\" flex><label>Annual Revenue</label>\n<md-icon class=\"icon icon-currency-usd\"></md-icon><input type=\"number\" name=\"annualRevenue\" readonly=\"readonly\" \nng-model=\"vm.selectedInstallation.Customer.annualRevenue.value\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Contract Type <span>*</span></label><md-select \nname=\"contractType\" ng-model=\"vm.selectedInstallation.Customer.contractType\" required><md-option \nng-repeat=\"type in vm.ContractTypes\" value=\"{{type}}\">{{type}}</md-option></md-select><div \nng-messages=\"customerForm.contractType.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block g2e-input-has-left-icon\" flex><label \nclass=\"g2e-required-label\">Contract Credit/Surcharge for Hauls <span>*</span></label><md-icon \nclass=\"icon icon-currency-usd\"></md-icon><input required type=\"number\" name=\"haulingCost\" \nng-model=\"vm.selectedInstallation.Customer.haulingCost.value\" required min=\"0\"><div \nng-messages=\"customerForm.haulingCost.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.</div>\n<div ng-message=\"min\">Equal or greater than 0</div></div></md-input-container><md-input-container \nclass=\"md-block g2e-input-has-left-icon\" flex><label class=\"g2e-required-label\">Contract Est. Annual Service Cost \n<span>*</span></label><md-icon class=\"icon icon-currency-usd\"></md-icon><input required type=\"number\" \nname=\"serviceCost\" ng-model=\"vm.selectedInstallation.Customer.allocatedServiceCost.value\" required min=\"0\"><div \nng-messages=\"customerForm.serviceCost.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.</div>\n<div ng-message=\"min\">Equal or greater than 0</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\" style=\"font-size:12px\">\nContract Est. Annual Max Number of Hauls <span>*</span></label><input type=\"number\" name=\"contractedMaxHauls\" \nng-model=\"vm.selectedInstallation.Customer.maxHaulsAnnual\" required min=\"0\"><div \nng-messages=\"customerForm.contractedMaxHauls.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.\n</div><div ng-message=\"min\">Equal or greater than 0</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\" style=\"font-size:12px\">Contract Est. Annual Min Number of Hauls\n</label><input type=\"number\" name=\"contractedMinHauls\" ng-model=\"vm.selectedInstallation.Customer.minHaulsAnnual\" \nmin=\"0\"><div ng-messages=\"customerForm.contractedMinHauls.$error\" multiple=\"multiple\"><div ng-message=\"min\">\nEqual or greater than 0</div></div></md-input-container><md-input-container class=\"md-block\" flex><label \nclass=\"g2e-required-label\" style=\"font-size:12px\">Contract Est. Waste Processed (tons/week) <span>*</span></label>\n<input type=\"number\" name=\"contractWasteProductionEstimate\" \nng-model=\"vm.selectedInstallation.Tank.contractWasteProductionEstimate.value\" required min=\"0\"><div \nng-messages=\"customerForm.contractWasteProductionEstimate.$error\" multiple=\"multiple\"><div ng-message=\"required\">\nThis is required.</div><div ng-message=\"min\">Equal or greater than 0</div></div></md-input-container></div></div><div \nflex=\"50\" class=\"pl-24\"><div class=\"h2 pb-16\">Set-up Information</div><div layout=\"row\"><div class=\"md-block\" flex>\n<label class=\"dp-floating-label g2e-required-label\">Contract Start Date <span>*</span></label><md-datepicker \nname=\"installDate\" ng-model=\"vm.customerFormInstallDate\" ng-change=\"vm.calculateRenewalDate();\"></md-datepicker><div \nclass=\"dp-messages\" ng-if=\"customerForm.installDate.$touched && !vm.customerFormInstallDate\">This is required.</div>\n</div><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Contract Length(Months) <span>*\n</span></label><input type=\"number\" name=\"contractLength\" ng-model=\"vm.selectedInstallation.Tank.contractLength.value\" \nng-change=\"vm.calculateRenewalDate();\" required min=\"1\"><div ng-messages=\"customerForm.contractLength.$error\" \nmultiple=\"multiple\"><div ng-message=\"required\">This is required.</div><div ng-message=\"min\">Should be greater than 0\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">\nExpected Renewal Date <span>*</span></label><input name=\"expectedRenewalDate\" \nng-model=\"vm.customerFormExpectedRenewalDate\" readonly=\"readonly\"></md-input-container></div><div layout=\"row\" \nclass=\"pb-32\"><div class=\"md-block\" flex><label class=\"dp-floating-label g2e-required-label\">IoT Activation Date <span>\n*</span></label><md-datepicker name=\"iotActivationDate\" ng-model=\"vm.customerFormIotActivationDate\"></md-datepicker>\n<div class=\"dp-messages\" ng-if=\"customerForm.iotActivationDate.$touched && !vm.customerFormIotActivationDate\">\nThis is required.</div></div><div class=\"md-block\" flex><label class=\"dp-floating-label\">Client Since</label>\n<md-datepicker name=\"clientSinceDate\" ng-model=\"vm.customerFormClientSinceDate\"></md-datepicker></div>\n<md-input-container class=\"md-block\" flex></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Nominal Tank Volume (gallons) <span>*</span></label><input \ntype=\"number\" name=\"normalTankVolume\" ng-model=\"vm.selectedInstallation.Tank.nominalVolume.value\" required min=\"1\"><div\n ng-messages=\"customerForm.normalTankVolume.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.\n</div><div ng-message=\"min\">Should be greater than 0</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Useful Tank Volume (gallons) <span>*</span></label><input \ntype=\"number\" name=\"usefulTankVolume\" ng-model=\"vm.selectedInstallation.Tank.usefulVolume.value\" required min=\"1\"><div \nng-messages=\"customerForm.normalTankVolume.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.\n</div><div ng-message=\"min\">Should be greater than 0</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex ng-show=\"!vm.selectedInstallation.Tank.isAutoHighThreshold\"><label \nclass=\"g2e-required-label\">Tank High Threshold (%) <span>*</span></label><input type=\"number\" name=\"tankHighThreshold\" \nng-model=\"vm.selectedInstallation.Tank.highThreshold.value\" required min=\"0\" max=\"100\"><div \nng-messages=\"customerForm.tankHighThreshold.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.\n</div><div ng-message=\"min\">Should be equal or greater than 0</div><div ng-message=\"max\">\nShould be equal or less than 100</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-show=\"vm.selectedInstallation.Tank.isAutoHighThreshold\"><label class=\"g2e-required-label\">Tank High Threshold (%) \n<span>*</span></label><input type=\"number\" name=\"tankHighThresholdAutoReadOnly\" \nng-model=\"vm.highThresholdAutoReadOnly\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container><md-switch \nng-model=\"vm.selectedInstallation.Tank.isAutoHighThreshold\" flex ng-change=\"vm.onChangeIsAutoHighThreshold()\">\n{{vm.selectedInstallation.Tank.isAutoHighThreshold?\'Auto\':\'Manual\'}}</md-switch><md-input-container class=\"md-block\" \nflex ng-show=\"!vm.selectedInstallation.Tank.isAutoCriticalThreshold\"><label class=\"g2e-required-label\">\nTank Critical Threshold (%) <span>*</span></label><input type=\"number\" name=\"tankCriticalThreshold\" \nng-model=\"vm.selectedInstallation.Tank.criticalThreshold.value\" required min=\"0\" max=\"100\"><div \nng-messages=\"customerForm.tankCriticalThreshold.$error\" multiple=\"multiple\"><div ng-message=\"required\">\nThis is required.</div><div ng-message=\"min\">Should be equal or greater than 0</div><div ng-message=\"max\">\nShould be equal or less than 100</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-show=\"vm.selectedInstallation.Tank.isAutoCriticalThreshold\"><label class=\"g2e-required-label\">\nTank Critical Threshold (%) <span>*</span></label><input type=\"number\" name=\"tankCriticalThresholdAutoReadOnly\" \nng-model=\"vm.criticalThresholdAutoReadOnly\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container><md-switch \nng-model=\"vm.selectedInstallation.Tank.isAutoCriticalThreshold\" flex ng-change=\"vm.onChangeIsAutoCriticalThreshold()\">\n{{vm.selectedInstallation.Tank.isAutoCriticalThreshold?\'Auto\':\'Manual\'}}</md-switch></div><div layout=\"row\" \nclass=\"pb-24\"><md-input-container class=\"md-block\" flex ng-show=\"!vm.selectedInstallation.Tank.isAutoConsiderSaturday\">\n<label class=\"g2e-required-label\">Consider Saturday for Pick-up <span>*</span></label><md-select \nname=\"considerSaturday\" ng-model=\"vm.selectedInstallation.Tank.considerSaturday\" required><md-option value=\"true\">Yes\n</md-option><md-option value=\"false\">No</md-option></md-select><div ng-messages=\"customerForm.considerSaturday.$error\">\n<div ng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-show=\"vm.selectedInstallation.Tank.isAutoConsiderSaturday\"><label class=\"g2e-required-label\">\nConsider Saturday for Pick-up <span>*</span></label><md-select name=\"considerSaturdayAutoReadOnly\" \nng-model=\"vm.considerSaturdayAutoReadOnly\" disabled=\"disabled\"><md-option value=\"true\">Yes</md-option><md-option \nvalue=\"false\">No</md-option></md-select></md-input-container><md-switch \nng-model=\"vm.selectedInstallation.Tank.isAutoConsiderSaturday\" flex ng-change=\"vm.onChangeIsAutoConsiderSaturday()\">\n{{vm.selectedInstallation.Tank.isAutoConsiderSaturday?\'Auto\':\'Manual\'}}</md-switch></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex ng-show=\"!vm.selectedInstallation.Tank.isAutoLeadTimeForSchedulingPickUp\">\n<label class=\"g2e-required-label\">Lead Time for Scheduling a Pick-up (days) <span>*</span></label><input type=\"number\" \nname=\"leadTimeForPickUp\" ng-model=\"vm.selectedInstallation.Tank.leadTimeForSchedulingPickUp\" required min=\"0\"><div \nng-messages=\"customerForm.leadTimeForPickUp.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.\n</div><div ng-message=\"min\">Equal or greater than 0</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex ng-show=\"vm.selectedInstallation.Tank.isAutoLeadTimeForSchedulingPickUp\"><label \nclass=\"g2e-required-label\">Lead Time for Scheduling a Pick-up (days) <span>*</span></label><input type=\"number\" \nname=\"leadTimeForPickUpAutoReadOnly\" ng-model=\"vm.leadTimeForSchedulingPickUpAutoReadOnly\" readonly=\"readonly\" \ndisabled=\"disabled\"></md-input-container><md-switch \nng-model=\"vm.selectedInstallation.Tank.isAutoLeadTimeForSchedulingPickUp\" flex \nng-change=\"vm.onChangeIsAutoLeadTimeForSchedulingPickUp()\">\n{{vm.selectedInstallation.Tank.isAutoLeadTimeForSchedulingPickUp?\'Auto\':\'Manual\'}}</md-switch></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Safety Window for Pick-up Trigger (days) \n<span>*</span></label><input type=\"number\" name=\"safetyWindowDays\" \nng-model=\"vm.selectedInstallation.Tank.safetyWindowDays\" required min=\"0\"><div \nng-messages=\"customerForm.safetyWindowDays.$error\" multiple=\"multiple\"><div ng-message=\"required\">This is required.\n</div><div ng-message=\"min\">Equal or greater than 0</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Expected Slurry Yield (gallons/ton) <span>*</span></label>\n<input type=\"number\" name=\"expectedSlurryYield\" ng-model=\"vm.selectedInstallation.Tank.expectedSlurryYield.value\" \nrequired min=\"1\"><div ng-messages=\"customerForm.expectedSlurryYield.$error\" multiple=\"multiple\"><div \nng-message=\"required\">This is required.</div><div ng-message=\"min\">Should be greater than 0</div></div>\n</md-input-container></div><div layout=\"row\" class=\"pb-24\"><md-input-container class=\"md-block\" flex><label \nclass=\"g2e-required-label\">Indoor/Outdoor Tank <span>*</span></label><md-select name=\"indoorOutdoorTank\" \nng-model=\"vm.selectedInstallation.Tank.tankLocation\" required><md-option ng-repeat=\"in_out in vm.IndoorOutdoors\" \nvalue=\"{{in_out}}\">{{in_out}}</md-option></md-select><div ng-messages=\"customerForm.indoorOutdoorTank.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label class=\"g2e-required-label\">Frost Protection <span>*</span></label><md-select name=\"frostProtection\" \nng-model=\"vm.selectedInstallation.Tank.frostProtection\" required><md-option ng-repeat=\"fp in vm.FrostProtection\" \nvalue=\"{{fp.value}}\">{{fp.label}}</md-option></md-select><div ng-messages=\"customerForm.frostProtection.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"50\"><label class=\"g2e-required-label\">System Voltage <span>*</span></label><md-select \nname=\"systemVoltage\" ng-model=\"vm.selectedInstallation.Tank.systemVoltage\" required><md-option \nng-repeat=\"voltage in vm.SystemVoltages\" value=\"{{voltage}}\">{{voltage}}</md-option></md-select><div \nng-messages=\"customerForm.systemVoltage.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>SIM card handle</label><input \nname=\"simCardHandle\" ng-model=\"vm.selectedInstallation.simCardHandle\" readonly=\"readonly\"></md-input-container></div>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label class=\"g2e-required-label\">Serial Number <span>\n*</span></label><input name=\"serialNumber\" ng-model=\"vm.selectedInstallation.serialNumber\" required \nreadonly=\"readonly\"><div ng-messages=\"customerForm.serialNumber.$error\" multiple=\"multiple\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\" \nng-if=\"vm.mode==\'edit\'\"><label class=\"g2e-required-label\">Installation ID <span>*</span></label><input \nname=\"installationID\" ng-model=\"vm.selectedInstallation.id\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label>Installer Company Name</label><input \nname=\"installerName\" ng-model=\"vm.selectedInstallation.Tank.installerContact.name\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Installer Contact Name</label><input name=\"installerTitle\" \nng-model=\"vm.selectedInstallation.Tank.installerContact.title\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Installer Contact Phone #1</label><input name=\"tankPhone1\" \nng-model=\"vm.selectedInstallation.Tank.installerContact.phone1\" ui-mask=\"(999) 999-9999\" model-view-value=\"true\" \nui-options=\"{addDefaultPlaceholder:false}\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nInstaller Contact Phone #2</label><input name=\"tankPhone2\" \nng-model=\"vm.selectedInstallation.Tank.installerContact.phone2\" ui-mask=\"(999) 999-9999\" model-view-value=\"true\" \nui-options=\"{addDefaultPlaceholder:false}\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"50\"><label>Installer Contact Email</label><input type=\"email\" name=\"tankEmail\" \nng-model=\"vm.selectedInstallation.Tank.installerContact.email\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"customerForm.tankEmail.$error\"><div ng-message-exp=\"[\'pattern\']\">Please enter a valid Email address.</div>\n</div></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\">\n<md-button class=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deactivateInstallation($event)\" \nng-show=\"vm.mode==\'edit\'\" ng-disabled=\"vm.isSaving || vm.isLoading\">Deactivate</md-button><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deleteInstallation($event)\" ng-show=\"vm.mode==\'edit\'\" \nng-disabled=\"vm.isSaving || vm.isLoading\">Deactivate & Delete</md-button><span flex></span><div ng-if=\"vm.isSaving\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.updateInstallation()\" \nng-disabled=\"customerForm.$invalid || !vm.selectedCompany || !vm.customerFormInstallDate || !vm.customerFormIotActivationDate || vm.isSaving || vm.isLoading || (vm.mode==\'edit\' && vm.selectedInstallation.isActive!==true)\">\nUpdate</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/customer/graph-dialog.tmpl.html","<md-dialog class=\"graph-dialog\" aria-label=\"Selected Units Results Graph\" flex=\"80\"><md-toolbar \nclass=\"md-background-bg border-bottom\"><div class=\"md-toolbar-tools\"><h2>Selected Units Results Graph</h2><span flex>\n</span><md-button class=\"md-icon-button\" aria-label=\"Export\" ng-disabled=\"vm.isLoading\" ng-csv=\"vm.getCSVRows()\" \ncsv-header=\"vm.getCSVHeaders()\" filename=\"{{vm.getCSVFilename()}}\"><img src=\"/assets/images/icons/btn-export.png\">\n</md-button><md-button class=\"pl-24 md-icon-button\" aria-label=\"Close\" ng-click=\"vm.close()\"><img \nsrc=\"/assets/images/icons/btn-close.png\"></md-button></div></md-toolbar><md-dialog-content class=\"loading-overlay\" \nbs-loading-overlay=\"graph_loader\"><div layout=\"row\"><div layout=\"row\" flex=\"nogrow\"><div layout=\"column\"><div \nclass=\"search-box-head\">Metric</div><md-select ng-model=\"vm.search_metric\" aria-label=\"Rolling Period\" \nng-change=\"vm.onChangeMetric()\" ng-disabled=\"vm.isLoading\"><md-option ng-repeat=\"metric in vm.Metrics\" \nvalue=\"{{$index}}\">{{metric.text}}</md-option></md-select></div></div><div layout=\"row\" flex=\"nogrow\"><div \nlayout=\"column\"><div class=\"search-box-head\">Start Date</div><md-datepicker ng-model=\"vm.search_start_date\" \nmd-placeholder=\"\" md-max-date=\"vm.search_end_date\" ng-change=\"vm.onChangeDate()\" ng-disabled=\"vm.isLoading\">\n</md-datepicker></div><div layout=\"column\"><div class=\"search-box-head\">End Date</div><md-datepicker \nng-model=\"vm.search_end_date\" md-placeholder=\"\" md-min-date=\"vm.search_start_date\" ng-change=\"vm.onChangeDate()\" \nng-disabled=\"vm.isLoading\"></md-datepicker></div></div><div flex=\"\"></div><div layout=\"row\" flex=\"nogrow\"><div \nclass=\"groupX-container\"><section layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-background-fg groupX left\" ng-class=\"vm.status_by==\'ALL\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'ALL\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\">All</md-button><md-button \nclass=\"md-raised md-background-fg groupX middle\" \nng-class=\"vm.status_by==\'HOURS\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'HOURS\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\">Hours</md-button><md-button \nclass=\"md-raised md-background-fg groupX middle\" \nng-class=\"vm.status_by==\'DAYS\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'DAYS\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\">Days</md-button><md-button \nclass=\"md-raised md-background-fg groupX middle\" \nng-class=\"vm.status_by==\'WEEKS\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'WEEKS\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\">Weeks</md-button><md-button \nclass=\"md-raised md-background-fg groupX right\" \nng-class=\"vm.status_by==\'MONTHS\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'MONTHS\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\">Months</md-button></section></div>\n</div></div><div layout=\"row\" class=\"pb-32\"><nvd3 class=\"h-400 remove-opacity\" api=\"vm.chart.api\" \noptions=\"vm.chart.options\" data=\"vm.chart.data\"></nvd3></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/customer/log-dialog.tmpl.html","<md-dialog class=\"fullscreen-anyway loading-overlay\" aria-label=\"Logs\" ng-cloak bs-loading-overlay=\"log_loader\"><form \nname=\"userForm\"><md-toolbar class=\"md-background-bg border-bottom\"><div class=\"md-toolbar-tools\"><h1 class=\"pr-24\">Logs\n</h1><div layout=\"row\" layout-align=\"start end\" flex=\"nogrow\" style=\"margin-top:-4px\"><label class=\"h3 pl-24 pr-16\">\nDisplay logs between:</label><div class=\"search-box\"><div class=\"search-box-head\">Start Date</div><md-datepicker \nng-model=\"vm.search_start_date\" md-placeholder=\"\" md-max-date=\"vm.search_end_date\" ng-change=\"vm.onChangeDateRange()\" \nng-disabled=\"vm.isLoading\"></md-datepicker></div><div class=\"search-box\"><div class=\"search-box-head\">End Date</div>\n<md-datepicker ng-model=\"vm.search_end_date\" md-placeholder=\"\" md-min-date=\"vm.search_start_date\" \nng-change=\"vm.onChangeDateRange()\" ng-disabled=\"vm.isLoading\"></md-datepicker></div><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Clear\" ng-if=\"vm.search_start_date || vm.search_end_date\" \nng-click=\"vm.clearFilter()\" ng-disabled=\"vm.isLoading\"><md-icon md-font-icon=\"icon-close\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Search\" ng-class=\"{\'md-accent\':vm.filterChangedTimeHorizon}\" \nng-click=\"vm.filterLogs()\" ng-disabled=\"vm.isLoading\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>\n</md-button></div><div flex></div><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"vm.close()\"><img \nsrc=\"/assets/images/icons/btn-contract-view.png\"></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\">\n<div layout=\"row\" flex=\"nogrow\"><div class=\"groupX-container\"><section layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-background-fg groupX left\" \nng-class=\"vm.status_by==\'PICK_UP\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'PICK_UP\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\" ng-if=\"vm.tabs[\'PICK_UP\']\">Pick-ups\n</md-button><md-button class=\"md-raised md-background-fg groupX middle\" \nng-class=\"vm.status_by==\'TANK_LEVEL\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'TANK_LEVEL\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\" ng-if=\"vm.tabs[\'TANK_LEVEL\']\">\nTank Level Events</md-button><md-button class=\"md-raised md-background-fg groupX middle\" \nng-class=\"vm.status_by==\'SYSTEM_FAULT\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'SYSTEM_FAULT\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\" ng-if=\"vm.tabs[\'SYSTEM_FAULT\']\">\nSystem Faults</md-button><md-button class=\"md-raised md-background-fg groupX right\" \nng-class=\"vm.status_by==\'NON_CRITICAL\'?\'md-light-blue-900-bg\':\'md-grey-700-bg\'\" \nng-click=\"vm.status_by=\'NON_CRITICAL\';vm.onChangeStatus()\" ng-disabled=\"vm.isLoading\" ng-if=\"vm.tabs[\'NON_CRITICAL\']\">\nNon-critical Events</md-button></section></div></div><div flex=\"\"></div><div layout=\"row\"><label class=\"h5\">\nMax display: 100 of most recent logs of each installation</label></div></div><div ng-show=\"vm.status_by==\'PICK_UP\'\">\n<div layout=\"row\" class=\"pt-24 pl-24\"><div layout=\"row\"><label class=\"h3\"><strong>Pick-up</strong>\n {{vm.pickupTableTotalLogs}} Logs found</label></div><div flex=\"\"></div><div class=\"widget-toolbar\"><label class=\"h5\">\nDownload All Pick-up Logs</label><md-button class=\"md-icon-button\" aria-label=\"Export\" \nng-csv=\"vm.getCSVRows(\'Pickup\')\" csv-header=\"vm.getCSVHeaders(\'Pickup\')\" filename=\"{{vm.getCSVFilename(\'Pickup\')}}\">\n<img src=\"/assets/images/icons/btn-export.png\"></md-button></div></div><md-table-container \nclass=\"fixed-height blue-scroll\"><table md-table><thead md-head md-order=\"vm.pickupTableMain.order\" fix-head><tr \nmd-row><th md-column></th><th md-column class=\"text-left\" md-order-by=\"Customer.name\">Installation Name</th><th \nmd-column class=\"text-left\" md-order-by=\"rows.length\"># of Entries</th><th md-column>&nbsp;</th><th md-column \nclass=\"text-left\">&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th>\n</tr></thead><tbody md-body ng-if=\"vm.selectedInstallations.length == 0\"><tr md-row><td md-cell colspan=\"100\">\n{{ vm.accTab.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody><tbody md-body \nng-repeat=\"(instId, installation) in vm.pickupTable | sortByWithEmpty: vm.pickupTableMain.order\"><tr md-row \nng-class=\"{\'selected\': installation.isExpanded}\"><td md-cell class=\"cell-expand\" \nng-click=\"installation.isExpanded = !installation.isExpanded;\" style=\"width: 36px\"><i \nng-class=\"{\'icon-chevron-right\':!installation.isExpanded,\'icon-chevron-down\':installation.isExpanded}\"></i></td><td \nmd-cell class=\"text-left\">{{installation.Customer.name}}</td><td md-cell class=\"text-left\">{{installation.rows.length}}\n</td><td md-cell><div ng-if=\"vm.editable && installation.isExpanded\"><md-button style=\"width: 100px\" \nclass=\"md-icon-button\" aria-label=\"Add\" ng-click=\"vm.addLog(installation.installationId)\" \nng-disabled=\"vm.isLoading || vm.isUpdating\" ng-if=\"!installation.editMode\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"icon\"></md-icon>Add</md-button><md-button style=\"width: 100px\" class=\"md-icon-button\" aria-label=\"Edit\" \nng-click=\"vm.editLog(installation.installationId)\" ng-disabled=\"vm.isLoading || vm.isUpdating\" \nng-if=\"!installation.editMode && installation.selectedLogId\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon\">\n</md-icon>Edit</md-button><md-button style=\"width: 100px\" class=\"md-icon-button\" aria-label=\"Delete\" \nng-click=\"vm.deleteLog($event, installation.installationId)\" ng-disabled=\"vm.isLoading || vm.isUpdating\" \nng-if=\"!installation.editMode && installation.selectedLogId\"><md-icon md-font-icon=\"icon-delete\" class=\"icon\">\n</md-icon>Delete</md-button><md-button style=\"width: 100px\" class=\"md-icon-button md-accent\" aria-label=\"Save\" \nng-click=\"vm.saveLog(installation.installationId)\" ng-disabled=\"vm.isLoading || vm.isUpdating\" \nng-if=\"installation.editMode\"><md-icon md-font-icon=\"icon-check\" class=\"icon\"></md-icon>Save</md-button><md-button \nstyle=\"width: 100px\" class=\"md-icon-button md-accent\" aria-label=\"Cancel\" \nng-click=\"vm.cancelEdit(installation.installationId)\" ng-disabled=\"vm.isLoading || vm.isUpdating\" \nng-if=\"installation.editMode\"><md-icon md-font-icon=\"icon-close\" class=\"icon\"></md-icon>Cancel</md-button></div></td>\n<td md-cell class=\"text-right\" colspan=\"3\"><md-button ng-show=\"vm.isAdminLogs\" class=\"md-icon-button\" \naria-label=\"Open Graph\" ng-click=\"vm.openGraphDlg(installation.installationId, $event)\"><img \nsrc=\"/assets/images/icons/btn-graph-display.png\"></md-button></td></tr><tr class=\"has-child-table\" \nstyle=\"background: white\"><td colspan=\"100\" ng-if=\"installation.isExpanded\"><div class=\"child-table-container\" \nstyle=\"padding: 16px 0px 16px 70px\"><md-table-container><table md-table><thead md-head md-order=\"installation.order\">\n<tr md-row><th md-column md-order-by=\"{{col_index}}\" ng-repeat=\"(col_index, column) in ::installation.columns\" \nng-if=\"!column.hidden\"><span ng-bind-html=\"column.title\"></span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"installation.editMode==\'ADD\'\"><td md-cell ng-repeat=\"(col_index, column) in ::installation.columns\" \nng-if=\"!column.hidden\"><md-checkbox aria-label=\"Invalid\" ng-if=\"col_index == 1\" \nng-model=\"installation.newPickupLog[column.model.name]\"></md-checkbox><input type=\"text\" \nng-class=\"{\'error\':installation.newPickupLogError[column.model.name]}\" style=\"width:100%;height:24px\" \nng-model=\"installation.newPickupLog[column.model.name]\" ng-if=\"col_index > 2\" \nng-change=\"vm.validateColumnValue(installation.newPickupLog[column.model.name], column, installation.installationId)\">\n</td></tr><tr md-row ng-if=\"installation.rows.length==0\"><td md-cell colspan=\"100\" align=\"center\"><span \nng-if=\"!vm.isLoading\">No data available in table</span> <span ng-if=\"vm.isLoading\">Loading...</span></td></tr></tbody>\n<tbody md-body><tr md-row ng-repeat=\"row in installation.rows | orderBy:installation.order\" \nng-click=\"vm.selectLog(row[0], installation.installationId)\" \nng-class=\"{\'selected\':vm.isSelectedLog(row[0], installation.installationId)}\"><td md-cell \nng-repeat=\"cell in row track by $index\" ng-if=\"!installation.columns[$index].hidden\"><div \nng-if=\"installation.editMode != \'EDIT\' || !vm.isSelectedLog(row[0], installation.installationId)\"><md-checkbox \naria-label=\"Invalid\" ng-model=\"row[$index]\" ng-if=\"$index == 1\" ng-change=\"vm.onChangeInvalidEvents(row[0])\">\n</md-checkbox><span ng-if=\"$index == 2\" \nng-class=\"row[$index]?\'g2e-icon-truck-pickup-not-needed-checked\':\'g2e-icon-truck-pickup-not-needed\'\" \nstyle=\"cursor:pointer\" ng-click=\"vm.onExportBilling(row[0], installation.installationId)\"></span> <span \nng-if=\"$index>2 && installation.columns[$index].format\">{{ installation.columns[$index].format(cell)}}</span> <span \nng-if=\"$index>2 && !installation.columns[$index].format\">{{ cell }}</span></div><div \nng-if=\"installation.editMode == \'EDIT\' && vm.isSelectedLog(row[0], installation.installationId)\"><md-checkbox \naria-label=\"Invalid\" ng-if=\"$index == 1\" ng-model=\"installation.newPickupLog[installation.columns[$index].model.name]\">\n</md-checkbox><input type=\"text\" \nng-class=\"{\'error\':installation.newPickupLogError[installation.columns[$index].model.name]}\" \nstyle=\"width:100%;height:24px\" ng-model=\"installation.newPickupLog[installation.columns[$index].model.name]\" \nng-if=\"$index > 2\" \nng-change=\"vm.validateColumnValue(installation.newPickupLog[installation.columns[$index].model.name], installation.columns[$index], installation.installationId)\">\n</div></td></tr></tbody></table></md-table-container></div></td></tr></tbody></table></md-table-container></div><div \nng-show=\"vm.status_by==\'TANK_LEVEL\'\"><div layout=\"row\" class=\"pt-24 pl-24\"><div layout=\"row\"><label class=\"h3\"><strong>\nTank Level</strong> {{vm.tankLevelTableTotalLogs}} Logs found</label></div><div flex=\"\"></div><div \nclass=\"widget-toolbar\"><label class=\"h5\">Download All Tank Level Logs</label><md-button class=\"md-icon-button\" \naria-label=\"Export\" ng-csv=\"vm.getCSVRows(\'TankLevel\')\" csv-header=\"vm.getCSVHeaders(\'TankLevel\')\" \nfilename=\"{{vm.getCSVFilename(\'TankLevel\')}}\"><img src=\"/assets/images/icons/btn-export.png\"></md-button></div></div>\n<md-table-container class=\"fixed-height blue-scroll\"><table md-table><thead md-head \nmd-order=\"vm.tankLevelTableMain.order\" fix-head><tr md-row><th md-column></th><th md-column class=\"text-left\" \nmd-order-by=\"Customer.name\">Installation Name</th><th md-column class=\"text-left\" md-order-by=\"rows.length\">\n# of Entries</th><th md-column>&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th><th md-column class=\"text-left\">\n&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th></tr></thead><tbody md-body \nng-if=\"vm.selectedInstallations.length == 0\"><tr md-row><td md-cell colspan=\"100\">\n{{ vm.accTab.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody><tbody md-body \nng-repeat=\"(instId, installation) in vm.tankLevelTable | sortByWithEmpty: vm.tankLevelTableMain.order\"><tr md-row \nng-class=\"{\'selected\': installation.isExpanded}\"><td md-cell class=\"cell-expand\" \nng-click=\"installation.isExpanded = !installation.isExpanded;\" style=\"width: 36px\"><i \nng-class=\"{\'icon-chevron-right\':!installation.isExpanded,\'icon-chevron-down\':installation.isExpanded}\"></i></td><td \nmd-cell class=\"text-left\">{{installation.Customer.name}}</td><td md-cell class=\"text-left\">{{installation.rows.length}}\n</td><td md-cell></td><td md-cell class=\"text-right\" colspan=\"3\">&nbsp;</td></tr><tr class=\"has-child-table\" \nstyle=\"background: white\"><td colspan=\"100\" ng-if=\"installation.isExpanded\"><div class=\"child-table-container\" \nstyle=\"padding: 16px 0px 16px 70px\"><md-table-container><table md-table><thead md-head md-order=\"installation.order\">\n<tr md-row><th md-column><span>&nbsp;</span></th><th md-column md-order-by=\"{{col_index}}\" \nng-repeat=\"(col_index, column) in ::installation.columns\" ng-if=\"!column.hidden\"><span ng-bind-html=\"column.title\">\n</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"installation.rows.length==0\"><td md-cell colspan=\"100\" \nalign=\"center\"><span ng-if=\"!vm.isLoading\">No data available in table</span> <span ng-if=\"vm.isLoading\">Loading...\n</span></td></tr></tbody><tbody md-body><tr md-row \nng-repeat=\"(row_index, row) in installation.rows | orderBy:installation.order\"><td md-cell><span \nng-class=\"row[vm.resolvedAtIndex]?\'g2e-icon-truck-pickup-not-needed-checked\':\'g2e-icon-truck-pickup-not-needed\'\" \nstyle=\"cursor:pointer\" ng-click=\"vm.resolveTankLevelEvent(row[0], installation.installationId)\"></span></td><td \nmd-cell ng-repeat=\"cell in row track by $index\" ng-if=\"!installation.columns[$index].hidden\"><span \nng-if=\"installation.columns[$index].format\">{{ installation.columns[$index].format(cell) }}</span> <span \nng-if=\"!installation.columns[$index].format\">{{ cell }}</span></td></tr></tbody></table></md-table-container></div>\n</td></tr></tbody></table></md-table-container></div><div ng-show=\"vm.status_by==\'SYSTEM_FAULT\'\"><div layout=\"row\" \nclass=\"pt-24 pl-24\"><div layout=\"row\"><label class=\"h3\"><strong>System Fault</strong>\n {{vm.systemFaultTableTotalLogs}} Logs found</label></div><div flex=\"\"></div><div class=\"widget-toolbar\"><label \nclass=\"h5\">Download All System Fault Logs</label><md-button class=\"md-icon-button\" aria-label=\"Export\" \nng-csv=\"vm.getCSVRows(\'SystemFault\')\" csv-header=\"vm.getCSVHeaders(\'SystemFault\')\" \nfilename=\"{{vm.getCSVFilename(\'SystemFault\')}}\"><img src=\"/assets/images/icons/btn-export.png\"></md-button></div></div>\n<md-table-container class=\"fixed-height blue-scroll\"><table md-table><thead md-head \nmd-order=\"vm.systemFaultTableMain.order\" fix-head><tr md-row><th md-column></th><th md-column class=\"text-left\" \nmd-order-by=\"Customer.name\">Installation Name</th><th md-column class=\"text-left\" md-order-by=\"rows.length\">\n# of Entries</th><th md-column>&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th><th md-column class=\"text-left\">\n&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th></tr></thead><tbody md-body \nng-if=\"vm.selectedInstallations.length == 0\"><tr md-row><td md-cell colspan=\"100\">\n{{ vm.accTab.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody><tbody md-body \nng-repeat=\"(instId, installation) in vm.systemFaultTable | sortByWithEmpty: vm.systemFaultTableMain.order\"><tr md-row \nng-class=\"{\'selected\': installation.isExpanded}\"><td md-cell class=\"cell-expand\" \nng-click=\"installation.isExpanded = !installation.isExpanded;\" style=\"width: 36px\"><i \nng-class=\"{\'icon-chevron-right\':!installation.isExpanded,\'icon-chevron-down\':installation.isExpanded}\"></i></td><td \nmd-cell class=\"text-left\">{{installation.Customer.name}}</td><td md-cell class=\"text-left\">{{installation.rows.length}}\n</td><td md-cell></td><td md-cell class=\"text-right\" colspan=\"3\">&nbsp;</td></tr><tr class=\"has-child-table\" \nstyle=\"background: white\"><td colspan=\"100\" ng-if=\"installation.isExpanded\"><div class=\"child-table-container\" \nstyle=\"padding: 16px 0px 16px 70px\"><md-table-container><table md-table><thead md-head md-order=\"installation.order\">\n<tr md-row><th md-column md-order-by=\"{{col_index}}\" ng-repeat=\"(col_index, column) in ::installation.columns\" \nng-if=\"!column.hidden\"><span ng-bind-html=\"column.title\"></span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"installation.rows.length==0\"><td md-cell colspan=\"100\" align=\"center\"><span ng-if=\"!vm.isLoading\">\nNo data available in table</span> <span ng-if=\"vm.isLoading\">Loading...</span></td></tr></tbody><tbody md-body><tr \nmd-row ng-repeat=\"row in installation.rows | orderBy:installation.order\"><td md-cell \nng-repeat=\"cell in row track by $index\"><span ng-if=\"installation.columns[$index].format\">\n{{ installation.columns[$index].format(cell) }}</span> <span ng-if=\"!installation.columns[$index].format\">{{ cell }}\n</span></td></tr></tbody></table></md-table-container></div></td></tr></tbody></table></md-table-container></div><div \nng-show=\"vm.status_by==\'NON_CRITICAL\'\"><div layout=\"row\" class=\"pt-24 pl-24\"><div layout=\"row\"><label class=\"h3\">\n<strong>Non-critical</strong> {{vm.nonCriticalTableTotalLogs}} Logs found</label></div><div flex=\"\"></div><div \nclass=\"widget-toolbar\"><label class=\"h5\">Download All Non-critical Logs</label><md-button class=\"md-icon-button\" \naria-label=\"Export\" ng-csv=\"vm.getCSVRows(\'NonCritical\')\" csv-header=\"vm.getCSVHeaders(\'NonCritical\')\" \nfilename=\"{{vm.getCSVFilename(\'NonCritical\')}}\"><img src=\"/assets/images/icons/btn-export.png\"></md-button></div></div>\n<md-table-container class=\"fixed-height blue-scroll\"><table md-table><thead md-head \nmd-order=\"vm.nonCriticalTableMain.order\" fix-head><tr md-row><th md-column></th><th md-column class=\"text-left\" \nmd-order-by=\"Customer.name\">Installation Name</th><th md-column class=\"text-left\" md-order-by=\"rows.length\">\n# of Entries</th><th md-column>&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th><th md-column class=\"text-left\">\n&nbsp;</th><th md-column class=\"text-left\">&nbsp;</th></tr></thead><tbody md-body \nng-if=\"vm.selectedInstallations.length == 0\"><tr md-row><td md-cell colspan=\"100\">\n{{ vm.accTab.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody><tbody md-body \nng-repeat=\"(instId, installation) in vm.nonCriticalTable | sortByWithEmpty: vm.nonCriticalTableMain.order\"><tr md-row \nng-class=\"{\'selected\': installation.isExpanded}\"><td md-cell class=\"cell-expand\" \nng-click=\"installation.isExpanded = !installation.isExpanded;\" style=\"width: 36px\"><i \nng-class=\"{\'icon-chevron-right\':!installation.isExpanded,\'icon-chevron-down\':installation.isExpanded}\"></i></td><td \nmd-cell class=\"text-left\">{{installation.Customer.name}}</td><td md-cell class=\"text-left\">{{installation.rows.length}}\n</td><td md-cell></td><td md-cell class=\"text-right\" colspan=\"3\">&nbsp;</td></tr><tr class=\"has-child-table\" \nstyle=\"background: white\"><td colspan=\"100\" ng-if=\"installation.isExpanded\"><div class=\"child-table-container\" \nstyle=\"padding: 16px 0px 16px 70px\"><md-table-container><table md-table><thead md-head md-order=\"installation.order\">\n<tr md-row><th md-column md-order-by=\"{{col_index}}\" ng-repeat=\"(col_index, column) in ::installation.columns\" \nng-if=\"!column.hidden\"><span ng-bind-html=\"column.title\"></span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"installation.rows.length==0\"><td md-cell colspan=\"100\" align=\"center\"><span ng-if=\"!vm.isLoading\">\nNo data available in table</span> <span ng-if=\"vm.isLoading\">Loading...</span></td></tr></tbody><tbody md-body><tr \nmd-row ng-repeat=\"row in installation.rows | orderBy:installation.order\"><td md-cell \nng-repeat=\"cell in row track by $index\"><span ng-if=\"installation.columns[$index].format\">\n{{ installation.columns[$index].format(cell) }}</span> <span ng-if=\"!installation.columns[$index].format\">{{ cell }}\n</span></td></tr></tbody></table></md-table-container></div></td></tr></tbody></table></md-table-container></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dashboard/customer/new-device-dialog.tmpl.html","<md-dialog aria-label=\"\" ng-cloak flex=\"{{vm.steps[vm.stepIndex].dialogWidth}}\"><form name=\"deviceForm\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>{{vm.steps[vm.stepIndex].dialogTitle}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"step0\" ng-if=\"vm.stepIndex==0\"><p>\nThis device needs to be assigned a location and installation ID<br>Select a location type to begin registration.</p>\n<md-radio-group ng-model=\"vm.registrationMode\" class=\"md-primary\"><md-radio-button value=\"EXIST\" \nclass=\"md-align-top-left\"><strong>Existing Customer Location</strong><br><span>\nSelect from a list of existing customer locations to associate this install with</span></md-radio-button>\n<md-radio-button value=\"NEW\" class=\"md-align-top-left\"><strong>New Customer Location</strong><br><span>\nCreate a new customer location to associate this install with</span></md-radio-button></md-radio-group></div><div \nclass=\"step1\" ng-if=\"vm.stepIndex==1\"><p>Please associate Unassigned install <strong>{{vm.newDevice.serialNumber}}\n</strong> with an existing location</p><div layout=\"row\" ng-show=\"vm.isLoading\" layout-align=\"center center\">\n<md-progress-circular id=\"toolbar-progress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><span>Loading...</span></div><div layout=\"row\" ng-show=\"!vm.isLoading\"><md-radio-group \nng-model=\"vm.selectedCustomerID\"><table id=\"deviceCustomerTable\" class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Installation ID\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Location Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">City</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">State</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Zip Code</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"installation in vm.installations\" ng-click=\"vm.selectCustomer(installation)\"><td><md-radio-button\n aria-label=\"installation\" ng-value=\"installation.id\" class=\"md-primary\"></md-radio-button></td><td>\n{{ installation.id }}</td><td>{{ installation.Customer.name }}</td><td>{{ installation.Customer.address }}</td><td>\n{{ installation.Customer.city }}</td><td>{{ installation.Customer.state }}</td><td>{{ installation.Customer.zipcode }}\n</td></tr></tbody></table></md-radio-group></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"border-top\"><div layout=\"row\" layout-align=\"left center\" ng-if=\"vm.isSaving\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span>Updating...</span></div><span \nflex></span><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.nextStep()\" \nng-disabled=\"vm.validateStep() || vm.isSaving\">Next</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/holiday/holiday-dialog-add.tmpl.html","<md-dialog aria-label=\"Add/Edit User\" ng-cloak flex=\"50\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>{{vm.mode==\'add\'?\'Add Holiday\':\'Edit Holiday\'}}</h1><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\" flex=\"50\"><label \nclass=\"g2e-required-label\">Title <span>*</span></label><input name=\"title\" ng-model=\"vm.holidayData.title\" required>\n<div ng-messages=\"saveForm.firstName.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container><div class=\"md-block pb-20\" flex=\"50\"><label class=\"dp-floating-label g2e-required-label\">\nStart Date <span>*</span></label><md-datepicker name=\"start\" ng-model=\"vm.startDate\"></md-datepicker><div \nclass=\"dp-messages\" ng-if=\"saveForm.start.$touched && !vm.startDate\">This is required.</div></div><div \nclass=\"md-block pb-20\" flex=\"50\"><label class=\"dp-floating-label g2e-required-label\">End Date</label><md-datepicker \nname=\"end\" ng-model=\"vm.endDate\"></md-datepicker></div><md-input-container class=\"md-block\" flex=\"50\"><label>Repeat\n</label><md-select name=\"repeat\" ng-model=\"vm.holidayData.repeat\"><md-option value=\"0\">None</md-option><md-option \nvalue=\"1\">Every Year</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"left center\" \nng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\" ng-if=\"vm.isSaving\">\n</md-progress-circular><span>{{vm.msg}}</span></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"border-top\"><md-button class=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deleteHoliday($event)\" \nng-show=\"vm.mode==\'edit\'\" ng-disabled=\"vm.isSaving\">Delete Holiday</md-button><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.updateHoliday()\" \nng-disabled=\"saveForm.$invalid || !vm.startDate || vm.isSaving\">Save</md-button><md-button class=\"md-raised\" \nng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/holiday/holiday-dialog.tmpl.html","<md-dialog class=\"fullscreen-anyway\" aria-label=\"Holidays\"><md-toolbar class=\"md-background-bg border-bottom\"><div \nclass=\"md-toolbar-tools\"><h1>Holidays</h1><span flex></span><md-button class=\"pl-24 md-icon-button\" aria-label=\"Close\" \nng-click=\"vm.close()\"><img src=\"/assets/images/icons/btn-close.png\"></md-button></div></md-toolbar><md-dialog-content>\n<div layout=\"row\" ng-if=\"vm.isLoading\" layout-align=\"center center\"><md-progress-circular id=\"toolbar-progress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span>Loading...</span></div><div \nid=\"calendar\" layout=\"column\" ng-if=\"!vm.isLoading\"><div class=\"header\"><div class=\"header-content\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span>Previous</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span>Next</span></md-tooltip></md-button><div \nclass=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" \naria-label=\"Today\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span>Today</span></md-tooltip>\n</md-button></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"add-event-button md-fab md-warn\" ng-click=\"vm.openAddDlg($event,\'add\',{repeat: 1})\" aria-label=\"Add event\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div></div><div class=\"content\"><div \nid=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\" \ncalendar-watch-event=\"vm.extraEventSignature(event)\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/media-manager/add-media-dialog.tmpl.html","<md-dialog aria-label=\"Edit Training Material\" ng-cloak id=\"add-media-dialog\" flex=\"50\" class=\"loading-overlay\" \nbs-loading-overlay=\"add_media_loader\"><form name=\"saveForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h1>\nEdit Training Material</h1><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \nclass=\"g2e-required-label\">Title <span>*</span></label><input name=\"title\" ng-model=\"vm.mediaData.title\" required><div \nng-messages=\"saveForm.title.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Description</label><input name=\"description\" \nng-model=\"vm.mediaData.description\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"25\" flex=\"50\"><label>Version</label><input name=\"version\" ng-model=\"vm.mediaData.version\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"25\" flex=\"50\" ng-if=\"vm.mediaData.originalName\">\n<label>File Type</label><input name=\"fileType\" disabled=\"disabled\" value=\"{{ vm.mediaData.fileType }}\">\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.mediaData.originalName\"><md-input-container class=\"md-block\" \nflex><label>Original File Name</label><input name=\"originalName\" disabled=\"disabled\" \nvalue=\"{{ vm.mediaData.originalName }}\"></md-input-container></div><div layout=\"row\" \nng-if=\"!vm.mediaData.originalName\"><md-input-container class=\"md-block\" flex><label>URL</label><input name=\"videoUrl\" \ndisabled=\"disabled\" value=\"{{ vm.mediaData.videoUrl }}\"></md-input-container></div><md-content class=\"md-padding\" \nid=\"ben-tab-content\"><form><div class=\"filter-bar\" layout=\"row\"><span flex=\"\"></span><div class=\"pt-8\" \nng-show1=\"vm.selectedSite\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.openChangeVisibilityDlg($event)\" \nng-disabled=\"vm.sitesTable.selected.length === 0 || vm.isLoading\">Change Visibility</md-button></div></div></form><div \nng-show=\"true\"><md-table-container class=\"fixed-height blue-scroll\"><table md-table><thead md-head \nmd-order=\"vm.sitesTable.order\" fix-head><tr md-row><th md-column><md-checkbox aria-label=\"Choose All Rows\" \nng-click=\"vm.chooseAllSitesTableRows()\" ng-checked=\"vm.isSelectedAllSitesTableRows()\"></md-checkbox></th><th md-column \nclass=\"text-left\" md-order-by=\"Division.Company.name\">Company</th><th md-column class=\"text-left\" \nmd-order-by=\"Division.name\">Regional Division</th><th md-column class=\"text-left\" md-order-by=\"name\">Site Name</th><th \nmd-column class=\"text-left\" md-order-by=\"visibility\" style=\"background: #fff9dd; width: 120px\">Visibility</th></tr>\n</thead><tbody md-body><tr md-row><td md-cell></td><td md-cell class=\"filter-cell\"><md-chips \nng-model=\"vm.sitesTable.filters[0].queries\" placeholder=\"filter companies\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-input-name=\"companyFilter\" \nmd-min-length=\"0\" md-no-cache=\"vm.noCache\" md-search-text=\"vm.companyFilterText\" \nmd-selected-item-change=\"vm.onChangeCompanyFilter()\" md-items=\"item in vm.queryCompanyFilter(vm.companyFilterText)\" \nmd-item-text=\"item\" placeholder=\"filter compaines\"><md-item-template><span md-highlight-text=\"vm.companyFilterText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span>\n</md-chip-template></md-chips></td><td md-cell class=\"filter-cell\"><md-chips \nng-model=\"vm.sitesTable.filters[1].queries\" placeholder=\"filter divisions\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-input-name=\"divisionFilter\" \nmd-min-length=\"0\" md-no-cache=\"vm.noCache\" md-search-text=\"vm.divisionFilterText\" \nmd-selected-item-change=\"vm.onChangeDivisionFilter()\" md-items=\"item in vm.queryDivisionFilter(vm.divisionFilterText)\" \nmd-item-text=\"item\" placeholder=\"filter divisions\"><md-item-template><span md-highlight-text=\"vm.divisionFilterText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span>\n</md-chip-template></md-chips></td><td md-cell class=\"filter-cell\"><md-chips \nng-model=\"vm.sitesTable.filters[2].queries\" placeholder=\"filter sites\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-input-name=\"siteFilter\" \nmd-min-length=\"0\" md-no-cache=\"vm.noCache\" md-search-text=\"vm.siteFilterText\" \nmd-selected-item-change=\"vm.onChangeSiteFilter()\" md-items=\"item in vm.querySiteFilter(vm.siteFilterText)\" \nmd-item-text=\"item\" placeholder=\"filter sites\"><md-item-template><span md-highlight-text=\"vm.siteFilterText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span>\n</md-chip-template></md-chips></td><td md-cell></td></tr></tbody><tbody md-body ng-if=\"vm.sites.length == 0\"><tr \nmd-row><td md-cell colspan=\"100\">{{ vm.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody><tbody \nmd-body><tr md-row \nng-repeat=\"site in vm.sites |\n                    benchBy: vm.sitesTable.filters |\n                    sortByWithEmpty: vm.sitesTable.order |\n                    limitTo: vm.sitesTable.pagination.limit: (vm.sitesTable.pagination.page - 1) * vm.sitesTable.pagination.limit\" \nng-class=\"{\'selected\':vm.isSelectedSitesTableRows(site)}\" ng-click=\"vm.chooseSitesTableRows(site)\"><td md-cell>\n<md-checkbox aria-label=\"Choose Row\" ng-checked=\"vm.isSelectedSitesTableRows(site)\"></md-checkbox></td><td md-cell \nclass=\"text-left\">{{ site.Division.Company.name }}</td><td md-cell class=\"text-left\">{{ site.Division.name }}</td><td \nmd-cell class=\"text-left\">{{ site.name }}</td><td md-cell class=\"text-left\" style=\"background: #fff9dd; width: 120px\">\n<md-input-container><md-select aria-label=\"Visibility\" ng-model=\"site.visibility\" \nng-change=\"vm.onChangeVisibility(site)\" ng-disabled=\"vm.isLoading === true\"><md-option value=\"{{ vis.name }}\" \nng-repeat=\"vis in vm.visibilities\">{{ vis.label }}</md-option></md-select></md-input-container></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.sitesTable.pagination.limit\" \nmd-limit-options=\"vm.sitesTable.pagination.lengths\" md-page=\"vm.sitesTable.pagination.page\" \nmd-total=\"{{(vm.sites | benchBy: vm.sitesTable.filters).length}}\" md-page-select></md-table-pagination></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\"><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deleteMedia($event)\" ng-show=\"vm.mode==\'edit\'\" \nng-disabled=\"vm.isLoading\">Delete</md-button><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.updateMedia()\" ng-disabled=\"saveForm.$invalid || vm.isLoading\">Save</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isLoading\">Cancel</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/dashboard/media-manager/media-manager-dialog.tmpl.html","<md-dialog class=\"fullscreen-anyway\" aria-label=\"Media Manager\" id=\"media-manager-dialog\" ng-cloak \nclass=\"loading-overlay\" bs-loading-overlay=\"media_manager_loader\"><md-toolbar class=\"md-background-bg border-bottom\">\n<div class=\"md-toolbar-tools\"><h1>Media Manager</h1><span flex></span><md-button class=\"pl-24 md-icon-button\" \naria-label=\"Close\" ng-click=\"vm.close()\"><img src=\"/assets/images/icons/btn-close.png\"></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\"><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.openUploadMediaDlg($event)\" ng-disabled=\"vm.isLoading || !vm.currentUser.hasAdminRole()\">\nUpload Training Material</md-button></div><md-table-container id=\"mediaTableContainer\"><table md-table><thead md-head \nmd-order=\"vm.mediaTable.order\" fix-head><tr md-row><th md-column md-order-by=\"\"></th><th md-column class=\"text-left\" \nmd-order-by=\"title\">Title</th><th md-column class=\"text-left\" md-order-by=\"description\">Description</th><th md-column \nclass=\"text-left\" md-order-by=\"fileType\">File Type</th><th md-column class=\"text-left\" md-order-by=\"createdAt\">Uploaded\n</th><th md-column class=\"text-left\" md-order-by=\"version\">Version</th><th md-column></th></tr></thead><tbody md-body>\n<tr md-row ng-if=\"vm.medias.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"media in vm.medias | sortByWithEmpty: vm.mediaTable.order\"><td md-cell style=\"width: 48px\"><a \nhref=\"{{media.videoUrl?media.videoUrl:vm.hostUrl+media.uniqueName}}\" target=\"_blank\"><media-button media=\"media\" \ntype=\"small\"></media-button></a></td><td md-cell class=\"text-left\"><a href=\"\" \nng-click=\"vm.openAddMediaDlg($event,\'edit\',media)\">{{media.title}}</a></td><td md-cell class=\"text-left\">\n{{ media.description }}</td><td md-cell class=\"text-left\">{{ media.fileType }}</td><td md-cell class=\"text-left\">\n{{ media.createdAt | date: \'MM/dd/yyyy\' }}</td><td md-cell class=\"text-left\">{{ media.version }}</td><td md-cell \nclass=\"text-right\"><md-button class=\"md-icon-button\" aria-label=\"Remove\" ng-click=\"vm.deleteMedia($event, media)\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"icon\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/media-manager/upload-media-dialog.tmpl.html","<md-dialog aria-label=\"Upload Training Material\" ng-cloak id=\"upload-media-dialog\" flex=\"60\" class=\"loading-overlay\" \nbs-loading-overlay=\"upload_media_loader\"><form name=\"saveForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 \nng-if=\"vm.step==1\">Upload Training Material</h1><h1 ng-if=\"vm.step==2\">File Detail</h1><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\" ng-disabled=\"vm.isLoading\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"step1\" ng-show=\"vm.step==1\"><h3>\nMust be DOC, DOCX, PAGES, PDF, PPT, PPTX, RTF, TXT, WPD, WPS, XLS, XLSX for documents, and AVI, FLV, MOV, MP4, MPG, SWF, VOB, WMV for videos. - not to exceed 500 MB.\n</h3><div class=\"drop-box\" ngf-drop ng-model=\"file\" \nngf-change=\"vm.onChangeFile($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)\" \nngf-drag-over-class=\"\'dragover\'\" ngf-max-size=\"500MB\" \naccept=\".DOC,.DOCX,.PAGES,.PDF,.PPT,.PPTX,.RTF,.TXT,.WPD,.WPS,.XLS,.XLSX,.AVI,.FLV,.MOV,.MP4,.MPG,.SWF,.VOB,.WMV\" \nngf-pattern=\"\'.DOC,.DOCX,.PAGES,.PDF,.PPT,.PPTX,.RTF,.TXT,.WPD,.WPS,.XLS,.XLSX,.AVI,.FLV,.MOV,.MP4,.MPG,.SWF,.VOB,.WMV\'\">\n<div class=\"info\"><h1>Drag and drop file here</h1><h3>Or select your file to upload</h3><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.isLink === true\" ngf-select ng-model=\"file\" ngf-keep=\"true\" \nngf-change=\"vm.onChangeFile($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)\" ngf-max-size=\"500MB\" \naccept=\".DOC,.DOCX,.PAGES,.PDF,.PPT,.PPTX,.RTF,.TXT,.WPD,.WPS,.XLS,.XLSX,.AVI,.FLV,.MOV,.MP4,.MPG,.SWF,.VOB,.WMV\" \nngf-pattern=\"\'.DOC,.DOCX,.PAGES,.PDF,.PPT,.PPTX,.RTF,.TXT,.WPD,.WPS,.XLS,.XLSX,.AVI,.FLV,.MOV,.MP4,.MPG,.SWF,.VOB,.WMV\'\">\nselect file...</md-button><h1 ng-show=\"!vm.isLink\">{{vm.media.file.name}}</h1><md-input-container class=\"md-block\" \nflex><md-checkbox aria-label=\"Add a Link\" ng-model=\"vm.isLink\">Add a Link</md-checkbox></md-input-container>\n<md-input-container class=\"md-block\" flex><label>URL</label><input name=\"videoUrl\" ng-model=\"vm.media.videoUrl\" \nng-disabled=\"!vm.isLink\"></md-input-container></div></div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div></div><div class=\"step2\" ng-show=\"vm.step==2\"><div layout=\"row\">\n<div flex=\"60\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Title \n<span>*</span></label><input name=\"title\" ng-model=\"vm.media.title\" required><div ng-messages=\"saveForm.title.$error\">\n<div ng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Description</label><input name=\"description\" \nng-model=\"vm.media.description\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"50\"><label>Version</label><input name=\"version\" ng-model=\"vm.media.version\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\" ng-if=\"!vm.isLink\"><label>File Type</label><input name=\"fileType\" \ndisabled=\"disabled\" value=\"{{ (vm.isLink?\'\':vm.media.file.name) | fileExt:true }}\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"!vm.isLink\"><md-input-container class=\"md-block\" flex><label>Original File Name</label><input \nname=\"originalName\" disabled=\"disabled\" value=\"{{ vm.isLink?\'\':vm.media.file.name }}\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.isLink\"><md-input-container class=\"md-block\" flex><label>URL</label><input name=\"videoUrl\" \ndisabled=\"disabled\" value=\"{{ vm.media.videoUrl }}\"></md-input-container></div></div><div flex=\"40\"><h3>Video Preview\n</h3><video controls ngf-src=\"vm.isLink?vm.media.videoUrl:vm.media.file\" style=\"width: 100%\"></video></div></div><div \nlayout=\"row\" ng-show=\"vm.isLoading\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.determinateValue}}\">\n</md-progress-linear></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\" \nng-if=\"vm.step==1\"><span flex></span><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus>Cancel</md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.gotoStep(2)\" \nng-disabled=\"(!vm.media.file && !vm.isLink) || (!vm.media.videoUrl && vm.isLink === true)\">Next</md-button>\n</md-dialog-actions><md-dialog-actions layout=\"row\" class=\"border-top\" ng-if=\"vm.step==2\"><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.gotoStep(1)\" ng-disabled=\"vm.isLoading\">\nSelect a difference file</md-button><span flex></span><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus \nng-disabled=\"vm.isLoading\">Cancel</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.uploadMedia()\" \nng-disabled=\"saveForm.$invalid || vm.isLoading\">Upload</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/add-admingroup-dialog.tmpl.html","<md-dialog aria-label=\"Add/Edit Parent Administration Group\" ng-cloak flex=\"50\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>{{vm.mode==\'add\'?\'Add Parent Administration Group\':\'Edit Parent Administration Group\'}}\n</h1><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \nclass=\"g2e-required-label\">Parent Group Name <span>*</span></label><input name=\"name\" \nng-model=\"vm.adminGroupData.groupName\" required><div ng-messages=\"saveForm.name.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container></div><div layout=\"row\"><strong>\nSelect G2E Administrators for this group</strong></div><div layout=\"row\"><md-content flex><md-table-container \nclass=\"max-fixed-height blue-scroll\"><table md-table md-row-select multiple=\"true\" ng-model=\"vm.adminGroupData.Users\">\n<thead md-head md-order=\"vm.adminGroupData.order\" fix-head><tr md-row><th md-column class=\"text-left\" \nmd-order-by=\"firstName\">First Name</th><th md-column class=\"text-left\" md-order-by=\"lastName\">Last Name</th><th \nmd-column class=\"text-left\" md-order-by=\"email\">Email</th><th md-column class=\"text-left\" md-order-by=\"role\">User Role\n</th></tr></thead><tbody md-body><tr md-row ng-if=\"vm.adminUsersData.length == 0\"><td md-cell colspan=\"100\">\nNo data available in table</td></tr><tr md-row md-select=\"user\" md-select-id=\"id\" md-auto-select \nng-repeat=\"user in vm.adminUsersData | sortByWithEmpty: vm.adminGroupData.order\"><td md-cell class=\"text-left\">\n{{ user.firstName }}</td><td md-cell class=\"text-left\">{{ user.lastName }}</td><td md-cell class=\"text-left\"><a \nhref=\"mailto:{{ user.email }}\">{{ user.email }}</a></td><td md-cell class=\"text-left\">\n{{ user.Roles | pluckJoin:\'id\':\'title\' }}</td></tr></tbody></table></md-table-container></md-content></div><div \nlayout=\"row\" layout-align=\"left center\" ng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span>{{vm.msg}}</span></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"border-top\"><md-button class=\"md-raised md-background-fg md-grey-700-bg\" \nng-click=\"vm.deleteAdminGroup($event)\" ng-show=\"vm.mode==\'edit\'\" ng-disabled=\"vm.isSaving\">Delete</md-button><span \nflex></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.updateAdminGroup()\" \nng-disabled=\"saveForm.$invalid || vm.isSaving\">Save</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" \nmd-autofocus ng-disabled=\"vm.isSaving\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/add-badge-dialog.tmpl.html","<md-dialog aria-label=\"Add/Edit Badge\" ng-cloak id=\"add-badge-dialog\" flex=\"40\" class=\"loading-overlay\" \nbs-loading-overlay=\"add_badge_loader\"><form name=\"saveForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h1>\n{{vm.mode==\'add\'?\'Add Badge\':\'Edit Badge\'}}</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Badge ID <span>*</span></label><input \nname=\"badgeId\" ng-model=\"vm.badgeData.badgeId\" required ng-disabled=\"!vm.currentUser.hasAdminRole()\"><div \nng-messages=\"saveForm.badgeId.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Badge Name</label>\n<input name=\"name\" ng-model=\"vm.badgeData.name\"><div ng-messages=\"saveForm.name.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label class=\"g2e-required-label\">Department</label><input name=\"department\" ng-model=\"vm.badgeData.department\"><div \nng-messages=\"saveForm.department.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.updateBadge()\" ng-disabled=\"saveForm.$invalid || vm.isLoading\">Save\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isLoading\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/add-division-dialog.tmpl.html","<md-dialog aria-label=\"Add/Edit Regional Division\" ng-cloak flex=\"50\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>{{vm.mode==\'add\'?\'Add Regional Division\':\'Edit Regional Division\'}}</h1><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\">\n<label class=\"g2e-required-label\">Regional Division Name <span>*</span></label><input name=\"name\" \nng-model=\"vm.divisionData.name\" required><div ng-messages=\"saveForm.name.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>Description\n</label><input name=\"description\" ng-model=\"vm.divisionData.description\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"50\"><label>Regional Division Contact</label><input name=\"contact\" \nng-model=\"vm.divisionData.contact\"></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label>\nRegional Division Contact Phone #</label><input name=\"phone\" ng-model=\"vm.divisionData.phone\" ui-mask=\"(999) 999-9999\" \nmodel-view-value=\"true\" ui-options=\"{addDefaultPlaceholder:false}\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"50\"><label>Regional Division Contact Email</label><input name=\"email\" \nng-model=\"vm.divisionData.email\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"saveForm.email.$error\"><div \nng-message-exp=\"[\'pattern\']\">Please enter a valid Email address.</div></div></md-input-container></div><div \nlayout=\"row\" layout-align=\"left center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span ng-if=\"vm.msg\">{{vm.msg}}</span></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\"><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deleteDivision($event)\" ng-show=\"vm.mode==\'edit\'\" \nng-disabled=\"vm.isSaving\">Delete</md-button><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.updateDivision()\" ng-disabled=\"saveForm.$invalid || vm.isSaving\">Save</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/dashboard/site/add-shift-dialog.tmpl.html","<md-dialog aria-label=\"Add/Edit Shift\" ng-cloak id=\"add-shift-dialog\" flex=\"40\" class=\"loading-overlay\" \nbs-loading-overlay=\"add_shift_loader\"><form name=\"saveForm\"><md-toolbar><div class=\"md-toolbar-tools\"><h1>\n{{vm.mode==\'add\'?\'Add Shift\':\'Edit Shift\'}}</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Shift Name <span>*</span></label><input \nname=\"name\" ng-model=\"vm.shiftData.name\" required><div ng-messages=\"saveForm.name.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container></div><div layout=\"row\"><mdp-time-picker name=\"startTime\" \nng-model=\"vm.shiftData.startTime\" required flex><label class=\"g2e-required-label\">Start Time <span>*</span></label><div\n ng-messages=\"saveForm.startTime.$error\"><div ng-message=\"required\">This is required.</div></div></mdp-time-picker>\n<mdp-time-picker name=\"endTime\" ng-model=\"vm.shiftData.endTime\" required flex><label class=\"g2e-required-label\">\nEnd Time <span>*</span></label><div ng-messages=\"saveForm.endTime.$error\"><div ng-message=\"required\">This is required.\n</div></div><div class=\"dp-messages\" ng-if=\"vm.shiftData.startTime>=vm.shiftData.endTime\">\nEnd Time should be greater than Start Time</div></mdp-time-picker></div><div layout=\"column\"><label \nclass=\"g2e-required-label pv-16\">Days <span>*</span></label><table class=\"days\"><tr><td><md-checkbox \naria-label=\"Everyday\" ng-click=\"vm.selectEveryday()\" \nng-checked=\"vm.shiftData.days.Sunday && vm.shiftData.days.Monday && vm.shiftData.days.Tuesday && vm.shiftData.days.Wednesday && vm.shiftData.days.Thursday && vm.shiftData.days.Friday && vm.shiftData.days.Saturday\">\nEveryday</md-checkbox></td></tr><tr><td><md-checkbox aria-label=\"Sunday\" ng-model=\"vm.shiftData.days.Sunday\" \nng-change=\"vm.validateDaysSelected()\">Sunday</md-checkbox></td><td><md-checkbox aria-label=\"Monday\" \nng-model=\"vm.shiftData.days.Monday\" ng-change=\"vm.validateDaysSelected()\">Monday</md-checkbox></td><td><md-checkbox \naria-label=\"Tuesday\" ng-model=\"vm.shiftData.days.Tuesday\" ng-change=\"vm.validateDaysSelected()\">Tuesday</md-checkbox>\n</td><td><md-checkbox aria-label=\"Wednesday\" ng-model=\"vm.shiftData.days.Wednesday\" \nng-change=\"vm.validateDaysSelected()\">Wednesday</md-checkbox></td></tr><tr><td><md-checkbox aria-label=\"Thursday\" \nng-model=\"vm.shiftData.days.Thursday\" ng-change=\"vm.validateDaysSelected()\">Thursday</md-checkbox></td><td><md-checkbox\n aria-label=\"Friday\" ng-model=\"vm.shiftData.days.Friday\" ng-change=\"vm.validateDaysSelected()\">Friday</md-checkbox>\n</td><td><md-checkbox aria-label=\"Saturday\" ng-model=\"vm.shiftData.days.Saturday\" \nng-change=\"vm.validateDaysSelected()\">Saturday</md-checkbox></td></tr></table><div class=\"dp-messages\" \nng-if=\"vm.isDaysInvald\">This is required.</div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"border-top\"><span flex></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.updateShift()\" \nng-disabled=\"saveForm.$invalid || vm.shiftData.startTime>=vm.shiftData.endTime || vm.isLoading\">Save</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isLoading\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/add-site-dialog.tmpl.html","<md-dialog aria-label=\"Add/Edit Site\" ng-cloak flex=\"40\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>{{vm.mode==\'add\'?\'Add Site\':\'Edit Site\'}}</h1><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \nclass=\"g2e-required-label\">Company <span>*</span></label><md-select name=\"company\" ng-model=\"vm.companyId\" \nng-disabled=\"true\" required><md-option value=\"{{ vm.divisionData.Company.id }}\" selected=\"selected\">\n{{ vm.divisionData.Company.name }}</md-option></md-select><div ng-messages=\"saveForm.company.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Division <span>*</span></label><md-select name=\"division\" \nng-model=\"vm.divisionId\" ng-disabled=\"vm.mode==\'add\'\" required><md-option value=\"{{ division.id }}\" \nng-repeat=\"division in vm.divisionsData\">{{ division.name }}</md-option></md-select><div \nng-messages=\"saveForm.division.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Site Name <span>*\n</span></label><input name=\"name\" ng-model=\"vm.siteName\" required><div ng-messages=\"saveForm.name.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"left center\" ng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span>{{vm.msg}}</span></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"border-top\"><md-button class=\"md-raised md-background-fg md-grey-700-bg\" \nng-click=\"vm.deleteSite($event)\" ng-show=\"vm.mode==\'edit\'\" ng-disabled=\"vm.isSaving\">Delete</md-button><span flex>\n</span><md-button class=\"md-raised md-accent\" ng-click=\"vm.updateSite()\" \nng-disabled=\"saveForm.$invalid || vm.isSaving\">Save</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" \nmd-autofocus ng-disabled=\"vm.isSaving\">Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/add-siteuser-dialog.tmpl.html","<md-dialog aria-label=\"Add/Edit Site Account User\" ng-cloak flex=\"50\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><div ng-switch=\"vm.mode\"><h1 ng-switch-when=\"add\">Add Site Account User</h1><h1 \nng-switch-when=\"edit\">Edit Site Account User</h1></div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">First Name <span>*</span></label><input \nname=\"firstName\" ng-model=\"vm.userData.firstName\" required><div ng-messages=\"saveForm.firstName.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label class=\"g2e-required-label\">Last Name <span>*</span></label><input name=\"lastName\" \nng-model=\"vm.userData.lastName\" required><div ng-messages=\"saveForm.lastName.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label class=\"g2e-required-label\">Email <span>*</span></label><input type=\"email\" name=\"userEmail\" \nng-model=\"vm.userData.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"saveForm.userEmail.$error\"><div \nng-message-exp=\"[\'required\', \'pattern\']\">Please enter a valid Email address.</div></div></md-input-container></div><div\n layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Password</label><input \ntype=\"password\" name=\"userPassword\" ng-model=\"vm.userPassword\" ng-change=\"vm.validatePasswordConfirm()\" \nplaceholder=\"System Generated\"><div ng-messages=\"saveForm.userPassword.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label class=\"g2e-required-label\">Confirmation</label><input type=\"password\" name=\"userPasswordConfirm\" \nng-model=\"vm.userPasswordConfirm\" ng-change=\"vm.validatePasswordConfirm()\" placeholder=\"System Generated\"><div \nng-messages=\"saveForm.userPasswordConfirm.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.errMsg\"><div class=\"error-message\">{{vm.errMsg}}</div></div><div\n layout=\"row\" layout-align=\"left center\" ng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span>{{vm.msg}}</span></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\"><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deleteSiteUser($event)\" ng-show=\"vm.mode==\'edit\'\" \nng-disabled=\"vm.isSaving\">Delete User</md-button><md-button class=\"md-raised md-background-fg md-grey-700-bg\" \nng-click=\"vm.updateSiteUser(true)\" \nng-disabled=\"saveForm.$invalid ||\n                              vm.isSaving ||\n                              !vm.validatePasswordConfirm() ||\n                              vm.userPassword\">\nSave & Send Welcome Email</md-button><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.updateSiteUser(false)\" \nng-disabled=\"saveForm.$invalid ||\n                              vm.isSaving ||\n                              !vm.validatePasswordConfirm()\">\nSave</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/change-visibility-dialog.tmpl.html","<md-dialog aria-label=\"Change Visibility\" ng-cloak flex=\"40\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>Change Visibility</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Visibility Type <span>*</span></label>\n<md-select name=\"visibility\" ng-model=\"vm.visibility\" required><md-option value=\"{{ vis.name }}\" \nng-repeat=\"vis in vm.visibilitiesData\">{{ vis.label }}</md-option></md-select><div \nng-messages=\"saveForm.visibility.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n</div><div layout=\"row\" layout-align=\"left center\" ng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span>{{vm.msg}}</span></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.updateVisibility()\" ng-disabled=\"saveForm.$invalid || vm.isSaving\">Save\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/edit-parentadmins-dialog.tmpl.html","<md-dialog aria-label=\"Edit G2E Administrators\" ng-cloak flex=\"60\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>Edit G2E Administrators</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pt-0 pb-0\" \nclass=\"loading-overlay\" bs-loading-overlay=\"admin_groups_loader\" style=\"min-height: 400px\"><div layout=\"row\"><div \nclass=\"md-toolbar-tools\"><span flex></span><md-button class=\"md-raised md-background-fg md-grey-600-bg\" \nng-click=\"vm.openAddAdminGroupDlg($event,\'add\')\">Add New Group</md-button></div></div><div layout=\"row\" \nng-repeat=\"group in vm.adminGroups\"><div flex><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\" style=\"background-color: #eeeeee\"><span>{{ group.groupName }}</span> <span flex></span>\n<md-button class=\"md-raised md-background-fg md-grey-600-bg\" ng-click=\"vm.openAddAdminGroupDlg($event,\'edit\',group)\">\nEdit</md-button></div></md-toolbar><md-table-container><table md-table class=\"first-padding\"><thead md-head \nmd-order=\"group.order\"><tr md-row><th md-column class=\"text-left\" md-order-by=\"firstName\" width=\"20%\">First Name</th>\n<th md-column class=\"text-left\" md-order-by=\"lastName\" width=\"20%\">Last Name</th><th md-column class=\"text-left\" \nmd-order-by=\"email\">Email</th><th md-column class=\"text-left\" md-order-by=\"role\" width=\"20%\">User Role</th><th \nmd-column class=\"text-right\" width=\"40px\"></th></tr></thead><tbody md-body><tr md-row ng-if=\"group.Users.length == 0\">\n<td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"user in group.Users | sortByWithEmpty: group.order\"><td md-cell class=\"text-left\">{{ user.firstName }}</td>\n<td md-cell class=\"text-left\">{{ user.lastName }}</td><td md-cell class=\"text-left\"><a href=\"mailto:{{ user.email }}\">\n{{ user.email }}</a></td><td md-cell class=\"text-left\">{{ user.Roles | pluckJoin:\'id\':\'title\' }}</td><td md-cell \nclass=\"text-right\"><md-button class=\"md-icon-button\" aria-label=\"Remove\" \nng-click=\"vm.removeAdminGroupUser($event,group,user)\"><md-icon md-font-icon=\"icon-cancel\" class=\"icon\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"border-top\"><span flex></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.close()\" \nmd-autofocus ng-disabled=\"vm.isSaving\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/import-badge-dialog.tmpl.html","<md-dialog aria-label=\"Import Badge List\" ng-cloak id=\"import-badge-dialog\" flex=\"60\" class=\"loading-overlay\" \nbs-loading-overlay=\"import_badge_loader\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 ng-if=\"vm.step==1\">\nImport Badge List</h1><h1 ng-if=\"vm.step==2\">Badge List Results</h1><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"step1\" ng-show=\"vm.step==1\"><h3>\nMust be a CSV file with columns in the proper format. <a ng-href=\"{{vm.csvSampleLink}}\" target=\"_blank\">\nDownload a sample file here.</a></h3><div class=\"drop-box\" ngf-drop ng-model=\"file\" \nngf-change=\"vm.onChangeFile($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)\" \nngf-drag-over-class=\"\'dragover\'\" accept=\".CSV\" ngf-pattern=\"\'.CSV\'\"><div class=\"info\"><h1>Drag and drop .csv file here\n</h1><h3>Or select your file to upload</h3><md-button class=\"md-raised md-accent\" ngf-select ng-model=\"file\" \nngf-keep=\"true\" ngf-change=\"vm.onChangeFile($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)\" \naccept=\".CSV\" ngf-pattern=\"\'.CSV\'\">select file...</md-button><h1>{{vm.file.name}}</h1></div></div><div \nngf-no-file-drop>File Drag/Drop is not supported for this browser</div></div><div class=\"step2\" ng-show=\"vm.step==2\">\n<h3>Results: {{ vm.badges.length }} badges to be uploaded</h3><md-table-container class=\"max-fixed-height blue-scroll\">\n<table md-table><thead md-head md-order=\"vm.badgesTable.order\" fix-head><tr md-row><th md-column class=\"text-left\" \nmd-order-by=\"badgeId\">Badge ID</th><th md-column class=\"text-left\" md-order-by=\"name\">Badge Name</th><th md-column \nclass=\"text-left\" md-order-by=\"department\">Department</th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.badges.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"badge in vm.badges | sortByWithEmpty: vm.badgesTable.order\"><td md-cell class=\"text-left\">\n{{badge[\'badgeId\']}}</td><td md-cell class=\"text-left\">{{badge[\'name\']}}</td><td md-cell class=\"text-left\">\n{{badge[\'department\']}}</td></tr></tbody></table></md-table-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"border-top\" ng-if=\"vm.step==1\"><span flex></span><md-button class=\"md-raised\" \nng-click=\"vm.close()\" md-autofocus>Cancel</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.gotoStep(2)\" \nng-disabled=\"!vm.file || vm.isLoading\">Next</md-button></md-dialog-actions><md-dialog-actions layout=\"row\" \nclass=\"border-top\" ng-if=\"vm.step==2\"><md-button class=\"md-raised md-background-fg md-grey-700-bg\" \nng-click=\"vm.gotoStep(1)\" ng-disabled=\"vm.isLoading\">Select a difference file</md-button><span flex></span><md-button \nclass=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isLoading\">Cancel</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.uploadBadges()\" ng-disabled=\"!vm.file || vm.badges.length==0 || vm.isLoading\">\nAdd Badges</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/dashboard/site/select-installation-dialog.tmpl.html","<md-dialog aria-label=\"Select Installation\" ng-cloak flex=\"40\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>Select Installation</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Site <span>*</span></label><md-select \nname=\"site\" ng-model=\"vm.siteData.id\" ng-disabled=\"true\" required><md-option value=\"{{ vm.siteData.id }}\">\n{{ vm.siteData.name }}</md-option></md-select><div ng-messages=\"saveForm.site.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label class=\"g2e-required-label\">Installation Name <span>*</span></label><md-select name=\"installation\" \nng-model=\"vm.newInstallationId\" required><md-option value=\"null\">Not Assigned</md-option><md-option \nvalue=\"{{ inst.id }}\" ng-repeat=\"inst in vm.installationsData | orderBy:\'Customer.name\'\">{{ inst.Customer.name }}\n</md-option></md-select><div ng-messages=\"saveForm.installation.$error\"><div ng-message=\"required\">This is required.\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"left center\" ng-if=\"vm.msg\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\" ng-if=\"vm.isSaving\">\n</md-progress-circular><span>{{vm.msg}}</span></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"border-top\"><span flex></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.selectInstallation()\" \nng-disabled=\"saveForm.$invalid || vm.isSaving || vm.newInstallationId === vm.oldInstallationId\">Save</md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/site/site-account-dialog.tmpl.html","<md-dialog class=\"fullscreen-anyway\" aria-label=\"Site Accounts\" ng-cloak id=\"site-account-dialog\" \nclass=\"loading-overlay\" bs-loading-overlay=\"site_account_loader\"><md-toolbar class=\"md-background-bg border-bottom\">\n<div class=\"md-toolbar-tools\"><h1>Site Accounts</h1><span flex></span><md-button class=\"pl-24 md-icon-button\" \naria-label=\"Close\" ng-click=\"vm.close()\"><img src=\"/assets/images/icons/btn-close.png\"></md-button></div></md-toolbar>\n<md-dialog-content><md-tabs md-dynamic-height md-border-bottom md-selected=\"vm.tabIndexSelected\"><md-tab \nlabel=\"Accounts and Users\" md-on-select=\"vm.accTab.init()\"><md-content class=\"md-padding\" id=\"acc-tab-content\"><form>\n<div class=\"filter-bar\" layout=\"row\"><md-autocomplete md-input-name=\"company\" md-min-length=\"0\" \nmd-no-cache=\"vm.accTab.noCache\" md-selected-item-change=\"vm.accTab.selectedCompanyChange(item)\" \nmd-selected-item=\"vm.accTab.selectedCompany\" md-search-text=\"vm.accTab.searchCompany\" \nmd-search-text-change=\"vm.accTab.searchCompanyTextChange(vm.accTab.searchCompany)\" \nmd-items=\"item in vm.accTab.queryCompany(vm.accTab.searchCompany)\" md-item-text=\"item.name\" \nmd-floating-label=\"Company\" ng-disabled=\"vm.isLoading || vm.accTab.isLoading\"><md-item-template><span \nmd-highlight-text=\"vm.accTab.searchCompany\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template>\n<md-not-found>No matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"division\" \nmd-min-length=\"0\" md-no-cache=\"vm.accTab.noCache\" md-selected-item-change=\"vm.accTab.selectedDivisionChange(item)\" \nmd-selected-item=\"vm.accTab.selectedDivision\" md-search-text=\"vm.accTab.searchDivision\" \nmd-search-text-change=\"vm.accTab.searchDivisionTextChange(vm.accTab.searchDivision)\" \nmd-items=\"item in vm.accTab.queryDivision(vm.accTab.searchDivision)\" md-item-text=\"item.name\" \nmd-floating-label=\"Regional Division\" ng-disabled=\"!vm.accTab.selectedCompany || vm.accTab.isLoading\">\n<md-item-template><span md-highlight-text=\"vm.accTab.searchDivision\" md-highlight-flags=\"^i\">{{item.name}}</span>\n</md-item-template><md-not-found>No matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"site\" \nmd-min-length=\"0\" md-no-cache=\"vm.accTab.noCache\" md-selected-item-change=\"vm.accTab.selectedSiteChange(item)\" \nmd-selected-item=\"vm.accTab.selectedSite\" md-search-text=\"vm.accTab.searchSite\" \nmd-search-text-change=\"vm.accTab.searchSiteTextChange(vm.accTab.searchSite)\" \nmd-items=\"item in vm.accTab.querySite(vm.accTab.searchSite)\" md-item-text=\"item.name\" md-floating-label=\"Site\" \nng-disabled=\"!vm.accTab.selectedCompany || vm.accTab.isLoading\"><md-item-template><span \nmd-highlight-text=\"vm.accTab.searchSite\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching...</md-not-found></md-autocomplete><span flex=\"\"></span><div class=\"pt-8\" \nng-show=\"vm.accTab.selectedCompany\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.accTab.openAddDivisionDlg($event,\'add\')\" ng-disabled=\"vm.accTab.isLoading\">Add Regional Division\n</md-button></div></div></form><div ng-show=\"vm.accTab.selectedCompany\"><md-table-container \nclass=\"fixed-height blue-scroll\"><table md-table><thead md-head md-order=\"vm.accTab.divisionsTable.order\" fix-head><tr \nmd-row><th md-column></th><th md-column class=\"text-left\" md-order-by=\"name\">Division</th><th md-column \nclass=\"text-left\">Description</th><th md-column md-order-by=\"sites_length\"># of Sites</th><th md-column \nclass=\"text-left\" md-order-by=\"contact\">Regional Division Contact</th><th md-column class=\"text-left\" \nmd-order-by=\"phone\">Regional Division Contact Phone</th><th md-column class=\"text-left\" md-order-by=\"email\">\nRegional Division Contact Email</th></tr></thead><tbody md-body ng-if=\"vm.accTab.divisions.length == 0\"><tr md-row><td \nmd-cell colspan=\"100\">{{ vm.accTab.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody><tbody \nmd-body \nng-repeat=\"division in vm.accTab.divisions | filter: {id: vm.accTab.selectedDivision.id}: true | sortByWithEmpty: vm.accTab.divisionsTable.order | limitTo: vm.accTab.divisionsTable.pagination.limit: (vm.accTab.divisionsTable.pagination.page - 1) * vm.accTab.divisionsTable.pagination.limit\">\n<tr md-row ng-class=\"{\'selected\': division.isExpanded}\"><td md-cell class=\"cell-expand\" \nng-click=\"division.isExpanded = !division.isExpanded;\"><i \nng-class=\"{\'icon-chevron-right\':!division.isExpanded,\'icon-chevron-down\':division.isExpanded}\"></i></td><td md-cell \nclass=\"text-left\"><a href=\"\" ng-click=\"vm.accTab.openAddDivisionDlg($event,\'edit\',division)\">{{division.name}}</a></td>\n<td md-cell class=\"text-left\">{{division.description}}</td><td md-cell><span>{{division.sites_length}}</span></td><td \nmd-cell class=\"text-left\">{{division.contact}}</td><td md-cell class=\"text-left\">{{division.phone}}</td><td md-cell \nclass=\"text-left\"><a href=\"mailto:{{division.email}}\">{{division.email}}</a></td></tr><tr class=\"has-child-table\"><td \ncolspan=\"100\" ng-if=\"division.isExpanded\"><div class=\"child-table-container\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span>Sites</span> <span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.accTab.openAddSiteDlg($event,\'add\',division)\">Add Site</md-button></div>\n</md-toolbar><md-table-container><table md-table><thead md-head md-order=\"vm.accTab.sitesTable.order\"><tr md-row><th \nmd-column></th><th md-column class=\"text-left\" md-order-by=\"name\">Site Name</th><th md-column \nmd-order-by=\"users_length\"># of Users</th><th md-column>Visibility Manager</th><th md-column>Benchmarking</th><th \nmd-column>G2E Administrators</th><th md-column>Edit Site Attributes</th></tr></thead><tbody md-body \nng-if=\"division.Sites.length == 0\"><tr md-row><td md-cell colspan=\"100\">No data available in table</td></tr></tbody>\n<tbody md-body \nng-repeat=\"site in division.Sites | filter: {id: vm.accTab.selectedSite.id}: true | sortByWithEmpty: vm.accTab.sitesTable.order\">\n<tr md-row ng-class=\"{\'selected\': site.isExpanded}\"><td md-cell class=\"cell-expand\" \nng-click=\"site.isExpanded = !site.isExpanded;\"><i \nng-class=\"{\'icon-chevron-right\':!site.isExpanded,\'icon-chevron-down\':site.isExpanded}\"></i></td><td md-cell \nclass=\"text-left\"><a href=\"\" ng-click=\"vm.accTab.openAddSiteDlg($event,\'edit\',division,site)\">{{site.name}}</a></td><td\n md-cell><span>{{site.users_length}}</span></td><td md-cell><md-button class=\"md-icon-button md-accent\" \naria-label=\"Visibility Manager\" ng-click=\"vm.gotoVisibilityManager(vm.accTab.selectedCompany.id, site.id)\"><i \nclass=\"icon-eye\"></i></md-button></td><td md-cell><md-button class=\"md-icon-button md-accent\" \naria-label=\"Benchmarking\" ng-click=\"vm.gotoBenchMarking(vm.accTab.selectedCompany.id, site.id)\"><i \nclass=\"icon-poll-box\"></i></md-button></td><td md-cell><md-button class=\"md-icon-button md-accent\" \naria-label=\"G2E Administrators\" ng-click=\"vm.accTab.openEditParentAdminsDlg($event,site)\"><i \nclass=\"icon-account-multiple\"></i></md-button></td><td md-cell><md-button class=\"md-icon-button md-accent\" \naria-label=\"Edit Site Attributes\" ng-click=\"vm.accTab.openSiteAttrDlg($event,site,1)\"><i class=\"icon-store\"></i>\n</md-button></td></tr><tr class=\"has-child-table\"><td colspan=\"100\" ng-if=\"site.isExpanded\"><div \nclass=\"child-table-container\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span>Users\n</span> <span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.accTab.openAddSiteUserDlg($event,\'add\',site)\">Add User</md-button></div></md-toolbar><md-table-container>\n<table md-table><thead md-head md-order=\"vm.accTab.usersTable.order\"><tr md-row><th md-column class=\"text-left\" \nmd-order-by=\"firstName\">First Name</th><th md-column class=\"text-left\" md-order-by=\"lastName\">Last Name</th><th \nmd-column class=\"text-left\" md-order-by=\"email\">Email</th><th md-column class=\"text-left\" md-order-by=\"createdAt\">\nCreated</th><th md-column class=\"text-left\" md-order-by=\"lastAccessedAt\">Last Accessed</th></tr></thead><tbody md-body>\n<tr md-row ng-if=\"site.Users.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"user in site.Users | sortByWithEmpty: vm.accTab.usersTable.order\"><td md-cell class=\"text-left\"><a href=\"\" \nng-click=\"vm.accTab.openAddSiteUserDlg($event,\'edit\',site,user)\">{{user.firstName}}</a></td><td md-cell \nclass=\"text-left\"><a href=\"\" ng-click=\"vm.accTab.openAddSiteUserDlg($event,\'edit\',site,user)\">{{user.lastName}}</a>\n</td><td md-cell class=\"text-left\"><a href=\"mailto:{{user.email}}\">{{user.email}}</a></td><td md-cell \nclass=\"text-left\">{{user.createdAt | date: \'MM/dd/yyyy\'}}</td><td md-cell class=\"text-left\">\n{{user.lastAccessedAt | date: \'MM/dd/yyyy\'}}</td></tr></tbody></table></md-table-container></div></td></tr></tbody>\n</table></md-table-container></div></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"vm.accTab.divisionsTable.pagination.limit\" md-limit-options=\"vm.accTab.divisionsTable.pagination.lengths\" \nmd-page=\"vm.accTab.divisionsTable.pagination.page\" \nmd-total=\"{{ (vm.accTab.divisions | filter: {id: vm.accTab.selectedDivision.id}: true).length }}\" md-page-select>\n</md-table-pagination></div></md-content></md-tab><md-tab label=\"Visibility Manager\" md-on-select=\"vm.visTab.init()\">\n<md-content class=\"md-padding\" id=\"vis-tab-content\"><form><div class=\"filter-bar\" layout=\"row\"><md-autocomplete \nmd-input-name=\"company\" md-min-length=\"0\" md-no-cache=\"vm.visTab.noCache\" \nmd-selected-item-change=\"vm.visTab.selectedCompanyChange(item)\" md-selected-item=\"vm.visTab.selectedCompany\" \nmd-search-text=\"vm.visTab.searchCompany\" \nmd-search-text-change=\"vm.visTab.searchCompanyTextChange(vm.visTab.searchCompany)\" \nmd-items=\"item in vm.visTab.queryCompany(vm.visTab.searchCompany)\" md-item-text=\"item.name\" \nmd-floating-label=\"Company\" ng-disabled=\"vm.isLoading || vm.visTab.isLoading\"><md-item-template><span \nmd-highlight-text=\"vm.visTab.searchCompany\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template>\n<md-not-found>No matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"division\" \nmd-min-length=\"0\" md-no-cache=\"vm.visTab.noCache\" md-selected-item-change=\"vm.visTab.selectedDivisionChange(item)\" \nmd-selected-item=\"vm.visTab.selectedDivision\" md-search-text=\"vm.visTab.searchDivision\" \nmd-search-text-change=\"vm.visTab.searchDivisionTextChange(vm.visTab.searchDivision)\" \nmd-items=\"item in vm.visTab.queryDivision(vm.visTab.searchDivision)\" md-item-text=\"item.name\" \nmd-floating-label=\"Regional Division\" ng-disabled=\"!vm.visTab.selectedCompany || vm.visTab.isLoading\">\n<md-item-template><span md-highlight-text=\"vm.visTab.searchDivision\" md-highlight-flags=\"^i\">{{item.name}}</span>\n</md-item-template><md-not-found>No matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"site\" \nmd-min-length=\"0\" md-no-cache=\"vm.visTab.noCache\" md-selected-item-change=\"vm.visTab.selectedSiteChange(item)\" \nmd-selected-item=\"vm.visTab.selectedSite\" md-search-text=\"vm.visTab.searchSite\" \nmd-search-text-change=\"vm.visTab.searchSiteTextChange(vm.visTab.searchSite)\" \nmd-items=\"item in vm.visTab.querySite(vm.visTab.searchSite)\" md-item-text=\"item.name\" md-floating-label=\"Site\" \nng-disabled=\"!vm.visTab.selectedCompany || vm.visTab.isLoading\"><md-item-template><span \nmd-highlight-text=\"vm.visTab.searchSite\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching...</md-not-found></md-autocomplete><span flex=\"\"></span><div class=\"pt-8\" \nng-show=\"vm.visTab.expendedSite != null\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.visTab.isLoading || !vm.visTab.isVisibilityChanged\" ng-click=\"vm.visTab.updateSiteVisibilities()\">Save\n</md-button></div></div></form><div ng-show=\"vm.visTab.selectedCompany\"><md-table-container \nclass=\"fixed-height blue-scroll\"><table md-table><thead md-head md-order=\"vm.visTab.sitesTable.order\" fix-head><tr \nmd-row><th md-column></th><th md-column class=\"text-left\" md-order-by=\"name\">Site Name</th><th md-column \nclass=\"text-left\" md-order-by=\"Division.name\">Regional Division</th><th md-column class=\"text-left\" \nmd-order-by=\"Installation.Customer.name\">Installation Name</th><th md-column></th><th md-column \nmd-order-by=\"InstallationId\">Installation ID</th><th md-column md-order-by=\"Installation.Tank.iotActivationDateObj\">\nInstallation Activation Date</th><th md-column class=\"text-left\" md-order-by=\"Installation.Customer.address\">\nStreet Address</th><th md-column class=\"text-left\" md-order-by=\"Installation.Customer.city\">City</th><th md-column \nclass=\"text-left\" md-order-by=\"Installation.Customer.state\">State (Region)</th><th md-column \nmd-order-by=\"Installation.Customer.zipcode\">ZIP</th></tr></thead><tbody md-body ng-if=\"vm.visTab.sites.length == 0\"><tr\n md-row><td md-cell colspan=\"100\">{{ vm.visTab.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody>\n<tbody md-body \nng-repeat=\"site in vm.visTab.sites | filter: {id: vm.visTab.selectedSite.id, DivisionId: vm.visTab.selectedDivision.id}: true | sortByWithEmpty: vm.visTab.sitesTable.order | limitTo: vm.visTab.sitesTable.pagination.limit: (vm.visTab.sitesTable.pagination.page - 1) * vm.visTab.sitesTable.pagination.limit\">\n<tr md-row ng-class=\"{\'selected\': site.isExpanded}\"><td md-cell class=\"cell-expand\" \nng-click=\"vm.visTab.expendSite(site, !site.isExpanded)\"><i \nng-class=\"{\'icon-chevron-right\':!site.isExpanded,\'icon-chevron-down\':site.isExpanded}\"></i></td><td md-cell \nclass=\"text-left\">{{ site.name }}</td><td md-cell class=\"text-left\">{{ site.Division.name }}</td><td md-cell \nclass=\"text-left\"><span ng-if=\"site.Installation\">{{ site.Installation.Customer.name }}</span> <span \nng-if=\"!site.Installation\">Not Assigned</span></td><td md-cell><md-button class=\"md-icon-button md-accent\" \naria-label=\"Select Installation\" ng-click=\"vm.visTab.openSelectInstallationDlg($event,site)\"><i class=\"icon-link\"></i>\n</md-button></td><td md-cell>{{ (site.Installation)?site.Installation.id:\'\' }}</td><td md-cell>\n{{ (site.Installation)?site.Installation.Tank.iotActivationDate:\'\' }}</td><td md-cell class=\"text-left\">\n{{ (site.Installation)?site.Installation.Customer.address:\'\' }}</td><td md-cell class=\"text-left\">\n{{ (site.Installation)?site.Installation.Customer.city:\'\' }}</td><td md-cell class=\"text-left\">\n{{ (site.Installation)?site.Installation.Customer.state:\'\' }}</td><td md-cell>\n{{ (site.Installation)?site.Installation.Customer.zipcode:\'\' }}</td></tr><tr class=\"has-child-table\"><td colspan=\"100\" \nng-if=\"site.isExpanded\"><div class=\"child-table-container\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><span>Key Metrics</span></div></md-toolbar><metric-table data=\"site.metrics\" \nresult=\"site.selectedMetrics\"></metric-table></div><div class=\"child-table-container\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span>Training Materials</span> <span flex></span>\n</div></md-toolbar><md-table-container><table md-table md-row-select multiple=\"true\" ng-model=\"site.selectedMedias\">\n<thead md-head><tr md-row><th md-column class=\"text-left\">Select All</th></tr></thead><tbody md-body><tr md-row \nmd-select=\"media\" md-select-id=\"id\" md-auto-select ng-repeat=\"media in vm.medias\"><td md-cell class=\"text-left\">\n{{ media.title }}</td></tr></tbody></table></md-table-container></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.visTab.sitesTable.pagination.limit\" \nmd-limit-options=\"vm.visTab.sitesTable.pagination.lengths\" md-page=\"vm.visTab.sitesTable.pagination.page\" \nmd-total=\"{{ (vm.visTab.sites | filter: {id: vm.visTab.selectedSite.id, DivisionId: vm.visTab.selectedDivision.id}: true).length }}\" \nmd-page-select></md-table-pagination></div></md-content></md-tab><md-tab label=\"Benchmarking\" \nmd-on-select=\"vm.benTab.init()\"><md-content class=\"md-padding\" id=\"ben-tab-content\"><form><div class=\"filter-bar\" \nlayout=\"row\"><md-autocomplete md-input-name=\"company\" md-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" \nmd-selected-item-change=\"vm.benTab.selectedCompanyChange(item)\" md-selected-item=\"vm.benTab.selectedCompany\" \nmd-search-text=\"vm.benTab.searchCompany\" \nmd-search-text-change=\"vm.benTab.searchCompanyTextChange(vm.benTab.searchCompany)\" \nmd-items=\"item in vm.benTab.queryCompany(vm.benTab.searchCompany)\" md-item-text=\"item.name\" \nmd-floating-label=\"Company\" ng-disabled=\"vm.isLoading || vm.benTab.isLoading\"><md-item-template><span \nmd-highlight-text=\"vm.benTab.searchCompany\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template>\n<md-not-found>No matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"division\" \nmd-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" md-selected-item-change=\"vm.benTab.selectedDivisionChange(item)\" \nmd-selected-item=\"vm.benTab.selectedDivision\" md-search-text=\"vm.benTab.searchDivision\" \nmd-search-text-change=\"vm.benTab.searchDivisionTextChange(vm.benTab.searchDivision)\" \nmd-items=\"item in vm.benTab.queryDivision(vm.benTab.searchDivision)\" md-item-text=\"item.name\" \nmd-floating-label=\"Regional Division\" ng-disabled=\"!vm.benTab.selectedCompany || vm.benTab.isLoading\">\n<md-item-template><span md-highlight-text=\"vm.benTab.searchDivision\" md-highlight-flags=\"^i\">{{item.name}}</span>\n</md-item-template><md-not-found>No matching...</md-not-found></md-autocomplete><md-autocomplete md-input-name=\"site\" \nmd-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" md-selected-item-change=\"vm.benTab.selectedSiteChange(item)\" \nmd-selected-item=\"vm.benTab.selectedSite\" md-search-text=\"vm.benTab.searchSite\" \nmd-search-text-change=\"vm.benTab.searchSiteTextChange(vm.benTab.searchSite)\" \nmd-items=\"item in vm.benTab.querySite(vm.benTab.searchSite)\" md-item-text=\"item.name\" md-floating-label=\"Site\" \nng-disabled=\"!vm.benTab.selectedCompany || vm.benTab.isLoading\"><md-item-template><span \nmd-highlight-text=\"vm.benTab.searchSite\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching...</md-not-found></md-autocomplete><span flex=\"\"></span><div class=\"pt-8\" ng-show=\"vm.benTab.selectedSite\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.benTab.openChangeVisibilityDlg($event)\" \nng-disabled=\"vm.benTab.benchmarkingsTable.selected.length === 0 || vm.benTab.isLoading\">Change Visibility</md-button>\n</div></div></form><div ng-show=\"vm.benTab.selectedSite\"><md-table-container class=\"fixed-height blue-scroll\"><table \nmd-table><thead md-head md-order=\"vm.benTab.benchmarkingsTable.order\" fix-head><tr md-row><th md-column><md-checkbox \naria-label=\"Choose All Rows\" ng-click=\"vm.benTab.chooseAllBenchmarkingsTableRows()\" \nng-checked=\"vm.benTab.isSelectedAllBenchmarkingsTableRows()\"></md-checkbox></th><th md-column class=\"text-left\" \nmd-order-by=\"Division.Company.name\">Company</th><th md-column class=\"text-left\" md-order-by=\"Division.name\">\nRegional Division</th><th md-column class=\"text-left\" md-order-by=\"name\">Site Name</th><th md-column class=\"text-left\" \nmd-order-by=\"Installation.Customer.address\">Street Address</th><th md-column class=\"text-left\" \nmd-order-by=\"Installation.Customer.city\">City</th><th md-column class=\"text-left\" \nmd-order-by=\"Installation.Customer.state\">State (Region)</th><th md-column class=\"text-left\" \nmd-order-by=\"Installation.Customer.zipcode\">ZIP</th><th md-column class=\"text-left\" \nmd-order-by=\"BenchMarking.visibility\" style=\"background: #fff9dd; width: 120px\">Visibility</th></tr></thead><tbody \nmd-body><tr md-row><td md-cell></td><td md-cell class=\"filter-cell\"><md-chips \nng-model=\"vm.benTab.benchmarkingsTable.filters[0].queries\" placeholder=\"filter compaines\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-input-name=\"companyFilter\" \nmd-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" md-search-text=\"vm.benTab.companyFilterText\" \nmd-selected-item-change=\"vm.benTab.onChangeCompanyFilter()\" \nmd-items=\"item in vm.benTab.queryCompanyFilter(vm.benTab.companyFilterText)\" md-item-text=\"item\" \nplaceholder=\"filter compaines\"><md-item-template><span md-highlight-text=\"vm.benTab.companyFilterText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span>\n</md-chip-template></md-chips></td><td md-cell class=\"filter-cell\"><md-chips \nng-model=\"vm.benTab.benchmarkingsTable.filters[1].queries\" placeholder=\"filter divisions\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-input-name=\"divisionFilter\" \nmd-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" md-search-text=\"vm.benTab.divisionFilterText\" \nmd-selected-item-change=\"vm.benTab.onChangeDivisionFilter()\" \nmd-items=\"item in vm.benTab.queryDivisionFilter(vm.benTab.divisionFilterText)\" md-item-text=\"item\" \nplaceholder=\"filter divisions\"><md-item-template><span md-highlight-text=\"vm.benTab.divisionFilterText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span>\n</md-chip-template></md-chips></td><td md-cell class=\"filter-cell\"><md-chips \nng-model=\"vm.benTab.benchmarkingsTable.filters[2].queries\" placeholder=\"filter sites\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-input-name=\"siteFilter\" \nmd-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" md-search-text=\"vm.benTab.siteFilterText\" \nmd-selected-item-change=\"vm.benTab.onChangeSiteFilter()\" \nmd-items=\"item in vm.benTab.querySiteFilter(vm.benTab.siteFilterText)\" md-item-text=\"item\" placeholder=\"filter sites\">\n<md-item-template><span md-highlight-text=\"vm.benTab.siteFilterText\" md-highlight-flags=\"^i\">{{item}}</span>\n</md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span></md-chip-template></md-chips></td><td \nmd-cell></td><td md-cell class=\"filter-cell\"><md-chips ng-model=\"vm.benTab.benchmarkingsTable.filters[3].queries\" \nplaceholder=\"filter cities\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\">\n<md-autocomplete md-input-name=\"cityFilter\" md-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" \nmd-search-text=\"vm.benTab.cityFilterText\" md-selected-item-change=\"vm.benTab.onChangeCityFilter()\" \nmd-items=\"item in vm.benTab.queryCityFilter(vm.benTab.cityFilterText)\" md-item-text=\"item\" placeholder=\"filter cities\">\n<md-item-template><span md-highlight-text=\"vm.benTab.cityFilterText\" md-highlight-flags=\"^i\">{{item}}</span>\n</md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span></md-chip-template></md-chips></td><td \nmd-cell class=\"filter-cell\"><md-chips ng-model=\"vm.benTab.benchmarkingsTable.filters[4].queries\" \nplaceholder=\"filter states\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\">\n<md-autocomplete md-input-name=\"stateFilter\" md-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" \nmd-search-text=\"vm.benTab.stateFilterText\" md-selected-item-change=\"vm.benTab.onChangeStateFilter()\" \nmd-items=\"item in vm.benTab.queryStateFilter(vm.benTab.stateFilterText)\" md-item-text=\"item\" \nplaceholder=\"filter states\"><md-item-template><span md-highlight-text=\"vm.benTab.stateFilterText\" \nmd-highlight-flags=\"^i\">{{item}}</span></md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span>\n</md-chip-template></md-chips></td><td md-cell class=\"filter-cell\"><md-chips \nng-model=\"vm.benTab.benchmarkingsTable.filters[5].queries\" placeholder=\"filter ZIPs\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\"><md-autocomplete md-input-name=\"zipFilter\" \nmd-min-length=\"0\" md-no-cache=\"vm.benTab.noCache\" md-search-text=\"vm.benTab.zipFilterText\" \nmd-selected-item-change=\"vm.benTab.onChangeZipFilter()\" \nmd-items=\"item in vm.benTab.queryZipFilter(vm.benTab.zipFilterText)\" md-item-text=\"item\" placeholder=\"filter ZIPs\">\n<md-item-template><span md-highlight-text=\"vm.benTab.zipFilterText\" md-highlight-flags=\"^i\">{{item}}</span>\n</md-item-template></md-autocomplete><md-chip-template><span>{{$chip}}</span></md-chip-template></md-chips></td><td \nmd-cell></td></tr></tbody><tbody md-body ng-if=\"vm.benTab.benchmarkings.length == 0\"><tr md-row><td md-cell \ncolspan=\"100\">{{ vm.benTab.isLoading?\'Loading...\':\'No data available in table\' }}</td></tr></tbody><tbody md-body><tr \nmd-row \nng-repeat=\"site in vm.benTab.benchmarkings |\n                      benchBy: vm.benTab.benchmarkingsTable.filters |\n                      sortByWithEmpty: vm.benTab.benchmarkingsTable.order |\n                      limitTo: vm.benTab.benchmarkingsTable.pagination.limit: (vm.benTab.benchmarkingsTable.pagination.page - 1) * vm.benTab.benchmarkingsTable.pagination.limit\" \nng-class=\"{\'selected\':vm.benTab.isSelectedBenchmarkingsTableRows(site)}\" \nng-click=\"vm.benTab.chooseBenchmarkingsTableRows(site)\"><td md-cell><md-checkbox aria-label=\"Choose Row\" \nng-checked=\"vm.benTab.isSelectedBenchmarkingsTableRows(site)\"></md-checkbox></td><td md-cell class=\"text-left\">\n{{ site.Division.Company.name }}</td><td md-cell class=\"text-left\">{{ site.Division.name }}</td><td md-cell \nclass=\"text-left\">{{ site.name }}</td><td md-cell class=\"text-left\">{{ site.Installation.Customer.address }}</td><td \nmd-cell class=\"text-left\">{{ site.Installation.Customer.city }}</td><td md-cell class=\"text-left\">\n{{ site.Installation.Customer.state }}</td><td md-cell class=\"text-left\">{{ site.Installation.Customer.zipcode }}</td>\n<td md-cell class=\"text-left\" style=\"background: #fff9dd; width: 120px\"><md-input-container><md-select \naria-label=\"Visibility\" ng-model=\"site.BenchMarking.visibility\" ng-change=\"vm.benTab.onChangeVisibility(site)\" \nng-disabled=\"site.BenchMarking.isUpdating === true\"><md-option value=\"{{ vis.name }}\" \nng-repeat=\"vis in vm.visibilities\">{{ vis.label }}</md-option></md-select></md-input-container></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"vm.benTab.benchmarkingsTable.pagination.limit\" \nmd-limit-options=\"vm.benTab.benchmarkingsTable.pagination.lengths\" \nmd-page=\"vm.benTab.benchmarkingsTable.pagination.page\" \nmd-total=\"{{(vm.benTab.benchmarkings | benchBy: vm.benTab.benchmarkingsTable.filters).length}}\" md-page-select>\n</md-table-pagination></div></md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/site/site-attribute-dialog.tmpl.html","<md-dialog aria-label=\"Site Attributes\" ng-cloak id=\"site-attribute-dialog\" flex=\"85\" class=\"loading-overlay\" \nbs-loading-overlay=\"site_attr_loader\"><md-toolbar><div class=\"md-toolbar-tools\"><h1>Site Attributes</h1><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"attr-header\"><div layout=\"row\"><div><md-button \naria-label=\"Toggle Left Menu\" ng-click=\"vm.toggleLeft()\" class=\"md-icon-button md-primary\" hide-gt-sm><md-icon \nmd-font-icon=\"icon-menu\"></md-icon></md-button></div><div><h1 class=\"title\">{{ vm.siteData.name }}</h1><h4 \nclass=\"address secondary-text\">\n{{vm.siteData.Installation?vm.siteData.Installation.Customer.address+\', \'+vm.siteData.Installation.Customer.city+\', \'+vm.siteData.Installation.Customer.state+\' \'+vm.siteData.Installation.Customer.zipcode:\'\'}}\n</h4></div></div></div><md-divider></md-divider><div class=\"attr-body\"><section layout=\"row\" flex><md-sidenav \nclass=\"md-sidenav-left md-whiteframe-1dp\" md-component-id=\"site-attr-left-side\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\">\n<md-content ms-scroll><div class=\"navigation-simple\" layout=\"column\"><div class=\"item subheader\">Site Information</div>\n<md-button class=\"item\" aria-label=\"Site Details\" ng-click=\"vm.onChangeTab(1)\" ng-class=\"{\'active\': vm.tab==1}\"><span \nclass=\"title\">Site Details</span></md-button><md-button class=\"item\" aria-label=\"Site Users\" \nng-click=\"vm.onChangeTab(2)\" ng-class=\"{\'active\': vm.tab==2}\" ng-if=\"vm.siteData.Installation\"><span class=\"title\">\nSite Users</span></md-button><md-button class=\"item\" aria-label=\"Contract Details\" ng-click=\"vm.onChangeTab(3)\" \nng-class=\"{\'active\': vm.tab==3}\" ng-if=\"vm.siteData.Installation && vm.currentUser.isAdminUser()\"><span class=\"title\">\nContract Details</span></md-button><md-button class=\"item\" aria-label=\"Badges and Shifts\" ng-click=\"vm.onChangeTab(4)\" \nng-class=\"{\'active\': vm.tab==4}\"><span class=\"title\">Badges and Shifts</span></md-button><div class=\"item subheader\">\nData Access</div><md-button class=\"item\" aria-label=\"Key Metrics\" ng-click=\"vm.onChangeTab(5)\" \nng-class=\"{\'active\': vm.tab==5}\"><span class=\"title\">Key Metrics</span></md-button><md-button class=\"item\" \naria-label=\"Benchmarking\" ng-click=\"vm.onChangeTab(6)\" ng-class=\"{\'active\': vm.tab==6}\"><span class=\"title\">\nBenchmarking</span></md-button><div class=\"item subheader\" ng-if=\"vm.siteData.Installation\">Support</div><md-button \nclass=\"item\" aria-label=\"G2E Administrators\" ng-click=\"vm.onChangeTab(7)\" ng-class=\"{\'active\': vm.tab==7}\" \nng-if=\"vm.siteData.Installation\"><span class=\"title\">G2E Administrators</span></md-button><md-button class=\"item\" \naria-label=\"Training\" ng-click=\"vm.onChangeTab(8)\" ng-class=\"{\'active\': vm.tab==8}\" ng-if=\"vm.siteData.Installation\">\n<span class=\"title\">Training</span></md-button></div></md-content></md-sidenav><md-content ms-scroll flex><div \nclass=\"tab-content\" ng-show=\"vm.tab==1\"><form name=\"siteForm\"><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"tab-content-header\"><h1 class=\"title\">Site Details</h1><md-button class=\"md-raised md-accent pull-right\" \nng-click=\"vm.saveSiteDetail()\" \nng-disabled=\"siteForm.$invalid || vm.isLoading || (!vm.isSiteDetailChanged() && !vm.isSiteContactDetailChanged())\" \nng-if=\"vm.currentUser.hasAdminRole() || vm.currentUser.hasSiteEditRole()\">Save</md-button></div><div \nclass=\"tab-content-body\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">\nSite Name<span ng-if=\"vm.isSiteNameEditable\">*</span></label><input name=\"siteName\" required \nng-model=\"vm.siteDetailForm.siteName\" ng-disabled=\"!vm.isSiteNameEditable\"><div ng-messages=\"siteForm.siteName.$error\" \nmultiple=\"multiple\"><div ng-message=\"required\">This is required.</div></div></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.siteData.Installation\"><md-input-container class=\"md-block\" flex><label>Address</label><input \nname=\"address\" ng-model=\"vm.siteData.Installation.Customer.address\" disabled=\"disabled\"></md-input-container></div><div\n layout=\"row\" ng-if=\"vm.siteData.Installation\"><md-input-container class=\"md-block\" flex=\"50\"><label>City</label><input\n name=\"city\" ng-model=\"vm.siteData.Installation.Customer.city\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>State</label><input name=\"state\" \nng-model=\"vm.siteData.Installation.Customer.state\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>ZIP</label><input name=\"zip\" ng-model=\"vm.siteData.Installation.Customer.zipcode\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label>\nCompany</label><input name=\"company\" ng-model=\"vm.siteData.Division.Company.name\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Division</label><input name=\"division\" \nng-model=\"vm.siteData.Division.name\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.siteData.Installation\"><md-input-container class=\"md-block\" flex=\"50\"><label>IoT Activation Date</label>\n<input name=\"iotActivationDate\" ng-model=\"vm.siteData.Installation.Tank.iotActivationDate\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Installation ID</label><input \nname=\"installationId\" ng-model=\"vm.siteData.Installation.id\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.siteData.Installation\"><md-input-container class=\"md-block\" flex=\"50\"><label>Contact Name\n</label><input name=\"contactName\" ng-model=\"vm.siteDetailForm.contactName\" \nng-disabled=\"!vm.isContactEditable || !vm.siteData.Installation\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Contact Title</label><input name=\"contactTitle\" ng-model=\"vm.siteDetailForm.contactTitle\" \nng-disabled=\"!vm.isContactEditable || !vm.siteData.Installation\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.siteData.Installation\"><md-input-container class=\"md-block\" flex=\"50\"><label>Contact Phone</label><input \nname=\"contactPhone\" ng-model=\"vm.siteDetailForm.contactPhone\" \nng-disabled=\"!vm.isContactEditable || !vm.siteData.Installation\" ui-mask=\"(999) 999-9999\" model-view-value=\"true\" \nui-options=\"{addDefaultPlaceholder:false}\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nContact Email</label><input type=\"email\" name=\"contactEmail\" ng-pattern=\"/^.+@.+\\..+$/\" \nng-model=\"vm.siteDetailForm.contactEmail\" ng-disabled=\"!vm.isContactEditable || !vm.siteData.Installation\"><div \nng-messages=\"siteForm.contactEmail.$error\"><div ng-message-exp=\"[\'pattern\']\">Please enter a valid Email address.</div>\n</div></md-input-container></div></div></form></div><div class=\"tab-content\" ng-show=\"vm.tab==2\"><div \nclass=\"tab-content-header\"><h1 class=\"title\">Site Users</h1><h5 class=\"description\">\nTo manage users, please contact your <a href=\"#\" ng-click=\"vm.selectTab(7)\">G2E Administrators</a>.</h5></div><div \nclass=\"tab-content-body\"><md-table-container id=\"usersTableContainer\" class=\"blue-scroll\"><table md-table><thead \nmd-head md-order=\"vm.usersTable.order\" fix-head><tr md-row><th md-column class=\"text-left\" md-order-by=\"firstName\">\nFirst Name</th><th md-column class=\"text-left\" md-order-by=\"lastName\">Last Name</th><th md-column class=\"text-left\" \nmd-order-by=\"email\">Email</th><th md-column class=\"text-left\" md-order-by=\"createdAt\">Created</th><th md-column \nclass=\"text-left\" md-order-by=\"lastAccessedAt\">Last Accessed</th><th md-column class=\"text-left\" \nng-if=\"vm.currentUser.hasAdminRole() || vm.currentUser.hasSiteEditRole()\">Welcome Email</th><th md-column \nclass=\"text-left\">List Serves</th></tr></thead><tbody md-body><tr md-row ng-if=\"vm.siteData.Users.length == 0\"><td \nmd-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"user in vm.siteData.Users | sortByWithEmpty: vm.usersTable.order\"><td md-cell class=\"text-left\">\n{{user.firstName}}</td><td md-cell class=\"text-left\">{{user.lastName}}</td><td md-cell class=\"text-left\"><a \nhref=\"mailto:{{user.email}}\">{{user.email}}</a></td><td md-cell class=\"text-left\">\n{{user.createdAt | date: \'MM/dd/yyyy\'}}</td><td md-cell class=\"text-left\">{{user.lastAccessedAt | date: \'MM/dd/yyyy\'}}\n</td><td md-cell class=\"text-left\" ng-if=\"vm.currentUser.hasAdminRole() || vm.currentUser.hasSiteEditRole()\"><a \nhref=\"#\" ng-click=\"vm.sendWelcomeEmail(user)\" ng-if=\"!user.isLoading\">Resend</a><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\" ng-if=\"user.isLoading\"></md-progress-circular></td><td \nmd-cell class=\"text-left\">{{ user.ListServs | pluckJoin:\'id\':\'title\' }}</td></tr></tbody></table></md-table-container>\n</div></div><div class=\"tab-content\" ng-show=\"vm.tab==3\"><form name=\"contractForm\"><div class=\"tab-content-header\"><h1 \nclass=\"title\">Contract Details</h1></div><div class=\"tab-content-body\"><div layout=\"row\"><md-input-container \nclass=\"md-block g2e-input-has-left-icon\" flex=\"33\"><label>Contract Price per Pay Period</label><md-icon \nclass=\"icon icon-currency-usd\"></md-icon><input type=\"number\" name=\"contractPrice\" \nng-model=\"vm.siteData.Installation.Customer.pricePerPayPeriod.value\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block g2e-input-has-right-unit\" flex=\"33\"><label>Payment Period Is Every</label><input \ntype=\"number\" name=\"paymentPeriod\" ng-model=\"vm.siteData.Installation.Customer.paymentPeriodInterval.value\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" flex><label></label><md-select \nname=\"paymentPeriodUnit\" aria-label=\"paymentPeriodUnit\" ng-model=\"paymentPeriodUnit\" disabled=\"disabled\"><md-option \nselected=\"selected\">{{vm.siteData.Installation.Customer.paymentPeriodInterval.units}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"33\"><label>Payments per Year\n</label><input type=\"number\" name=\"paymentsPerYear\" ng-model=\"vm.siteData.Installation.Customer.paymentsPerYear\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block g2e-input-has-left-icon\" flex=\"33\"><label>\nAnnual Revenue</label><md-icon class=\"icon icon-currency-usd\"></md-icon><input type=\"number\" name=\"annualRevenue\" \nng-model=\"vm.siteData.Installation.Customer.annualRevenue.value\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Contract Type</label><md-select name=\"contractType\" \nng-model=\"contractType\" disabled=\"disabled\"><md-option selected=\"selected\">\n{{vm.siteData.Installation.Customer.contractType}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block g2e-input-has-left-icon\" flex=\"33\"><label>Contract Credit/Surcharge for Hauls\n</label><md-icon class=\"icon icon-currency-usd\"></md-icon><input type=\"number\" name=\"haulingCost\" \nng-model=\"vm.siteData.Installation.Customer.haulingCost.value\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block g2e-input-has-left-icon\" flex=\"33\"><label>Contract Est. Annual Service Cost</label>\n<md-icon class=\"icon icon-currency-usd\"></md-icon><input type=\"number\" name=\"serviceCost\" \nng-model=\"vm.siteData.Installation.Customer.allocatedServiceCost.value\" disabled=\"disabled\"></md-input-container><div \nflex></div></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"33\"><label>\nContract Est. Annual Max Number of Hauls</label><input type=\"number\" name=\"contractedMaxHauls\" \nng-model=\"vm.siteData.Installation.Customer.maxHaulsAnnual\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"33\"><label>Contract Est. Annual Min Number of Hauls</label><input \ntype=\"number\" name=\"contractedMinHauls\" ng-model=\"vm.siteData.Installation.Customer.minHaulsAnnual\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nContract Est. Waste Processed (tons/week)</label><input type=\"number\" name=\"contractWasteProductionEstimate\" \nng-model=\"vm.siteData.Installation.Tank.contractWasteProductionEstimate.value\" disabled=\"disabled\">\n</md-input-container></div></div></form></div><div class=\"tab-content\" ng-show=\"vm.tab==4\"><div \nclass=\"tab-content-header\"><h1 class=\"title\">Badges and Shifts</h1><h5 class=\"description\">\nTo manage badges, please contact your <a href=\"#\" ng-click=\"vm.selectTab(7)\">G2E Administrators</a>.</h5></div><div \nclass=\"tab-content-body\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Badges\"><div layout=\"row\" \nng-if=\"vm.currentUser.hasAdminRole()\"><div flex></div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.openAddBadgeDlg($event,\'add\')\" ng-disabled=\"vm.isLoading\">ADD BADGE</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.openImportBadgeDlg($event)\" ng-disabled=\"vm.isLoading\">IMPORT BADGE LIST\n</md-button></div><md-content><md-table-container id=\"badgesTableContainer\" class=\"blue-scroll\"><table md-table \nclass=\"first-padding\"><thead md-head md-order=\"vm.badgesTable.order\" fix-head><tr md-row><th md-column \nclass=\"text-left\" md-order-by=\"badgeId\">Badge ID</th><th md-column class=\"text-left\" md-order-by=\"name\">Badge Name</th>\n<th md-column class=\"text-left\" md-order-by=\"department\">Department</th><th md-column class=\"text-left\" \nmd-order-by=\"createdAt\">Created On</th><th md-column class=\"text-left\" md-order-by=\"updatedAt\">Edited On</th><th \nmd-column ng-if=\"vm.currentUser.hasAdminRole()\"></th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.siteData.SiteBadges.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"badge in vm.siteData.SiteBadges | sortByWithEmpty: vm.badgesTable.order\"><td md-cell class=\"text-left\"><a \nhref=\"\" ng-click=\"vm.openAddBadgeDlg($event,\'edit\',badge)\" ng-if=\"!vm.currentUser.hasViewerRole()\">{{badge.badgeId}}\n</a> <span ng-if=\"vm.currentUser.hasViewerRole()\">{{badge.badgeId}}</span></td><td md-cell class=\"text-left\"><a \nhref=\"\" ng-click=\"vm.openAddBadgeDlg($event,\'edit\',badge)\" ng-if=\"!vm.currentUser.hasViewerRole()\">{{badge.name}}</a> \n<span ng-if=\"vm.currentUser.hasViewerRole()\">{{badge.name}}</span></td><td md-cell class=\"text-left\">\n{{badge.department}}</td><td md-cell class=\"text-left\">{{badge.createdAt | date: \'MM/dd/yyyy\'}}</td><td md-cell \nclass=\"text-left\">{{badge.updatedAt | date: \'MM/dd/yyyy\'}}</td><td md-cell class=\"text-right\" \nng-if=\"vm.currentUser.hasAdminRole()\"><md-button class=\"md-icon-button\" aria-label=\"Remove\" \nng-click=\"vm.deleteBadge($event,badge)\"><md-icon md-font-icon=\"icon-cancel\" class=\"icon\"></md-icon></md-button></td>\n</tr></tbody></table></md-table-container></md-content></md-tab><md-tab label=\"Shifts\"><div layout=\"row\" \nng-if=\"!vm.currentUser.hasViewerRole()\"><div flex></div><md-button class=\"md-raised md-accent\" \nng-click=\"vm.openAddShiftDlg($event,\'add\')\" ng-disabled=\"vm.isLoading\">ADD SHIFT</md-button></div><md-content>\n<md-table-container id=\"shiftsTableContainer\" class=\"blue-scroll\"><table md-table class=\"first-padding\"><thead md-head \nmd-order=\"vm.shiftsTable.order\" fix-head><tr md-row><th md-column class=\"text-left\" md-order-by=\"name\">Shift Name</th>\n<th md-column class=\"text-left\" md-order-by=\"startTime\">Start Time</th><th md-column class=\"text-left\" \nmd-order-by=\"endTime\">End Time</th><th md-column class=\"text-left\">Days</th><th md-column \nng-if=\"!vm.currentUser.hasViewerRole()\"></th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.siteData.SiteShifts.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"shift in vm.siteData.SiteShifts | sortByWithEmpty: vm.shiftsTable.order\"><td md-cell class=\"text-left\"><a \nhref=\"\" ng-click=\"vm.openAddShiftDlg($event,\'edit\',shift)\" ng-if=\"!vm.currentUser.hasViewerRole()\">{{shift.name}}</a> \n<span ng-if=\"vm.currentUser.hasViewerRole()\">{{shift.name}}</span></td><td md-cell class=\"text-left\">\n{{ shift.startTime | timeFormat:\'h:mm a\'}}</td><td md-cell class=\"text-left\">{{ shift.endTime | timeFormat:\'h:mm a\'}}\n</td><td md-cell class=\"text-left\">{{ shift.days | shiftDays}}</td><td md-cell class=\"text-right\" \nng-if=\"!vm.currentUser.hasViewerRole()\"><md-button class=\"md-icon-button\" aria-label=\"Remove\" \nng-click=\"vm.deleteShift($event,shift)\"><md-icon md-font-icon=\"icon-cancel\" class=\"icon\"></md-icon></md-button></td>\n</tr></tbody></table></md-table-container></md-content></md-tab></md-tabs></div></div><div class=\"tab-content\" \nng-show=\"vm.tab==5\"><div class=\"tab-content-header\"><h1 class=\"title\">Key Metrics</h1></div><div \nclass=\"tab-content-body\"><metric-table data=\"vm.siteData.metrics\" result=\"vm.siteData.selectedMetrics\" readonly=\"true\">\n</metric-table></div></div><div class=\"tab-content\" ng-show=\"vm.tab==6\"><div class=\"tab-content-header\"><h1 \nclass=\"title\">Benchmarking</h1><h5 class=\"description\" ng-if=\"vm.siteData.Benchmarkings.length == 0\">\nTo manage benchmarking, please contact your sales representative under <a href=\"#\" ng-click=\"vm.selectTab(7)\">\nG2E Administrators</a>.</h5><h5 class=\"description\" ng-if=\"vm.siteData.Benchmarkings.length > 0\">\nYou currently are able to compare the following sites:</h5></div><div class=\"tab-content-body\"><md-table-container \nid=\"benchmarkingTableContainer\" class=\"blue-scroll\"><table md-table><thead md-head \nmd-order=\"vm.bemchmarkingTable.order\" fix-head><tr md-row><th md-column class=\"text-left\" md-order-by=\"visibility\">\nVisibility</th><th md-column class=\"text-left\" md-order-by=\"BenchmarkingSite.name\">Site Name</th><th md-column \nclass=\"text-left\" md-order-by=\"BenchmarkingSite.Division.Company.name\">Company</th><th md-column class=\"text-left\" \nmd-order-by=\"BenchmarkingSite.Division.name\">Regional Division</th><th md-column class=\"text-left\" \nmd-order-by=\"BenchmarkingSite.Installation.Customer.address\">Street Address</th><th md-column class=\"text-left\" \nmd-order-by=\"BenchmarkingSite.Installation.Customer.city\">City</th><th md-column class=\"text-left\" \nmd-order-by=\"BenchmarkingSite.Installation.Customer.state\">State (Region)</th><th md-column class=\"text-left\" \nmd-order-by=\"BenchmarkingSite.Installation.Customer.zipcode\">ZIP</th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.siteData.Benchmarkings.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"benchmarking in vm.siteData.Benchmarkings | sortByWithEmpty: vm.bemchmarkingTable.order\"><td md-cell \nclass=\"text-left\">{{ benchmarking.visibility }}</td><td md-cell class=\"text-left\">\n{{ benchmarking.BenchmarkingSite.name }}</td><td md-cell class=\"text-left\">\n{{ benchmarking.BenchmarkingSite.Division.Company.name }}</td><td md-cell class=\"text-left\">\n{{ benchmarking.BenchmarkingSite.Division.name }}</td><td md-cell class=\"text-left\">\n{{ benchmarking.BenchmarkingSite.Installation.Customer.address }}</td><td md-cell class=\"text-left\">\n{{ benchmarking.BenchmarkingSite.Installation.Customer.city }}</td><td md-cell class=\"text-left\">\n{{ benchmarking.BenchmarkingSite.Installation.Customer.state }}</td><td md-cell class=\"text-left\">\n{{ benchmarking.BenchmarkingSite.Installation.Customer.zipcode }}</td></tr></tbody></table></md-table-container></div>\n</div><div class=\"tab-content\" ng-show=\"vm.tab==7\"><div class=\"tab-content-header\"><h1 class=\"title\">G2E Administrators\n</h1></div><div class=\"tab-content-body\"><div layout=\"row\" ng-repeat=\"group in vm.siteData.SiteAdminGroups\"><div flex>\n<md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" style=\"background-color: #eeeeee\"><span>\n{{ group.groupName }}</span> <span flex></span></div></md-toolbar><md-table-container><table md-table \nclass=\"first-padding\"><thead md-head md-order=\"group.order\"><tr md-row><th md-column class=\"text-left\" \nmd-order-by=\"firstName\" width=\"30%\">First Name</th><th md-column class=\"text-left\" md-order-by=\"lastName\" width=\"30%\">\nLast Name</th><th md-column class=\"text-left\" md-order-by=\"email\" width=\"40%\">Email</th></tr></thead><tbody md-body><tr\n md-row ng-if=\"group.Users.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"user in group.Users | sortByWithEmpty: group.order\"><td md-cell class=\"text-left\">{{ user.firstName }}</td>\n<td md-cell class=\"text-left\">{{ user.lastName }}</td><td md-cell class=\"text-left\"><a href=\"mailto:{{ user.email }}\">\n{{ user.email }}</a></td></tr></tbody></table></md-table-container></div></div></div></div><div class=\"tab-content\" \nng-show=\"vm.tab==8\"><div class=\"tab-content-header\"><h1 class=\"title\">Training</h1></div><div class=\"tab-content-body\">\n<md-table-container id=\"trainingTableContainer\" class=\"blue-scroll\"><table md-table><thead md-head \nmd-order=\"vm.trainingTable.order\" fix-head><tr md-row><th md-column class=\"text-left\" md-order-by=\"title\">Title</th><th\n md-column class=\"text-left\" md-order-by=\"description\">Description</th><th md-column class=\"text-left\" \nmd-order-by=\"version\">Version</th><th md-column>Actions</th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.siteData.Medias.length == 0\"><td md-cell colspan=\"100\">No data available in table</td></tr><tr md-row \nng-repeat=\"media in vm.siteData.Medias | sortByWithEmpty: vm.trainingTable.order\"><td md-cell class=\"text-left\">\n{{media.title}}</td><td md-cell class=\"text-left\">{{media.description}}</td><td md-cell class=\"text-left\">\n{{media.version}}</td><td md-cell><a href=\"{{media.uniqueName?vm.hostUrl+media.uniqueName:media.videoUrl}}\" \ntarget=\"_blank\"><media-button media=\"media\" type=\"small\"></media-button></a></td></tr></tbody></table>\n</md-table-container></div></div></md-content></section></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/site/support-contact-dialog.tmpl.html","<md-dialog aria-label=\"Grind2Energy Support\" ng-cloak id=\"support-contact-dialog\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>Grind2Energy Support</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"title\">\n{{ vm.group.groupName }}</div><div class=\"contact-info name\"><md-icon md-font-icon=\"icon-account-multiple\" \nclass=\"icon\"></md-icon><span>{{ vm.contact.displayName }}</span></div><div class=\"contact-info phone\"><md-icon \nmd-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>{{ vm.contact.phone }}</span></div><div \nclass=\"contact-info email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span><a \nhref=\"mailto:{{ vm.contact.email }}\">{{ vm.contact.email }}</a></span></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/sustainability/edit-waste-processed-dialog.tmpl.html","<md-dialog aria-label=\"Edit Waste Processed\" ng-cloak flex=\"40\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h1>Edit Waste Processed</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"pb-24\">\n<span class=\"h2\">{{vm.benchmarking.aliasName}}</span> <span flex></span> <span>\nIoT Activation Date: {{vm.benchmarking.Site.Installation.Tank.iotActivationDate | date: \'MM/dd/yyyy\'}}</span></div><div\n layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><label class=\"g2e-required-label\">Year <span>*</span>\n</label><md-select name=\"selectedYear\" ng-model=\"vm.selectedYear\" required ng-change=\"vm.onChangeYear()\"><md-option \nng-repeat=\"reportYear in vm.reports\" value=\"{{reportYear.year}}\" ng-if=\"reportYear.year >= vm.iotActivationDateYear\">\n{{reportYear.year}}</md-option></md-select><div ng-messages=\"saveForm.selectedYear.$error\"><div ng-message=\"required\">\nThis is required.</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\"><label \nclass=\"g2e-required-label\">Month <span>*</span></label><md-select name=\"selectedMonth\" ng-model=\"vm.selectedMonth\" \nrequired ng-change=\"vm.onChangeMonth()\"><md-option ng-repeat=\"reportMonth in vm.reportYear.months\" \nvalue=\"{{reportMonth.month}}\" \nng-if=\"vm.reportYear.year!=vm.iotActivationDateYear|| vm.reportYear.year==vm.iotActivationDateYear && reportMonth.month >= vm.iotActivationDateMonth\">\n{{reportMonth.month | monthShort}}</md-option></md-select><div ng-messages=\"saveForm.reportMonth.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Waste Processed <span>*</span></label><input \nname=\"selectedValue\" ng-model=\"vm.selectedValue\" required><div ng-messages=\"saveForm.selectedValue.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"left center\" ng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span>{{vm.msg}}</span></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" class=\"border-top\"><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.updateWasteProcessed()\" ng-disabled=\"saveForm.$invalid ||\n                              vm.isSaving\">Save\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/sustainability/sustainability-dialog.tmpl.html","<md-dialog class=\"fullscreen-anyway\" aria-label=\"SustainabilitySettings\" ng-cloak class=\"loading-overlay\" \nbs-loading-overlay=\"sustainability_setting_loader\"><form name=\"sustSettingsForm\"><md-toolbar \nclass=\"md-background-bg border-bottom\"><div class=\"md-toolbar-tools\"><h1>Edit Sustainability Report</h1><span flex>\n</span><md-button class=\"pl-24 md-icon-button\" aria-label=\"Close\" ng-click=\"vm.close()\"><img \nsrc=\"/assets/images/icons/btn-close.png\"></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><span \nflex></span></div><div layout=\"row\" ng-show=\"vm.isLoading\" layout-align=\"center center\"><md-progress-circular \nid=\"toolbar-progress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span>\nLoading...</span></div><div layout=\"row\" ng-show=\"!vm.isLoading\"><div class=\"simple-table-container\" flex><table \nclass=\"simple dashboard-matrix sustainability\" ms-responsive-table ng-repeat=\"sh in vm.sustDataHeads\"><thead><tr><th \ncolspan=\"4\" class=\"sust-item-head\">{{sh}}</th></tr><tr><th class=\"sust-item-key\">Code</th><th class=\"sust-item-det\">\nValue Description</th><th class=\"sust-item-unit\">Unit</th><th class=\"sust-item-val\">Conversion Factor<br>\n(per ton of waste processed)</th></tr></thead><tbody><tr class=\"\" ng-repeat=\"s in vm.sustData.settings\" \nng-if=\"s.headType==sh\"><td class=\"sust-item-key\">{{s.key}}</td><td class=\"sust-item-det {{s.indent ? \'indent\' : \'\'}}\">\n{{s.details}}</td><td class=\"sust-item-unit\">{{s.unit}}</td><td class=\"sust-item-val\"><div \nng-if=\"s.keyType === \'constant\'\">{{s.display}}</div><div ng-if=\"s.keyType === \'value\'\"><md-input-container \nclass=\"md-block\" flex><input name=\"vm.sustData.settings[s.key]\" aria-label=\"{{s.key}}\" ng-model=\"s.conversionFactor\" \nrequired></md-input-container></div><div ng-if=\"s.keyType === \'formula\'\" class=\"formula\">\n{{s.conversionFormula | sustainabilityFormula:s.key:vm.sustData.settings}}</div></td></tr></tbody><tfoot \nng-show=\"$last\"><tr><td colspan=\"4\"></td></tr></tfoot></table></div></div><div class=\"sustain-text-block\"><div \nlayout=\"row\" ng-repeat=\"arr in vm.textSettings\"><div class=\"sustain-body {{(!o.flex)? \'p-r-0\': \'\'}}\" \nng-repeat=\"o in arr track by $index\" flex-gt-sm=\"{{o.flex}}\" flex=\"{{o.flex}}\"><div class=\"md-block\">\n<md-input-container><label class=\"g2e-required-label\">{{o.key}}</label><textarea class=\"banners\" ng-if=\"o.isBanner\" \nname=\"vm.sustData.settings[o.key]\" ng-model=\"o.text\" maxlength=\"{{o.maxCharLength}}\" rows=\"2\" required></textarea>\n<textarea class=\"banners\" ng-if=\"o.isIcon\" name=\"vm.sustData.settings[o.key]\" ng-model=\"o.text\" \nmaxlength=\"{{o.maxCharLength+1}}\" cols=\"{{o.cols}}\" rows=\"2\" textarea-limit required></textarea><textarea \nng-if=\"o.isText\" name=\"vm.sustData.settings[o.key]\" ng-model=\"o.text\" maxlength=\"{{o.maxCharLength}}\" required>\n</textarea></md-input-container></div><div class=\"counter\" ng-if=\"o.isIcon\">\n{{(o.text)?o.text.replace(\'\\n\', \'\').length:0}}/{{o.maxCharLength}}</div><div class=\"counter\" ng-if=\"!o.isIcon\">\n{{o.text?o.text.length:0}}/{{o.maxCharLength}}</div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"border-top\" ng-show=\"!vm.isLoading\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.saveSettings()\" ng-disabled=\"sustSettingsForm.$invalid || vm.isSaving\">Save</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/dashboard/user/user-dialog-add.tmpl.html","<md-dialog aria-label=\"Add/Edit User\" ng-cloak flex=\"50\"><form name=\"saveForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><div ng-switch=\"vm.mode\"><h1 ng-switch-when=\"add\">Add Administrator</h1><h1 \nng-switch-when=\"edit\">Edit Administrator</h1><h1 ng-switch-when=\"profile\">Manage Your Account</h1></div><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><div flex=\"60\"><div class=\"h2\">User Information\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">First Name <span>*\n</span></label><input name=\"firstName\" ng-model=\"vm.userData.firstName\" required><div \nng-messages=\"saveForm.firstName.$error\"><div ng-message=\"required\">This is required.</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label class=\"g2e-required-label\">Last Name <span>*</span></label><input \nname=\"lastName\" ng-model=\"vm.userData.lastName\" required><div ng-messages=\"saveForm.lastName.$error\"><div \nng-message=\"required\">This is required.</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Email <span>*</span></label><input type=\"email\" \nname=\"userEmail\" ng-model=\"vm.userData.email\" ng-pattern=\"/^.+@.+\\..+$/\" required ng-disabled=\"vm.mode==\'profile\'\"><div\n ng-messages=\"saveForm.userEmail.$error\"><div ng-message-exp=\"[\'required\', \'pattern\']\">\nPlease enter a valid Email address.</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nPhone Number</label><input name=\"phone\" ng-model=\"vm.userData.phone\" ui-mask=\"(999) 999-9999\" model-view-value=\"true\" \nui-options=\"{addDefaultPlaceholder:false}\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label class=\"g2e-required-label\">Password <span ng-if=\"vm.mode==\'profile\'\">*</span></label>\n<input type=\"password\" name=\"userPassword\" ng-model=\"vm.userPassword\" ng-change=\"vm.validatePasswordConfirm()\" \nplaceholder=\"{{(vm.mode==\'add\'||vm.mode==\'edit\')?\'System Generated\':\'\'}}\" ng-required=\"vm.mode==\'profile\'\"><div \nng-messages=\"saveForm.userPassword.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \nclass=\"g2e-required-label\">Confirmation <span ng-if=\"vm.mode==\'profile\'\">*</span></label><input type=\"password\" \nname=\"userPasswordConfirm\" ng-model=\"vm.userPasswordConfirm\" ng-change=\"vm.validatePasswordConfirm()\" \nplaceholder=\"{{(vm.mode==\'add\'||vm.mode==\'edit\')?\'System Generated\':\'\'}}\" ng-required=\"vm.mode==\'profile\'\"><div \nng-messages=\"saveForm.userPasswordConfirm.$error\"><div ng-message=\"required\">This is required.</div></div>\n</md-input-container></div></div><div flex=\"40\" class=\"pv-32 ph-32\"><div layout=\"column\" \nng-if=\"vm.mode==\'add\' || vm.mode==\'edit\'\"><div class=\"pv-16\">User Roles :</div><div class=\"ph-16\" \nng-show=\"vm.isLoadingRoles\">...</div><md-checkbox aria-label=\"{{role.title}}\" ng-repeat=\"role in vm.Roles\" \nng-click=\"vm.chooseRole(role)\" ng-checked=\"vm.isSelectedRole(role)\">{{role.title}}</md-checkbox></div><div \nlayout=\"column\"><div class=\"pv-16\">Receive Emails for :</div><div class=\"ph-16\" ng-show=\"vm.isLoadingServs\">...</div>\n<md-checkbox aria-label=\"{{serv.title}}\" ng-repeat=\"serv in vm.Servs\" ng-click=\"vm.chooseServ(serv)\" \nng-checked=\"vm.isSelectedServ(serv)\" ng-disabled=\"vm.userRole==\'ADMIN_CONTACT_ONLY\'\" \nng-if=\"vm.mode!=\'profile\' || vm.mode==\'profile\' && vm.currentUser.data.ListservAvailability[serv.name]\">{{serv.title}}\n</md-checkbox></div></div></div><div layout=\"row\" ng-if=\"vm.errMsg\"><div class=\"error-message\">{{vm.errMsg}}</div>\n</div><div layout=\"row\" layout-align=\"left center\" ng-if=\"vm.msg\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\" ng-if=\"vm.isSaving\"></md-progress-circular><span>{{vm.msg}}</span></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"border-top\"><md-button \nclass=\"md-raised md-background-fg md-grey-700-bg\" ng-click=\"vm.deleteUser($event)\" ng-show=\"vm.mode==\'edit\'\" \nng-disabled=\"vm.isSaving\">Delete User</md-button><md-button class=\"md-raised md-background-fg md-grey-700-bg\" \nng-show=\"vm.mode==\'add\' || vm.mode==\'edit\'\" ng-click=\"vm.updateUser(true)\" \nng-disabled=\"saveForm.$invalid ||\n                              vm.isSaving ||\n                              !vm.validatePasswordConfirm() ||\n                              !vm.validateUserRoleSelected() ||\n                              vm.userRole==\'ADMIN_CONTACT_ONLY\' ||\n                              vm.userPassword\">\nSave & Send Welcome Email</md-button><span flex></span><md-button class=\"md-raised md-accent\" \nng-click=\"vm.updateUser(false)\" \nng-disabled=\"saveForm.$invalid ||\n                              vm.isSaving ||\n                              !vm.validatePasswordConfirm() ||\n                              !vm.validateUserRoleSelected()\">\nSave</md-button><md-button class=\"md-raised\" ng-click=\"vm.close()\" md-autofocus ng-disabled=\"vm.isSaving\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/user/user-dialog.tmpl.html","<md-dialog class=\"fullscreen-anyway\" aria-label=\"Users\" ng-cloak><form name=\"userForm\"><md-toolbar \nclass=\"md-background-bg border-bottom\"><div class=\"md-toolbar-tools\"><h1>Administrators</h1><span flex></span>\n<md-button class=\"pl-24 md-icon-button\" aria-label=\"Close\" ng-click=\"vm.close()\"><img \nsrc=\"/assets/images/icons/btn-close.png\"></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\"><span \nflex></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.openAddDlg($event,\'add\')\" \nng-disabled=\"vm.isLoading || !vm.currentUser.hasAdminRole()\">Add User</md-button></div><div layout=\"row\" \nng-show=\"vm.isLoading\" layout-align=\"center center\"><md-progress-circular id=\"toolbar-progress\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><span>Loading...</span></div><div layout=\"row\" \nng-show=\"!vm.isLoading\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.table.dtOptions\">\n<thead><tr><th class=\"secondary-text\" ng-repeat=\"column in vm.usersTable.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in vm.usersTable.rows\">\n<td ng-repeat=\"cell in row.cells\"><a href=\"#\" class=\"{{cell.classes}}\" ng-if=\"cell.isEditLink\" \nng-click=\"vm.openAddDlg($event,\'edit\', row.id)\">{{cell.value}} </a><span class=\"{{cell.classes}}\" \nng-if=\"!cell.isEditLink\">{{cell.value}}</span></td></tr></tbody></table></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dashboard-site/analytics/analytics.html","<div id=\"dashboard-site-analytics\"><div class=\"header\"><div class=\"title\">Select Sites for Analysis</div><div \nclass=\"filter\"><div class=\"multi-select-wrapper\" isteven-multi-select input-model=\"$parent.benchmarkings\" \noutput-model=\"$parent.benchmarkingsFiltered\" output-properties=\"id\" button-label=\"colorTag aliasName\" \nitem-label=\"colorTag aliasName\" tick-property=\"ticked\" helper-elements=\"all none\" \non-item-click=\"vm.onChangeSiteFilter()\" on-select-all=\"vm.onChangeSiteFilter()\" \non-select-none=\"vm.onChangeSiteFilter()\" group-property=\"msGroup\"></div></div></div><div class=\"section analytics\"><div\n class=\"body\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Tank Status\"><md-content ms-scroll \nclass=\"md-padding tank-status-content\"><div class=\"tank\" \nng-repeat=\"one in $parent.benchmarkings | filter:{ticked: true}\"><div class=\"tank-name\"><span class=\"site-color-icon\" \nstyle=\"background: {{ one.color }}\"></span> <span class=\"name\">{{ one.aliasName }}</span></div><svg tank-gauge \nlevel=\"one.Site.Stats[\'Tank Level\']\" id=\"tank-gauge{{$index}}\"></svg><div class=\"tank-info\"><div class=\"level\" \nng-if=\"$parent.visibilities.tankStatusLevel\"><span>Tank Level: </span><span><b>\n{{ one.Site.Stats[\'Tank Level\']?one.Site.Stats[\'Tank Level\']+\'%\':\'\' }}</b></span></div><div class=\"temperature\" \nng-if=\"$parent.visibilities.tankStatusTemperature\"><span>Temperature: </span><span><b>\n{{ one.Site.Stats[\'Temperature\']?one.Site.Stats[\'Temperature\']+\'°F\':\'\' }}</b></span></div><div \nclass=\"nominal-tank-volume\" ng-if=\"$parent.visibilities.tankStatusNominal\"><span>Nominal Tank Volume: </span><span><b>\n{{ one.Site.Installation?one.Site.Installation.Tank.nominalVolume.value+\' Gallons\':\'\' }}</b></span></div><div \nclass=\"useful-tank-volume\" ng-if=\"$parent.visibilities.tankStatusUseful\"><span>Useful Tank Volume: </span><span><b>\n{{ one.Site.Installation?one.Site.Installation.Tank.usefulVolume.value+\' Gallons\':\'\' }}</b></span></div></div></div>\n</md-content></md-tab><md-tab label=\"Sustainability Reporting\"><div class=\"md-padding reporting-content\"><div \nlayout=\"row\"><span flex></span><md-menu><md-button class=\"md-raised md-accent\" \nng-disabled=\"$parent.isLoading || !$parent.reports || $parent.reports.length==0\" \nng-click=\"vm.openDownloadMenu($mdOpenMenu, $event)\">Download pdf report</md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.onDownloadPdf()\">All</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item ng-repeat=\"reportYear in $parent.reports\"><md-button \nng-click=\"vm.onDownloadPdf(reportYear.year)\">{{ ($index == 0)?reportYear.year + \' - Present\':reportYear.year }}\n</md-button></md-menu-item></md-menu-content></md-menu></div><md-content ms-scroll><md-table-container><table md-table>\n<thead md-head><tr md-row><th md-column class=\"text-left cell-border-right\" colspan=\"4\" rowspan=\"3\">\nWaste Processed (tons)</th><th md-column ng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true}\"><span \nclass=\"site-color-icon\" style=\"background: {{ filter.color }}\"></span> <span>{{ filter.aliasName }}</span></th></tr><tr\n md-row><th md-column ng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true}\"><div>IoT Activation Date\n</div><div>{{ filter.Site.Installation.Tank.iotActivationDate | date: \'MM/dd/yyyy\' }}</div></th></tr></thead><tbody \nmd-body ng-repeat=\"(indexYear, reportYear) in $parent.reports\"><tr md-row><td md-cell class=\"cell-expand\" \nng-click=\"reportYear.isExpanded = !reportYear.isExpanded;\"><i \nng-class=\"{\'icon-chevron-right\':!reportYear.isExpanded,\'icon-chevron-down\':reportYear.isExpanded}\"></i></td><td \nmd-cell class=\"text-left cell-year\"><b>{{ reportYear.year }}</b></td><td md-cell class=\"cell-month\"></td><td md-cell \nclass=\"cell-border-right cell-total\"><b>{{ reportYear.value[\'total\'].toFixed(1) }}</b></td><td md-cell \nclass=\"cell-site\" ng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true}\"><b>\n{{ reportYear.value[\'site#\' + filter.Site.id].toFixed(1) }}</b></td></tr><tr md-row \nng-repeat=\"(indexMonth, reportMonth) in reportYear.months\" ng-show=\"reportYear.isExpanded\"><td md-cell></td><td \nmd-cell></td><td md-cell class=\"text-left\">{{ reportMonth.month | monthShort }}</td><td md-cell \nclass=\"cell-border-right\">{{ reportMonth.value[\'total\'].toFixed(1) }}</td><td md-cell \nng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true}\" \nng-mousemove=\"reportMonth.value[\'edit#\' + filter.Site.id]=true;\" \nng-mouseleave=\"reportMonth.value[\'edit#\' + filter.Site.id]=false;\"><span>\n{{ reportMonth.value[\'site#\' + filter.Site.id]!=undefined?reportMonth.value[\'site#\' + filter.Site.id]:\'-\' }}</span>\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Edit\" \nng-show=\"vm.currentUser.hasAdminRole() && filter.Site.Installation && reportMonth.value[\'edit#\' + filter.Site.id]==true\" \nng-click=\"vm.openSustainabilityReportEditDlg($event, filter, reportYear.year, reportMonth.month)\"><i \nclass=\"icon-pencil\"></i></md-button></td></tr></tbody></table></md-table-container></md-content></div></md-tab><md-tab \nlabel=\"System Usage\" ng-if=\"$parent.visibilities.systemUsage\"><md-content ms-scroll \nclass=\"md-padding system-usage-content\"><div layout=\"row\"><div class=\"metrics-graph\" flex><div layout=\"row\"><div \nclass=\"metrics\"><md-table-container><table md-table><thead md-head><tr md-row><th md-column class=\"text-left\">Metrics\n</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"metric in $parent.visibilities.systemUsageMetrics\" \nng-class=\"{\'selected\':$parent.metricFilter == $index}\" ng-click=\"vm.onSelectMetric($index)\"><td md-cell \nclass=\"text-left\">{{ metric.label }}</td></tr></tbody></table></md-table-container></div><div class=\"graph\" flex><div \nlayout=\"row\" class=\"search-bar\"><div layout=\"column\" flex=\"nogrow\"><div class=\"search-box\"><div \nclass=\"search-box-head\">Standard Period</div><md-select ng-model=\"$parent.search_period\" aria-label=\"Rolling Period\" \nng-change=\"vm.onChangeRolling()\" ng-disabled=\"$parent.isLoading\"><md-option ng-repeat=\"period in $root.RollingPeriods\" \nvalue=\"{{period.value}}\">{{period.text}}</md-option></md-select></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"nogrow\"><span class=\"or\">OR</span></div><div layout=\"row\" flex=\"nogrow\"><div \nclass=\"search-box\"><div class=\"search-box-head\">Start Date</div><md-datepicker ng-model=\"$parent.search_start_date\" \nmd-placeholder=\"\" md-max-date=\"vm.todayDate\" ng-change=\"vm.onChangeDateRange()\" ng-disabled=\"$parent.isLoading\">\n</md-datepicker></div><div class=\"search-box\"><div class=\"search-box-head\">End Date</div><md-datepicker \nng-model=\"$parent.search_end_date\" md-placeholder=\"\" md-min-date=\"$parent.search_start_date\" \nng-change=\"vm.onChangeDateRange()\" ng-disabled=\"$parent.isLoading\"></md-datepicker></div></div><div layout=\"row\" \nflex=\"nogrow\"><md-button aria-label=\"Search\" ng-class=\"{\'md-accent\':vm.filterChangedTimeHorizon}\" \nng-click=\"vm.onApplyFilters()\" \nng-disabled=\"$parent.isLoading || !$parent.search_start_date || !$parent.search_end_date\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>Refresh</md-button></div></div><nvd3 \noptions=\"$parent.chart.options\" data=\"$parent.chart.data\"></nvd3></div></div><div layout=\"row\" class=\"pt-16\">\n<md-table-container><table md-table><thead md-head><tr md-row><th md-column class=\"text-left metrics\">Sites</th><th \nmd-column ng-repeat=\"metric in $parent.visibilities.systemUsageMetrics\">\n{{ metric.label }} {{$parent.MetricsUnits[metric.name]?\' (\'+$parent.MetricsUnits[metric.name]+\')\':\'\'}}</th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true}\"><td md-cell \nclass=\"text-left metrics\"><span class=\"site-color-icon\" style=\"background: {{ filter.color }}\"></span> <span>\n{{ filter.aliasName }}</span></td><td md-cell \nng-repeat=\"(col_index, metric) in $parent.visibilities.systemUsageMetrics\" \nng-class=\"{\'selected\':$parent.metricFilter == col_index}\">{{ filter.Site.Stats?filter.Site.Stats[metric.name]:0 }}</td>\n</tr></tbody></table></md-table-container></div></div><div class=\"badges\"><div class=\"search-box\"><div \nclass=\"search-box-head\">Shifts</div><md-chips ng-model=\"$parent.shiftFilter\" md-on-add=\"vm.onChangeShiftFilter()\" \nmd-on-remove=\"vm.onChangeShiftFilter()\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"true\" ng-disabled=\"$parent.isLoading\"><md-autocomplete md-input-name=\"shifts\" md-min-length=\"0\" \nmd-no-cache=\"vm.noCache\" md-search-text=\"vm.shiftFilterText\" md-selected-item-change=\"\" \nmd-items=\"item in vm.queryShiftFilter(vm.shiftFilterText)\" md-item-text=\"item\" placeholder=\"\"><md-item-template><span \nmd-highlight-text=\"vm.shiftFilterText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template>\n</md-autocomplete><md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div><md-table-container>\n<table md-table><thead md-head><tr md-row><th md-column class=\"text-left\" colspan=\"3\">Badges</th></tr></thead><tbody \nmd-body ng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true}\"><tr md-row><td md-cell class=\"cell-expand\" \nng-click=\"filter.isBadgeExpanded = !filter.isBadgeExpanded;\"><i \nng-class=\"{\'icon-chevron-right\':!filter.isBadgeExpanded,\'icon-chevron-down\':filter.isBadgeExpanded}\"></i></td><td \nmd-cell class=\"text-left\"><span class=\"site-color-icon\" style=\"background: {{ filter.color }}\"></span> <span>\n{{ filter.aliasName }}</span></td></tr><tr class=\"has-child-table\"><td colspan=\"3\" ng-show=\"filter.isBadgeExpanded\">\n<div class=\"child-table-container\"><md-table-container><table md-table md-row-select multiple=\"true\" \nng-model=\"filter.selectedBadges\"><tbody md-body><tr md-row md-on-select=\"vm.onSelectBadge\" \nmd-on-deselect=\"vm.onDeselectBadge\" md-select=\"badge\" md-select-id=\"badgeId\" md-auto-select \nng-repeat=\"badge in filter.Site.SiteBadges\"><td md-cell class=\"text-left\">{{ badge.name }}</td></tr></tbody></table>\n</md-table-container></div></td></tr></tbody></table></md-table-container></div></div></md-content></md-tab><md-tab \nlabel=\"Pick-up History\" ng-if=\"$parent.visibilities.pickupHistory\"><md-content ms-scroll \nclass=\"md-padding hauling-content\"><md-table-container><table md-table><thead md-head><tr md-row><th md-column \nclass=\"text-left\">Month</th><th md-column class=\"text-right\">Number of Pick-ups</th></tr></thead><tbody md-body><tr \nmd-row class=\"has-child-table\" ng-repeat=\"pickup in $parent.pickups\"><td md-cell class=\"text-left month\">\n{{ pickup.yearMonth }}</td><td md-cell class=\"text-left\"><md-table-container><table md-table><tbody md-body><tr md-row \nng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true}\" ng-if=\"pickup.value[\'site#\'+filter.Site.id] >= 0\">\n<td md-cell class=\"text-left\"><span class=\"site-color-icon\" style=\"background: {{ filter.color }}\"></span> <span>\n{{ filter.aliasName }}</span> <span class=\"act-date\" ng-if=\"pickup.iotActivationDates[\'site#\'+filter.Site.id]\">\nIOT Activation Date: {{ pickup.iotActivationDates[\'site#\'+filter.Site.id] }}</span></td><td md-cell class=\"pickup\"><a \nhref=\"#\" ng-click=\"vm.openPickupLogDlg($event, pickup.year, pickup.month, filter.Site.Installation)\" \nng-if=\"$parent.visibilities.pickupHistoryView\">{{ pickup.value[\'site#\'+filter.Site.id] }}</a> <span \nng-if=\"!$parent.visibilities.pickupHistoryView\">{{ pickup.value[\'site#\'+filter.Site.id] }}</span></td></tr></tbody>\n</table></md-table-container></td></tr></tbody></table></md-table-container></md-content></md-tab><md-tab \nlabel=\"Hauling Details\" ng-if=\"$parent.visibilities.finance\"><md-content ms-scroll class=\"md-padding finance-content\">\n<md-table-container><table md-table><thead md-head md-order=\"vm.financeTable.order\"><tr md-row><th md-column \nclass=\"cell-border-right\" md-order-by=\"order\">Site</th><th md-column ng-repeat=\"column in vm.financeTable.columns\" \nmd-order-by=\"{{ \'FinanceDetails.\'+column.key+\'.value\' }}\">{{ column.title }}</th></tr></thead><tbody md-body><tr \nmd-row ng-repeat=\"filter in $parent.benchmarkings | filter:{ticked: true} | orderBy: vm.financeTable.order\"><td \nmd-cell class=\"text-left cell-border-right\"><span class=\"site-color-icon\" style=\"background: {{ filter.color }}\">\n</span> <span>{{ filter.aliasName }}</span></td><td md-cell ng-repeat=\"column in vm.financeTable.columns\"><div \nclass=\"g2e-icon-in-table {{ filter.FinanceDetails[column.key].image }}\" \nng-if=\"filter.FinanceDetails[column.key].image\"></div><span class=\"{{filter.FinanceDetails[column.key].classes}}\" \nng-class=\"{\'g2e-icon-text\':filter.FinanceDetails[column.key].image}\">\n{{ filter.FinanceDetails[column.key].format?filter.FinanceDetails[column.key].format(filter.FinanceDetails[column.key].value):filter.FinanceDetails[column.key].value }}\n</span></td></tr></tbody></table></md-table-container></md-content></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/dashboard-site/home/home.html","<div id=\"dashboard-site-home\"><div class=\"meta-info\"><div class=\"division\">\n{{ $parent.stats?$parent.stats.Division.Company.name + \' - \' + $parent.stats.Division.name:\'\' }}</div><div \nclass=\"site\">{{ $parent.stats.name }}</div></div><div class=\"welcome\">Hello, {{ vm.currentUser.getFullname() }}</div>\n</div>");
$templateCache.put("app/main/dashboard-site/materials/materials.html","<div id=\"dashboard-site-materials\"><div class=\"header\"><div class=\"title\">Training Materials</div><md-divider>\n</md-divider></div><div class=\"table-container\"><table class=\"simple\" ms-responsive-table><tbody><tr \nng-repeat=\"media in $parent.stats.Medias\"><td class=\"icon\"><media-button media=\"media\" type=\"large\"></media-button>\n</td><td class=\"desc\"><div><div class=\"title\">{{ media.title }}</div><div class=\"description secondary-text\">\n{{ media.description }}</div></div></td><td class=\"action\"><a \nhref=\"{{media.videoUrl?media.videoUrl:vm.hostUrl+media.uniqueName}}\" target=\"_blank\"><md-button \nclass=\"md-raised md-accent\">View</md-button></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between start\"><div layout=\"row\" layout-align=\"start center\" flex=\"none\" \nclass=\"pt-8 pr-24\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><img src=\"assets/images/logos/g2e.png\">\n</div></div><div layout=\"column\" flex ng-click=\"vm.showSearchByLocation=true;vm.showSearchByCompany=false;\" \non-click-outside=\"vm.showSearchByLocation=false\" ng-show=\"$root.viewMode==\'admin\'\"><div class=\"search-box\"><div \nclass=\"search-box-head\">Region</div><div ng-class=\"vm.showSearchByLocation?\'show\':\'hide\'\"><md-chips \nng-model=\"$root.search_location\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"true\"><md-autocomplete md-input-name=\"location\" md-min-length=\"1\" md-no-cache=\"vm.noCache\" \nmd-search-text=\"vm.searchLocation\" md-selected-item-change=\"vm.onChangeLocation()\" \nmd-items=\"item in vm.queryLocation(vm.searchLocation)\" md-item-text=\"item.name\"><md-item-template><span \nmd-highlight-text=\"vm.searchLocation\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template></md-autocomplete>\n<md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div><div class=\"chips-viewer\" \nng-class=\"vm.showSearchByLocation?\'hide\':\'show\'\"><span class=\"chips-viewer-item\" \nng-repeat=\"location in $root.search_location\">{{location.name}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"nogrow\" ng-show=\"$root.viewMode==\'admin\'\"><div class=\"toolbar-separator\"></div></div>\n<div layout=\"column\" flex ng-click=\"vm.showSearchByContractType=true;vm.showSearchByCompany=false;\" \non-click-outside=\"vm.showSearchByContractType=false\" ng-show=\"$root.viewMode==\'admin\'\"><div class=\"search-box\"><div \nclass=\"search-box-head\">Contract Type</div><div ng-class=\"vm.showSearchByContractType?\'show\':\'hide\'\"><md-chips \nng-model=\"$root.search_contract_type\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"true\"><md-autocomplete md-input-name=\"contractType\" md-min-length=\"1\" md-no-cache=\"vm.noCache\" \nmd-search-text=\"vm.searchLocation\" md-selected-item-change=\"vm.onChangeContractType()\" \nmd-items=\"item in $root.ContractTypes\" md-item-text=\"item.text\"><md-item-template><span \nmd-highlight-text=\"vm.searchLocation\" md-highlight-flags=\"^i\">{{item.value}}</span></md-item-template>\n</md-autocomplete><md-chip-template><span>{{$chip.value}}</span></md-chip-template></md-chips></div><div \nclass=\"chips-viewer\" ng-class=\"vm.showSearchByContractType?\'hide\':\'show\'\"><span class=\"chips-viewer-item\" \nng-repeat=\"item in $root.search_contract_type\">{{item.value}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"nogrow\" ng-show=\"$root.viewMode==\'admin\'\"><div class=\"toolbar-separator\"></div></div>\n<div layout=\"column\" flex ng-click=\"vm.showSearchByCompany=true;vm.showSearchByLocation=false;\" \non-click-outside=\"vm.showSearchByCompany=false\" ng-show=\"$root.viewMode==\'admin\'\"><div class=\"search-box\"><div \nclass=\"search-box-head\" layout=\"row\" layout-align=\"space-between start\"><label>Company</label><a href=\"#\" \nstyle=\"margin-left: 12px;white-space: nowrap\" ng-click=\"vm.openCompanyDlg($event)\" \nng-if=\"vm.currentUser.hasAdminRole()\">Add New</a></div><div ng-class=\"vm.showSearchByCompany?\'show\':\'hide\'\"><md-chips \nng-model=\"$root.search_company\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"true\"><md-autocomplete md-input-name=\"company\" md-min-length=\"1\" md-no-cache=\"vm.noCache\" \nmd-search-text=\"vm.searchCompany\" md-selected-item-change=\"vm.onChangeCompany()\" \nmd-items=\"item in vm.queryCompany(vm.searchCompany)\" md-item-text=\"item.name\"><md-item-template><span \nmd-highlight-text=\"vm.searchCompany\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template></md-autocomplete>\n<md-chip-template><span>{{$chip.name}}</span></md-chip-template></md-chips></div><div class=\"chips-viewer\" \nng-class=\"vm.showSearchByCompany?\'hide\':\'show\'\"><span class=\"chips-viewer-item\" \nng-repeat=\"company in $root.search_company\">{{company.name}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"nogrow\" ng-show=\"$root.viewMode==\'admin\'\"><div class=\"toolbar-separator\"></div></div>\n<div layout=\"column\" flex=\"nogrow\" ng-show=\"$root.viewMode==\'admin\'\"><div class=\"search-box\"><div \nclass=\"search-box-head\">Period</div><md-select ng-model=\"$root.search_period\" aria-label=\"Rolling Period\" \nng-change=\"vm.onChangeRolling()\"><md-option ng-repeat=\"period in $root.RollingPeriods\" value=\"{{period.value}}\">\n{{period.text}}</md-option></md-select></div></div><div layout=\"row\" flex=\"nogrow\" ng-show=\"$root.viewMode==\'admin\'\">\n<div class=\"search-box\"><div class=\"search-box-head\">Start Date</div><md-datepicker ng-model=\"$root.search_start_date\" \nmd-placeholder=\"\" md-max-date=\"$root.search_end_date\" ng-change=\"vm.onChangeDateRange()\"></md-datepicker></div><div \nclass=\"search-box\"><div class=\"search-box-head\">End Date</div><md-datepicker ng-model=\"$root.search_end_date\" \nmd-placeholder=\"\" md-min-date=\"$root.search_start_date\" ng-change=\"vm.onChangeDateRange()\"></md-datepicker></div></div>\n<div layout=\"row\" layout-align=\"start center\" flex=\"nogrow\" ng-show=\"$root.viewMode==\'admin\'\"><md-button \nclass=\"md-icon-button search-btn\" aria-label=\"Search\" ng-class=\"{\'md-accent\':vm.filterChangedTimeHorizon}\" \nng-click=\"vm.filterInstallations()\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon></md-button><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\" flex=\"nogrow\"><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs>{{vm.currentUser.getFullname()}}</span>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\" ng-click=\"vm.openUserDlg($event)\" ng-if=\"vm.currentUser.hasAdminRole()\">\n<md-icon md-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon><md-button>Add/Edit Administrators</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"vm.openCompanyDlg($event)\" \nng-if=\"vm.currentUser.hasAdminRole()\"><md-icon md-font-icon=\"icon-bank\" class=\"icon\"></md-icon><md-button>\nAdd/Edit Companies</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"vm.openSiteAccountDlg($event)\" \nng-if=\"vm.currentUser.hasAdminRole()\"><md-icon md-font-icon=\"icon-store\" class=\"icon\"></md-icon><md-button>\nAdd/Edit Site Accounts</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"vm.openHolidayDlg($event)\" \nng-if=\"vm.currentUser.hasAdminRole()\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"icon\"></md-icon><md-button>\nAdd/Edit Holiday</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"vm.openMediaManagerDlg($event)\" \nng-if=\"vm.currentUser.hasAdminRole()\"><md-icon md-font-icon=\"icon-folder-plus\" class=\"icon\"></md-icon><md-button>\nMedia Manager</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"vm.openSustainabilityDlg($event)\" \nng-if=\"vm.currentUser.hasAdminRole()\"><md-icon md-font-icon=\"icon-chart-pie\" class=\"icon\"></md-icon><md-button>\nEdit Sustainability Report</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-click=\"vm.switchViewMode()\" \nng-if=\"vm.currentUser.isAdminUser()\"><md-icon md-font-icon=\"icon-eye\" class=\"icon\"></md-icon><md-button>\n{{ ($root.viewMode == \'admin\')?\'View as a Site\':\'View as an Administrator\' }}</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ng-click=\"vm.openProfileDlg($event)\"><md-icon md-font-icon=\"icon-account-circle\" class=\"icon\">\n</md-icon><md-button>Manage Your Account</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\" ng-click=\"vm.logout()\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button>Logout\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" \nlayout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/dashboard/company/company-logo/company-logo-dialog.tmpl.html","<md-dialog id=\"company-logo-dialog\" aria-label=\"Edit Company Logo\" flex=\"50\" class=\"loading-overlay\" \nbs-loading-overlay=\"company_logo_upload_loader\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edit Company Logo</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"cropArea drop-box\" ngf-drop ng-model=\"file\" \nngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-drag-over-class=\"\'dragover\'\" \nngf-change=\"vm.onChangeFile($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)\"><div class=\"middle\" \nng-if=\"!vm.srcImg\"><h1>Drag and drop image here</h1><h3>Or select your image to upload</h3></div><ui-cropper \nng-if=\"vm.srcImg\" image=\"vm.srcImg\" result-image=\"vm.cropImg\" area-type=\"circle\" aspect-ratio=\"1\" \nresult-image-size=\"{w: 160,h: 160}\" init-max-area=\"true\"></ui-cropper></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-raised md-accent\" ngf-select ng-model=\"file\" ngf-keep=\"true\" ngf-pattern=\"\'image/*\'\" \nngf-accept=\"\'image/*\'\" ngf-change=\"vm.onChangeFile($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)\" \nng-disabled=\"vm.isLoading\">Choose Image</md-button><span flex></span><md-button ng-click=\"vm.close()\" \nclass=\"md-raised\" ng-disabled=\"vm.isLoading\">Cancel</md-button><md-button ng-click=\"vm.uploadCompanyLogo()\" \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.srcImg || vm.isLoading\">Upload</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");}]);